import * as e from "react";
import t, { Children as n, Fragment as r, cloneElement as i, createContext as a, forwardRef as o, isValidElement as s, useCallback as c, useContext as l, useEffect as u, useId as d, useImperativeHandle as f, useLayoutEffect as p, useMemo as m, useReducer as h, useRef as g, useState as _ } from "react";
import v from "classnames";
import { camelCase as y } from "change-case";
import { createSignal as b } from "@pexip/signal";
import { v4 as x } from "uuid";
import { useTooltipTriggerState as S } from "@react-stately/tooltip";
import { useTooltipTrigger as C } from "@react-aria/tooltip";
import { Overlay as w, ariaHideOutside as T, useModalOverlay as E, useOverlay as D, useOverlayFocusContain as O, useOverlayPosition as k, usePopover as A } from "@react-aria/overlays";
import { isFocusable as j, tabbable as M } from "tabbable";
import { useCountDown as N, useEnter as ee, useMatchMedia as P, useOnClickOutside as te, usePrevious as ne } from "@pexip/hooks";
import re from "simplebar-react";
import { mergeProps as ie } from "@react-aria/utils";
import { noop as ae, throttle as oe } from "@pexip/utils";
import { useFocusWithin as se, useHover as ce } from "@react-aria/interactions";
import { createPortal as le } from "react-dom";
import { useButton as ue } from "@react-aria/button";
import { useMenu as de, useMenuItem as fe, useMenuTrigger as pe } from "@react-aria/menu";
import { useMenuTriggerState as me } from "@react-stately/menu";
import { Item as he } from "@react-stately/collections";
import { useTreeState as ge } from "@react-stately/tree";
import { useOverlayTriggerState as _e } from "@react-stately/overlays";
// src/utils/helpers.ts
var ve = (e) => y(`${e} padding`), ye = (e) => y(`${e} spacing`), be = (e, t) => Object.keys(t).reduce((n, r) => (r !== e && (n[r] = t[r]), n), {}), xe = { themeProvider: "_themeProvider_1o5fn_1" }, Se = ["theme-legacy", "theme-pds"], Ce = /*#__PURE__*/ a({
	colorScheme: "dark",
	theme: "theme-pds"
}), { Consumer: F } = Ce, I = ({ children: e, colorScheme: n, theme: r }) => {
	let { colorScheme: i, theme: a } = l(Ce), o = n ?? i, s = r ?? a;
	return /*#__PURE__*/ t.createElement(Ce.Provider, { value: {
		colorScheme: o,
		theme: s
	} }, /*#__PURE__*/ t.createElement("div", { className: v(xe.themeProvider, s, o) }, e));
};
function we(e, n) {
	return function(r) {
		return /*#__PURE__*/ t.createElement(I, { colorScheme: n }, /*#__PURE__*/ t.createElement(e, r));
	};
}
var Te = {
	boxHeader: "_boxHeader_kr7d7_4",
	nonePadding: "_nonePadding_kr7d7_9",
	compactPadding: "_compactPadding_kr7d7_13",
	smallPadding: "_smallPadding_kr7d7_17",
	mediumPadding: "_mediumPadding_kr7d7_21",
	largePadding: "_largePadding_kr7d7_25"
}, Ee = ({ className: e, padding: n = "small", contentBelowDivider: r, children: i }) => {
	let a = /*#__PURE__*/ t.createElement("div", { className: v(Te[ve(n)], Te.boxHeader, e) }, i);
	return r ? /*#__PURE__*/ t.createElement("div", null, a, r) : a;
}, De = {
	boxFooter: "_boxFooter_fgwhd_4",
	hasShadow: "_hasShadow_fgwhd_4",
	nonePaddingTop: "_nonePaddingTop_fgwhd_18",
	nonePaddingRight: "_nonePaddingRight_fgwhd_21",
	nonePaddingBottom: "_nonePaddingBottom_fgwhd_24",
	nonePaddingLeft: "_nonePaddingLeft_fgwhd_27",
	compactPaddingTop: "_compactPaddingTop_fgwhd_30",
	compactPaddingRight: "_compactPaddingRight_fgwhd_33",
	compactPaddingBottom: "_compactPaddingBottom_fgwhd_36",
	compactPaddingLeft: "_compactPaddingLeft_fgwhd_39",
	smallPaddingTop: "_smallPaddingTop_fgwhd_42",
	smallPaddingRight: "_smallPaddingRight_fgwhd_45",
	smallPaddingBottom: "_smallPaddingBottom_fgwhd_48",
	smallPaddingLeft: "_smallPaddingLeft_fgwhd_51",
	mediumPaddingTop: "_mediumPaddingTop_fgwhd_54",
	mediumPaddingRight: "_mediumPaddingRight_fgwhd_57",
	mediumPaddingBottom: "_mediumPaddingBottom_fgwhd_60",
	mediumPaddingLeft: "_mediumPaddingLeft_fgwhd_63",
	largePaddingTop: "_largePaddingTop_fgwhd_66",
	largePaddingRight: "_largePaddingRight_fgwhd_69",
	largePaddingBottom: "_largePaddingBottom_fgwhd_72",
	largePaddingLeft: "_largePaddingLeft_fgwhd_75"
}, Oe = ({ className: e, padding: n = "small", topPadding: r = n, rightPadding: i = n, bottomPadding: a = n, leftPadding: o = n, hasFooterShadow: s = !1, children: c }) => /*#__PURE__*/ t.createElement("div", { className: v(e, De.boxFooter, r && De[`${ve(r)}Top`], i && De[`${ve(i)}Right`], a && De[`${ve(a)}Bottom`], o && De[`${ve(o)}Left`], { [De.hasShadow]: s }) }, c), ke = {
	box: "_box_u4612_105",
	hasHeaderOrFooter: "_hasHeaderOrFooter_u4612_105",
	mainContent: "_mainContent_u4612_110",
	scrollable: "_scrollable_u4612_117",
	rounded: "_rounded_u4612_121",
	dark: "_dark_u4612_125",
	light: "_light_u4612_130",
	shadowLight: "_shadowLight_u4612_135",
	shadowDark: "_shadowDark_u4612_139",
	border: "_border_u4612_143",
	nonePadding: "_nonePadding_u4612_154",
	compactPadding: "_compactPadding_u4612_158",
	smallPadding: "_smallPadding_u4612_162",
	mediumPadding: "_mediumPadding_u4612_166",
	largePadding: "_largePadding_u4612_170"
}, Ae = /*#__PURE__*/ t.forwardRef(({ hasBackground: e = !0, headerContent: n, headerContentBelowDivider: r, footerContent: i, bgColor: a, children: o, className: s, childrenClassName: c, headerClassName: l, isRounded: u = !0, isWithBorder: d = !1, isWithShadow: f = !0, shadowModifier: p = "dark", padding: m = "none", headerPadding: h = m, footerPadding: g = m, footerTopPadding: _ = g, footerRightPadding: y = g, footerBottomPadding: b = g, footerLeftPadding: x = g, hasFooterShadow: S, scrollable: C, style: w, colorScheme: T, ...E }, D) => {
	let O = !!n || !!i;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: k }) => /*#__PURE__*/ t.createElement("div", {
		className: v(e && ke[T ?? k], {
			[ke.shadowDark]: f && p === "dark",
			[ke.shadowLight]: f && p === "light",
			[ke.rounded]: u,
			[ke.border]: d,
			[ke[ve(m)]]: !O,
			[ke.hasHeaderOrFooter]: O
		}, ke.box, s),
		style: e && a ? {
			...w,
			backgroundColor: a
		} : w,
		ref: D,
		...E
	}, n && /*#__PURE__*/ t.createElement(Ee, {
		contentBelowDivider: r,
		padding: h,
		className: l
	}, n), o && O ? /*#__PURE__*/ t.createElement("div", { className: v(ke[ve(m)], ke.mainContent, {
		"pb-0": i && m !== "none",
		[ke.scrollable]: C
	}, c) }, o) : o, i && /*#__PURE__*/ t.createElement(Oe, {
		padding: g,
		topPadding: _,
		rightPadding: y,
		bottomPadding: b,
		leftPadding: x,
		hasFooterShadow: S
	}, i)));
});
Ae.displayName = "Box";
var je = {
	dark: "_dark_14ps4_4",
	light: "_light_14ps4_8",
	horizontal: "_horizontal_14ps4_12",
	vertical: "_vertical_14ps4_17"
}, Me = ({ colorScheme: e, direction: n = "horizontal", className: r, ...i }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: a }) => /*#__PURE__*/ t.createElement("div", {
	className: v(je[e ?? a], je[n], r),
	...i
})), L = {
	dark: "_dark_12jtz_105",
	standard: "_standard_12jtz_105",
	link: "_link_12jtz_108",
	subtle: "_subtle_12jtz_111",
	tinted: "_tinted_12jtz_114",
	disabled: "_disabled_12jtz_117",
	success: "_success_12jtz_120",
	danger: "_danger_12jtz_123",
	warning: "_warning_12jtz_126",
	light: "_light_12jtz_130",
	hidden: "_hidden_12jtz_155",
	inherit: "_inherit_12jtz_167",
	truncated: "_truncated_12jtz_171",
	uppercase: "_uppercase_12jtz_178",
	underline: "_underline_12jtz_182",
	italicize: "_italicize_12jtz_186",
	normalWhiteSpace: "_normalWhiteSpace_12jtz_190",
	nowrapWhiteSpace: "_nowrapWhiteSpace_12jtz_194",
	preWhiteSpace: "_preWhiteSpace_12jtz_198",
	preWrapWhiteSpace: "_preWrapWhiteSpace_12jtz_202",
	preLineWhiteSpace: "_preLineWhiteSpace_12jtz_206",
	normalWordBreak: "_normalWordBreak_12jtz_210",
	breakAllWordBreak: "_breakAllWordBreak_12jtz_214",
	keepAllWordBreak: "_keepAllWordBreak_12jtz_218",
	overflowWrapWordBreak: "_overflowWrapWordBreak_12jtz_222",
	text: "_text_12jtz_227",
	h1: "_h1_12jtz_232",
	h2: "_h2_12jtz_238",
	h3: "_h3_12jtz_244",
	h4: "_h4_12jtz_250",
	h5: "_h5_12jtz_256",
	h6: "_h6_12jtz_262",
	"body-bold": "_body-bold_12jtz_268",
	bodyBold: "_body-bold_12jtz_268",
	button: "_button_12jtz_274",
	body: "_body_12jtz_268",
	"body-link": "_body-link_12jtz_286",
	bodyLink: "_body-link_12jtz_286",
	"small-bold": "_small-bold_12jtz_292",
	smallBold: "_small-bold_12jtz_292",
	small: "_small_12jtz_292",
	"small-link": "_small-link_12jtz_304",
	smallLink: "_small-link_12jtz_304",
	"x-small-bold": "_x-small-bold_12jtz_310",
	xSmallBold: "_x-small-bold_12jtz_310",
	"x-small": "_x-small_12jtz_310",
	xSmall: "_x-small_12jtz_310",
	"x-small-link": "_x-small-link_12jtz_322",
	xSmallLink: "_x-small-link_12jtz_322"
}, Ne = ({ children: e, className: n, colorScheme: r, fontVariant: i, htmlTag: a, isTruncated: o = !1, isUppercase: s, variant: c = "standard", ...l }) => {
	let u = i ?? a;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: i }) => /*#__PURE__*/ t.createElement(a, {
		className: v(L[r ?? i], L[c], L[u], {
			[L.truncated]: o,
			[L.uppercase]: s
		}, n),
		...l
	}, e));
}, R = /*#__PURE__*/ function(e) {
	return e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.BodyBold = "bodyBold", e.Button = "button", e.Body = "body", e.BodyLink = "bodyLink", e.SmallBold = "smallBold", e.Small = "small", e.SmallLink = "smallLink", e.XSmallBold = "xSmallBold", e.XSmall = "xSmall", e.XSmallLink = "xSmallLink", e;
}({}), Pe = {
	wrap: "_wrap_11372_11",
	divider: "_divider_11372_19",
	section: "_section_11372_23",
	grow: "_grow_11372_26",
	header: "_header_11372_30",
	headerTitleWrap: "_headerTitleWrap_11372_37"
}, Fe = ({ colorScheme: e = "light", title: n, titleHtmlTag: r = "h2", titleEnhancerStart: i, subtitle: a, secondaryComponent: o, children: s }) => /*#__PURE__*/ t.createElement(I, { colorScheme: e }, /*#__PURE__*/ t.createElement(Ae, {
	className: Pe.wrap,
	shadowModifier: "light"
}, /*#__PURE__*/ t.createElement("div", { className: Pe.header }, /*#__PURE__*/ t.createElement("div", { className: Pe.headerTitleWrap }, i && /*#__PURE__*/ t.createElement("div", { className: "mr-4" }, i), /*#__PURE__*/ t.createElement(Ne, {
	htmlTag: r,
	fontVariant: R.H5
}, n)), a && /*#__PURE__*/ t.createElement("div", null, a)), /*#__PURE__*/ t.createElement(Me, { className: Pe.divider }), /*#__PURE__*/ t.createElement("div", { className: Pe.section }, o), /*#__PURE__*/ t.createElement(Me, { className: Pe.divider }), /*#__PURE__*/ t.createElement("div", { className: v(Pe.section, Pe.grow) }, s))), Ie = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl"
], Le = [
	"xsOffset",
	"smOffset",
	"mdOffset",
	"lgOffset",
	"xlOffset"
], Re = [...Ie, ...Le], ze = {
	verticalGutter: "_verticalGutter_1ddso_1",
	cell: "_cell_1ddso_1",
	xs1: "_xs1_1ddso_12",
	xs2: "_xs2_1ddso_17",
	xs3: "_xs3_1ddso_22",
	xs4: "_xs4_1ddso_27",
	xs5: "_xs5_1ddso_32",
	xs6: "_xs6_1ddso_37",
	xs7: "_xs7_1ddso_42",
	xs8: "_xs8_1ddso_47",
	xs9: "_xs9_1ddso_52",
	xs10: "_xs10_1ddso_57",
	xs11: "_xs11_1ddso_62",
	xs12: "_xs12_1ddso_67",
	xsOffset0: "_xsOffset0_1ddso_72",
	xsOffset1: "_xsOffset1_1ddso_76",
	xsOffset2: "_xsOffset2_1ddso_80",
	xsOffset3: "_xsOffset3_1ddso_84",
	xsOffset4: "_xsOffset4_1ddso_88",
	xsOffset5: "_xsOffset5_1ddso_92",
	xsOffset6: "_xsOffset6_1ddso_96",
	xsOffset7: "_xsOffset7_1ddso_100",
	xsOffset8: "_xsOffset8_1ddso_104",
	xsOffset9: "_xsOffset9_1ddso_108",
	xsOffset10: "_xsOffset10_1ddso_112",
	xsOffset11: "_xsOffset11_1ddso_116",
	xsOffset12: "_xsOffset12_1ddso_120",
	sm1: "_sm1_1ddso_125",
	sm2: "_sm2_1ddso_129",
	sm3: "_sm3_1ddso_133",
	sm4: "_sm4_1ddso_137",
	sm5: "_sm5_1ddso_141",
	sm6: "_sm6_1ddso_145",
	sm7: "_sm7_1ddso_149",
	sm8: "_sm8_1ddso_153",
	sm9: "_sm9_1ddso_157",
	sm10: "_sm10_1ddso_161",
	sm11: "_sm11_1ddso_165",
	sm12: "_sm12_1ddso_169",
	smOffset0: "_smOffset0_1ddso_173",
	smOffset1: "_smOffset1_1ddso_176",
	smOffset2: "_smOffset2_1ddso_179",
	smOffset3: "_smOffset3_1ddso_182",
	smOffset4: "_smOffset4_1ddso_185",
	smOffset5: "_smOffset5_1ddso_188",
	smOffset6: "_smOffset6_1ddso_191",
	smOffset7: "_smOffset7_1ddso_194",
	smOffset8: "_smOffset8_1ddso_197",
	smOffset9: "_smOffset9_1ddso_200",
	smOffset10: "_smOffset10_1ddso_203",
	smOffset11: "_smOffset11_1ddso_206",
	smOffset12: "_smOffset12_1ddso_209",
	md1: "_md1_1ddso_214",
	md2: "_md2_1ddso_218",
	md3: "_md3_1ddso_222",
	md4: "_md4_1ddso_226",
	md5: "_md5_1ddso_230",
	md6: "_md6_1ddso_234",
	md7: "_md7_1ddso_238",
	md8: "_md8_1ddso_242",
	md9: "_md9_1ddso_246",
	md10: "_md10_1ddso_250",
	md11: "_md11_1ddso_254",
	md12: "_md12_1ddso_258",
	mdOffset0: "_mdOffset0_1ddso_262",
	mdOffset1: "_mdOffset1_1ddso_265",
	mdOffset2: "_mdOffset2_1ddso_268",
	mdOffset3: "_mdOffset3_1ddso_271",
	mdOffset4: "_mdOffset4_1ddso_274",
	mdOffset5: "_mdOffset5_1ddso_277",
	mdOffset6: "_mdOffset6_1ddso_280",
	mdOffset7: "_mdOffset7_1ddso_283",
	mdOffset8: "_mdOffset8_1ddso_286",
	mdOffset9: "_mdOffset9_1ddso_289",
	mdOffset10: "_mdOffset10_1ddso_292",
	mdOffset11: "_mdOffset11_1ddso_295",
	mdOffset12: "_mdOffset12_1ddso_298",
	lg1: "_lg1_1ddso_303",
	lg2: "_lg2_1ddso_307",
	lg3: "_lg3_1ddso_311",
	lg4: "_lg4_1ddso_315",
	lg5: "_lg5_1ddso_319",
	lg6: "_lg6_1ddso_323",
	lg7: "_lg7_1ddso_327",
	lg8: "_lg8_1ddso_331",
	lg9: "_lg9_1ddso_335",
	lg10: "_lg10_1ddso_339",
	lg11: "_lg11_1ddso_343",
	lg12: "_lg12_1ddso_347",
	lgOffset0: "_lgOffset0_1ddso_351",
	lgOffset1: "_lgOffset1_1ddso_354",
	lgOffset2: "_lgOffset2_1ddso_357",
	lgOffset3: "_lgOffset3_1ddso_360",
	lgOffset4: "_lgOffset4_1ddso_363",
	lgOffset5: "_lgOffset5_1ddso_366",
	lgOffset6: "_lgOffset6_1ddso_369",
	lgOffset7: "_lgOffset7_1ddso_372",
	lgOffset8: "_lgOffset8_1ddso_375",
	lgOffset9: "_lgOffset9_1ddso_378",
	lgOffset10: "_lgOffset10_1ddso_381",
	lgOffset11: "_lgOffset11_1ddso_384",
	lgOffset12: "_lgOffset12_1ddso_387",
	xl1: "_xl1_1ddso_392",
	xl2: "_xl2_1ddso_396",
	xl3: "_xl3_1ddso_400",
	xl4: "_xl4_1ddso_404",
	xl5: "_xl5_1ddso_408",
	xl6: "_xl6_1ddso_412",
	xl7: "_xl7_1ddso_416",
	xl8: "_xl8_1ddso_420",
	xl9: "_xl9_1ddso_424",
	xl10: "_xl10_1ddso_428",
	xl11: "_xl11_1ddso_432",
	xl12: "_xl12_1ddso_436",
	xlOffset0: "_xlOffset0_1ddso_440",
	xlOffset1: "_xlOffset1_1ddso_443",
	xlOffset2: "_xlOffset2_1ddso_446",
	xlOffset3: "_xlOffset3_1ddso_449",
	xlOffset4: "_xlOffset4_1ddso_452",
	xlOffset5: "_xlOffset5_1ddso_455",
	xlOffset6: "_xlOffset6_1ddso_458",
	xlOffset7: "_xlOffset7_1ddso_461",
	xlOffset8: "_xlOffset8_1ddso_464",
	xlOffset9: "_xlOffset9_1ddso_467",
	xlOffset10: "_xlOffset10_1ddso_470",
	xlOffset11: "_xlOffset11_1ddso_473",
	xlOffset12: "_xlOffset12_1ddso_476",
	xxl1: "_xxl1_1ddso_481",
	xxl2: "_xxl2_1ddso_485",
	xxl3: "_xxl3_1ddso_489",
	xxl4: "_xxl4_1ddso_493",
	xxl5: "_xxl5_1ddso_497",
	xxl6: "_xxl6_1ddso_501",
	xxl7: "_xxl7_1ddso_505",
	xxl8: "_xxl8_1ddso_509",
	xxl9: "_xxl9_1ddso_513",
	xxl10: "_xxl10_1ddso_517",
	xxl11: "_xxl11_1ddso_521",
	xxl12: "_xxl12_1ddso_525",
	xxlOffset0: "_xxlOffset0_1ddso_529",
	xxlOffset1: "_xxlOffset1_1ddso_532",
	xxlOffset2: "_xxlOffset2_1ddso_535",
	xxlOffset3: "_xxlOffset3_1ddso_538",
	xxlOffset4: "_xxlOffset4_1ddso_541",
	xxlOffset5: "_xxlOffset5_1ddso_544",
	xxlOffset6: "_xxlOffset6_1ddso_547",
	xxlOffset7: "_xxlOffset7_1ddso_550",
	xxlOffset8: "_xxlOffset8_1ddso_553",
	xxlOffset9: "_xxlOffset9_1ddso_556",
	xxlOffset10: "_xxlOffset10_1ddso_559",
	xxlOffset11: "_xxlOffset11_1ddso_562",
	xxlOffset12: "_xxlOffset12_1ddso_565"
}, Be = (e) => e in ze, Ve = (e) => Re.reduce((t, n) => {
	let r = `${n}${e[n] ?? ""}`;
	return Be(r) && t.push(ze[r]), t;
}, []), He = ({ className: e, children: n, hasVerticalGutter: r, ...i }) => /*#__PURE__*/ t.createElement("div", { className: v(ze.cell, Ve(i), { [ze.verticalGutter]: r }, e) }, n), Ue = {
	centerLayout: "_centerLayout_vjlw4_1",
	relative: "_relative_vjlw4_10",
	absolute: "_absolute_vjlw4_14",
	centerText: "_centerText_vjlw4_22",
	fullWidth: "_fullWidth_vjlw4_26"
}, We = ({ centerText: e = !1, children: n, className: r, isFullWidth: i, position: a = "relative", ...o }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Ue.centerLayout, Ue[a], e && Ue.centerText, { [Ue.fullWidth]: i }, r),
	...o
}, n), Ge = {
	xs: 0,
	sm: 479,
	md: 744,
	lg: 1025,
	xl: 2e3
}, Ke = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl"
], qe = (e) => typeof e == "string", Je = (e) => typeof e == "object", Ye = (e) => e === void 0 ? !0 : qe(e) ? !e.trim() : Object.entries(e).every(([e, t]) => !t.trim()), Xe = (e) => {
	let t = "", n = Object.entries(e);
	for (let e of n) {
		let r = e[0], i = e[1];
		t = t.concat(`${i} ${r}`), n.indexOf(e) !== n.length - 1 && (t = t.concat(", "));
	}
	return t.trim();
}, Ze = (e) => typeof e == "string", Qe = (e) => typeof e == "object", $e = (e) => e === void 0 ? !0 : Ze(e) ? !e.trim() : Object.entries(e).every(([e, t]) => !t.trim()), et = (e) => {
	let t = [...Ke].reverse();
	for (let n of t) {
		let t = e[n];
		if (t) return t;
	}
	return null;
}, tt = (e) => {
	let t = et(e);
	if (t) {
		let n = [...Ke].reverse(), r = { ...e };
		return n.forEach((e, i) => {
			if (!r[e]) {
				let a = n[i - 1], o = a && r[a] || t;
				r[e] = o;
			}
		}), r;
	}
	return e;
}, nt = (e) => {
	let t = tt(e);
	return Object.fromEntries(Object.entries(t).map(([e, t]) => [`--${e}-background-image`, `url("${t}")`]));
}, rt = /*#__PURE__*/ function(e) {
	return e.White = "#ffffff", e.Blue40 = "#b1aaff", e.Blue20 = "#d0ccff", e.Red100 = "#ff7273", e.Green100 = "#0ebec7", e.Blue100 = "#4b37ff", e.TextLinkBlueDarkBg = "#00c2ff", e.TextLinkBlueHoverDarkBg = "#52d7ff", e.Blue50 = "#a198ff", e.Green90 = "#30c8cf", e.Green80 = "#51d2d8", e.Green60 = "#8de5e9", e.Green40 = "#baf4f6", e.Red90 = "#ff9697", e.Red80 = "#ffb6b7", e.Red70 = "#f24949", e.Red60 = "#ffe3e4", e.Red40 = "#fff7f7", e.Blue90 = "#5d4cff", e.SignalRedHover = "#bc1515", e.DeepBlue100 = "#0a2136", e.Neutral100 = "#212121", e.DeepBlue90 = "#1e3a54", e.Neutral90 = "#323232", e.SignalRed = "#e60000", e.SignalGreen = "#2c8500", e.JoinHover = "#488716", e.JoinDisabled = "#e3eede", e.SignalGreen130 = "#205e01", e.Join = "#5eaf1d", e.DeepBlue80 = "#3c5974", e.Neutral80 = "#494949", e.DeepBlue50 = "#a5b8ca", e.Neutral50 = "#c3c4c5", e.DeepBlue40 = "#c1d1df", e.Neutral40 = "#d2d2d2", e.DeepBlue30 = "#d8e3ee", e.Neutral30 = "#dcdcdc", e.DeepBlue20 = "#e8f0f8", e.Neutral20 = "#e6e6e6", e.Grey = "#f7f7f7", e.Black = "#111111", e.DeepBlue60 = "#728fac", e.Neutral60 = "#989898", e.DeepBlue70 = "#577490", e.Neutral70 = "#777777", e.DeepBlue10 = "#f4f7fb", e.Neutral10 = "#f2f2f2", e.DeepBlue5 = "#ffffff", e.Neutral5 = "#ffffff", e.TextLinkBlueWhiteBg = "#032fff", e.TextLinkBlueHoverWhiteBg = "#0023d1", e.SignalOrange130 = "#bc5a00", e.SignalOrange80 = "#fef1e6", e.Green130 = "#00777c", e.SignalOrange120 = "#ff9a3e", e.SignalOrange110 = "#fcc592", e.SignalOrange100 = "#ffd1a7", e.SignalOrange90 = "#fdd8b7", e.SignalOrange60 = "#fff5ed", e.SignalOrange40 = "#fff8f2", e;
}({}), it = /*#__PURE__*/ function(e) {
	return e.White = "255,255,255", e.Blue40 = "177,170,255", e.Blue20 = "208,204,255", e.Red100 = "255,114,115", e.Green100 = "14,190,199", e.Blue100 = "75,55,255", e.TextLinkBlueDarkBg = "0,194,255", e.TextLinkBlueHoverDarkBg = "82,215,255", e.Blue50 = "161,152,255", e.Green90 = "48,200,207", e.Green80 = "81,210,216", e.Green60 = "141,229,233", e.Green40 = "186,244,246", e.Red90 = "255,150,151", e.Red80 = "255,182,183", e.Red60 = "255,227,228", e.Red40 = "255,247,247", e.Blue90 = "93,76,255", e.SignalRedHover = "188,21,21", e.DeepBlue100 = "10,33,54", e.Neutral100 = "33,33,33", e.DeepBlue90 = "30,58,84", e.Neutral90 = "50,50,50", e.SignalRed = "230,0,0", e.SignalGreen = "44,133,0", e.JoinHover = "72,135,22", e.JoinDisabled = "227,238,222", e.SignalGreen130 = "32,94,1", e.Join = "94,175,29", e.DeepBlue80 = "60,89,116", e.Neutral80 = "73,73,73", e.DeepBlue50 = "165,184,202", e.Neutral50 = "195,196,197", e.DeepBlue40 = "193,209,223", e.Neutral40 = "210,210,210", e.DeepBlue30 = "216,227,238", e.Neutral30 = "220,220,220", e.DeepBlue20 = "232,240,248", e.Neutral20 = "230,230,230", e.Grey = "247,247,247", e.Black = "17,17,17", e.DeepBlue60 = "114,143,172", e.Neutral60 = "152,152,152", e.DeepBlue70 = "87,116,144", e.Neutral70 = "119,119,119", e.DeepBlue10 = "244,247,251", e.Neutral10 = "242,242,242", e.DeepBlue5 = "255,255,255", e.Neutral5 = "255,255,255", e.TextLinkBlueWhiteBg = "3,47,255", e.TextLinkBlueHoverWhiteBg = "0,35,209", e.SignalOrange130 = "188,90,0", e.SignalOrange80 = "254,241,230", e.Green130 = "0,119,124", e.SignalOrange120 = "255,154,62", e.SignalOrange110 = "252,197,146", e.SignalOrange100 = "255,209,167", e.SignalOrange90 = "253,216,183", e.SignalOrange60 = "255,245,237", e.SignalOrange40 = "255,248,242", e;
}({}), at = ({ background: e, backgroundImageSrc: t, backgroundBlendMode: n, overlayOpacity: r, overlay: i }) => m(() => {
	let a = e === "image" && !$e(t), o = a && Qe(t), s = a && n !== "normal", c = e === "none", l = e === "white", u = e === "dark" || e === "image" && !a, d = e === "light", f = {};
	if (a && (Ze(t) && (f = {
		...f,
		backgroundImage: `url("${t}")`
	}), Qe(t))) {
		let e = nt(t);
		f = {
			...f,
			...e
		};
	}
	return s && (f = {
		...f,
		"--blend-mode": n,
		"--background-color-opacity": `${r}`,
		"--background-color-rgb": `${i === "light" ? it.White : it.Black}`
	}), {
		isBackgroundNone: c,
		isBackgroundWhite: l,
		isBackgroundDark: u,
		isBackgroundLight: d,
		isBackgroundImage: a,
		isBackgroundImageBreakpointImageSet: o,
		isBackgroundImageBlend: s,
		backgroundStyleProps: f
	};
}, [
	e,
	t,
	n,
	r,
	i
]), ot = {
	light: "_light_7bega_114",
	dark: "_dark_7bega_120",
	fullSizeWindow: "_fullSizeWindow_7bega_129",
	fixed: "_fixed_7bega_160",
	absolute: "_absolute_7bega_164",
	paddingNone: "_paddingNone_7bega_168",
	paddingSmall: "_paddingSmall_7bega_172",
	backgroundNone: "_backgroundNone_7bega_176",
	backgroundWhite: "_backgroundWhite_7bega_180",
	backgroundDark: "_backgroundDark_7bega_184",
	backgroundLight: "_backgroundLight_7bega_196",
	backgroundImage: "_backgroundImage_7bega_200",
	backgroundImageBreakpointImageSet: "_backgroundImageBreakpointImageSet_7bega_207",
	backgroundBlend: "_backgroundBlend_7bega_232",
	row: "_row_7bega_238",
	rowReverse: "_rowReverse_7bega_242",
	column: "_column_7bega_246",
	columnReverse: "_columnReverse_7bega_250",
	flexStart: "_flexStart_7bega_254",
	center: "_center_7bega_258"
}, st = /*#__PURE__*/ t.forwardRef(({ children: e, className: n, padding: r = "small", background: i = "none", flexDirection: a = "row", justifyContent: o = "flexStart", backgroundImageSrc: s, backgroundBlendMode: c = "normal", overlayOpacity: l = .7, overlay: u = "dark", position: d = "fixed", style: f, ...p }, m) => {
	let h = r === "small", g = r === "none", { isBackgroundNone: _, isBackgroundWhite: y, isBackgroundDark: b, isBackgroundLight: x, isBackgroundImage: S, isBackgroundImageBreakpointImageSet: C, isBackgroundImageBlend: w, backgroundStyleProps: T } = at({
		background: i,
		backgroundImageSrc: s,
		backgroundBlendMode: c,
		overlayOpacity: l,
		overlay: u
	});
	return /*#__PURE__*/ t.createElement("div", {
		style: {
			...f,
			...T
		},
		className: v(ot.fullSizeWindow, {
			[ot.paddingNone]: g,
			[ot.paddingSmall]: h,
			[ot.backgroundNone]: _,
			[ot.backgroundWhite]: y,
			[ot.backgroundDark]: b,
			[ot.backgroundLight]: x,
			[ot.backgroundImage]: S,
			[ot.backgroundImageBreakpointImageSet]: C,
			[ot.backgroundBlend]: S && w
		}, ot[a], ot[o], ot[d], n),
		ref: m,
		...p
	}, e);
});
st.displayName = "FullSizeWindow";
var ct = {
	wrapper: "_wrapper_m0c6u_1",
	roundedCorners: "_roundedCorners_m0c6u_15",
	small: "_small_m0c6u_19",
	medium: "_medium_m0c6u_23",
	large: "_large_m0c6u_27",
	full: "_full_m0c6u_32",
	mediumWidth: "_mediumWidth_m0c6u_37",
	fullWidth: "_fullWidth_m0c6u_41",
	autoHeight: "_autoHeight_m0c6u_45",
	flexStart: "_flexStart_m0c6u_49",
	center: "_center_m0c6u_53"
}, lt = ({ className: e, children: n, modifier: r, heightModifier: i, size: a = "full", justifyContent: o = "flexStart", borderRadius: s = "none", ...c }) => /*#__PURE__*/ t.createElement("div", {
	className: v(ct.wrapper, e, r && ct[r], ct[a], i && ct[i], s === "box" && ct.roundedCorners, ct[o]),
	...c
}, n), ut = ({ children: e }) => /*#__PURE__*/ t.createElement(st, {
	padding: "none",
	background: "dark"
}, /*#__PURE__*/ t.createElement(lt, { modifier: "fullWidth" }, /*#__PURE__*/ t.createElement(We, null, e))), dt = { overlay: "_overlay_174tg_4" }, ft = ({ children: e, ...n }) => /*#__PURE__*/ t.createElement(st, {
	padding: "none",
	background: "dark",
	className: dt.overlay,
	...n
}, e), pt = (e) => /*#__PURE__*/ s(e) && !!e.props.children, mt = (e) => /*#__PURE__*/ s(e) && pt(e) && n.toArray(e.props.children).reduce((e, t) => e || /*#__PURE__*/ s(t), !1), ht = (e, t) => n.toArray(e).map((e, n, r) => /*#__PURE__*/ s(e) && mt(e) ? t(/*#__PURE__*/ i(e, {
	...e.props,
	children: ht(e.props.children, t)
})) : t(e, n, r)), gt = (e, t) => t === void 0 ? null : `${e}${t}`, _t = (e, t) => {
	if (typeof t != "string") return t;
	let [n, r] = t.match(/^url\(#(.*)\)$/) ?? [null, null];
	if (r === null) return t;
	let i = gt(e, r);
	return i === null ? t : `url(#${i})`;
}, vt = (e) => /*#__PURE__*/ t.isValidElement(e) && typeof e.props == "object", yt = (e) => {
	let n = d();
	return ht(e.children, (e) => !e || typeof e == "string" || typeof e == "number" || !vt(e) ? e : /*#__PURE__*/ t.cloneElement(e, {
		...Object.entries(e.props).reduce((e, [t, r]) => (e[t] = _t(n, r ?? ""), e), {}),
		id: gt(n, e.props.id)
	}));
}, bt = {
	dark: "_dark_1zxj7_4",
	light: "_light_1zxj7_8",
	tertiary: "_tertiary_1zxj7_12",
	small: "_small_1zxj7_16",
	medium: "_medium_1zxj7_21"
}, xt = ({ size: e, source: n, className: r, colorScheme: i, ref: a, ...o }) => {
	let s = v(i && bt[i], e && bt[e], r), c = n, l = typeof c == "function" ? c({
		className: s,
		...o
	}) : /*#__PURE__*/ t.createElement(n, {
		className: s,
		...o
	});
	return /*#__PURE__*/ t.createElement(yt, null, l);
}, St = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: 4.267,
	d: "M24.187 9.163a10.667 10.667 0 10-13.65 15.998"
}), /* @__PURE__ */ e.createElement("mask", {
	id: "a",
	width: 20,
	height: 10,
	x: 7,
	y: 20,
	style: { maskType: "alpha" },
	maskUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("path", {
	stroke: "url(#paint0_linear)",
	strokeLinecap: "round",
	strokeWidth: 5.333,
	d: "M10.537 25.161A10.666 10.666 0 0024.04 23.01"
})), /* @__PURE__ */ e.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ e.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: 4.267,
	d: "M26.667 16a10.667 10.667 0 10-2.627 7.01"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("linearGradient", {
	id: "paint0_linear",
	x1: 13.067,
	x2: 25.6,
	y1: 26.133,
	y2: 22.133,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("stop", null), /* @__PURE__ */ e.createElement("stop", {
	offset: 1,
	stopOpacity: 0
})))), Ct = {
	wrapper: "_wrapper_sm86s_24",
	label: "_label_sm86s_28",
	spinner: "_spinner_sm86s_40",
	spin: "_spin_sm86s_40",
	compact: "_compact_sm86s_49",
	small: "_small_sm86s_53",
	medium: "_medium_sm86s_57",
	dark: "_dark_sm86s_62",
	light: "_light_sm86s_66",
	subtle: "_subtle_sm86s_70"
}, wt = "Loading", Tt = ({ className: e, label: n = wt, sizeModifier: r = "medium", colorScheme: i, ...a }) => /*#__PURE__*/ t.createElement("div", {
	role: "status",
	className: v(Ct.wrapper, i && Ct[i], e),
	...a
}, /*#__PURE__*/ t.createElement("span", { className: Ct.label }, n), /*#__PURE__*/ t.createElement(xt, {
	source: St,
	className: v(Ct.spinner, Ct[r])
})), Et = (e) => /*#__PURE__*/ t.createElement(ut, null, /*#__PURE__*/ t.createElement(Tt, {
	colorScheme: "dark",
	...e
})), Dt = { grid: "_grid_172qj_1" }, Ot = ({ className: e, children: n, hasCellVerticalGutter: r, ...i }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Dt.grid, { hasCellVerticalGutter: r }, e),
	...i
}, n), kt = {
	top: "_top_9teu4_4",
	bottom: "_bottom_9teu4_5",
	content: "_content_9teu4_24"
}, At = ({ children: e, position: r = "top", className: i }) => /*#__PURE__*/ t.createElement("div", { className: v(kt[r], i) }, n.count(e) > 0 ? /*#__PURE__*/ t.createElement("span", { className: kt.content }, e) : e), jt = {
	hasCustomFocusStyle: "_hasCustomFocusStyle_1cxdp_116",
	el: "_el_1cxdp_120"
}, Mt = (e) => "href" in e && !!e.href && e.href !== "#", Nt = /*#__PURE__*/ t.forwardRef(({ children: e, className: n, focusClassName: r, disabled: i, htmlTag: a = "button", ...o }, s) => /*#__PURE__*/ t.createElement(i ? "button" : Mt(o) ? "a" : a, {
	ref: s,
	className: v(jt.el, n, r, { [jt.hasCustomFocusStyle]: !!r }),
	disabled: i,
	...o
}, e));
Nt.displayName = "InteractiveElementContent";
var z = ({ ...e }) => /*#__PURE__*/ t.createElement(Nt, e), Pt = /*#__PURE__*/ t.forwardRef(({ ...e }, n) => /*#__PURE__*/ t.createElement(Nt, {
	...e,
	ref: n
}));
Pt.displayName = "InteractiveElementContent";
var B = {
	dark: "_dark_m8zy9_108",
	light: "_light_m8zy9_125",
	button: "_button_m8zy9_597",
	disc: "_disc_m8zy9_641",
	noBorderRadius: "_noBorderRadius_m8zy9_644",
	buttonContent: "_buttonContent_m8zy9_647",
	buttonChildren: "_buttonChildren_m8zy9_653",
	disabled: "_disabled_m8zy9_658",
	loading: "_loading_m8zy9_662",
	loadingIcon: "_loadingIcon_m8zy9_667",
	enhancerStart: "_enhancerStart_m8zy9_674",
	enhancerEnd: "_enhancerEnd_m8zy9_675",
	primary: "_primary_m8zy9_679",
	noHover: "_noHover_m8zy9_683",
	hasBackgroundTransparency: "_hasBackgroundTransparency_m8zy9_695",
	textComponent: "_textComponent_m8zy9_738",
	secondary: "_secondary_m8zy9_758",
	tertiary: "_tertiary_m8zy9_837",
	translucent: "_translucent_m8zy9_916",
	text: "_text_m8zy9_738",
	danger: "_danger_m8zy9_1074",
	dangerBordered: "_dangerBordered_m8zy9_1153",
	success: "_success_m8zy9_1232",
	neutral: "_neutral_m8zy9_1311",
	transparent: "_transparent_m8zy9_1390",
	transparentAlternative: "_transparentAlternative_m8zy9_1469",
	none: "_none_m8zy9_2417",
	square: "_square_m8zy9_2427",
	compact: "_compact_m8zy9_2432",
	small: "_small_m8zy9_2447",
	medium: "_medium_m8zy9_2462",
	large: "_large_m8zy9_2477",
	fullWidth: "_fullWidth_m8zy9_2569",
	fluid: "_fluid_m8zy9_2573"
}, Ft = /*#__PURE__*/ t.forwardRef(({ children: e, className: n, colorScheme: r, htmlTag: i, isActive: a, isDisabled: o, modifier: s, noBorderRadius: c = !1, noHover: l = !1, size: u = "medium", variant: d = "primary", backgroundTransparency: f = 1, style: p, ...m }, h) => {
	let g = f < 1, _ = g ? { "--background-alpha": f } : void 0;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: f }) => {
		let y = r ?? f;
		return /*#__PURE__*/ t.createElement(Pt, {
			ref: h,
			style: p || _ ? {
				...p,
				..._
			} : void 0,
			className: v(y, B.button, B[y], B[d], B[u], s && B[s], {
				[B.disabled]: o,
				[B.noBorderRadius]: c,
				[B.noHover]: l || o,
				[B.hasBackgroundTransparency]: g
			}, n),
			"data-active": a && !o,
			disabled: o,
			htmlTag: i,
			...m
		}, e);
	});
});
Ft.displayName = "SimpleButtonContent";
var It = ({ ...e }) => /*#__PURE__*/ t.createElement(Ft, e), Lt = /*#__PURE__*/ t.forwardRef(({ ...e }, n) => /*#__PURE__*/ t.createElement(Ft, {
	...e,
	ref: n
}));
Lt.displayName = "SimpleButtonContent";
// src/components/elements/Text/Text.tsx
var V = ({ children: e, className: n, colorScheme: r, fontVariant: i = R.Body, htmlTag: a = "span", isTruncated: o = !1, isUnderlined: s, isUppercase: c, isItalicized: l, whiteSpace: u, wordBreak: d, variant: f = "standard", ...p }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: m }) => /*#__PURE__*/ t.createElement(a, {
	className: v(r ?? m, L.text, L[r ?? m], L[f], L[i], u && L[`${u}WhiteSpace`], d && L[`${d}WordBreak`], {
		[L.truncated]: o,
		[L.uppercase]: c,
		[L.underline]: s,
		[L.italicize]: l
	}, n),
	...p
}, e)), Rt = ({ children: e, className: n, isLoading: r, sizeModifier: i = "compact", colorScheme: a }) => r ? /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("div", { className: v(n, "visibility-hidden") }, e), /*#__PURE__*/ t.createElement("div", { className: B.loadingIcon }, /*#__PURE__*/ t.createElement(Tt, {
	sizeModifier: i,
	colorScheme: a
}))) : n ? /*#__PURE__*/ t.createElement("div", { className: n }, e) : e, zt = ({ children: e, className: n, enhancerEnd: r, enhancerEndClassName: i, enhancerStart: a, enhancerStartClassName: o, noEnhancerPadding: s }) => /*#__PURE__*/ t.createElement("div", { className: v(n, B.buttonContent) }, a && /*#__PURE__*/ t.createElement("span", { className: v(B.enhancerStart, { "pe-0": s }, o) }, a), /*#__PURE__*/ t.createElement("div", { className: B.buttonChildren }, e), r && /*#__PURE__*/ t.createElement("span", { className: v(B.enhancerEnd, { "ps-0": s }, i) }, r)), Bt = ({ children: e, className: n, fontVariant: r = R.BodyBold, variant: i = "inherit", ...a }) => /*#__PURE__*/ t.createElement(V, {
	className: v(n, B.textComponent),
	fontVariant: r,
	variant: i,
	...a
}, e), Vt = /*#__PURE__*/ t.forwardRef(({ children: e, colorScheme: n, enhancerEnd: r, enhancerEndClassName: i, enhancerStart: a, enhancerStartClassName: o, fontVariant: s, hideChildren: c, isDisabled: l, isLoading: u, noEnhancerPadding: d, textVariant: f, underlineText: p, useTextComponent: m, variant: h, ...g }, _) => /*#__PURE__*/ t.createElement(Lt, {
	colorScheme: n,
	isDisabled: !!l || u,
	variant: h,
	ref: _,
	...g
}, /*#__PURE__*/ t.createElement(Rt, { isLoading: u }, /*#__PURE__*/ t.createElement(zt, {
	className: v({ [B.textComponent]: !m && h === "text" && p }),
	enhancerEnd: r,
	enhancerEndClassName: i,
	enhancerStart: a,
	enhancerStartClassName: o,
	noEnhancerPadding: d
}, !c && (m ? /*#__PURE__*/ t.createElement(Bt, {
	colorScheme: n,
	fontVariant: s,
	variant: f
}, e) : e)))));
Vt.displayName = "ButtonContent";
var H = ({ ...e }) => /*#__PURE__*/ t.createElement(Vt, e), Ht = /*#__PURE__*/ t.forwardRef(({ ...e }, n) => /*#__PURE__*/ t.createElement(Vt, {
	...e,
	ref: n
}));
Ht.displayName = "RefButton";
// design-tokens/generated/icons/add-16.svg
var Ut = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdd_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.5 1h-9A2.5 2.5 0 0 0 1 3.5v9A2.5 2.5 0 0 0 3.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 12.5 1m-.964 7.75H8.75v2.786a.75.75 0 0 1-1.5 0V8.75H4.464a.75.75 0 0 1 0-1.5H7.25V4.464a.75.75 0 0 1 1.5 0V7.25h2.786a.75.75 0 0 1 0 1.5"
})), Wt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdd_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.429 2H5.571A3.57 3.57 0 0 0 2 5.571v12.857A3.57 3.57 0 0 0 5.571 22h12.857A3.57 3.57 0 0 0 22 18.429V5.571A3.57 3.57 0 0 0 18.429 2M17 13h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2"
})), Gt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAddSomeone_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13 1.833a.5.5 0 0 1 .5.5V3.5h1.167a.5.5 0 1 1 0 1H13.5v1.167a.5.5 0 1 1-1 0V4.5h-1.167a.5.5 0 1 1 0-1H12.5V2.333a.5.5 0 0 1 .5-.5M7.333 8.391c1.352 0 2.452-1.099 2.452-2.452 0-1.351-1.1-2.45-2.452-2.45a2.454 2.454 0 0 0-2.452 2.45c0 1.352 1.1 2.452 2.452 2.452m4.014 2.24c-.64-.684-1.844-1.192-4.014-1.192-2.188 0-3.395.516-4.03 1.209l-.018.02c-.172.187-.45.489-.565 1.231a.67.67 0 0 0 .661.768h7.904a.67.67 0 0 0 .662-.768c-.12-.757-.405-1.061-.59-1.258z",
	clipRule: "evenodd"
})), Kt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAddSomeone_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M19.5 2.75a.75.75 0 0 1 .75.75v1.75H22a.75.75 0 0 1 0 1.5h-1.75V8.5a.75.75 0 0 1-1.5 0V6.75H17a.75.75 0 0 1 0-1.5h1.75V3.5a.75.75 0 0 1 .75-.75M11 12.587a3.68 3.68 0 0 0 3.677-3.678A3.68 3.68 0 0 0 11 5.233a3.68 3.68 0 0 0-3.678 3.676A3.68 3.68 0 0 0 11 12.587m6.021 3.359c-.959-1.026-2.767-1.788-6.021-1.788-3.282 0-5.093.775-6.046 1.814l-.026.029c-.258.28-.674.734-.848 1.848A1.005 1.005 0 0 0 5.072 19h11.856c.61 0 1.086-.548.992-1.151-.178-1.136-.607-1.593-.885-1.888z",
	clipRule: "evenodd"
})), qt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdjust_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.333 2.667a.667.667 0 0 0-.666.666v3.334H2A.667.667 0 0 0 2 8h.667v4.667a.667.667 0 1 0 1.333 0V8h.667a.667.667 0 0 0 0-1.333H4V3.333a.667.667 0 0 0-.667-.666m4.667 0a.667.667 0 0 0-.667.666V10h-.666a.667.667 0 0 0 0 1.333h.666v1.334a.667.667 0 1 0 1.334 0v-1.334h.666a.667.667 0 1 0 0-1.333h-.666V3.333A.667.667 0 0 0 8 2.667m4 .666a.667.667 0 0 1 1.333 0v1.334H14A.667.667 0 1 1 14 6h-.667v6.667a.667.667 0 1 1-1.333 0V6h-.667a.667.667 0 1 1 0-1.333H12z",
	clipRule: "evenodd"
})), Jt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdjust_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5 4a1 1 0 0 0-1 1v5H3a1 1 0 1 0 0 2h1v7a1 1 0 1 0 2 0v-7h1a1 1 0 1 0 0-2H6V5a1 1 0 0 0-1-1m7 0a1 1 0 0 0-1 1v10h-1a1 1 0 1 0 0 2h1v2a1 1 0 1 0 2 0v-2h1a1 1 0 1 0 0-2h-1V5a1 1 0 0 0-1-1m6 1a1 1 0 1 1 2 0v2h1a1 1 0 1 1 0 2h-1v10a1 1 0 1 1-2 0V9h-1a1 1 0 1 1 0-2h1z",
	clipRule: "evenodd"
})), Yt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdjust_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M6.833 5.333a1.5 1.5 0 0 0-1.5 1.5v6.5H4c-.736 0-1.333.597-1.333 1.334V15c0 .736.597 1.333 1.333 1.333h1.333v8.834a1.5 1.5 0 0 0 3 0v-8.834h1c.737 0 1.334-.597 1.334-1.333v-.333c0-.737-.597-1.334-1.334-1.334h-1v-6.5a1.5 1.5 0 0 0-1.5-1.5m9.334 0a1.5 1.5 0 0 0-1.5 1.5V20h-1.333c-.737 0-1.334.597-1.334 1.333v.334c0 .736.597 1.333 1.334 1.333h1.333v2.167a1.5 1.5 0 0 0 3 0V23h1c.736 0 1.333-.597 1.333-1.333v-.334c0-.736-.597-1.333-1.333-1.333h-1V6.833a1.5 1.5 0 0 0-1.5-1.5M24 6.833a1.5 1.5 0 0 1 3 0V9h.667C28.403 9 29 9.597 29 10.333v.334c0 .736-.597 1.333-1.333 1.333H27v13.167a1.5 1.5 0 0 1-3 0V12h-1.667A1.333 1.333 0 0 1 21 10.667v-.334C21 9.597 21.597 9 22.333 9H24z",
	clipRule: "evenodd"
})), Xt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdmit_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.01 13c-.258 0-.516-.098-.712-.294L1.295 8.7a1.006 1.006 0 0 1 1.421-1.422l3.293 3.293 7.275-7.277a1.005 1.005 0 1 1 1.421 1.422L6.72 12.705a1 1 0 0 1-.71.295"
})), Zt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdmit_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.156 20c-.368 0-.735-.147-1.016-.442l-5.72-6.007a1.56 1.56 0 0 1 0-2.133c.562-.59 1.47-.59 2.032 0l4.704 4.94L19.548 5.442c.561-.59 1.47-.59 2.031 0a1.56 1.56 0 0 1 0 2.134L10.171 19.557c-.28.295-.647.443-1.015.443"
})), Qt = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAdmit_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.019 26c-.515 0-1.03-.206-1.423-.618l-8.007-8.41a2.187 2.187 0 0 1 0-2.987 1.943 1.943 0 0 1 2.844 0l6.586 6.916L26.567 5.619a1.943 1.943 0 0 1 2.844 0 2.187 2.187 0 0 1 0 2.987L13.44 25.38c-.393.413-.906.62-1.421.62"
})), $t = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAiAssistant_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", {
	fill: "currentColor",
	clipPath: "url(#IconAiAssistant_16__a)"
}, /* @__PURE__ */ e.createElement("path", { d: "M5.143 12.017V6h1.016q.111 0 .222.025t.222.058L11 7.8a.7.7 0 0 1 .357.3.84.84 0 0 1 .135.45.74.74 0 0 1-.23.567.75.75 0 0 1-.532.216H9.063a.6.6 0 0 1-.119-.008.4.4 0 0 1-.103-.042l-1.016-.416-.206.65 1.222.45q.032.016.095.025Q9 10 9.048 10h4.349q.508 0 .889.383.38.384.38.95l-5.063 2zm-3.81 1.316V6h2.54v7.333zM12.7 8.667q0-1.535 1.173-2.6Q15.047 5 16.733 5q-1.687 0-2.86-1.067-1.173-1.065-1.173-2.6 0 1.535-1.173 2.6Q10.353 5 8.667 5q1.686 0 2.86 1.067 1.173 1.065 1.173 2.6" })), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconAiAssistant_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), en = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAiAssistant_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", {
	fill: "currentColor",
	clipPath: "url(#IconAiAssistant_24__a)"
}, /* @__PURE__ */ e.createElement("path", { d: "M7.714 18.025V9h1.524q.166 0 .333.037.168.038.334.088L16.5 11.7q.332.125.536.45.202.325.202.675 0 .525-.345.85t-.798.325h-2.5a1 1 0 0 1-.178-.012.6.6 0 0 1-.155-.063l-1.524-.625-.31.975 1.834.675q.048.026.143.038t.166.012h6.524q.762 0 1.334.575.57.574.571 1.425l-7.595 3zM2 20V9h3.81v11zM19.05 13q0-2.3 1.76-3.9t4.29-1.6q-2.53 0-4.29-1.6T19.05 2q0 2.3-1.76 3.9T13 7.5q2.53 0 4.29 1.6t1.76 3.9" })), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconAiAssistant_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})))), tn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAlert_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.656 2.557a1.554 1.554 0 0 1 2.692 0l5.385 9.327a1.554 1.554 0 0 1-1.347 2.332H2.617a1.554 1.554 0 0 1-1.346-2.331zm1.34 8.437c-.403 0-.73.33-.73.735 0 .406.327.734.73.735h.009a.733.733 0 0 0 .731-.735.734.734 0 0 0-.731-.735zm.009-5.879a.734.734 0 0 0-.732.735v2.94c0 .405.328.734.732.734a.733.733 0 0 0 .731-.734V5.85a.734.734 0 0 0-.731-.735"
})), nn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAlert_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M10.046 4.081c.87-1.508 3.049-1.508 3.92 0l7.84 13.578c.87 1.509-.219 3.395-1.96 3.395H4.166c-1.741 0-2.83-1.886-1.96-3.395zm1.953 12.282c-.588 0-1.065.48-1.065 1.07s.477 1.07 1.065 1.07h.01c.588 0 1.065-.479 1.065-1.07 0-.59-.477-1.07-1.065-1.07zm.01-8.558c-.587 0-1.064.48-1.064 1.07v4.28c0 .59.477 1.069 1.064 1.069s1.065-.479 1.065-1.07V8.876c0-.59-.477-1.07-1.065-1.07"
})), rn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAnalyticsChart_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.158 2a1 1 0 0 0-1 1v7.21a1 1 0 0 0 1 1h1.316a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM3.474 4.947a1 1 0 0 0-1 1v4.264a1 1 0 0 0 1 1h.947a1 1 0 0 0 1-1V5.946a1 1 0 0 0-1-1zm6.736 1a1 1 0 0 1 1-1h.948a1 1 0 0 1 1 1v4.264a1 1 0 0 1-1 1h-.947a1 1 0 0 1-1-1zm-8.473 6.369a.737.737 0 0 0 0 1.473h12.526a.737.737 0 0 0 0-1.473z",
	clipRule: "evenodd"
})), an = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAnalyticsChart_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.368 4a1 1 0 0 0-1 1v11.158a1 1 0 0 0 1 1h2.737a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM5.105 8.21a1 1 0 0 0-1 1v6.948a1 1 0 0 0 1 1h2.21a1 1 0 0 0 1-1V9.21a1 1 0 0 0-1-1zm10.053 1a1 1 0 0 1 1-1h2.21a1 1 0 0 1 1 1v6.948a1 1 0 0 1-1 1h-2.21a1 1 0 0 1-1-1zM3.053 18.738a1.053 1.053 0 0 0 0 2.105h17.894a1.053 1.053 0 0 0 0-2.105z",
	clipRule: "evenodd"
})), on = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAnalyticsProgress_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13.72 7.806c.19.326.61.438.937.25a.68.68 0 0 0 .251-.932L13.294 4.34a.687.687 0 0 0-.994-.213.68.68 0 0 0-.286.366l-1.658 5.082-1.807-3.721a.69.69 0 0 0-.72-.378.69.69 0 0 0-.548.405L5.566 9.794l-1.149-1.98a.69.69 0 0 0-.573-.34.69.69 0 0 0-.61.29l-2.111 3.02a.68.68 0 0 0 .171.95c.31.214.738.138.954-.171l1.509-2.158 1.255 2.163a.687.687 0 0 0 1.144.066.7.7 0 0 0 .22-.275l1.576-3.596 1.867 3.843a.69.69 0 0 0 .57.384.686.686 0 0 0 .771-.462l1.7-5.206z",
	clipRule: "evenodd"
})), sn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAnalyticsProgress_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M20.172 11.464a.98.98 0 1 0 1.697-.98L19.562 6.49a.98.98 0 0 0-1.42-.306.98.98 0 0 0-.407.526l-2.37 7.295-2.581-5.342a.98.98 0 0 0-1.029-.543.98.98 0 0 0-.782.581l-2.45 5.617-1.641-2.842a.98.98 0 0 0-.819-.49.98.98 0 0 0-.872.419l-3.015 4.333a.98.98 0 0 0 1.607 1.12L5.94 13.76l1.792 3.105a.98.98 0 0 0 1.634.095 1 1 0 0 0 .315-.395l2.252-5.163 2.666 5.517a.98.98 0 0 0 .816.551.98.98 0 0 0 1.101-.662l2.427-7.475z",
	clipRule: "evenodd"
})), cn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAndroidLogo_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.402 9.23a.615.615 0 1 1 0-1.23.615.615 0 0 1 0 1.23m-6.796 0a.615.615 0 1 1 0-1.23.615.615 0 0 1 0 1.23m7.016-3.704 1.229-2.128a.256.256 0 1 0-.443-.256l-1.244 2.155a7.6 7.6 0 0 0-3.16-.676 7.6 7.6 0 0 0-3.16.676L3.6 3.142a.256.256 0 1 0-.443.256l1.229 2.128a7.26 7.26 0 0 0-3.764 5.807h14.764a7.26 7.26 0 0 0-3.764-5.807"
})), ln = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAndroidLogo_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M17.103 14.844A.922.922 0 1 1 17.102 13a.922.922 0 0 1 0 1.844m-10.194 0a.922.922 0 1 1 0-1.843.922.922 0 0 1 0 1.843M17.433 9.29l1.843-3.192a.384.384 0 1 0-.664-.384l-1.866 3.233a11.4 11.4 0 0 0-4.74-1.014c-1.71 0-3.313.363-4.74 1.014L5.4 5.713a.383.383 0 1 0-.665.384L6.58 9.289C3.414 11.011 1.249 14.215.932 18H23.08c-.317-3.786-2.482-6.99-5.647-8.71"
})), un = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAppleLogo_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.952 10.974q-.279.644-.66 1.188-.523.743-.852 1.028-.509.469-1.093.482-.42 0-1.01-.241-.591-.24-1.088-.24-.52 0-1.118.24-.598.242-.966.254-.561.024-1.119-.495-.356-.31-.89-1.064a7.4 7.4 0 0 1-.94-1.87 6.8 6.8 0 0 1-.396-2.228q0-1.235.534-2.128.42-.717 1.12-1.132a3 3 0 0 1 1.512-.427q.445.001 1.17.272.724.272.928.273.153 0 1.03-.321.826-.297 1.398-.249 1.551.125 2.327 1.225-1.387.84-1.373 2.352.014 1.176.852 1.954a2.8 2.8 0 0 0 .85.558q-.102.296-.216.57m-2.37-9.328q0 .922-.673 1.719c-.54.631-1.193.996-1.901.938a2 2 0 0 1-.014-.232c0-.59.256-1.222.712-1.738q.342-.391.869-.652.526-.256.993-.281.014.123.013.246"
})), dn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAppleLogo_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M19.264 16.428a9.8 9.8 0 0 1-.968 1.74q-.764 1.087-1.247 1.506-.745.686-1.602.706-.615 0-1.48-.354-.866-.352-1.593-.352-.763 0-1.638.352-.877.355-1.416.372-.822.036-1.638-.724-.522-.455-1.304-1.56-.84-1.18-1.38-2.739-.578-1.684-.578-3.264 0-1.81.783-3.118.615-1.05 1.64-1.659a4.4 4.4 0 0 1 2.215-.625q.652 0 1.715.399 1.06.399 1.36.4.223 0 1.507-.471 1.211-.436 2.05-.364 2.272.183 3.408 1.795-2.031 1.232-2.01 3.444.018 1.724 1.247 2.863.556.528 1.247.818-.15.435-.318.834M15.79 2.76q-.001 1.35-.985 2.519c-.79.925-1.748 1.46-2.785 1.375A3 3 0 0 1 12 6.313c0-.865.376-1.79 1.044-2.546a4 4 0 0 1 1.272-.955q.771-.375 1.456-.412.02.18.019.36"
})), fn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowCornerDown_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1.875 1c.483 0 .875.392.875.875v5.011c0 .508.215 1.008.62 1.386a2.3 2.3 0 0 0 1.568.603h7.075L9.13 5.994a.875.875 0 0 1 1.238-1.238l4.375 4.375a.875.875 0 0 1 0 1.238l-4.375 4.375a.875.875 0 0 1-1.238-1.238l2.882-2.881H4.938c-1.027 0-2.021-.38-2.764-1.075A3.65 3.65 0 0 1 1 6.886V1.875C1 1.392 1.392 1 1.875 1",
	clipRule: "evenodd"
})), pn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowCornerDown_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.125 3c.621 0 1.125.504 1.125 1.125v6.443c0 .653.277 1.296.797 1.782a2.96 2.96 0 0 0 2.016.775h9.096l-3.704-3.704a1.125 1.125 0 0 1 1.59-1.591l5.626 5.624c.439.44.439 1.152 0 1.592l-5.625 5.625a1.125 1.125 0 0 1-1.591-1.591l3.704-3.705H8.063c-1.32 0-2.599-.49-3.553-1.382A4.7 4.7 0 0 1 3 10.568V4.125C3 3.504 3.504 3 4.125 3",
	clipRule: "evenodd"
})), mn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowDown_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.433 8.327a.65.65 0 0 0-.817-.203L9 9.921V3a1 1 0 0 0-2 0v6.921L3.384 8.124a.65.65 0 0 0-.748 1.042l4.905 4.905a.65.65 0 0 0 .919 0l4.905-4.905a.65.65 0 0 0 .068-.839"
})), hn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowDown_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.79 12.408a.814.814 0 0 0-1.02-.253l-4.52 2.246V5.75a1.25 1.25 0 0 0-2.5 0v8.651l-4.52-2.246a.813.813 0 0 0-.936 1.302l6.13 6.132a.813.813 0 0 0 1.15 0l6.13-6.132a.81.81 0 0 0 .087-1.049"
})), gn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowLeft_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13 7H6.079l1.797-3.616a.65.65 0 0 0-1.042-.748L1.929 7.541a.65.65 0 0 0 0 .919l4.905 4.905a.65.65 0 0 0 1.042-.749L6.079 9H13a1 1 0 0 0 0-2"
})), _n = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowLeft_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.25 10.75H9.6l2.245-4.52a.813.813 0 0 0-1.302-.935l-6.132 6.131a.813.813 0 0 0 0 1.15l6.132 6.13a.812.812 0 0 0 1.302-.936L9.6 13.25h8.651a1.25 1.25 0 0 0 0-2.5"
})), vn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowLeftRegular_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m1.254 8.619 4.334 4.375a.86.86 0 0 0 1.225 0 .88.88 0 0 0 0-1.237L4.016 8.933h10.106A.88.88 0 0 0 15 8.046a.88.88 0 0 0-.878-.887H3.926l2.887-2.915a.88.88 0 0 0 0-1.237.86.86 0 0 0-1.225 0L1.254 7.382a.88.88 0 0 0 0 1.237",
	clipRule: "evenodd"
})), yn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowLeftRegular_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m4.29 12.707 4.953 5a.983.983 0 0 0 1.4 0 1.005 1.005 0 0 0 0-1.414l-3.196-3.227h11.55c.554 0 1.003-.454 1.003-1.013 0-.56-.45-1.014-1.004-1.014H7.343l3.3-3.332a1.005 1.005 0 0 0 0-1.414.983.983 0 0 0-1.4 0l-4.953 5a1.005 1.005 0 0 0 0 1.414",
	clipRule: "evenodd"
})), bn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowRight_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.071 7.541 9.166 2.636a.65.65 0 0 0-1.042.748L9.921 7H3a1 1 0 0 0 0 2h6.921l-1.797 3.616a.65.65 0 0 0 1.042.749l4.905-4.905a.65.65 0 0 0 0-.919"
})), xn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowRight_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m19.589 11.426-6.132-6.131a.814.814 0 0 0-1.302.936l2.246 4.52H5.75a1.249 1.249 0 1 0 0 2.499h8.651l-2.246 4.52a.813.813 0 0 0 1.302.936l6.132-6.131a.813.813 0 0 0 0-1.149"
})), Sn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowUp_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.364 6.834 8.459 1.929a.67.67 0 0 0-.919 0L2.636 6.834a.65.65 0 0 0 .748 1.042L7 6.079V13a1 1 0 0 0 2 0V6.079l3.616 1.797a.65.65 0 0 0 .748-1.042"
})), Cn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconArrowUp_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m18.705 10.543-6.13-6.132a.836.836 0 0 0-1.15 0l-6.13 6.132a.813.813 0 0 0 .935 1.302l4.52-2.246v8.651a1.25 1.25 0 0 0 2.5 0V9.599l4.52 2.246a.813.813 0 0 0 .935-1.302"
})), wn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAudioTransmission_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m11.614 10.318-.705-.704q.5-.466.784-1.103a3.3 3.3 0 0 0 .284-1.352q0-.716-.284-1.34a3.4 3.4 0 0 0-.784-1.092L11.614 4q.636.603 1.011 1.42.375.818.375 1.74 0 .92-.375 1.738a4.5 4.5 0 0 1-1.011 1.42m-1.455-1.454-.727-.728q.204-.192.33-.437.124-.245.124-.54t-.125-.54a1.6 1.6 0 0 0-.33-.437l.728-.727q.364.33.568.767.205.437.205.937t-.205.938a2.4 2.4 0 0 1-.568.767m-3.523.113q-.75 0-1.284-.534a1.75 1.75 0 0 1-.534-1.284q0-.75.534-1.284a1.75 1.75 0 0 1 1.284-.534q.75 0 1.284.534.535.534.535 1.284T7.92 8.443a1.75 1.75 0 0 1-1.284.534M3 12.614V11.34q0-.375.193-.705a1.26 1.26 0 0 1 .534-.5 7 7 0 0 1 1.307-.5 6 6 0 0 1 1.602-.204q.876 0 1.603.204.727.205 1.306.5.342.17.534.5.195.33.194.705v1.273z"
})), Tn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAudioTransmission_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m17.782 15.11-1.128-1.128a5.4 5.4 0 0 0 1.255-1.764q.455-1.018.455-2.163 0-1.146-.455-2.146a5.4 5.4 0 0 0-1.255-1.745L17.783 5A7.3 7.3 0 0 1 19.4 7.273q.6 1.309.6 2.782 0 1.472-.6 2.781a7.3 7.3 0 0 1-1.618 2.273m-2.328-2.328-1.163-1.164q.327-.31.527-.7t.2-.863-.2-.864a2.6 2.6 0 0 0-.527-.7l1.163-1.164q.582.527.91 1.228.327.699.327 1.5 0 .8-.327 1.5a3.8 3.8 0 0 1-.91 1.227m-5.636.182q-1.2 0-2.054-.855a2.8 2.8 0 0 1-.855-2.054q0-1.2.855-2.055a2.8 2.8 0 0 1 2.054-.855q1.2 0 2.055.855.854.855.854 2.055t-.854 2.054-2.055.855M4 18.782v-2.037q0-.6.31-1.127.308-.527.854-.8a11.4 11.4 0 0 1 2.09-.8q1.164-.327 2.564-.327t2.564.327 2.09.8q.547.273.855.8.31.528.31 1.127v2.037z"
})), En = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAuthenticated_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.584 12.209Q5.168 14.387 7.6 15q2.432-.613 4.016-2.791Q13.2 10.029 13.2 7.37V3.1L7.6 1 2 3.1v4.27q0 2.66 1.584 4.839m6.332-6.091a.402.402 0 1 1 .569.569L7.289 9.882a.4.4 0 0 1-.57 0L5.119 8.28a.402.402 0 1 1 .569-.569L7.004 9.03z",
	clipRule: "evenodd"
})), Dn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAuthenticated_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.41 16.81Q9.22 19.3 12 20q2.78-.7 4.59-3.19t1.81-5.53V6.4L12 4 5.6 6.4v4.88q0 3.04 1.81 5.53m7.472-7.845a.563.563 0 1 1 .797.796l-4.474 4.474a.563.563 0 0 1-.797 0l-2.243-2.243a.563.563 0 1 1 .797-.797l1.844 1.845z",
	clipRule: "evenodd"
})), On = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconAuthenticated_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.88 22.413q2.413 3.32 6.12 4.254 3.707-.934 6.12-4.254t2.413-7.373V8.533L16 5.333l-8.533 3.2v6.507q0 4.053 2.413 7.373m9.963-10.46a.75.75 0 1 1 1.062 1.062l-5.966 5.965a.75.75 0 0 1-1.062 0l-2.99-2.99a.75.75 0 1 1 1.062-1.063l2.46 2.46z",
	clipRule: "evenodd"
})), kn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlur_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.368 9.842a.35.35 0 0 1-.257-.11.353.353 0 0 1 0-.516.353.353 0 0 1 .515 0 .353.353 0 0 1 0 .516.35.35 0 0 1-.258.11m0-2.947a.35.35 0 0 1-.257-.11.353.353 0 0 1 0-.517.353.353 0 0 1 .515 0 .353.353 0 0 1 0 .516.35.35 0 0 1-.258.11m2.21 6.263a.71.71 0 0 1-.524-.212.71.71 0 0 1-.212-.525q0-.313.212-.525a.71.71 0 0 1 .525-.212q.313 0 .525.212a.71.71 0 0 1 .212.525q0 .314-.212.525a.71.71 0 0 1-.525.212m.001-2.947a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.313 0 .525.212a.71.71 0 0 1 .212.525q0 .312-.212.525a.71.71 0 0 1-.525.211m0-2.948a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.312.212-.525a.71.71 0 0 1 .525-.212q.313 0 .525.212a.71.71 0 0 1 .212.525q0 .314-.212.525a.71.71 0 0 1-.525.212m0-2.947a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.313 0 .525.212a.71.71 0 0 1 .212.525q0 .313-.212.525a.71.71 0 0 1-.525.212m2.947 8.842a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.313.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .314-.212.525a.71.71 0 0 1-.525.212m0-8.842a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .313-.212.525a.71.71 0 0 1-.525.212m0 10.684a.35.35 0 0 1-.258-.11.354.354 0 0 1 0-.516.353.353 0 0 1 .516 0 .353.353 0 0 1 0 .515.35.35 0 0 1-.258.111m0-13.263a.35.35 0 0 1-.258-.11.353.353 0 0 1 0-.516.353.353 0 0 1 .516 0 .353.353 0 0 1 0 .515.35.35 0 0 1-.258.11m2.948 11.42a.71.71 0 0 1-.525-.21.71.71 0 0 1-.212-.526q0-.313.212-.525a.71.71 0 0 1 .525-.212q.312 0 .525.212a.71.71 0 0 1 .211.525q0 .314-.211.525a.71.71 0 0 1-.525.212m0-8.841a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.312 0 .525.212a.71.71 0 0 1 .211.525q0 .313-.211.525a.71.71 0 0 1-.525.212m0 10.684a.35.35 0 0 1-.258-.11.354.354 0 0 1 0-.516.35.35 0 0 1 .258-.11q.147 0 .258.11a.353.353 0 0 1 0 .515.35.35 0 0 1-.258.111m0-13.263a.35.35 0 0 1-.258-.11.353.353 0 0 1 0-.516.353.353 0 0 1 .516 0 .353.353 0 0 1 0 .515.35.35 0 0 1-.258.11m2.947 11.42a.71.71 0 0 1-.525-.21.71.71 0 0 1-.212-.526q0-.313.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .314-.212.525a.71.71 0 0 1-.525.212m0-2.947a.71.71 0 0 1-.525-.211.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .312-.212.525a.71.71 0 0 1-.525.211m0-2.947a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.312.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .314-.212.525a.71.71 0 0 1-.525.212m0-2.947a.71.71 0 0 1-.525-.212.71.71 0 0 1-.212-.525q0-.314.212-.525a.71.71 0 0 1 .525-.212q.314 0 .525.212a.71.71 0 0 1 .212.525q0 .313-.212.525a.71.71 0 0 1-.525.212m2.21 5.526a.35.35 0 0 1-.257-.11.35.35 0 0 1-.11-.258q0-.149.11-.258a.353.353 0 0 1 .515 0q.111.11.111.258a.35.35 0 0 1-.11.258.35.35 0 0 1-.258.11m0-2.947a.35.35 0 0 1-.257-.11.353.353 0 0 1 0-.516.353.353 0 0 1 .516 0 .353.353 0 0 1 0 .515.35.35 0 0 1-.258.11m-9.578 4.052v-.405q0-.957.92-1.381A4.8 4.8 0 0 1 8 8.737a4.8 4.8 0 0 1 2.026.424q.921.424.921 1.381v.405zM8 8a1.42 1.42 0 0 1-1.04-.433 1.42 1.42 0 0 1-.434-1.04q0-.609.433-1.041A1.42 1.42 0 0 1 8 5.053q.608 0 1.04.433.434.432.434 1.04T9.04 7.567A1.42 1.42 0 0 1 8 8"
})), An = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlur_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.579 14.895a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.233.174-.405a.56.56 0 0 1 .405-.174q.232 0 .405.174.174.173.174.405t-.174.405a.56.56 0 0 1-.405.174m0-4.632a.56.56 0 0 1-.405-.174A.56.56 0 0 1 1 9.685q0-.232.174-.405a.56.56 0 0 1 .405-.174q.232 0 .405.174.174.173.174.405t-.174.406a.56.56 0 0 1-.405.173m3.474 9.842a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.332q.492 0 .825.332.333.333.333.825t-.333.825a1.12 1.12 0 0 1-.825.333m0-4.631a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0-4.632a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0-4.631a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m4.631 13.894a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.332q.492 0 .825.332.333.333.333.825t-.333.825a1.12 1.12 0 0 1-.825.333m0-13.894a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0 16.789a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.232.174-.405a.56.56 0 0 1 .405-.174q.232 0 .406.174.173.173.173.405t-.174.405a.56.56 0 0 1-.405.174m0-20.842a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.232.174-.405A.56.56 0 0 1 9.684 1q.232 0 .406.174.173.172.173.405 0 .232-.174.405a.56.56 0 0 1-.405.174m4.632 17.947a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.332q.492 0 .825.332.333.333.333.825t-.333.825a1.12 1.12 0 0 1-.825.333m0-13.894a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.333-.825q0-.492.333-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0 16.789a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.232.174-.405a.56.56 0 0 1 .405-.174q.232 0 .405.174.174.173.174.405t-.174.405a.56.56 0 0 1-.405.174m0-20.842a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.232.174-.405A.56.56 0 0 1 14.316 1q.232 0 .405.174.174.172.174.405 0 .232-.174.405a.56.56 0 0 1-.405.174m4.631 17.947a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.332-.825q0-.492.332-.825a1.12 1.12 0 0 1 .825-.332q.492 0 .825.332.333.333.333.825t-.333.825a1.12 1.12 0 0 1-.825.333m0-4.631a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.332-.825q0-.492.332-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0-4.632a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.332-.825q0-.492.332-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m0-4.631a1.12 1.12 0 0 1-.825-.333 1.12 1.12 0 0 1-.332-.825q0-.492.332-.825a1.12 1.12 0 0 1 .825-.333q.492 0 .825.333t.333.825-.333.825a1.12 1.12 0 0 1-.825.333m3.474 8.684a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.233.174-.405a.56.56 0 0 1 .405-.174q.232 0 .405.174.174.173.174.405t-.174.405a.56.56 0 0 1-.405.174m0-4.632a.56.56 0 0 1-.405-.174.56.56 0 0 1-.174-.405q0-.232.174-.405a.56.56 0 0 1 .405-.174q.232 0 .405.174.174.173.174.405t-.174.406a.56.56 0 0 1-.405.173M7.368 16.632v-.637q0-1.506 1.448-2.171 1.447-.666 3.184-.666t3.184.666q1.448.666 1.448 2.17v.638zM12 12a2.23 2.23 0 0 1-1.636-.68 2.23 2.23 0 0 1-.68-1.636q0-.956.68-1.635A2.23 2.23 0 0 1 12 7.369a2.23 2.23 0 0 1 1.636.68q.68.68.68 1.635a2.23 2.23 0 0 1-.68 1.636A2.23 2.23 0 0 1 12 12"
})), jn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlur_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M4.632 19.158a.6.6 0 0 1-.443-.19.6.6 0 0 1-.189-.442q0-.252.19-.442a.6.6 0 0 1 .442-.19q.252 0 .442.19t.19.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19m0-5.053a.6.6 0 0 1-.443-.19.6.6 0 0 1-.189-.441q0-.253.19-.442a.6.6 0 0 1 .442-.19q.252 0 .442.19.19.189.19.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19M8.42 24.842q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0-5.052q-.537 0-.9-.364a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.364m0-5.053q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.364.9.364.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0-5.053q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m5.053 15.158q-.537 0-.9-.363a1.22 1.22 0 0 1-.364-.9q0-.537.364-.9.363-.363.9-.363t.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0-15.158q-.537 0-.9-.363a1.22 1.22 0 0 1-.364-.9q0-.537.364-.9.363-.363.9-.363t.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0 18.316a.6.6 0 0 1-.442-.19.6.6 0 0 1-.19-.442q0-.252.19-.442a.6.6 0 0 1 .442-.19q.252 0 .442.19t.19.442a.6.6 0 0 1-.19.443.6.6 0 0 1-.442.189m0-22.737a.6.6 0 0 1-.442-.19.6.6 0 0 1-.19-.441q0-.253.19-.443A.6.6 0 0 1 13.474 4q.252 0 .442.19.19.189.19.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19m5.052 19.58q-.537 0-.9-.364a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.364.9-.364.9a1.22 1.22 0 0 1-.9.363m0-15.159q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.364.9-.364.9a1.22 1.22 0 0 1-.9.363m0 18.316a.6.6 0 0 1-.442-.19.6.6 0 0 1-.19-.442q0-.252.19-.442a.6.6 0 0 1 .442-.19q.253 0 .442.19.19.19.19.442a.6.6 0 0 1-.19.443.6.6 0 0 1-.442.189m0-22.737a.6.6 0 0 1-.442-.19.6.6 0 0 1-.19-.441q0-.253.19-.443A.6.6 0 0 1 18.526 4q.253 0 .442.19.19.189.19.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19m5.053 19.58q-.537 0-.9-.364a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0-5.053q-.537 0-.9-.364a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.364m0-5.053q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.364.9.364.363.9-.363.9a1.22 1.22 0 0 1-.9.363m0-5.053q-.537 0-.9-.363a1.22 1.22 0 0 1-.363-.9q0-.537.363-.9t.9-.363.9.363.363.9-.363.9a1.22 1.22 0 0 1-.9.363m3.79 9.474a.6.6 0 0 1-.443-.19.6.6 0 0 1-.19-.442q0-.252.19-.442a.6.6 0 0 1 .442-.19q.253 0 .443.19.189.19.189.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19m0-5.053a.6.6 0 0 1-.443-.19.6.6 0 0 1-.19-.441q0-.253.19-.442a.6.6 0 0 1 .442-.19q.253 0 .443.19.189.189.189.442a.6.6 0 0 1-.19.442.6.6 0 0 1-.442.19m-16.422 6.948v-.695q0-1.642 1.58-2.369 1.578-.726 3.473-.726t3.474.726 1.579 2.369v.695zM16 16q-1.043 0-1.784-.742a2.43 2.43 0 0 1-.742-1.784q0-1.043.742-1.784A2.43 2.43 0 0 1 16 10.947q1.043 0 1.784.743.742.741.742 1.784 0 1.042-.742 1.784A2.43 2.43 0 0 1 16 16"
})), Mn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurLight_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_16__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_16__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 2.333,
	cy: 2.5,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.083,
	cy: 2.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 2.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.917,
	cy: 2.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurLight_16__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 13.667,
	cy: 2.5,
	r: .333,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.333,
	cy: 10.667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 8q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177q0-.687.49-1.177T8 4.666t1.177.49.49 1.177-.49 1.177T8 8m-2.5 3.333a.8.8 0 0 1-.588-.244.8.8 0 0 1-.245-.589v-.333q0-.355.182-.652.183-.296.484-.453.646-.322 1.313-.484a5.74 5.74 0 0 1 2.708 0q.667.163 1.313.484.302.158.484.453.182.298.182.652v.333q0 .344-.244.589a.8.8 0 0 1-.589.244z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.333,
	cy: 13.5,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.083,
	cy: 13.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 13.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.917,
	cy: 13.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.667,
	cy: 13.5,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.5,
	cy: 5.167,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 13.5 5.167)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.5,
	cy: 7.833,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 13.5 7.833)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.5,
	cy: 5.167,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 2.5 5.167)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.5,
	cy: 7.833,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 2.5 7.833)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.5,
	cy: 10.5,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 13.5 10.5)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.5,
	cy: 10.5,
	r: .5,
	fill: "currentColor",
	transform: "rotate(90 2.5 10.5)"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: .333,
	cy: 8,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: .333,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 15.667,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 15.667,
	cy: 8,
	r: .333,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_16__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2 2h12v12H2z"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurLight_16__c",
	width: 6,
	height: 6,
	x: 10.667,
	y: 2.167,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 2.667 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 1.333 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_393"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_393",
	result: "shape"
})))), Nn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurLight_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_24__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_24__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 3.5,
	cy: 3.75,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 7.625,
	cy: 3.75,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 3.75,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16.375,
	cy: 3.75,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurLight_24__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 20.5,
	cy: 3.75,
	r: .5,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 16,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 12a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 9.5 9.5q0-1.03.734-1.766A2.4 2.4 0 0 1 12 7q1.032 0 1.766.734.734.735.734 1.766t-.734 1.766T12 12m-3.75 5q-.516 0-.883-.367A1.2 1.2 0 0 1 7 15.75v-.5q0-.531.274-.977.273-.444.726-.68a9.3 9.3 0 0 1 1.969-.726 8.6 8.6 0 0 1 4.062 0 9.3 9.3 0 0 1 1.969.727q.453.234.726.68.274.444.274.976v.5q0 .516-.367.883-.368.367-.883.367z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 3.5,
	cy: 20.25,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 7.625,
	cy: 20.25,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 20.25,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16.375,
	cy: 20.25,
	r: .75,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 20.5,
	cy: 20.25,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 20.25,
	cy: 7.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 20.25 7.75)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 20.25,
	cy: 11.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 20.25 11.75)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 3.75,
	cy: 7.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 3.75 7.75)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 3.75,
	cy: 11.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 3.75 11.75)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 20.25,
	cy: 15.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 20.25 15.75)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 3.75,
	cy: 15.75,
	r: .75,
	fill: "currentColor",
	transform: "rotate(90 3.75 15.75)"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: .5,
	cy: 12,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: .5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 23.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 23.5,
	cy: 12,
	r: .5,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_24__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M3 3h18v18H3z"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurLight_24__c",
	width: 9,
	height: 9,
	x: 16,
	y: 3.25,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_341"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_341",
	result: "shape"
})))), Pn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurLight_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_32__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurLight_32__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 4.667,
	cy: 5,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.167,
	cy: 5,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 5,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 21.833,
	cy: 5,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurLight_32__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 27.333,
	cy: 5,
	r: .667,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.667,
	cy: 21.333,
	r: 1.333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M16 16a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.353q0-1.376.98-2.354A3.2 3.2 0 0 1 16 9.333a3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .98 2.354 3.2 3.2 0 0 1-.98 2.354A3.2 3.2 0 0 1 16 16m-5 6.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 9.333 21v-.667q0-.708.365-1.302t.969-.906q1.29-.645 2.625-.97A11.5 11.5 0 0 1 16 16.834q1.376 0 2.708.323 1.334.323 2.625.969.604.312.969.906t.365 1.302V21q0 .687-.49 1.177t-1.177.49z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.667,
	cy: 27,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.167,
	cy: 27,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 27,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 21.833,
	cy: 27,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 27.333,
	cy: 27,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 27,
	cy: 10.333,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 27 10.333)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 27,
	cy: 15.667,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 27 15.667)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5,
	cy: 10.333,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 5 10.333)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5,
	cy: 15.667,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 5 15.667)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 27,
	cy: 21,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 27 21)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5,
	cy: 21,
	r: 1,
	fill: "currentColor",
	transform: "rotate(90 5 21)"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: .667,
	cy: 16,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: .667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 31.333,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 31.333,
	cy: 16,
	r: .667,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_32__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h32v32H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurLight_32__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M4 4h24v24H4z"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurLight_32__c",
	width: 12,
	height: 12,
	x: 21.333,
	y: 4.333,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_367"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_367",
	result: "shape"
})))), Fn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurStrong_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_16__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_16__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 2.333,
	cy: 2.833,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.917,
	cy: 2.833,
	r: .833,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 2.833,
	r: .833,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 11.083,
	cy: 2.833,
	r: .833,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_16__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 13.667,
	cy: 2.833,
	r: .333,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.333,
	cy: 10.667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 8q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177q0-.687.49-1.177T8 4.666t1.177.49.49 1.177-.49 1.177T8 8m-2.5 3.333a.8.8 0 0 1-.588-.244.8.8 0 0 1-.245-.589v-.333q0-.355.182-.652.183-.296.484-.453.646-.322 1.313-.484a5.74 5.74 0 0 1 2.708 0q.667.163 1.313.484.302.158.484.453.182.298.182.652v.333q0 .344-.244.589a.8.8 0 0 1-.589.244z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.333,
	cy: 13.333,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5,
	cy: 13.333,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 13.333,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 11,
	cy: 13.333,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.667,
	cy: 13.333,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.167,
	cy: 5.5,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 13.167 5.5)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.167,
	cy: 8.167,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 13.167 8.167)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.833,
	cy: 5.5,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 2.833 5.5)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.833,
	cy: 8.167,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 2.833 8.167)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 13.167,
	cy: 10.833,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 13.167 10.833)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 2.833,
	cy: 10.833,
	r: .833,
	fill: "currentColor",
	transform: "rotate(90 2.833 10.833)"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: .333,
	cy: 8,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: .333,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 15.667,
	r: .333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 15.667,
	cy: 8,
	r: .333,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_16__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2 2h12v12H2z"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_16__c",
	width: 6,
	height: 6,
	x: 10.667,
	y: 2.5,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 2.667 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 1.333 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_288"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_288",
	result: "shape"
})))), In = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurStrong_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_24__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_24__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 3.5,
	cy: 4.25,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 7.375,
	cy: 4.25,
	r: 1.25,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 4.25,
	r: 1.25,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16.625,
	cy: 4.25,
	r: 1.25,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_24__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 20.5,
	cy: 4.25,
	r: .5,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 8,
	cy: 16,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 12a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 9.5 9.5q0-1.03.734-1.766A2.4 2.4 0 0 1 12 7q1.032 0 1.766.734.734.735.734 1.766t-.734 1.766T12 12m-3.75 5q-.516 0-.883-.367A1.2 1.2 0 0 1 7 15.75v-.5q0-.531.274-.977.273-.444.726-.68a9.3 9.3 0 0 1 1.969-.726 8.6 8.6 0 0 1 4.062 0 9.3 9.3 0 0 1 1.969.727q.453.234.726.68.274.444.274.976v.5q0 .516-.367.883-.368.367-.883.367z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 3.5,
	cy: 20,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 7.5,
	cy: 20,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 20,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16.5,
	cy: 20,
	r: 1,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 20.5,
	cy: 20,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 19.75,
	cy: 8.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 19.75 8.25)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 19.75,
	cy: 12.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 19.75 12.25)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.25,
	cy: 8.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 4.25 8.25)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.25,
	cy: 12.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 4.25 12.25)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 19.75,
	cy: 16.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 19.75 16.25)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.25,
	cy: 16.25,
	r: 1.25,
	fill: "currentColor",
	transform: "rotate(90 4.25 16.25)"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: .5,
	cy: 12,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: .5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 12,
	cy: 23.5,
	r: .5,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 23.5,
	cy: 12,
	r: .5,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_24__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M3 3h18v18H3z"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_24__c",
	width: 9,
	height: 9,
	x: 16,
	y: 3.75,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_262"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_262",
	result: "shape"
})))), Ln = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundBlurStrong_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_32__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundBlurStrong_32__b)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 4.667,
	cy: 5.667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 9.833,
	cy: 5.667,
	r: 1.667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 5.667,
	r: 1.667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 22.167,
	cy: 5.667,
	r: 1.667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_32__c)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 27.333,
	cy: 5.667,
	r: .667,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("circle", {
	cx: 10.667,
	cy: 21.333,
	r: 1.333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M16 16a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.353q0-1.376.98-2.354A3.2 3.2 0 0 1 16 9.333a3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .98 2.354 3.2 3.2 0 0 1-.98 2.354A3.2 3.2 0 0 1 16 16m-5 6.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 9.333 21v-.667q0-.708.365-1.302t.969-.906q1.29-.645 2.625-.97A11.5 11.5 0 0 1 16 16.834q1.376 0 2.708.323 1.334.323 2.625.969.604.312.969.906t.365 1.302V21q0 .687-.49 1.177t-1.177.49z"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 4.667,
	cy: 26.667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 10,
	cy: 26.667,
	r: 1.333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 26.667,
	r: 1.333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 22,
	cy: 26.667,
	r: 1.333,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 27.333,
	cy: 26.667,
	r: .667,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 26.333,
	cy: 11,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 26.333 11)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 26.333,
	cy: 16.333,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 26.333 16.333)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.667,
	cy: 11,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 5.667 11)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.667,
	cy: 16.333,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 5.667 16.333)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 26.333,
	cy: 21.667,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 26.333 21.667)"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 5.667,
	cy: 21.667,
	r: 1.667,
	fill: "currentColor",
	transform: "rotate(90 5.667 21.667)"
})), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_32__d)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 1,
	cy: 16,
	r: 1,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_32__e)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 1,
	r: 1,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_32__f)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 31,
	cy: 16,
	r: 1,
	fill: "currentColor"
})), /* @__PURE__ */ e.createElement("g", { filter: "url(#IconBackgroundBlurStrong_32__g)" }, /* @__PURE__ */ e.createElement("circle", {
	cx: 16,
	cy: 31,
	r: 1,
	fill: "currentColor"
}))), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_32__c",
	width: 12,
	height: 12,
	x: 21.333,
	y: 5,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_314"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_314",
	result: "shape"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_32__d",
	width: 12.667,
	height: 12.667,
	x: -5.333,
	y: 15,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_314"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_314",
	result: "shape"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_32__e",
	width: 12.667,
	height: 12.667,
	x: 9.667,
	y: 0,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_314"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_314",
	result: "shape"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_32__f",
	width: 12.667,
	height: 12.667,
	x: 24.667,
	y: 15,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_314"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_314",
	result: "shape"
})), /* @__PURE__ */ e.createElement("filter", {
	id: "IconBackgroundBlurStrong_32__g",
	width: 12.667,
	height: 12.667,
	x: 9.667,
	y: 30,
	colorInterpolationFilters: "sRGB",
	filterUnits: "userSpaceOnUse"
}, /* @__PURE__ */ e.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ e.createElement("feColorMatrix", {
	in: "SourceAlpha",
	result: "hardAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /* @__PURE__ */ e.createElement("feOffset", { dy: 5.333 }), /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2.667 }), /* @__PURE__ */ e.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ e.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_6106_314"
}), /* @__PURE__ */ e.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_6106_314",
	result: "shape"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_32__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h32v32H0z"
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundBlurStrong_32__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M4 4h24v24H4z"
})))), Rn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundReplace_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundReplace_16__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundReplace_16__b)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 9.038a2.78 2.78 0 0 0 2.778-2.778A2.78 2.78 0 0 0 8 3.483 2.78 2.78 0 0 0 5.222 6.26 2.78 2.78 0 0 0 8 9.038"
})), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m15.417-8.08 1.238 1.238-9.498 9.498a3.69 3.69 0 0 0-2.77 2.77L-6.2 16.013l-1.238-1.237zM2.766 9.877 4.71 7.932A3.7 3.7 0 0 0 5.866 9.25l-.001.002c-1.198.113-2.226.325-3.1.624m-3.952 3.95-6.203 6.204 1.237 1.238 5.46-5.46a2.04 2.04 0 0 1-.54-1.74q.022-.124.046-.241m3.447 2.739.797.796.797-.796zm4.422 0L5.4 17.848l1.237 1.237 2.521-2.52zM15 10.723a7.6 7.6 0 0 0-1.663-.812L24.97-1.722l1.238 1.237zm-3.014 5.842L-5.059 33.61l1.237 1.238 18.283-18.283zm5.202-2.727a4.7 4.7 0 0 0-.571-1.506 4 4 0 0 0-.159-.24L28.755-.203l1.237 1.238zm-6.131-4.475a17 17 0 0 0-.973-.116 3.67 3.67 0 0 0 1.563-2.949L22.24-4.296l1.237 1.238zM9.664 2.977c.527.275.98.673 1.319 1.156L21.249-6.133 20.01-7.37zm.214-10.82 1.238 1.237-17.234 17.233-1.237-1.237zm20.114 14.58L28.755 5.5-5.06 39.314l1.237 1.237z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.018 11.705c-.8-.855-2.306-1.49-5.018-1.49-2.735 0-4.244.646-5.038 1.512-.213.232-.579.603-.729 1.564a.837.837 0 0 0 .827.959h9.88a.837.837 0 0 0 .827-.96c-.151-.962-.519-1.34-.75-1.585"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundReplace_16__a" }, /* @__PURE__ */ e.createElement("rect", {
	width: 13.333,
	height: 13.333,
	x: 1.333,
	y: 1.75,
	fill: "currentColor",
	rx: .833
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundReplace_16__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.333 1.75h13.333v13.333H1.333z"
})))), zn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackgroundReplace_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundReplace_24__a)" }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBackgroundReplace_24__b)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 13.557a4.17 4.17 0 0 0 4.167-4.167A4.17 4.17 0 0 0 12 5.225 4.17 4.17 0 0 0 7.834 9.39a4.17 4.17 0 0 0 4.168 4.167"
})), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m16.084-7.204 1.237 1.237-22.855 22.855-1.237-1.237zm-5.54.236 1.238 1.237L-5.45 11.502l-1.237-1.237zm11.372 1.71-1.238-1.237L9.963 4.22a5.5 5.5 0 0 1 2.79-.316zM-6.722 20.907 6.817 7.366a5.5 5.5 0 0 0-.315 2.79L-5.485 22.143zm11.634-6.331 2.342-2.342c.308.502.695.952 1.142 1.332l-.4.4a20.5 20.5 0 0 0-3.084.61m.334 10.272-9.638 9.639 1.237 1.237L7.721 24.847zm5.703 0L-4.392 40.19l1.237 1.237 16.58-16.579zm11.36-8.885a11 11 0 0 0-1.636-.838l8.749-8.749 1.237 1.238zm-4.092-1.611a22 22 0 0 0-2.103-.372L29.422.672l1.237 1.237zm-.746-4.992q0 .229-.019.453L26.875.39 25.637-.847l-8.452 8.452c.185.55.286 1.14.286 1.754m-2.64-4.703c.503.308.953.694 1.332 1.142l7.982-7.981-1.238-1.238z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M19.526 17.558c-1.198-1.283-3.459-2.235-7.526-2.235-4.102 0-6.366.968-7.557 2.267-.32.349-.868.905-1.093 2.346a1.256 1.256 0 0 0 1.24 1.439h14.82c.762 0 1.357-.685 1.24-1.439-.226-1.444-.777-2.01-1.124-2.378"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundReplace_24__a" }, /* @__PURE__ */ e.createElement("rect", {
	width: 20,
	height: 20,
	x: 2,
	y: 2.625,
	fill: "currentColor",
	rx: .833
})), /* @__PURE__ */ e.createElement("clipPath", { id: "IconBackgroundReplace_24__b" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2 2.625h20v20H2z"
})))), Bn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackspace_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.87 3.174c.163-.11.36-.174.57-.174h8.526C14.538 3 15 3.47 15 4.05v8.4c0 .58-.463 1.05-1.033 1.05H5.438c-.147 0-.288-.032-.415-.089a1 1 0 0 1-.1-.042c-.237-.12-.652-.604-.952-.954l-.082-.096-2.66-3.347a1.06 1.06 0 0 1-.012-1.304L3.89 4.18c.087-.089.178-.198.274-.314.202-.245.43-.52.706-.693m6.923 7.62a.7.7 0 0 1-.99 0L9.15 9.138l-1.654 1.654a.7.7 0 1 1-.99-.99L8.159 8.15 6.505 6.495a.7.7 0 1 1 .99-.99l1.654 1.654 1.654-1.654a.7.7 0 1 1 .99.99L10.14 8.149l1.654 1.654a.7.7 0 0 1 0 .99",
	clipRule: "evenodd"
})), Vn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackspace_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.528 5.249c.234-.157.514-.249.815-.249h12.18C21.34 5 22 5.672 22 6.5v12c0 .828-.661 1.5-1.477 1.5H8.343c-.212 0-.413-.045-.595-.127a1 1 0 0 1-.143-.06c-.337-.172-.93-.863-1.359-1.363l-.118-.137-3.8-4.781a1.52 1.52 0 0 1-.017-1.864l3.817-4.98c.126-.128.255-.284.392-.45.29-.35.613-.742 1.008-.99m9.89 3.33a1 1 0 0 1 0 1.414l-2.362 2.363 2.363 2.363a1 1 0 0 1-1.414 1.414l-2.363-2.363-2.363 2.363a1 1 0 0 1-1.415-1.414l2.363-2.363-2.363-2.363a1 1 0 1 1 1.415-1.414l2.363 2.363 2.363-2.363a1 1 0 0 1 1.414 0",
	clipRule: "evenodd"
})), Hn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackToTop_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1.656 1a.656.656 0 1 0 0 1.313h12.688a.656.656 0 0 0 0-1.313zM3.84 7.685l3.663-3.628a.737.737 0 0 1 1.036 0l3.663 3.628a.72.72 0 0 1 0 1.026.737.737 0 0 1-1.036 0L8.802 6.37l-.036 7.864c0 .406-.289.766-.699.766s-.74-.36-.74-.766v-7.95L4.876 8.71a.737.737 0 0 1-1.036 0 .72.72 0 0 1 0-1.026",
	clipRule: "evenodd"
})), Un = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBackToTop_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2.938 2a.937.937 0 1 0 0 1.875h18.125a.937.937 0 1 0 0-1.875zm3.119 9.55 5.233-5.183a1.05 1.05 0 0 1 1.48 0l5.233 5.183c.41.406.41 1.06 0 1.466s-1.07.406-1.48 0l-3.377-3.345-.052 11.235c0 .58-.412 1.094-.998 1.094s-1.057-.514-1.057-1.094V9.548l-3.502 3.468c-.41.406-1.07.406-1.48 0a1.03 1.03 0 0 1 0-1.466",
	clipRule: "evenodd"
})), Wn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBandwidth_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconBandwidth_16__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15.9 8.726C15.317 5.012 12.04 2 8 2a8 8 0 0 0-8 8c0 1.243.288 2.417.796 3.466a.98.98 0 0 0 .888.534h12.633a.98.98 0 0 0 .887-.534 7.97 7.97 0 0 0 .696-4.74m-3.206-.757-3.971 3.912A1.51 1.51 0 1 1 7.016 9.44l5.038-2.386c.576-.273 1.094.468.64.915"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconBandwidth_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), Gn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBandwidth_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M22.862 12.748c-.758-4.828-4.786-8.661-9.646-9.182C6.596 2.855 1 8.024 1 14.5c0 1.709.396 3.324 1.094 4.766.223.46.71.734 1.221.734h17.371c.511 0 .997-.274 1.22-.734a10.95 10.95 0 0 0 .956-6.518m-4.408-1.04-5.46 5.379a2.07 2.07 0 0 1-1.81.567 2.07 2.07 0 0 1-1.35-.857 2.07 2.07 0 0 1-.305-1.723c.15-.566.538-1.07 1.119-1.345l6.927-3.281c.792-.374 1.504.644.879 1.26"
})), Kn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBell_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.522 1.523a4.916 4.916 0 0 1 8.396 3.48c0 2.32.496 3.755.949 4.587.228.418.449.69.601.852a2 2 0 0 0 .205.19.754.754 0 0 1-.427 1.375H1.754a.754.754 0 0 1-.428-1.375h.001l.034-.027q.054-.044.17-.163c.153-.161.374-.434.602-.852.453-.832.949-2.268.949-4.587 0-1.305.518-2.557 1.44-3.48m2.453 11.842a.754.754 0 0 0-1.392.581c.232.556.577 1.047 1.022 1.403.45.36.987.57 1.559.57s1.11-.21 1.559-.57c.445-.357.79-.848 1.022-1.403a.754.754 0 0 0-1.392-.58c-.15.361-.356.632-.572.805a1 1 0 0 1-.617.239 1 1 0 0 1-.617-.239c-.216-.173-.421-.444-.572-.806",
	clipRule: "evenodd"
})), qn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBell_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.607 3.82A6.209 6.209 0 0 1 18.21 8.216c0 2.93.627 4.743 1.199 5.793.288.528.567.873.76 1.076a3 3 0 0 0 .258.24h.001a.952.952 0 0 1-.54 1.737H4.111a.952.952 0 0 1-.541-1.736l.001-.001.043-.034c.044-.037.12-.104.216-.206.192-.203.471-.548.759-1.076.573-1.05 1.199-2.863 1.199-5.793 0-1.648.654-3.229 1.818-4.394m3.097 14.956a.952.952 0 0 0-1.758.734c.293.701.729 1.321 1.291 1.771.567.454 1.247.72 1.97.72.721 0 1.4-.266 1.968-.72.563-.45.998-1.07 1.29-1.771a.952.952 0 0 0-1.757-.734c-.19.457-.45.8-.723 1.018-.269.215-.537.301-.779.301s-.51-.086-.779-.301c-.273-.219-.532-.56-.723-1.018",
	clipRule: "evenodd"
})), Jn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBilling_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1 4.429C1 3.639 1.627 3 2.4 3h11.2c.773 0 1.4.64 1.4 1.429v1.428H1zM1 8h14v3.571c0 .79-.627 1.429-1.4 1.429H2.4c-.773 0-1.4-.64-1.4-1.429z"
})), Yn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBilling_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2zM2 12h20v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
})), Xn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBlock_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 1C4.136 1 1 4.136 1 8s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7M2.4 8c0-3.094 2.506-5.6 5.6-5.6 1.295 0 2.485.441 3.43 1.183L3.583 11.43A5.53 5.53 0 0 1 2.4 8M8 13.6a5.53 5.53 0 0 1-3.43-1.183l7.847-7.847A5.53 5.53 0 0 1 13.6 8c0 3.094-2.506 5.6-5.6 5.6"
})), Zn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBlock_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.9 7.9 0 0 1 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.9 7.9 0 0 1 20 12c0 4.42-3.58 8-8 8"
})), Qn = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBluetooth_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.888 5.002q.03-.03.059-.065a.7.7 0 0 0-.11-.984L8.342 1.157A.7.7 0 0 0 7.2 1.7v4.61L4.195 3.305a.7.7 0 0 0-.99.99L6.91 8l-3.705 3.705a.7.7 0 0 0 .99.99L7.2 9.69v4.604a.701.701 0 0 0 1.142.55l3.487-2.791.038-.032a.7.7 0 0 0 .02-1.023l-2-2L8.89 8zM8.6 9.69v3.154l1.752-1.402-1.131-1.131zm0-6.534V6.31l1.752-1.752z",
	clipRule: "evenodd"
})), $n = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBluetooth_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M17.697 7.717a1 1 0 0 0-.072-1.498L12.63 2.224A.999.999 0 0 0 11 3v6.586L6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L11 14.414v6.578a1 1 0 0 0 1.63.784l4.983-3.986.054-.045a1 1 0 0 0 .03-1.462l-2.858-2.858L13.414 12zM13 14.414v4.505l2.503-2.002-1.616-1.616zm0-9.333v4.505l2.503-2.503z",
	clipRule: "evenodd"
})), er = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBreakoutRooms_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M0 3.6A1.6 1.6 0 0 1 1.6 2h12.8A1.6 1.6 0 0 1 16 3.6v8.8a1.6 1.6 0 0 1-1.6 1.6H1.6A1.6 1.6 0 0 1 0 12.4zm2.4.8h4.8v3.2H2.4zm4.8 4H2.4v3.2h4.8zm1.6-4h4.8v3.2H8.8zm4.8 4H8.8v3.2h4.8z",
	clipRule: "evenodd"
})), tr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBreakoutRooms_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M0 5.4A2.4 2.4 0 0 1 2.4 3h19.2A2.4 2.4 0 0 1 24 5.4v13.2a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 18.6zm3.6 1.2h7.2v4.8H3.6zm7.2 6H3.6v4.8h7.2zm2.4-6h7.2v4.8h-7.2zm7.2 6h-7.2v4.8h7.2z",
	clipRule: "evenodd"
})), nr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBulletPoint_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
})), rr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconBulletPoint_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
})), ir = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCalendar_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.1 1.543v-.18C10.1.612 10.727 0 11.5 0h.14c.773 0 1.4.61 1.4 1.364v.179h.56c.77 0 1.4.606 1.4 1.346v10.765c0 .74-.63 1.346-1.4 1.346H2.4c-.77 0-1.4-.606-1.4-1.346V2.89c0-.74.63-1.346 1.4-1.346h.7v-.18C3.1.612 3.727 0 4.5 0h.14c.773 0 1.4.61 1.4 1.364v.179zm3.5 12.111H2.4V4.907h11.2z",
	clipRule: "evenodd"
})), ar = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCalendar_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15 2.366V2.09C15 .936 15.895 0 17 0h.2c1.105 0 2 .936 2 2.09v.276h.8c1.1 0 2 .928 2 2.063v16.508C22 22.07 21.1 23 20 23H4c-1.1 0-2-.928-2-2.063V4.429c0-1.135.9-2.063 2-2.063h1V2.09C5 .936 5.895 0 7 0h.2c1.105 0 2 .936 2 2.09v.276zm5 18.57H4V7.525h16z",
	clipRule: "evenodd"
})), or = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChat_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 1H4a3 3 0 0 0-3 3v10.341c0 .59.754.836 1.102.36l1.358-1.859A2.06 2.06 0 0 1 5.119 12H12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m0 7.5H4v-1h8zm0-3H4v-1h8z"
})), sr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChat_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.286 1.027H5.714A4.715 4.715 0 0 0 1 5.741V21.47c0 .926 1.185 1.313 1.732.565l2.135-2.92a3.23 3.23 0 0 1 2.606-1.325h10.813A4.715 4.715 0 0 0 23 13.075V5.74a4.715 4.715 0 0 0-4.714-4.714m-.524 11.262H6.238v-1.571h11.524zm0-4.19H6.238V6.527h11.524z"
})), cr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCheckmark_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.721 3.312a1 1 0 0 0-1.414 0l-7.235 7.234-3.274-3.275a.999.999 0 1 0-1.414 1.414l3.981 3.981c.44.44 1.075.339 1.414 0l7.942-7.94a1 1 0 0 0 0-1.414"
})), lr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCheckmark_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.109 19.44c-.384 0-.768-.146-1.061-.439L2.076 13.03a1.5 1.5 0 1 1 2.121-2.12l4.912 4.91L19.96 4.967a1.5 1.5 0 1 1 2.121 2.121L10.169 19c-.293.293-.676.44-1.06.44"
})), ur = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCheckmarkRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M4.39 8.74l2.1 2.1a.7.7 0 0 0 .99 0l4.2-4.2a.7.7 0 1 0-.99-.99L6.985 9.355 5.38 7.75a.7.7 0 1 0-.99.99",
	clipRule: "evenodd"
})), dr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCheckmarkRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-5.157-8.943 3 3a1 1 0 0 0 1.414 0l6-6a1 1 0 1 0-1.414-1.414l-5.293 5.293-2.293-2.293a1 1 0 0 0-1.414 1.414",
	clipRule: "evenodd"
})), fr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronDown_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.41 10.749 3.245 6.463a.873.873 0 0 1 0-1.212.816.816 0 0 1 1.179 0L8 8.931l3.577-3.68a.816.816 0 0 1 1.179 0 .873.873 0 0 1 0 1.212L8.589 10.75a.816.816 0 0 1-1.178 0"
})), pr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronDown_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m11.293 15.207-5-5a.999.999 0 1 1 1.414-1.414L12 13.086l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0"
})), mr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronLeft_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.537 12.891 5.25 8.606a.856.856 0 0 1 0-1.212l4.286-4.285a.856.856 0 1 1 1.212 1.212L7.069 8l3.68 3.68a.856.856 0 1 1-1.212 1.211"
})), hr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronLeft_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m13.793 17.707-5-5a1 1 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L10.914 12l4.293 4.293a.999.999 0 1 1-1.414 1.414"
})), gr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronRight_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M5.251 12.756a.816.816 0 0 1 0-1.179L8.931 8 5.25 4.423a.816.816 0 0 1 0-1.179.873.873 0 0 1 1.212 0l4.286 4.167a.816.816 0 0 1 0 1.178l-4.286 4.167a.873.873 0 0 1-1.212 0"
})), _r = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronRight_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8.793 17.707a1 1 0 0 1 0-1.414L13.086 12 8.793 7.707a.999.999 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0"
})), vr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronUp_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.577 10.749 8 7.069l-3.577 3.68a.816.816 0 0 1-1.179 0 .874.874 0 0 1 0-1.212L7.411 5.25a.816.816 0 0 1 1.178 0l4.167 4.286a.873.873 0 0 1 0 1.212.816.816 0 0 1-1.179 0"
})), yr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChevronUp_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M16.293 15.207 12 10.914l-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0l5 5a.999.999 0 1 1-1.414 1.414"
})), br = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChromeLogo_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M14.023 4.432a.115.115 0 0 1-.099.173H8.296Q8.145 4.592 8 4.592a3.41 3.41 0 0 0-3.3 2.557.115.115 0 0 1-.211.029l-1.97-3.413a.115.115 0 0 1 .009-.13A6.97 6.97 0 0 1 8 1a7 7 0 0 1 6.023 3.432M8 10.616A2.62 2.62 0 0 1 5.384 8 2.62 2.62 0 0 1 8 5.384 2.62 2.62 0 0 1 10.616 8 2.62 2.62 0 0 1 8 10.616m1.034.709a.11.11 0 0 0-.121-.04 3.4 3.4 0 0 1-.913.124 3.43 3.43 0 0 1-3.091-1.973L2.098 4.567a.115.115 0 0 0-.2.001 7.004 7.004 0 0 0 5.058 10.355l.017.001c.04 0 .078-.021.099-.057l1.971-3.414a.12.12 0 0 0-.009-.128m1.431-5.954h3.946c.048 0 .09.029.107.073.32.814.482 1.674.482 2.556a6.96 6.96 0 0 1-2.024 4.924 6.96 6.96 0 0 1-4.897 2.075.115.115 0 0 1-.1-.172l2.816-4.877.005-.008A3.4 3.4 0 0 0 11.409 8c0-.921-.364-1.785-1.024-2.432a.115.115 0 0 1 .08-.197",
	clipRule: "evenodd"
})), xr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconChromeLogo_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M20.604 6.903a.164.164 0 0 1-.141.247h-8.04a4.87 4.87 0 0 0-5.139 3.634.164.164 0 0 1-.3.041L4.169 5.95a.16.16 0 0 1 .014-.184A9.96 9.96 0 0 1 12 2.001a9.99 9.99 0 0 1 8.604 4.902M12 15.738A3.74 3.74 0 0 1 8.263 12 3.74 3.74 0 0 1 12 8.263a3.74 3.74 0 0 1 3.737 3.738A3.74 3.74 0 0 1 12 15.738m1.478 1.012a.16.16 0 0 0-.174-.058A4.9 4.9 0 0 1 12 16.87a4.89 4.89 0 0 1-4.416-2.818L3.568 7.096a.164.164 0 0 0-.285.001 10.005 10.005 0 0 0 7.225 14.793.17.17 0 0 0 .166-.08l2.816-4.878a.16.16 0 0 0-.012-.182m2.043-8.506h5.638c.067 0 .128.042.153.104A10 10 0 0 1 22 12.001a9.94 9.94 0 0 1-2.892 7.033 9.94 9.94 0 0 1-6.995 2.965h-.001a.164.164 0 0 1-.142-.246l4.022-6.967.008-.012c.569-.818.87-1.777.87-2.773 0-1.317-.52-2.551-1.463-3.476a.164.164 0 0 1 .114-.28",
	clipRule: "evenodd"
})), Sr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconClock_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m3.719 9.042a.75.75 0 0 1-1.018.296L7.639 8.657A.75.75 0 0 1 7.25 8V3a.75.75 0 0 1 1.5 0v4.556l2.672 1.468a.75.75 0 0 1 .297 1.018"
})), Cr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconClock_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m5.312 12.917a1.07 1.07 0 0 1-1.455.423l-4.374-2.401a1.07 1.07 0 0 1-.556-.939V4.857a1.07 1.07 0 1 1 2.142 0v6.509l3.818 2.096c.521.285.711.936.425 1.455"
})), wr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconClose_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M4.234 4.234a.8.8 0 0 1 1.132 0L8 6.868l2.634-2.634.061-.054a.8.8 0 0 1 1.07 1.185L9.131 8l2.634 2.635.055.061a.8.8 0 0 1-1.185 1.07L8 9.131l-2.635 2.634-.06.055a.8.8 0 0 1-1.07-1.186l2.633-2.635-2.634-2.634-.054-.06a.8.8 0 0 1 .054-1.07"
})), Tr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconClose_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M16.293 17.707a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414L12 10.586 7.707 6.293a1 1 0 0 0-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414L12 13.414z",
	clipRule: "evenodd"
})), Er = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconColumns_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1 11.846V4.058a1.5 1.5 0 0 1 .458-1.1 1.5 1.5 0 0 1 1.1-.458h10.884a1.5 1.5 0 0 1 1.1.458 1.5 1.5 0 0 1 .458 1.1v7.788a1.5 1.5 0 0 1-.458 1.1 1.5 1.5 0 0 1-1.1.458H2.558a1.5 1.5 0 0 1-1.1-.457 1.5 1.5 0 0 1-.458-1.1m1.538 0h2.59V4.058h-2.59zm4.148 0h2.59V4.058h-2.59zm4.147 0h2.59V4.058h-2.59z"
})), Dr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconColumns_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.5 17.77V6.087q0-.964.686-1.65a2.25 2.25 0 0 1 1.65-.687h16.327a2.25 2.25 0 0 1 1.65.686 2.25 2.25 0 0 1 .687 1.65V17.77a2.25 2.25 0 0 1-.686 1.65 2.25 2.25 0 0 1-1.65.686H3.836a2.25 2.25 0 0 1-1.65-.686 2.25 2.25 0 0 1-.687-1.65m2.307 0h3.885V6.087H3.807zm6.221 0h3.885V6.087h-3.885zm6.222 0h3.884V6.087H16.25z"
})), Or = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconColumns_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2 23.693V8.115a3 3 0 0 1 .915-2.2A3 3 0 0 1 5.115 5h21.77a3 3 0 0 1 2.2.915 3 3 0 0 1 .915 2.2v15.578a3 3 0 0 1-.915 2.2 3 3 0 0 1-2.2.915H5.115a3 3 0 0 1-2.2-.915 3 3 0 0 1-.915-2.2m3.076 0h5.18V8.115h-5.18zm8.295 0h5.18V8.115h-5.18zm8.295 0h5.18V8.115h-5.18z"
})), kr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconConnectionIndicatorHigh_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 4,
	x: 4,
	y: 16,
	fill: "currentColor",
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 9,
	x: 10,
	y: 11,
	fill: "currentColor",
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 16,
	x: 16,
	y: 4,
	fill: "currentColor",
	rx: 1
})), Ar = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconConnectionIndicatorLow_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", {
	fill: "currentColor",
	clipPath: "url(#IconConnectionIndicatorLow_24__a)"
}, /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 4,
	x: 4,
	y: 16,
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 9,
	x: 10,
	y: 11,
	opacity: .3,
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 16,
	x: 16,
	y: 4,
	opacity: .3,
	rx: 1
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconConnectionIndicatorLow_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})))), jr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconConnectionIndicatorMedium_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", {
	fill: "currentColor",
	clipPath: "url(#IconConnectionIndicatorMedium_24__a)"
}, /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 4,
	x: 4,
	y: 16,
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 9,
	x: 10,
	y: 11,
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 16,
	x: 16,
	y: 4,
	opacity: .3,
	rx: 1
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconConnectionIndicatorMedium_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})))), Mr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconConnectionIndicatorVeryLow_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconConnectionIndicatorVeryLow_24__a)" }, /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 4,
	x: 4,
	y: 16,
	fill: "currentColor",
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 9,
	x: 10,
	y: 11,
	fill: "currentColor",
	opacity: .3,
	rx: 1
}), /* @__PURE__ */ e.createElement("rect", {
	width: 4,
	height: 16,
	x: 16,
	y: 4,
	fill: "currentColor",
	opacity: .3,
	rx: 1
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconConnectionIndicatorVeryLow_24__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})))), Nr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCopy_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4 2h6a2 2 0 0 1 2 2v.75H6.75a2 2 0 0 0-2 2V12H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("rect", {
	width: 8,
	height: 8,
	x: 6,
	y: 6,
	fill: "currentColor",
	rx: 1.5
})), Pr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconCopy_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M6 3h10a3 3 0 0 1 3 3v1h-9a3 3 0 0 0-3 3v9H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("rect", {
	width: 12,
	height: 12,
	x: 9,
	y: 9,
	fill: "currentColor",
	rx: 2
})), Fr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDeny_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12.293 13.707a1 1 0 0 0 1.414-1.414L9.414 8l4.293-4.293a1 1 0 0 0-1.414-1.414L8 6.586 3.707 2.293a1 1 0 0 0-1.414 1.414L6.586 8l-4.293 4.293a1 1 0 1 0 1.414 1.414L8 9.414z",
	clipRule: "evenodd"
})), Ir = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDeny_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M19.155 21.512a1.667 1.667 0 1 0 2.357-2.357L14.357 12l7.155-7.155a1.667 1.667 0 1 0-2.357-2.357L12 9.643 4.845 2.488a1.667 1.667 0 1 0-2.357 2.357L9.643 12l-7.155 7.155a1.667 1.667 0 1 0 2.357 2.357L12 14.357z",
	clipRule: "evenodd"
})), Lr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDeny_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M22.586 26.414a2 2 0 1 0 2.828-2.828L16.828 15l8.586-8.586a2 2 0 1 0-2.828-2.828L14 12.172 5.414 3.586a2 2 0 1 0-2.828 2.828L11.172 15l-8.586 8.586a2 2 0 1 0 2.828 2.828L14 17.828z",
	clipRule: "evenodd"
})), Rr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronDown_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m8.531 11.817 3.117-3.116a.623.623 0 1 0-.881-.882L8.09 10.495 5.415 7.82a.623.623 0 1 0-.882.882l3.117 3.116a.623.623 0 0 0 .881 0m.105-3.636 3.117-3.116a.623.623 0 1 0-.882-.882L8.195 6.86 5.519 4.183a.623.623 0 1 0-.882.882L7.754 8.18a.623.623 0 0 0 .882 0",
	clipRule: "evenodd"
})), zr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronDown_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m12.797 17.726 4.675-4.675a.934.934 0 1 0-1.322-1.322l-4.014 4.014-4.014-4.014A.934.934 0 1 0 6.8 13.05l4.675 4.675a.934.934 0 0 0 1.322 0m.156-5.454 4.676-4.675a.934.934 0 1 0-1.323-1.322l-4.014 4.014-4.014-4.014a.934.934 0 1 0-1.322 1.322l4.675 4.675a.934.934 0 0 0 1.322 0",
	clipRule: "evenodd"
})), Br = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronLeft_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m4.183 8.531 3.116 3.117a.623.623 0 1 0 .882-.881L5.505 8.09 8.18 5.415a.623.623 0 1 0-.882-.882L4.183 7.65a.623.623 0 0 0 0 .881m3.636.104 3.116 3.117a.623.623 0 1 0 .882-.881L9.14 8.195l2.676-2.676a.623.623 0 1 0-.882-.882L7.82 7.754a.623.623 0 0 0 0 .881",
	clipRule: "evenodd"
})), Vr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronLeft_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m6.274 12.064 4.675 4.52a.957.957 0 0 0 1.322 0 .88.88 0 0 0 0-1.279l-4.014-3.88 4.015-3.882a.88.88 0 0 0 0-1.278.957.957 0 0 0-1.323 0l-4.675 4.52a.88.88 0 0 0 0 1.278m5.454.15 4.676 4.52a.957.957 0 0 0 1.322 0 .88.88 0 0 0 0-1.278l-4.015-3.88 4.015-3.882a.88.88 0 0 0 0-1.278.957.957 0 0 0-1.322 0l-4.676 4.52a.88.88 0 0 0 0 1.278",
	clipRule: "evenodd"
})), Hr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronRight_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.817 7.469 8.701 4.352a.623.623 0 1 0-.882.881l2.676 2.676-2.676 2.676a.623.623 0 1 0 .882.882l3.116-3.117a.623.623 0 0 0 0-.881m-3.636-.104L5.065 4.248a.623.623 0 1 0-.882.881L6.86 7.805l-2.676 2.677a.623.623 0 1 0 .882.88L8.18 8.247a.623.623 0 0 0 0-.881",
	clipRule: "evenodd"
})), Ur = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronRight_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M17.726 11.203 13.05 6.528a.934.934 0 1 0-1.322 1.322l4.014 4.014-4.014 4.014A.934.934 0 1 0 13.05 17.2l4.675-4.675a.934.934 0 0 0 0-1.322m-5.454-.156L7.597 6.37a.934.934 0 1 0-1.322 1.322l4.014 4.015-4.014 4.014a.934.934 0 1 0 1.322 1.322l4.675-4.675a.934.934 0 0 0 0-1.322",
	clipRule: "evenodd"
})), Wr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronUp_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.469 4.183 4.352 7.299a.623.623 0 1 0 .881.882L7.91 5.505l2.676 2.676a.623.623 0 1 0 .882-.882L8.35 4.183a.623.623 0 0 0-.881 0m-.105 3.636-3.117 3.116a.623.623 0 1 0 .882.882L7.805 9.14l2.676 2.676a.623.623 0 1 0 .882-.882L8.246 7.82a.623.623 0 0 0-.882 0",
	clipRule: "evenodd"
})), Gr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDoubleChevronUp_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.203 6.274 6.528 10.95a.934.934 0 1 0 1.322 1.322l4.014-4.014 4.014 4.014A.934.934 0 1 0 17.2 10.95l-4.675-4.675a.934.934 0 0 0-1.322 0m-.156 5.454L6.37 16.403a.934.934 0 1 0 1.323 1.322l4.014-4.014 4.014 4.014a.934.934 0 1 0 1.322-1.322l-4.675-4.675a.934.934 0 0 0-1.322 0",
	clipRule: "evenodd"
})), Kr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDraggable_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
})), qr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDraggable_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M10.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15.5 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
})), Jr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDtmf_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.6 13.929C9.6 14.52 9.108 15 8.5 15s-1.1-.48-1.1-1.071c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M9.6 9.643c0 .592-.492 1.071-1.1 1.071s-1.1-.48-1.1-1.071c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M9.6 5.357c0 .592-.492 1.072-1.1 1.072s-1.1-.48-1.1-1.072.492-1.071 1.1-1.071 1.1.48 1.1 1.071"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.6 1.071c0 .592-.492 1.072-1.1 1.072s-1.1-.48-1.1-1.072C7.4.48 7.892 0 8.5 0s1.1.48 1.1 1.071"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14 9.643c0 .592-.492 1.071-1.1 1.071-.607 0-1.1-.48-1.1-1.071 0-.592.492-1.072 1.1-1.072.607 0 1.1.48 1.1 1.072M14 5.357c0 .592-.492 1.072-1.1 1.072-.607 0-1.1-.48-1.1-1.072s.492-1.071 1.1-1.071c.607 0 1.1.48 1.1 1.071M14 1.071c0 .592-.492 1.072-1.1 1.072-.607 0-1.1-.48-1.1-1.072C11.8.48 12.292 0 12.9 0c.607 0 1.1.48 1.1 1.071M5.2 9.643c0 .592-.492 1.071-1.1 1.071S3 10.234 3 9.643c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M5.2 5.357c0 .592-.492 1.072-1.1 1.072S3 5.949 3 5.357s.492-1.071 1.1-1.071 1.1.48 1.1 1.071M5.2 1.071c0 .592-.492 1.072-1.1 1.072S3 1.663 3 1.07C3 .48 3.492 0 4.1 0s1.1.48 1.1 1.071"
})), Yr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDtmf_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M19 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M19 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
})), Xr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDualScreen_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M6.09 3.94c0-.704.57-1.273 1.274-1.273h6.363c.703 0 1.273.57 1.273 1.272v4.455c0 .703-.57 1.273-1.273 1.273H10.8v-3.39a2 2 0 0 0-2-2H6.09zM1 6.484c0-.703.57-1.273 1.273-1.273h6.363c.703 0 1.273.57 1.273 1.273v4.454c0 .703-.57 1.273-1.273 1.273H2.273C1.57 12.212 1 11.642 1 10.94zm5.675 6.181H4.324l-.31.726c-.058.135.07.274.253.274h2.465c.183 0 .311-.14.254-.274z",
	clipRule: "evenodd"
})), Zr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconDualScreen_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.273 5.818C9.273 4.814 10.087 4 11.09 4h9.09C21.187 4 22 4.814 22 5.818v6.364A1.82 1.82 0 0 1 20.182 14H16V8.3a2 2 0 0 0-2-2H9.273zM2 9.455c0-1.005.814-1.819 1.818-1.819h9.091c1.004 0 1.818.814 1.818 1.819v6.363a1.82 1.82 0 0 1-1.818 1.818H3.82A1.82 1.82 0 0 1 2 15.818zm8.108 8.83h-3.36l-.443 1.037c-.082.193.102.392.362.392h3.522c.26 0 .444-.2.362-.392z",
	clipRule: "evenodd"
})), Qr = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEdit_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12.041 2c-.52 0-1.018.206-1.385.574l-7.845 7.844a.63.63 0 0 0-.165.292l-.627 2.51a.628.628 0 0 0 .76.761l2.511-.627a.63.63 0 0 0 .292-.165l7.844-7.845A1.96 1.96 0 0 0 12.041 2",
	clipRule: "evenodd"
})), $r = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEdit_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M18.062 3c-.78 0-1.527.31-2.078.86L4.217 15.629a.94.94 0 0 0-.248.437l-.94 3.765a.94.94 0 0 0 1.14 1.142l3.766-.942a.94.94 0 0 0 .437-.247L20.14 8.016A2.938 2.938 0 0 0 18.062 3",
	clipRule: "evenodd"
})), ei = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEmoji_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M5.25 5.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6.434 5.478c-.041.092-1.051 2.272-3.684 2.272s-3.643-2.18-3.684-2.272a.75.75 0 1 1 1.368-.614c.024.051.67 1.386 2.316 1.386s2.292-1.335 2.318-1.393a.75.75 0 0 1 .993-.366.75.75 0 0 1 .373.987M10.75 8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
})), ti = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEmoji_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M8.071 8.429a1.786 1.786 0 1 1 0 3.572 1.786 1.786 0 0 1 0-3.572m9.192 7.825c-.059.133-1.501 3.246-5.263 3.246s-5.204-3.113-5.263-3.246a1.073 1.073 0 0 1 1.956-.878c.033.074.956 1.981 3.307 1.981 2.391 0 3.299-1.961 3.308-1.981.243-.541.879-.78 1.417-.539.54.244.78.878.538 1.417M15.929 12a1.786 1.786 0 1 1 0-3.572 1.786 1.786 0 0 1 0 3.572"
})), ni = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEnableshare_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.39 2.667q-.056.326-.057.666A4 4 0 0 0 16 6.313v5.154a3.2 3.2 0 0 1-3.2 3.2H8.72V8.744l2.604 1.526c.207.12.456.045.588-.172a.63.63 0 0 0-.05-.713L8.332 5.222a.43.43 0 0 0-.662 0L4.137 9.385a.63.63 0 0 0-.05.713c.135.22.385.293.589.172L7.28 8.744v5.923H3.2a3.2 3.2 0 0 1-3.2-3.2v-5.6a3.2 3.2 0 0 1 3.2-3.2z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m15.837 2.93-.418-.06a.43.43 0 0 1-.332-.26l-.002-.004a.43.43 0 0 1 .051-.42l.253-.337a.19.19 0 0 0-.017-.249l-.306-.305a.19.19 0 0 0-.249-.017l-.337.253a.43.43 0 0 1-.424.049.43.43 0 0 1-.259-.332l-.06-.418a.19.19 0 0 0-.188-.163h-.431a.19.19 0 0 0-.189.163l-.06.418a.43.43 0 0 1-.259.332l-.004.001a.43.43 0 0 1-.42-.05l-.337-.254a.19.19 0 0 0-.249.018l-.305.305a.19.19 0 0 0-.018.25l.253.336c.091.121.11.28.051.42l-.001.004a.43.43 0 0 1-.332.26l-.418.06a.19.19 0 0 0-.163.188v.431c0 .095.07.176.163.189l.417.06a.42.42 0 0 1 .334.263c.059.14.04.298-.05.42l-.254.336a.19.19 0 0 0 .018.25l.305.305a.19.19 0 0 0 .25.017l.336-.253c.121-.09.28-.109.42-.05l.004.001a.43.43 0 0 1 .26.332l.06.418a.19.19 0 0 0 .188.163h.431a.19.19 0 0 0 .189-.163l.06-.418a.43.43 0 0 1 .259-.332q.002 0 .004-.002a.43.43 0 0 1 .42.051l.337.253c.076.057.182.05.249-.017l.305-.305a.19.19 0 0 0 .018-.25l-.253-.337a.42.42 0 0 1-.051-.42l.002-.004a.43.43 0 0 1 .332-.26l.417-.059A.19.19 0 0 0 16 3.55v-.431a.19.19 0 0 0-.163-.189m-2.504 1.356a.952.952 0 1 1 0-1.905.952.952 0 0 1 0 1.905"
})), ri = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconEnableshare_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.085 4q-.084.489-.085 1a6 6 0 0 0 10 4.47v7.73a4.8 4.8 0 0 1-4.8 4.8h-6.12v-8.884l3.906 2.288c.31.181.683.068.882-.258a.94.94 0 0 0-.074-1.068l-5.298-6.245a.646.646 0 0 0-.993 0l-5.297 6.245a.94.94 0 0 0-.074 1.069c.2.33.576.44.882.257l3.906-2.288V22H4.8A4.8 4.8 0 0 1 0 17.2V8.8A4.8 4.8 0 0 1 4.8 4z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m23.755 4.394-.626-.09a.64.64 0 0 1-.501-.395.64.64 0 0 1 .077-.63l.379-.505a.286.286 0 0 0-.026-.374l-.459-.457a.285.285 0 0 0-.373-.026l-.506.379a.64.64 0 0 1-.635.074.64.64 0 0 1-.389-.499l-.09-.626A.286.286 0 0 0 20.323 1h-.646a.286.286 0 0 0-.283.245l-.09.626a.64.64 0 0 1-.389.499l-.006.002a.64.64 0 0 1-.63-.077l-.505-.379a.285.285 0 0 0-.373.027l-.458.458c-.1.1-.112.259-.027.373l.38.505c.135.182.163.42.076.63l-.002.006a.64.64 0 0 1-.499.389l-.626.09a.286.286 0 0 0-.245.283v.647c0 .142.105.263.245.283l.626.089a.64.64 0 0 1 .501.395c.087.21.06.448-.077.63l-.379.505a.286.286 0 0 0 .026.374l.458.458c.1.1.26.112.374.026l.505-.38a.64.64 0 0 1 .63-.076l.006.003a.64.64 0 0 1 .39.498l.089.626c.02.14.14.245.283.245h.647a.286.286 0 0 0 .283-.245l.089-.626a.64.64 0 0 1 .39-.498l.006-.003a.64.64 0 0 1 .63.077l.505.379a.29.29 0 0 0 .374-.026l.457-.458c.1-.1.112-.26.027-.374l-.38-.505a.64.64 0 0 1-.076-.63l.002-.006a.64.64 0 0 1 .499-.39l.625-.089c.14-.02.245-.14.245-.283v-.646a.286.286 0 0 0-.245-.283M20 6.429a1.428 1.428 0 1 1 0-2.857 1.428 1.428 0 0 1 0 2.857"
})), ii = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconExpand_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.53 2.195 4.195 5.528a.666.666 0 1 0 .943.943L8 3.609l2.862 2.862a.666.666 0 1 0 .943-.943L8.472 2.195a.666.666 0 0 0-.943 0m.941 12.053 3.333-3.333a.666.666 0 1 0-.942-.942L8 12.834 5.138 9.973a.666.666 0 1 0-.943.942l3.334 3.333c.26.26.681.26.942 0",
	clipRule: "evenodd"
})), ai = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconExpand_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.538 4.251 7.253 8.537a.856.856 0 1 0 1.211 1.212l3.68-3.68 3.68 3.68a.856.856 0 1 0 1.211-1.212L12.75 4.25a.856.856 0 0 0-1.212 0m1.211 15.498 4.286-4.286a.856.856 0 1 0-1.212-1.212l-3.68 3.68-3.68-3.68a.856.856 0 1 0-1.212 1.212l4.286 4.286a.856.856 0 0 0 1.212 0",
	clipRule: "evenodd"
})), oi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconExport_16",
	viewBox: "0 0 16 17",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m13.125 6.634-4.54 4.54a.6.6 0 0 1-.852 0l-4.54-4.54a.602.602 0 0 1 .693-.965l3.347 1.664V.926a.926.926 0 0 1 1.852 0v6.407l3.347-1.664a.601.601 0 0 1 .693.965M1.7 11.517a.7.7 0 0 1 .7.7v2.1h11.2v-2.1a.7.7 0 1 1 1.4 0v2.8a.7.7 0 0 1-.428.645l-.015.006a.7.7 0 0 1-.257.049H1.7a.7.7 0 0 1-.7-.7v-2.8000000000000003a.7.7 0 0 1 .7-.7"
})), si = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconExport_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m19.32 10.025-6.486 6.487a.86.86 0 0 1-1.215 0l-6.487-6.488a.86.86 0 0 1 .99-1.378l4.782 2.377V1.87a1.323 1.323 0 0 1 2.645 0v9.153l4.782-2.376a.859.859 0 0 1 .99 1.378M22 18a1 1 0 1 0-2 0v3H4v-3a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1z",
	clipRule: "evenodd"
})), ci = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFecc_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m14.534 9.47-2.164 2.164-.735-.735L13.8 8.735a1.04 1.04 0 0 0 0-1.471l-2.165-2.165.736-.736 2.164 2.165a2.08 2.08 0 0 1 0 2.942M7.265 2.2 5.101 4.364l-.735-.735L6.53 1.465a2.08 2.08 0 0 1 2.941 0l2.163 2.163-.735.736L8.736 2.2a1.04 1.04 0 0 0-1.47 0M4.366 5.1l-.735-.736-2.164 2.164a2.08 2.08 0 0 0 0 2.942l2.163 2.164.736-.736-2.164-2.163a1.04 1.04 0 0 1 0-1.471zm7.27 7.27-.736-.736-2.164 2.164a1.04 1.04 0 0 1-1.47 0L5.1 11.634l-.735.735 2.164 2.164a2.08 2.08 0 0 0 2.941 0zM8 10.121a2.123 2.123 0 1 0 0-4.245 2.123 2.123 0 0 0 0 4.245",
	clipRule: "evenodd"
})), li = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFecc_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M22.195 14.824 19.219 17.8l-1.414-1.415 2.976-2.976a2 2 0 0 0 0-2.828l-2.976-2.977L19.22 6.19l2.976 2.976a4 4 0 0 1 0 5.658M10.588 3.214 7.612 6.19 6.198 4.776l2.976-2.977a4 4 0 0 1 5.656 0l2.975 2.977-1.414 1.414-2.975-2.976a2 2 0 0 0-2.828 0m-4.39 4.39L4.784 6.19 1.81 9.166a4 4 0 0 0 0 5.658L4.784 17.8l1.414-1.415-2.975-2.976a2 2 0 0 1 0-2.828zm11.607 11.61L16.391 17.8l-2.975 2.976a2 2 0 0 1-2.828 0L7.612 17.8l-1.414 1.414 2.976 2.977a4 4 0 0 0 5.656 0zm-5.803-3.765a3.453 3.453 0 1 0 0-6.907 3.453 3.453 0 0 0 0 6.906",
	clipRule: "evenodd"
})), ui = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFirefoxLogo_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M10.71 1.305a.292.292 0 0 0-.248.521c1.16.79 1.87 2.902 1.913 4.56a3.8 3.8 0 0 0-1.095-1.283.292.292 0 0 0-.408.408 3.208 3.208 0 0 1-2.58 5.114 2.4 2.4 0 0 1-.955-.152c.332-.138.65-.31.946-.514a2.35 2.35 0 0 1 1.176-.5.292.292 0 0 0 .283-.363 1.144 1.144 0 0 0-1.158-.804 1 1 0 0 0-.753.298c-.157.14-.32.285-.996.285-1.193 0-1.75-.696-1.75-1.166a.6.6 0 0 1 .255-.434q.195-.138.413-.233a.3.3 0 0 0 .413 0 .69.69 0 0 0 .144-.675l1.56-1.04a.292.292 0 0 0-.16-.535h-.584c-.649 0-1.073-.126-1.166-.345-.134-.322.306-1.008.788-1.49a.292.292 0 0 0-.205-.497c-.767.068-1.459.49-1.873 1.139a6.3 6.3 0 0 0-1.32.02 1.5 1.5 0 0 1-.233-.35 3 3 0 0 1-.365-1.101.292.292 0 0 0-.498-.207 2.3 2.3 0 0 0-.449 2.491 7 7 0 0 0 6.196 10.255C11.926 14.707 15 11.761 15 8v-.583c0-3.558-2.216-5.49-4.29-6.112"
})), di = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFirefoxLogo_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15.871 2.436a.417.417 0 0 0-.354.744c1.658 1.127 2.67 4.146 2.734 6.514a5.4 5.4 0 0 0-1.565-1.833.417.417 0 0 0-.583.583 4.583 4.583 0 0 1-3.685 7.306 3.4 3.4 0 0 1-1.365-.217 7.3 7.3 0 0 0 1.351-.734 3.36 3.36 0 0 1 1.68-.716.417.417 0 0 0 .405-.517 1.635 1.635 0 0 0-1.654-1.15 1.42 1.42 0 0 0-1.077.428c-.224.2-.455.406-1.423.406-1.704 0-2.5-.994-2.5-1.666a.87.87 0 0 1 .365-.62q.279-.196.59-.333a.43.43 0 0 0 .59 0 .98.98 0 0 0 .206-.964l2.23-1.486a.417.417 0 0 0-.23-.763h-.834c-.927 0-1.534-.18-1.666-.494-.191-.46.437-1.44 1.125-2.127a.417.417 0 0 0-.292-.712 3.55 3.55 0 0 0-2.676 1.627 9 9 0 0 0-1.886.029 2.2 2.2 0 0 1-.333-.5 4.35 4.35 0 0 1-.52-1.573.417.417 0 0 0-.712-.295 3.29 3.29 0 0 0-.642 3.559C.581 11.82 2.46 17.865 7.349 20.434a10 10 0 0 0 4.653 1.148C17.608 21.582 22 17.372 22 12v-.833c0-5.082-3.166-7.842-6.129-8.73"
})), fi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFlipCamera_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13 3h-1.5l-.724-1.447A1 1 0 0 0 9.882 1H6.118a1 1 0 0 0-.894.553L4.5 3H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M4.235 9.801 2.467 8.033a.374.374 0 0 1 .432-.601l1.103.548A4.003 4.003 0 0 1 8 4c.926 0 1.776.32 2.453.852a.495.495 0 0 1 .002.764.49.49 0 0 1-.619.014A3 3 0 0 0 8 5a3 3 0 0 0-2.998 2.977L6.1 7.431a.375.375 0 0 1 .432.602L4.765 9.801a.375.375 0 0 1-.53 0m9.337-1.35a.376.376 0 0 1-.472.117l-1.102-.548A4.003 4.003 0 0 1 8 12c-.926 0-1.776-.32-2.453-.852a.495.495 0 0 1-.002-.764.49.49 0 0 1 .619-.014c.508.394 1.145.63 1.836.63a3 3 0 0 0 2.998-2.977l-1.099.545a.375.375 0 0 1-.431-.601l1.768-1.768a.385.385 0 0 1 .53 0l1.768 1.768c.129.13.145.335.038.484"
})), pi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFlipCamera_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M19.5 6h-2.25l-1.085-2.171A1.5 1.5 0 0 0 14.823 3H9.177a1.5 1.5 0 0 0-1.342.829L6.75 6H4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M6.352 16.201 3.7 13.55a.563.563 0 0 1 .648-.902l1.653.821A6.006 6.006 0 0 1 12 7.5c1.389 0 2.664.48 3.68 1.278.366.287.358.847.002 1.146a.736.736 0 0 1-.928.021A4.48 4.48 0 0 0 12 9a4.504 4.504 0 0 0-4.497 4.467l1.648-.819a.563.563 0 0 1 .648.902l-2.652 2.651a.56.56 0 0 1-.795 0m14.006-2.025a.564.564 0 0 1-.707.176l-1.653-.821A6.005 6.005 0 0 1 12 19.5a5.94 5.94 0 0 1-3.68-1.278c-.365-.287-.358-.847-.002-1.146a.736.736 0 0 1 .928-.021A4.48 4.48 0 0 0 12 18a4.504 4.504 0 0 0 4.497-4.467l-1.648.819a.563.563 0 0 1-.648-.902l2.652-2.651c.22-.22.576-.22.796 0L20.3 13.45a.56.56 0 0 1 .058.726"
})), mi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFlipCamera_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M26 8h-3l-1.447-2.895A2 2 0 0 0 19.764 4h-7.528a2 2 0 0 0-1.79 1.105L9 8H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4M8.47 21.601l-3.537-3.534a.751.751 0 0 1 .864-1.203l2.204 1.095C8.024 13.567 11.603 10 16 10c1.852 0 3.552.64 4.907 1.704.488.383.477 1.13.002 1.528a.98.98 0 0 1-1.237.028A5.97 5.97 0 0 0 16 12c-3.293 0-5.97 2.668-5.996 5.956l2.197-1.092a.751.751 0 0 1 .864 1.203L9.53 21.6a.75.75 0 0 1-1.06 0m18.674-2.7a.75.75 0 0 1-.943.235l-2.204-1.095C23.976 22.433 20.397 26 16 26a7.9 7.9 0 0 1-4.907-1.704c-.486-.383-.477-1.13-.002-1.528a.98.98 0 0 1 1.237-.028A5.97 5.97 0 0 0 16 24c3.293 0 5.97-2.668 5.996-5.956l-2.197 1.092a.751.751 0 0 1-.864-1.203L22.47 14.4a.75.75 0 0 1 1.061 0l3.535 3.534c.26.26.292.67.077.968"
})), hi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOff_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconFullscreenOff_16__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m12.369 5.046 2.815.946a.515.515 0 0 1-.164 1.003h-5.5a.514.514 0 0 1-.515-.515V.98a.517.517 0 0 1 1.004-.163l.946 2.815L13.813.774a.999.999 0 1 1 1.414 1.414zM.98 9.005h5.5c.285 0 .515.23.514.514v5.5a.515.515 0 0 1-1.003.164l-.946-2.815-2.858 2.858a.999.999 0 1 1-1.414-1.414l2.858-2.858-2.815-.946A.514.514 0 0 1 .98 9.005",
	clipRule: "evenodd"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconFullscreenOff_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), gi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOff_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m17.36 8.407 3.52 1.183a.642.642 0 0 1-.205 1.254H13.8a.644.644 0 0 1-.644-.644V3.325a.644.644 0 0 1 1.254-.205l1.183 3.519 3.573-3.573a1.25 1.25 0 1 1 1.768 1.768zM3.326 13.156H10.2c.356 0 .644.288.644.644v6.875a.644.644 0 0 1-1.254.205l-1.183-3.519-3.573 3.573a1.25 1.25 0 0 1-1.768-1.768l3.573-3.573-3.52-1.183a.642.642 0 0 1 .206-1.254",
	clipRule: "evenodd"
})), _i = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOff_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m23.148 11.21 4.692 1.577a.858.858 0 0 1-.273 1.672H18.4a.86.86 0 0 1-.859-.859V4.433a.858.858 0 0 1 1.672-.273l1.578 4.692 4.764-4.764a1.666 1.666 0 1 1 2.357 2.357zM4.433 17.54H13.6c.475 0 .859.384.859.859v9.167a.858.858 0 0 1-1.672.273l-1.578-4.692-4.764 4.764a1.667 1.667 0 0 1-2.357-2.357l4.764-4.764-4.692-1.578a.858.858 0 0 1 .273-1.672",
	clipRule: "evenodd"
})), vi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOn_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8.98 1.005h5.5c.285 0 .515.23.514.515v5.5a.515.515 0 0 1-1.003.164l-.946-2.815-2.858 2.858a.999.999 0 1 1-1.414-1.414l2.858-2.859-2.815-.946a.515.515 0 0 1 .164-1.003M4.369 13.046l2.815.946a.515.515 0 0 1-.164 1.003h-5.5a.514.514 0 0 1-.515-.515v-5.5a.515.515 0 0 1 1.003-.164l.947 2.816 2.858-2.858a.999.999 0 1 1 1.414 1.414z",
	clipRule: "evenodd"
})), yi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOn_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13.325 3.156H20.2c.356 0 .644.288.644.644v6.875a.644.644 0 0 1-1.254.205l-1.183-3.519-3.573 3.573a1.25 1.25 0 0 1-1.768-1.768l3.573-3.573L13.12 4.41a.642.642 0 0 1 .205-1.254M7.361 18.407l3.519 1.183a.642.642 0 0 1-.205 1.254H3.8a.644.644 0 0 1-.644-.644v-6.875a.644.644 0 0 1 1.254-.205l1.183 3.519 3.573-3.573a1.25 1.25 0 1 1 1.768 1.768z",
	clipRule: "evenodd"
})), bi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconFullscreenOn_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M17.767 4.208h9.166c.475 0 .859.384.859.859v9.166a.858.858 0 0 1-1.672.274l-1.577-4.692-4.764 4.764a1.668 1.668 0 0 1-2.358-2.358l4.764-4.764-4.692-1.577a.858.858 0 0 1 .273-1.672M9.815 24.543l4.692 1.577a.858.858 0 0 1-.273 1.672H5.066a.86.86 0 0 1-.859-.859v-9.166c0-.422.304-.78.72-.848a.87.87 0 0 1 .952.574l1.577 4.692 4.764-4.764a1.666 1.666 0 1 1 2.358 2.358z",
	clipRule: "evenodd"
})), xi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGeneric2_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 15a6.8 6.8 0 0 1-2.73-.551 7.1 7.1 0 0 1-2.222-1.496A7.1 7.1 0 0 1 1.55 10.73 6.8 6.8 0 0 1 1 8q0-1.452.551-2.73a7.1 7.1 0 0 1 1.497-2.222A7.1 7.1 0 0 1 5.27 1.55 6.8 6.8 0 0 1 8 1q1.452 0 2.73.551a7.1 7.1 0 0 1 2.223 1.497q.944.945 1.496 2.222.55 1.278.551 2.73v1.015q0 1.033-.709 1.759a2.34 2.34 0 0 1-1.741.726q-.612 0-1.155-.262a2.47 2.47 0 0 1-.91-.753 3.4 3.4 0 0 1-1.146.761Q8.7 11.501 8 11.5a3.37 3.37 0 0 1-2.476-1.024A3.37 3.37 0 0 1 4.5 8q0-1.453 1.024-2.476A3.37 3.37 0 0 1 8 4.5q1.453 0 2.476 1.024A3.37 3.37 0 0 1 11.5 8v1.015q0 .455.297.77a1 1 0 0 0 .753.315 1 1 0 0 0 .752-.315 1.08 1.08 0 0 0 .298-.77V8q0-2.344-1.627-3.972Q10.344 2.4 8 2.4T4.028 4.028 2.4 8q0 2.344 1.628 3.973Q5.655 13.6 8 13.6h4.2s.7 0 .7.7-.7.7-.7.7zm0-4.9q.875 0 1.488-.612Q10.1 8.874 10.1 8q0-.876-.612-1.487A2.03 2.03 0 0 0 8 5.9q-.876 0-1.487.612A2.03 2.03 0 0 0 5.9 8q0 .875.612 1.488.613.612 1.488.612"
})), Si = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGeneric2_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12v1.45q0 1.474-1.012 2.513Q19.975 17 18.5 17a3.74 3.74 0 0 1-1.65-.375 3.5 3.5 0 0 1-1.3-1.075 4.8 4.8 0 0 1-1.638 1.087A5.1 5.1 0 0 1 12 17q-2.075 0-3.537-1.463Q7 14.075 7 12q0-2.075 1.463-3.537Q9.926 7 12 7q2.075 0 3.537 1.463Q17 9.926 17 12v1.45q0 .65.425 1.1T18.5 15t1.075-.45.425-1.1V12q0-3.35-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20h6s1 0 1 1-1 1-1 1zm0-7q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 12q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 9q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 12q0 1.25.875 2.125A2.9 2.9 0 0 0 12 15"
})), Ci = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGroup_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconGroup_16__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.534 7.943c1.599 0 2.9-1.301 2.9-2.9a2.903 2.903 0 0 0-2.9-2.899 2.903 2.903 0 0 0-2.9 2.899c0 1.599 1.301 2.9 2.9 2.9M6.138 6.227c0 1.16-.944 2.104-2.104 2.104A2.107 2.107 0 0 1 1.93 6.226c0-1.159.944-2.102 2.104-2.102s2.104.943 2.104 2.103M.575 10.268C1.12 9.673 2.156 9.23 4.034 9.23a8.3 8.3 0 0 1 1.64.147 4 4 0 0 0-.662.579c-.276.3-.703.805-.894 1.814a4 4 0 0 0-.035.23H.643a.575.575 0 0 1-.568-.658c.1-.64.339-.899.486-1.059zm9.96-1.086c2.566 0 3.992.601 4.748 1.41l.014.016c.218.233.555.594.694 1.484a.792.792 0 0 1-.782.908H5.86a.79.79 0 0 1-.781-.908c.137-.879.465-1.236.668-1.457l.021-.023c.751-.819 2.179-1.43 4.767-1.43",
	clipRule: "evenodd"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconGroup_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), wi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGroup_24",
	viewBox: "0 0 25 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15.818 3.716c2.409 0 4.368 1.951 4.368 4.348 0 2.4-1.96 4.35-4.368 4.35s-4.369-1.95-4.369-4.35c0-2.398 1.96-4.348 4.37-4.348M9.195 9.34a3.167 3.167 0 0 1-3.17 3.156A3.166 3.166 0 0 1 2.857 9.34a3.167 3.167 0 0 1 3.17-3.155 3.166 3.166 0 0 1 3.17 3.155m-3.17 4.505c1.272 0 2.276.14 3.083.368-.613.348-1.168.741-1.61 1.221-.331.358-.986 1.082-1.306 2.566H.917a.863.863 0 0 1-.856-.987c.15-.959.51-1.347.732-1.588l.021-.023c.822-.892 2.383-1.557 5.212-1.557M8.776 20H22.86c.724 0 1.29-.648 1.177-1.361-.21-1.339-.718-1.88-1.047-2.23l-.02-.021c-1.139-1.214-3.287-2.115-7.153-2.115-3.899 0-6.05.917-7.182 2.146l-.028.03c-.306.332-.802.867-1.01 2.19A1.19 1.19 0 0 0 8.777 20",
	clipRule: "evenodd"
})), Ti = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGuest_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 8c1.158 0 2.1-.942 2.1-2.1S9.158 3.8 8 3.8c-1.157 0-2.1.942-2.1 2.1S6.842 8 8 8M11.182 9.906c-.547-.585-1.577-1.019-3.432-1.019-1.87 0-2.902.442-3.445 1.034l-.014.015c-.147.16-.385.418-.484 1.055a.572.572 0 0 0 .565.655h6.757a.572.572 0 0 0 .565-.656c-.1-.644-.344-.905-.502-1.074z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-.7 0A6.3 6.3 0 1 1 1.7 8a6.3 6.3 0 0 1 12.6 0",
	clipRule: "evenodd"
})), Ei = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconGuest_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 12c1.655 0 3-1.346 3-3 0-1.655-1.346-3-3-3S9 7.345 9 9s1.346 3 3 3M16.546 14.722c-.781-.835-2.253-1.455-4.903-1.455-2.672 0-4.146.631-4.922 1.477l-.02.022c-.21.228-.55.597-.691 1.506-.077.49.31.937.807.937h9.653a.817.817 0 0 0 .807-.937c-.144-.92-.492-1.293-.717-1.535z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
	clipRule: "evenodd"
})), Di = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHeadset_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 2a7 7 0 0 1 7 7v2.45a2.45 2.45 0 0 1-2.45 2.45c-1.353 0-1.45-1.097-1.45-2.45v-1.4c0-1.353.097-2.45 1.45-2.45.324 0 .633.063.916.177a5.602 5.602 0 0 0-10.932 0c.283-.114.592-.177.916-.177 1.353 0 1.45 1.097 1.45 2.45v1.4c0 1.353-.097 2.45-1.45 2.45A2.45 2.45 0 0 1 1 11.45V9a7 7 0 0 1 7-7"
})), Oi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHeadset_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 3c5.523 0 10 4.477 10 10v3.5a3.5 3.5 0 0 1-3.5 3.5c-1.933 0-2.5-1.567-2.5-3.5v-2c0-1.933.567-3.5 2.5-3.5.463 0 .904.09 1.309.253a8.003 8.003 0 0 0-15.618 0A3.5 3.5 0 0 1 5.5 11C7.433 11 8 12.567 8 14.5v2c0 1.933-.567 3.5-2.5 3.5A3.5 3.5 0 0 1 2 16.5V13C2 7.477 6.477 3 12 3"
})), ki = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHelpRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M7.235 5.39a1.399 1.399 0 0 1 2.108 1.209c0 .328-.255.672-.738.993a4.2 4.2 0 0 1-.872.44l-.011.004a.7.7 0 1 0 .444 1.328L7.944 8.7l.222.664h.002l.002-.002.008-.002.024-.009.082-.03a5.632 5.632 0 0 0 1.099-.564c.567-.378 1.361-1.086 1.361-2.157a2.8 2.8 0 0 0-5.442-.932.7.7 0 1 0 1.322.464 1.4 1.4 0 0 1 .611-.743M8 10.8a.7.7 0 1 0 0 1.4h.007a.7.7 0 1 0 0-1.4z",
	clipRule: "evenodd"
})), Ai = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHelpRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M21.986 12c0 5.523-4.474 10-9.993 10S2 17.523 2 12 6.474 2 11.993 2s9.993 4.477 9.993 10M10.9 8.27a1.996 1.996 0 0 1 3.01 1.728V10c0 .47-.365.958-1.054 1.418a6 6 0 0 1-1.246.628l-.015.005a1 1 0 0 0 .633 1.897L11.913 13l.317.948h.002l.004-.002.01-.004.036-.012.116-.043a8.043 8.043 0 0 0 1.569-.806c.81-.54 1.943-1.55 1.944-3.08l-1-.001h1a4 4 0 0 0-3.322-3.947A3.996 3.996 0 0 0 8.14 8.668a1 1 0 1 0 1.887.663 2 2 0 0 1 .873-1.06M11.992 16a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2z",
	clipRule: "evenodd"
})), ji = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHome_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1.751 4.51A2 2 0 0 0 1 6.07v7.834c0 .424.164.831.456 1.13.291.3.687.47 1.1.47h2.92v-7.06c0-.395.283-.714.632-.714h3.785c.348 0 .63.32.63.713v7.06h2.921c.413 0 .809-.168 1.1-.468s.456-.707.456-1.13V6.07a2 2 0 0 0-.751-1.562l-5-3.998a2 2 0 0 0-2.498 0z",
	clipRule: "evenodd"
})), Mi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHome_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.751 8.035A2 2 0 0 0 3 9.597v10.347c0 .545.21 1.068.586 1.454C3.96 21.783 4.47 22 5 22h3.756v-9.077c0-.507.363-.918.811-.918h4.867c.448 0 .81.41.81.917V22H19c.53 0 1.04-.217 1.414-.602.375-.386.586-.909.586-1.454V9.597a2 2 0 0 0-.751-1.562l-7-5.597a2 2 0 0 0-2.498 0z",
	clipRule: "evenodd"
})), Ni = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHospital_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1.751 4.56A2 2 0 0 0 1 6.123v7.833c0 .424.164.831.456 1.131.291.3.687.468 1.1.468h10.888c.413 0 .809-.168 1.1-.468s.456-.707.456-1.13V6.121a2 2 0 0 0-.751-1.562l-5-3.997a2 2 0 0 0-2.498 0zM7 6.051h2v2h2v2H9v2H7v-2H5v-2h2z",
	clipRule: "evenodd"
})), Pi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHospital_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.751 8.035A2 2 0 0 0 3 9.597v10.347c0 .545.21 1.068.586 1.454C3.96 21.783 4.47 22 5 22h14c.53 0 1.04-.217 1.414-.602.375-.386.586-.909.586-1.454V9.597a2 2 0 0 0-.751-1.562l-7-5.597a2 2 0 0 0-2.498 0zm6.963 1.745h2.572v2.571h2.571v2.572h-2.571v2.571h-2.572v-2.571H8.143V12.35h2.571z",
	clipRule: "evenodd"
})), Fi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHost_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m0-7c1.158 0 2.1-.942 2.1-2.1S9.158 3.8 8 3.8c-1.157 0-2.1.942-2.1 2.1S6.842 8 8 8m3.182 1.906c-.547-.585-1.577-1.019-3.432-1.019-1.87 0-2.902.442-3.445 1.034l-.014.015c-.147.16-.385.418-.484 1.055a.572.572 0 0 0 .565.655h6.757a.572.572 0 0 0 .565-.656c-.1-.644-.344-.905-.502-1.074z",
	clipRule: "evenodd"
})), Ii = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconHost_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-10c1.655 0 3-1.346 3-3 0-1.655-1.346-3-3-3S9 7.345 9 9s1.346 3 3 3m4.546 2.722c-.781-.835-2.253-1.455-4.903-1.455-2.672 0-4.146.631-4.922 1.477l-.02.022c-.21.228-.55.597-.691 1.506-.077.49.31.937.807.937h9.653a.817.817 0 0 0 .807-.937c-.144-.92-.492-1.293-.717-1.535z",
	clipRule: "evenodd"
})), Li = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconIconSort_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.833 6.352 4.843 3.39a.6.6 0 0 0-.845 0l-2.99 2.962a.59.59 0 0 0 0 .837.6.6 0 0 0 .846 0l1.992-1.973v6.967c0 .332.272.6.606.6a.603.603 0 0 0 .606-.6V5.278l1.93 1.911a.6.6 0 0 0 .845 0 .59.59 0 0 0 0-.837M7.834 9.648l2.989 2.962a.6.6 0 0 0 .845 0l2.99-2.962a.59.59 0 0 0 0-.837.6.6 0 0 0-.845 0l-1.993 1.973V3.817c0-.331-.27-.6-.606-.6a.603.603 0 0 0-.605.6v6.905l-1.93-1.911a.6.6 0 0 0-.845 0 .59.59 0 0 0 0 .837"
})), Ri = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconIconSort_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 14.355a.84.84 0 0 1 0-1.196.86.86 0 0 1 1.208 0l2.757 2.73V6.025c0-.474.387-.857.865-.858.478 0 .866.384.866.858v9.952l2.846-2.818a.86.86 0 0 1 1.208 0 .84.84 0 0 1 0 1.196l-4.271 4.23a.86.86 0 0 1-1.207 0zM2.25 10.841a.84.84 0 0 1 0-1.196l4.271-4.23a.86.86 0 0 1 1.208 0L12 9.644a.84.84 0 0 1 0 1.196.86.86 0 0 1-1.208 0l-2.757-2.73v9.865a.86.86 0 0 1-.865.857.86.86 0 0 1-.865-.857V8.023L3.458 10.84a.86.86 0 0 1-1.208 0"
})), zi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconImport_16",
	viewBox: "0 0 16 17",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M3.193 4.717 7.733.176a.6.6 0 0 1 .851 0l4.541 4.541a.602.602 0 0 1-.693.965L9.084 4.018v6.407a.926.926 0 0 1-1.851 0V4.018L3.885 5.68a.601.601 0 0 1-.692-.964M1.7 11.65a.7.7 0 0 1 .7.7v2.1h11.2v-2.1a.7.7 0 1 1 1.4 0v2.8a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7v-2.799a.7.7 0 0 1 .7-.7"
})), Bi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconImport_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5.132 7.094 11.62.608a.86.86 0 0 1 1.215 0l6.487 6.487a.86.86 0 0 1-.99 1.378l-4.782-2.377v9.153a1.323 1.323 0 0 1-2.645 0V6.096L6.12 8.472a.859.859 0 0 1-.989-1.378M22 18a1 1 0 1 0-2 0v3H4v-3a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1z",
	clipRule: "evenodd"
})), Vi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconInfoRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M7.3 5.2a.7.7 0 0 1 .7-.7h.007a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7M8 7.3a.7.7 0 0 1 .7.7v2.8a.7.7 0 1 1-1.4 0V8a.7.7 0 0 1 .7-.7",
	clipRule: "evenodd"
})), Hi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconInfoRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M11 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m1 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
	clipRule: "evenodd"
})), Ui = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconKey_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M10.25 2C8.18 2 6.5 3.68 6.5 5.75c0 .24 0 .48.045.705L2 11v3h4.5v-3h3V9.5l.045-.045c.225.045.465.045.705.045C12.32 9.5 14 7.82 14 5.75S12.32 2 10.25 2M11 3.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5S9.5 5.825 9.5 5s.675-1.5 1.5-1.5"
})), Wi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconKey_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15.375 3C12.27 3 9.75 5.615 9.75 8.838c0 .374 0 .747.068 1.098L3 17.01v4.67h6.75v-4.67h4.5v-2.335l.068-.07c.337.07.697.07 1.057.07 3.105 0 5.625-2.615 5.625-5.838S18.48 3 15.375 3M16.5 5.335c1.238 0 2.25 1.051 2.25 2.335s-1.012 2.336-2.25 2.336-2.25-1.051-2.25-2.336 1.012-2.335 2.25-2.335"
})), Gi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLanguage_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8 15q-1.434 0-2.713-.551a7.1 7.1 0 0 1-2.23-1.505 7.1 7.1 0 0 1-1.506-2.232A6.8 6.8 0 0 1 1 8q0-1.452.551-2.721a7.1 7.1 0 0 1 1.505-2.223 7.1 7.1 0 0 1 2.231-1.505A6.8 6.8 0 0 1 8 1q1.452 0 2.721.551 1.269.552 2.223 1.505a7.1 7.1 0 0 1 1.505 2.223Q14.999 6.548 15 8q0 1.435-.551 2.713a7.1 7.1 0 0 1-1.505 2.23 7.1 7.1 0 0 1-2.223 1.506A6.8 6.8 0 0 1 8 15m0-1.435q.455-.63.787-1.312.333-.684.543-1.453H6.67q.21.77.543 1.452.332.683.787 1.313m-1.82-.28a10 10 0 0 1-.551-1.199 10 10 0 0 1-.394-1.286H3.17a5.8 5.8 0 0 0 1.269 1.522 5 5 0 0 0 1.741.963m3.64 0a5 5 0 0 0 1.741-.963q.761-.647 1.269-1.522h-2.065q-.157.665-.394 1.286a10 10 0 0 1-.551 1.199M2.575 9.4h2.38a9.246 9.246 0 0 1-.079-2.109q.027-.341.079-.691h-2.38A5.571 5.571 0 0 0 2.4 8a5.6 5.6 0 0 0 .175 1.4m3.78 0h3.29q.052-.35.079-.691a9 9 0 0 0 0-1.418 10 10 0 0 0-.079-.691h-3.29a9.246 9.246 0 0 0-.079 2.109q.027.341.079.691m4.69 0h2.38q.087-.35.131-.691.044-.342.044-.709a5.6 5.6 0 0 0-.175-1.4h-2.38A10 10 0 0 1 11.15 8a9 9 0 0 1-.105 1.4m-.28-4.2h2.065a5.8 5.8 0 0 0-1.269-1.522 5 5 0 0 0-1.741-.963q.315.578.551 1.199t.394 1.286m-4.095 0h2.66a8.3 8.3 0 0 0-.543-1.453A9 9 0 0 0 8 2.436q-.455.63-.787 1.313Q6.88 4.43 6.67 5.2m-3.5 0h2.065q.157-.665.394-1.286.236-.621.551-1.199-.98.314-1.741.963-.761.647-1.269 1.522"
})), Ki = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLanguage_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 22a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 2 12q0-2.075.788-3.887a10.2 10.2 0 0 1 2.15-3.175 10.1 10.1 0 0 1 3.187-2.15A9.7 9.7 0 0 1 12 2q2.076 0 3.887.788a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175A9.65 9.65 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.875 10.1 10.1 0 0 1-2.15 3.188 10.2 10.2 0 0 1-3.175 2.15A9.65 9.65 0 0 1 12 22m0-2.05q.65-.9 1.125-1.875T13.9 16h-3.8q.3 1.1.775 2.075T12 19.95m-2.6-.4q-.45-.824-.787-1.713A15 15 0 0 1 8.05 16H5.1a8.3 8.3 0 0 0 1.813 2.175A7.2 7.2 0 0 0 9.4 19.55m5.2 0a7.2 7.2 0 0 0 2.487-1.375A8.3 8.3 0 0 0 18.9 16h-2.95q-.225.95-.562 1.837a14 14 0 0 1-.788 1.713M4.25 14h3.4a13.208 13.208 0 0 1-.15-2 13 13 0 0 1 .15-2h-3.4A7.959 7.959 0 0 0 4 12a8 8 0 0 0 .25 2m5.4 0h4.7q.075-.5.113-.988.037-.487.037-1.012a13 13 0 0 0-.15-2h-4.7q-.075.5-.113.988Q9.5 11.475 9.5 12a13 13 0 0 0 .15 2m6.7 0h3.4a7.953 7.953 0 0 0 .25-2 8 8 0 0 0-.25-2h-3.4q.075.5.112.988.038.487.038 1.012a13 13 0 0 1-.15 2m-.4-6h2.95a8.3 8.3 0 0 0-1.812-2.175A7.2 7.2 0 0 0 14.6 4.45q.45.825.787 1.712.338.888.563 1.838M10.1 8h3.8q-.3-1.1-.775-2.075A12.7 12.7 0 0 0 12 4.05q-.65.9-1.125 1.875T10.1 8m-5 0h2.95q.224-.95.563-1.838.337-.887.787-1.712Q8 4.9 6.912 5.825A8.3 8.3 0 0 0 5.1 8"
})), qi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLeave_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.43 0H4.57A2.573 2.573 0 0 0 2 2.57V7h5.587L6.449 4.708a.65.65 0 0 1 1.041-.749l3.581 3.581a.65.65 0 0 1 0 .92L7.49 12.041a.65.65 0 0 1-1.042-.749L7.587 9H2v4.43A2.573 2.573 0 0 0 4.57 16h6.859a2.573 2.573 0 0 0 2.57-2.57V2.57A2.57 2.57 0 0 0 11.43 0"
})), Ji = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLeave_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15.787 2H7.213A3.217 3.217 0 0 0 4 5.213v5.537h6.984L9.561 7.885a.814.814 0 0 1 .253-1.022.82.82 0 0 1 1.049.085l4.476 4.476a.814.814 0 0 1 0 1.15l-4.476 4.476a.813.813 0 0 1-1.302-.937l1.423-2.865H4v5.537A3.217 3.217 0 0 0 7.213 22h8.574A3.217 3.217 0 0 0 19 18.787V5.213A3.217 3.217 0 0 0 15.787 2"
})), Yi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLink_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.8 6.4a1.4 1.4 0 0 0-1.4 1.4v1.4a1.4 1.4 0 0 0 1.4 1.4h2.8a.7.7 0 1 1 0 1.4H3.8A2.8 2.8 0 0 1 1 9.2V7.8A2.8 2.8 0 0 1 3.8 5h2.8a.7.7 0 1 1 0 1.4zm4.9-.7a.7.7 0 0 1 .7-.7h2.8A2.8 2.8 0 0 1 15 7.8v1.4a2.8 2.8 0 0 1-2.8 2.8H9.4a.7.7 0 1 1 0-1.4h2.8a1.4 1.4 0 0 0 1.4-1.4V7.8a1.4 1.4 0 0 0-1.4-1.4H9.4a.7.7 0 0 1-.7-.7M5.2 8.5a.7.7 0 0 1 .7-.7h4.2a.7.7 0 1 1 0 1.4H5.9a.7.7 0 0 1-.7-.7",
	clipRule: "evenodd"
})), Xi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLink_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5.968 9.8c-1.189 0-2.063.851-2.063 1.8v1.8c0 .949.874 1.8 2.063 1.8H9.99c.526 0 .953.403.953.9s-.427.9-.953.9H5.97C3.825 17 2 15.434 2 13.4v-1.8C2 9.567 3.826 8 5.968 8H9.99c.526 0 .953.403.953.9s-.427.9-.953.9zm7.09-.9c0-.497.427-.9.953-.9h4.02C20.175 8 22 9.567 22 11.6v1.8c0 2.034-1.826 3.6-3.968 3.6H14.01c-.526 0-.953-.403-.953-.9s.427-.9.953-.9h4.02c1.19 0 2.064-.851 2.064-1.8v-1.8c0-.949-.874-1.8-2.063-1.8H14.01c-.526 0-.953-.403-.953-.9m-5.026 3.6c0-.497.426-.9.952-.9h6.032c.526 0 .952.403.952.9s-.426.9-.952.9H8.984c-.526 0-.952-.403-.952-.9",
	clipRule: "evenodd"
})), Zi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveCaption_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 2.75a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2zm4.983 4.568h-.994a1 1 0 0 0-.111-.359.9.9 0 0 0-.52-.44 1.1 1.1 0 0 0-.37-.06q-.36 0-.629.187a1.2 1.2 0 0 0-.415.541 2.2 2.2 0 0 0-.148.86q0 .52.148.872.15.354.417.534.269.18.62.18.198 0 .366-.054a1 1 0 0 0 .301-.159.9.9 0 0 0 .218-.259q.09-.15.123-.346l.994.005q-.039.335-.193.645-.152.309-.41.553a1.9 1.9 0 0 1-.614.384q-.354.14-.8.14a2.1 2.1 0 0 1-1.113-.294 2.05 2.05 0 0 1-.772-.852q-.28-.556-.281-1.35 0-.795.286-1.352.286-.558.776-.85a2.1 2.1 0 0 1 1.103-.294q.405 0 .75.119.346.118.614.346.268.226.436.553.17.327.218.75m4.806 0h-.994a1 1 0 0 0-.111-.359.9.9 0 0 0-.52-.44 1.1 1.1 0 0 0-.37-.06q-.36 0-.629.187a1.2 1.2 0 0 0-.415.541 2.2 2.2 0 0 0-.148.86q0 .52.148.872.15.354.417.534.269.18.62.18.197 0 .365-.054a1 1 0 0 0 .302-.159.9.9 0 0 0 .218-.259q.09-.15.123-.346l.994.005a1.94 1.94 0 0 1-.604 1.198 1.9 1.9 0 0 1-.613.384q-.354.14-.8.14a2.1 2.1 0 0 1-1.113-.294 2.05 2.05 0 0 1-.772-.852q-.28-.556-.281-1.35 0-.795.286-1.352.286-.558.776-.85a2.1 2.1 0 0 1 1.103-.294q.405 0 .75.119.346.118.614.346.268.226.436.553.17.327.218.75",
	clipRule: "evenodd"
})), Qi = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveCaption_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2.4 3A2.4 2.4 0 0 0 0 5.4v13.2A2.4 2.4 0 0 0 2.4 21h19.2a2.4 2.4 0 0 0 2.4-2.4V5.4A2.4 2.4 0 0 0 21.6 3zm9.57 7.83h-1.703a1.8 1.8 0 0 0-.191-.614 1.55 1.55 0 0 0-.891-.756 1.9 1.9 0 0 0-.634-.102q-.62 0-1.078.321-.459.317-.712.928-.253.606-.253 1.472 0 .891.253 1.497.257.607.716.915.459.31 1.062.31.34 0 .626-.094.293-.093.518-.273.226-.183.373-.443.153-.26.21-.594l1.705.008a3.3 3.3 0 0 1-.331 1.107 3.29 3.29 0 0 1-1.755 1.607 3.7 3.7 0 0 1-1.373.24q-1.065 0-1.907-.505-.836-.504-1.323-1.46-.482-.957-.482-2.315 0-1.362.49-2.318.49-.957 1.33-1.457A3.6 3.6 0 0 1 8.513 7.8q.693 0 1.284.203.595.204 1.054.594.459.387.747.948.293.562.374 1.285m8.24 0h-1.705a1.8 1.8 0 0 0-.19-.614 1.55 1.55 0 0 0-.891-.756 1.9 1.9 0 0 0-.634-.102q-.62 0-1.078.321-.46.317-.712.928-.253.606-.253 1.472 0 .891.253 1.497.257.607.716.915.459.31 1.062.31.338 0 .626-.094.292-.093.518-.273.226-.183.373-.443.151-.26.21-.594l1.705.008a3.3 3.3 0 0 1-.331 1.107 3.29 3.29 0 0 1-1.755 1.607 3.7 3.7 0 0 1-1.373.24q-1.067 0-1.907-.505-.836-.504-1.323-1.46-.482-.957-.482-2.315 0-1.362.49-2.318.49-.957 1.33-1.457a3.6 3.6 0 0 1 1.892-.504q.692 0 1.284.203.595.204 1.054.594.459.387.747.948.293.562.374 1.285",
	clipRule: "evenodd"
})), $i = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveStream_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.545 3h8.91C13.86 3 15 4.205 15 5.692v5.385c0 1.487-1.14 2.692-2.546 2.692H3.545C2.14 13.77 1 12.564 1 11.077V5.692C1 4.205 2.14 3 3.545 3m7.572 5.947a.5.5 0 0 0 0-.893L6.726 5.836A.5.5 0 0 0 6 6.282v4.437a.5.5 0 0 0 .726.446z",
	clipRule: "evenodd"
})), ea = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveStream_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5.318 4.5h13.364c2.11 0 3.818 1.807 3.818 4.038v8.077c0 2.232-1.709 4.039-3.818 4.039H5.318c-2.11 0-3.818-1.807-3.818-4.039V8.538C1.5 6.308 3.209 4.5 5.318 4.5m11.358 8.92a.75.75 0 0 0 0-1.34l-6.587-3.327A.75.75 0 0 0 9 9.423v6.655a.75.75 0 0 0 1.088.67z",
	clipRule: "evenodd"
})), ta = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveStreamCloud_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2.333 11.667h9.606q.175 0 .34.004c.61.012 1.142.022 1.72-.338.426-.264.668-1.562.668-2.291q0-1.006-.69-1.758a2.68 2.68 0 0 0-1.735-.867q0-1.707-1.235-2.895Q9.774 2.334 8 2.333q-1.44 0-2.576.832A3.96 3.96 0 0 0 3.91 5.338a3.17 3.17 0 0 0-1.864 1.137 3.16 3.16 0 0 0-.712 2.027c0 .885.667 3.165 1 3.165m7.667-4-3.333-2v4z",
	clipRule: "evenodd"
})), na = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLiveStreamCloud_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.5 17.5h14.41q.26 0 .51.006c.913.018 1.712.033 2.58-.506.637-.396 1-2.344 1-3.437q0-1.51-1.034-2.636t-2.602-1.302q0-2.56-1.853-4.342Q14.66 3.5 12 3.5q-2.16 0-3.864 1.247t-2.272 3.26q-1.728.371-2.796 1.705A4.73 4.73 0 0 0 2 12.753C2 14.08 3 17.5 3.5 17.5m11.5-6-5-3v6z",
	clipRule: "evenodd"
})), ra = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLocation_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8 15s5.6-4.375 5.6-8.75C13.6 3.35 11.093 1 8 1S2.4 3.35 2.4 6.25C2.4 10.625 8 15 8 15m0-7a2.1 2.1 0 1 0 0-4.2A2.1 2.1 0 0 0 8 8",
	clipRule: "evenodd"
})), ia = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLocation_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 22s8-6.25 8-12.5C20 5.358 16.418 2 12 2S4 5.358 4 9.5C4 15.75 12 22 12 22m0-10a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
	clipRule: "evenodd"
})), aa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLock_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.846 4.538v-.461a3.078 3.078 0 0 1 6.154 0v2.308h1.539c.34 0 .615.275.615.615v7.385c0 .34-.276.615-.615.615H3.615A.615.615 0 0 1 3 14.385V7c0-.34.276-.615.615-.615h1.231V4.538M9.77 6.385V4.077c0-1.052-.794-1.908-1.846-1.908s-1.846.856-1.846 1.908v2.308z",
	clipRule: "evenodd"
})), oa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLock_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7 6.56v-.725C7 3.166 9.24 1 12 1s5 2.166 5 4.835v3.627h2c.552 0 1 .433 1 .967v11.604c0 .534-.448.967-1 .967H5c-.552 0-1-.433-1-.967V10.429c0-.534.448-.967 1-.967h2V6.56m8 2.902V5.835c0-1.653-1.29-2.998-3-2.998S9 4.182 9 5.835v3.627z",
	clipRule: "evenodd"
})), sa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLowerhand_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12.959 6.386c.128-.492.607-.78 1.07-.644.462.135.734.645.606 1.137l-.454 1.742-.7 2.691a7 7 0 0 1-.189.615l-3.513-3.72 1.361-5.232c.129-.492.607-.781 1.07-.645.463.137.734.646.606 1.138l-1.39 5.344.837.246zM9.072 7.458l1.463-5.62C10.663 1.346 10.39.837 9.929.7c-.463-.137-.942.152-1.07.644-.084.321-.75 2.878-1.201 4.616zm-2.518-.724-.155.598.837.247q.001-.002.025-.096l5.417 5.735c-.357.578-.79 1.06-1.275 1.39-1.391.942-3.233.877-5.14.316-1.548-.456-4.737-2.046-4.88-5.486a77 77 0 0 1-.05-2.648c-.002-.463.316-.855.747-.926.47-.076.912.256 1 .752.147.829.355 1.984.422 2.293.085.398.58.396.682.003l.688-2.645.268-1.03zm.397-1.522.839-3.224c.127-.492-.143-1-.606-1.137s-.942.152-1.07.644l-.577 2.22z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	d: "m3 3 11.333 12"
})), ca = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconLowerhand_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M19.439 9.58c.192-.738.91-1.172 1.604-.967.694.203 1.102.968.91 1.705l-.681 2.615-.976 3.748-5.304-5.616 1.719-6.603c.192-.738.91-1.171 1.604-.967s1.1.968.91 1.706l-2.087 8.017 1.257.369zm-5.507.362 1.87-7.186c.193-.737-.215-1.5-.909-1.705s-1.412.229-1.604.966L11.81 7.696zm-3.776-1.086-.558 2.142 1.257.37.361-1.389 8.345 8.836c-.61 1.313-1.462 2.421-2.457 3.096-2.086 1.414-4.85 1.316-7.71.474-2.32-.683-7.105-3.068-7.319-8.228A116 116 0 0 1 2 10.186c-.003-.695.473-1.283 1.12-1.389.704-.115 1.367.384 1.5 1.127.22 1.244.532 2.977.633 3.44.127.597.87.595 1.023.006L8.035 6.61zm.594-2.283.934-3.591c.192-.738-.214-1.501-.908-1.706-.694-.204-1.413.229-1.604.967l-.543 2.085z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: 2,
	d: "m4.727 4.313 17 18"
})), la = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMail_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.661 8.446a2.5 2.5 0 0 1-3.323 0L1.297 3.964A1.99 1.99 0 0 1 3 3h10a1.99 1.99 0 0 1 1.702.963zM15 11c0 .343-.094.66-.246.942l-3.336-3.72L15 5.037zM1 5.037V11c0 .343.094.66.246.942l3.336-3.72zm9.326 4.157.345-.307 3.404 3.795A2 2 0 0 1 13 13H3c-.396 0-.764-.119-1.075-.317l3.404-3.796.345.306A3.5 3.5 0 0 0 8 10.078c.832 0 1.663-.295 2.326-.884",
	clipRule: "evenodd"
})), ua = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMail_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m22.054 5.445-7.562 6.724a3.75 3.75 0 0 1-4.984 0L1.946 5.445A2.99 2.99 0 0 1 4.5 4h15a2.99 2.99 0 0 1 2.554 1.445m.077 11.968-5.004-5.58L22.5 7.056V16c0 .514-.141.99-.369 1.413m-6.642-4.123A5.24 5.24 0 0 1 12 14.616a5.24 5.24 0 0 1-3.489-1.326l-.517-.46-5.106 5.693A2.98 2.98 0 0 0 4.5 19h15c.594 0 1.145-.178 1.611-.477l-5.105-5.693zM1.5 16V7.056l5.373 4.777-5.004 5.58A2.96 2.96 0 0 1 1.5 16",
	clipRule: "evenodd"
})), da = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMeetingRoom_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.5 2h-11A2.503 2.503 0 0 0 0 4.5v7C0 12.879 1.122 14 2.5 14h11c1.378 0 2.5-1.121 2.5-2.5v-7C16 3.121 14.878 2 13.5 2M8 4.387c1.269 0 2.3 1.032 2.3 2.3A2.303 2.303 0 0 1 8 8.988a2.304 2.304 0 0 1-2.301-2.301c0-1.268 1.032-2.3 2.301-2.3M11.709 13H4.291a.627.627 0 0 1-.62-.72c.112-.722.387-1 .547-1.174.596-.65 1.729-1.135 3.782-1.135 2.036 0 3.167.477 3.767 1.118.173.185.449.468.562 1.191a.628.628 0 0 1-.62.72"
})), fa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMeetingRoom_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M20.25 3.5H3.75A3.754 3.754 0 0 0 0 7.25v10.5a3.754 3.754 0 0 0 3.75 3.75h16.5A3.754 3.754 0 0 0 24 17.75V7.25a3.754 3.754 0 0 0-3.75-3.75M12 7.08a3.455 3.455 0 0 1 3.451 3.45A3.455 3.455 0 0 1 12 13.983a3.455 3.455 0 0 1-3.451-3.451A3.454 3.454 0 0 1 12 7.08M17.563 20H6.437a.942.942 0 0 1-.93-1.08c.169-1.082.58-1.5.82-1.762.893-.975 2.593-1.702 5.673-1.702 3.054 0 4.75.715 5.65 1.677.26.277.674.702.843 1.786a.942.942 0 0 1-.93 1.081"
})), pa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMeetings_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5.974 12.737h4.052l.535 1.604a.46.46 0 0 1-.437.606H5.876a.46.46 0 0 1-.437-.606zM2.916 1.684h10.168C14.142 1.684 15 2.542 15 3.6v6.484A1.916 1.916 0 0 1 13.084 12H2.916A1.916 1.916 0 0 1 1 10.084V3.6c0-1.058.858-1.916 1.916-1.916m10.168 9.21a.81.81 0 0 0 .81-.81V3.6a.81.81 0 0 0-.81-.81H2.916a.81.81 0 0 0-.81.81v6.484c0 .448.363.81.81.81zM4.1 3.785a1 1 0 0 0-1 1v.8a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-.8a1 1 0 0 0-1-1zm3.2 1a1 1 0 0 1 1-1h3.6a1 1 0 0 1 1 1v4.3a1 1 0 0 1-1 1H8.3a1 1 0 0 1-1-1zm-3.2 2.5a1 1 0 0 0-1 1v.8a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-.8a1 1 0 0 0-1-1z",
	clipRule: "evenodd"
})), ma = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMeetings_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m14.895 18.79.764 2.291a.658.658 0 0 1-.624.866h-6.07a.658.658 0 0 1-.624-.866l.764-2.291zM4.737 3h14.526A2.737 2.737 0 0 1 22 5.737V15a2.737 2.737 0 0 1-2.737 2.737H4.737A2.737 2.737 0 0 1 2 15V5.737A2.737 2.737 0 0 1 4.737 3m14.526 13.158c.64 0 1.158-.518 1.158-1.158V5.737c0-.64-.519-1.158-1.158-1.158H4.737c-.64 0-1.158.519-1.158 1.158V15c0 .64.519 1.158 1.158 1.158zM6 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm5 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm-5 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z",
	clipRule: "evenodd"
})), ha = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneMutedByHost_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M8.1 5.8c-.418.374-.76.83-1.003 1.344L3.083 3.13A2.52 2.52 0 0 1 5.572 1 2.53 2.53 0 0 1 8.1 3.529zM.72 1.958l6.075 6.076a4.2 4.2 0 0 0 .022 1.897c-.366.215-.789.342-1.245.342a2.53 2.53 0 0 1-2.53-2.529V5.473L.124 2.553a.422.422 0 0 1 .596-.595M10.898 13.133h.053a.4.4 0 0 1-.14 0z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M5.993 11.936a4.1 4.1 0 0 0 1.549-.478 4.2 4.2 0 0 1-.442-.729 3.2 3.2 0 0 1-1.528.387A3.375 3.375 0 0 1 2.2 7.744v-.843a.422.422 0 0 0-.843 0v.843c0 2.18 1.669 3.957 3.793 4.172v1.73a.422.422 0 0 0 .843 0z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.733 5.667a3.267 3.267 0 1 0 0 6.533 3.267 3.267 0 0 0 0-6.533m0 4.9a.327.327 0 0 0 0-.654h-.003a.327.327 0 0 0 0 .654zm-.326-1.634a.327.327 0 1 0 .653 0V7.627a.327.327 0 0 0-.653 0z",
	clipRule: "evenodd"
})), ga = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneMutedByHost_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.4 9.348a6.45 6.45 0 0 0-1.537 2.057L4.72 5.259A3.86 3.86 0 0 1 8.53 2a3.87 3.87 0 0 1 3.87 3.871zM1.101 3.466l9.3 9.3a6.45 6.45 0 0 0 .034 2.903c-.561.33-1.208.524-1.907.524a3.87 3.87 0 0 1-3.87-3.87V8.846L.187 4.378a.646.646 0 0 1 .913-.912M16.681 20.571h.081a.7.7 0 0 1-.213 0z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.173 18.738a6.3 6.3 0 0 0 2.37-.73 6.4 6.4 0 0 1-.675-1.116 4.9 4.9 0 0 1-2.34.592 5.166 5.166 0 0 1-5.161-5.162v-1.29a.645.645 0 0 0-1.29 0v1.29c0 3.337 2.554 6.057 5.806 6.386v2.647a.645.645 0 0 0 1.29 0z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M16.429 9.143a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 7.5a.5.5 0 0 0 0-1h-.005a.5.5 0 1 0 0 1zm-.5-2.5a.5.5 0 1 0 1 0v-2a.5.5 0 1 0-1 0z",
	clipRule: "evenodd"
})), _a = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOff_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11 8.5v-5a3 3 0 0 0-3-3 2.99 2.99 0 0 0-2.952 2.526l5.908 5.909.005-.033c.02-.132.039-.265.039-.402m2 0v-1a.5.5 0 0 0-1 0v1c0 .442-.09.859-.222 1.257l.779.779c.28-.624.443-1.31.443-2.036M2.244 1.636l12.41 12.411a.5.5 0 1 1-.707.706l-2.583-2.583A4.95 4.95 0 0 1 8.5 13.472V15.5a.5.5 0 0 1-1 0v-2.051C4.98 13.194 3 11.086 3 8.5v-1a.5.5 0 0 1 1 0v1c0 2.206 1.794 4 4 4 1.025 0 1.94-.409 2.646-1.047l-.698-.698A2.96 2.96 0 0 1 8 11.5a3 3 0 0 1-3-3V5.806L1.537 2.343a.5.5 0 0 1 .707-.707",
	clipRule: "evenodd"
})), va = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOff_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15.75 12.625v-6.25A3.75 3.75 0 0 0 12 2.625a3.74 3.74 0 0 0-3.69 3.158l7.385 7.386.007-.049c.024-.163.048-.326.048-.495m2.5 0v-1.25a.625.625 0 0 0-1.25 0v1.25c0 .552-.111 1.074-.277 1.571l.973.973c.35-.779.554-1.636.554-2.544M4.805 4.045l15.512 15.514a.625.625 0 1 1-.883.883l-3.229-3.229a6.2 6.2 0 0 1-3.58 1.627v2.535a.625.625 0 0 1-1.25 0v-2.563c-3.149-.319-5.625-2.955-5.625-6.187v-1.25a.625.625 0 1 1 1.25.001v1.25c0 2.758 2.243 5 5 5 1.281 0 2.425-.511 3.308-1.308l-.873-.873a3.7 3.7 0 0 1-2.435.931 3.75 3.75 0 0 1-3.75-3.75V9.259l-4.329-4.33a.625.625 0 0 1 .884-.884",
	clipRule: "evenodd"
})), ya = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOff_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M21 16.833V8.5a5 5 0 0 0-5-5c-2.49 0-4.54 1.827-4.92 4.21l9.847 9.849.01-.065c.031-.218.063-.435.063-.66m3.333 0v-1.666a.834.834 0 0 0-1.666 0v1.666c0 .736-.149 1.432-.37 2.095l1.297 1.297a8.24 8.24 0 0 0 .74-3.392M6.407 5.393 27.089 26.08a.833.833 0 1 1-1.177 1.177l-4.305-4.305a8.26 8.26 0 0 1-4.774 2.169v3.38a.834.834 0 0 1-1.666 0v-3.417c-4.2-.426-7.5-3.94-7.5-8.25v-1.666a.834.834 0 1 1 1.666.001v1.667A6.673 6.673 0 0 0 16 23.5c1.708 0 3.233-.681 4.41-1.744l-1.163-1.164c-.875.76-1.996 1.242-3.247 1.242a5 5 0 0 1-5-5v-4.49L5.228 6.572a.834.834 0 0 1 1.179-1.179",
	clipRule: "evenodd"
})), ba = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOn_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11 8.5a3 3 0 1 1-6 0v-5a3 3 0 1 1 6 0zm1-1a.5.5 0 0 1 1 0v1c0 2.586-1.98 4.694-4.5 4.949V15.5a.5.5 0 0 1-1 0v-2.051C4.98 13.194 3 11.086 3 8.5v-1a.5.5 0 0 1 1 0v1c0 2.206 1.794 4 4 4s4-1.794 4-4z",
	clipRule: "evenodd"
})), xa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOn_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15.75 12.625a3.75 3.75 0 0 1-7.5 0v-6.25a3.75 3.75 0 0 1 7.5 0zm1.25-1.25a.625.625 0 0 1 1.25 0v1.25c0 3.232-2.476 5.868-5.625 6.187v2.563a.625.625 0 0 1-1.25 0v-2.563c-3.149-.319-5.625-2.955-5.625-6.187v-1.25a.625.625 0 0 1 1.25 0v1.25c0 2.758 2.243 5 5 5s5-2.242 5-5z",
	clipRule: "evenodd"
})), Sa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMicrophoneOn_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M21 16.833a5 5 0 0 1-10 0V8.5a5 5 0 0 1 10 0zm1.667-1.666a.834.834 0 0 1 1.666 0v1.666c0 4.31-3.3 7.824-7.5 8.25V28.5a.834.834 0 0 1-1.666 0v-3.417c-4.199-.426-7.5-3.94-7.5-8.25v-1.666a.834.834 0 0 1 1.666 0v1.666A6.673 6.673 0 0 0 16 23.5a6.673 6.673 0 0 0 6.667-6.667z",
	clipRule: "evenodd"
})), Ca = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMinus_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13.326 8a.8.8 0 0 1-.8.8H3.474a.8.8 0 1 1 0-1.6h9.05a.8.8 0 0 1 .8.8",
	clipRule: "evenodd"
})), wa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMinus_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M20.071 12a1 1 0 0 1-1 1H4.929a1 1 0 1 1 0-2H19.07a1 1 0 0 1 1 1",
	clipRule: "evenodd"
})), Ta = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMoreHorizontal_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
})), Ea = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMoreVertical_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.667 12c0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333-.6-1.333-1.333-1.333-1.333.6-1.333 1.333m0-8c0 .733.6 1.333 1.333 1.333S9.333 4.733 9.333 4 8.733 2.667 8 2.667 6.667 3.267 6.667 4m0 4c0 .733.6 1.333 1.333 1.333S9.333 8.733 9.333 8 8.733 6.667 8 6.667 6.667 7.267 6.667 8"
})), Da = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMoreVertical_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
	clipRule: "evenodd"
})), Oa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMove_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m5.638 2-2.897.024a.72.72 0 0 0-.717.717L2 5.638a.705.705 0 0 0 .71.71.72.72 0 0 0 .718-.717l.011-1.217 2.872 2.872a.724.724 0 0 0 1.024-.005.724.724 0 0 0 .004-1.023l-2.82-2.82 1.112-.01a.72.72 0 0 0 .717-.718.705.705 0 0 0-.71-.71m0 12-2.897-.024a.72.72 0 0 1-.717-.717L2 10.362a.705.705 0 0 1 .71-.71.72.72 0 0 1 .718.717l.011 1.217 2.872-2.872a.724.724 0 0 1 1.024.004.724.724 0 0 1 .004 1.024l-2.82 2.82 1.112.01a.72.72 0 0 1 .717.717.705.705 0 0 1-.71.71m7.62-11.976L10.363 2a.705.705 0 0 0-.71.71.72.72 0 0 0 .717.718l1.112.01-2.82 2.82a.724.724 0 0 0 .004 1.023.724.724 0 0 0 1.024.005l2.872-2.872.011 1.217a.72.72 0 0 0 .717.717.705.705 0 0 0 .71-.71l-.023-2.897a.72.72 0 0 0-.717-.717M10.363 14l2.897-.024a.72.72 0 0 0 .717-.717L14 10.362a.705.705 0 0 0-.71-.71.72.72 0 0 0-.718.717l-.011 1.217-2.872-2.872a.724.724 0 0 0-1.024.004.724.724 0 0 0-.004 1.024l2.82 2.82-1.112.01a.72.72 0 0 0-.717.717.705.705 0 0 0 .71.71",
	clipRule: "evenodd"
})), ka = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconMove_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m8.457 3-4.345.036a1.08 1.08 0 0 0-1.076 1.076L3 8.457a1.06 1.06 0 0 0 1.066 1.066 1.08 1.08 0 0 0 1.076-1.076l.017-1.826 4.308 4.308a1.085 1.085 0 0 0 1.535-.007c.426-.426.43-1.113.007-1.535l-4.23-4.23 1.668-.015a1.08 1.08 0 0 0 1.076-1.076A1.06 1.06 0 0 0 8.457 3m0 18-4.345-.036a1.08 1.08 0 0 1-1.076-1.076L3 15.543a1.06 1.06 0 0 1 1.066-1.066 1.08 1.08 0 0 1 1.076 1.076l.017 1.825 4.308-4.308a1.085 1.085 0 0 1 1.535.008c.426.426.43 1.113.007 1.534l-4.23 4.23 1.668.016a1.08 1.08 0 0 1 1.076 1.076A1.06 1.06 0 0 1 8.457 21M19.888 3.036 15.543 3a1.06 1.06 0 0 0-1.066 1.066 1.08 1.08 0 0 0 1.076 1.076l1.668.015-4.23 4.23a1.085 1.085 0 0 0 .007 1.535c.426.426 1.113.43 1.535.007l4.308-4.308.017 1.826a1.08 1.08 0 0 0 1.076 1.076A1.06 1.06 0 0 0 21 8.457l-.036-4.345a1.08 1.08 0 0 0-1.076-1.076M15.543 21l4.345-.036a1.08 1.08 0 0 0 1.076-1.076L21 15.543a1.06 1.06 0 0 0-1.066-1.066 1.08 1.08 0 0 0-1.076 1.076l-.017 1.825-4.308-4.308a1.085 1.085 0 0 0-1.535.008 1.085 1.085 0 0 0-.007 1.534l4.23 4.23-1.668.016a1.08 1.08 0 0 0-1.076 1.076A1.06 1.06 0 0 0 15.543 21",
	clipRule: "evenodd"
})), Aa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotauthenticated_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.25 12.542q1.584 2.18 4.017 2.791 2.432-.612 4.016-2.79 1.584-2.18 1.584-4.84v-4.27l-5.6-2.1-5.6 2.1v4.27q0 2.66 1.584 4.84M8 11.333A.667.667 0 0 0 8 10h-.007a.667.667 0 0 0 0 1.333zM7.333 8a.667.667 0 0 0 1.334 0V5.333a.667.667 0 0 0-1.334 0z",
	clipRule: "evenodd"
})), ja = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotauthenticated_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.41 16.81Q9.22 19.3 12 20q2.78-.7 4.59-3.19t1.81-5.53V6.4L12 4 5.6 6.4v4.88q0 3.04 1.81 5.53M12 16a.8.8 0 0 0 0-1.6h-.008a.8.8 0 0 0 0 1.6zm-.8-4a.8.8 0 0 0 1.6 0V8.8a.8.8 0 0 0-1.6 0z",
	clipRule: "evenodd"
})), Ma = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotauthenticated_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.88 22.413q2.413 3.32 6.12 4.254 3.707-.934 6.12-4.254t2.413-7.373V8.533L16 5.333l-8.533 3.2v6.507q0 4.053 2.413 7.373m6.12-1.08a1.067 1.067 0 0 0 0-2.133h-.01a1.067 1.067 0 0 0 0 2.133zM14.933 16a1.067 1.067 0 0 0 2.134 0v-4.267a1.067 1.067 0 0 0-2.134 0z",
	clipRule: "evenodd"
})), Na = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotAuthenticated_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.25 12.542q1.584 2.18 4.017 2.791 2.432-.612 4.016-2.79 1.584-2.18 1.584-4.84v-4.27l-5.6-2.1-5.6 2.1v4.27q0 2.66 1.584 4.84M8 11.333A.667.667 0 0 0 8 10h-.007a.667.667 0 0 0 0 1.333zM7.333 8a.667.667 0 0 0 1.334 0V5.333a.667.667 0 0 0-1.334 0z",
	clipRule: "evenodd"
})), Pa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotAuthenticated_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.41 16.81Q9.22 19.3 12 20q2.78-.7 4.59-3.19t1.81-5.53V6.4L12 4 5.6 6.4v4.88q0 3.04 1.81 5.53M12 16a.8.8 0 0 0 0-1.6h-.008a.8.8 0 0 0 0 1.6zm-.8-4a.8.8 0 0 0 1.6 0V8.8a.8.8 0 0 0-1.6 0z",
	clipRule: "evenodd"
})), Fa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconNotAuthenticated_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.88 22.413q2.413 3.32 6.12 4.254 3.707-.934 6.12-4.254t2.413-7.373V8.533L16 5.333l-8.533 3.2v6.507q0 4.053 2.413 7.373m6.12-1.08a1.067 1.067 0 0 0 0-2.133h-.01a1.067 1.067 0 0 0 0 2.133zM14.933 16a1.067 1.067 0 0 0 2.134 0v-4.267a1.067 1.067 0 0 0-2.134 0z",
	clipRule: "evenodd"
})), Ia = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconOpenInNew_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.589 1.009A1 1 0 0 1 1.7 1h3.5a.7.7 0 1 1 0 1.4H2.4v11.2h11.2v-2.8a.7.7 0 1 1 1.4 0v3.5a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7V1.7a.7.7 0 0 1 .589-.691"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.398 1H7.977a.601.601 0 0 0-.192 1.172l3.543 1.19-4.53 4.531a.926.926 0 0 0 1.308 1.31l4.53-4.531 1.192 3.544A.601.601 0 0 0 15 8.024V1.602A.6.6 0 0 0 14.398 1"
})), La = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconOpenInNew_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.967 2h9.174a.86.86 0 0 1 .859.86v9.174a.86.86 0 0 1-1.675.274l-1.7-5.062-6.473 6.472a1.323 1.323 0 0 1-1.87-1.87l6.472-6.473-5.062-1.701A.859.859 0 0 1 11.967 2M3 2h5a1 1 0 0 1 0 2H4v16h16v-4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1",
	clipRule: "evenodd"
})), Ra = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconParticipant_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.677 4.909A3.68 3.68 0 0 1 8 8.587a3.68 3.68 0 0 1-3.678-3.678A3.68 3.68 0 0 1 8 1.233a3.68 3.68 0 0 1 3.677 3.676M8 10.158c3.254 0 5.062.762 6.021 1.788l.014.015c.278.295.707.752.885 1.888A1.004 1.004 0 0 1 13.928 15H2.072c-.61 0-1.085-.548-.992-1.151.174-1.114.59-1.567.848-1.848l.026-.029c.953-1.039 2.764-1.814 6.046-1.814",
	clipRule: "evenodd"
})), za = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconParticipant_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M16.59 8.595a4.6 4.6 0 0 1-4.596 4.597 4.6 4.6 0 0 1-4.597-4.597A4.6 4.6 0 0 1 11.994 4a4.6 4.6 0 0 1 4.596 4.595m-4.596 6.562c4.068 0 6.328.952 7.527 2.234l.021.023c.346.37.88.943 1.101 2.356a1.254 1.254 0 0 1-1.239 1.439H4.584a1.254 1.254 0 0 1-1.239-1.438c.218-1.396.74-1.962 1.061-2.313l.031-.033c1.191-1.299 3.455-2.268 7.557-2.268",
	clipRule: "evenodd"
})), Ba = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPasswordHide_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46A11.8 11.8 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
})), Va = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPasswordShow_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
})), Ha = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPause_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.79 1A1.79 1.79 0 0 0 3 2.79v10.42a1.79 1.79 0 1 0 3.581 0V2.79A1.79 1.79 0 0 0 4.791 1m7.164 0a1.79 1.79 0 0 0-1.791 1.79v10.42a1.79 1.79 0 1 0 3.581 0V2.79A1.79 1.79 0 0 0 11.954 1",
	clipRule: "evenodd"
})), Ua = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPause_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.302 3A2.3 2.3 0 0 0 5 5.302v13.396a2.302 2.302 0 0 0 4.605 0V5.302A2.3 2.3 0 0 0 7.302 3m9.21 0a2.3 2.3 0 0 0-2.303 2.302v13.396a2.302 2.302 0 1 0 4.605 0V5.302A2.3 2.3 0 0 0 16.512 3",
	clipRule: "evenodd"
})), Wa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPexip_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 18.675V21h4.8V2.4H3v2.325h2.541v13.95zm18-13.95V2.4h-4.8V21H21v-2.325h-2.541V4.725z",
	clipRule: "evenodd"
})), Ga = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPexipLogo_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 18.675V21h4.8V2.4H3v2.325h2.541v13.95zm18-13.95V2.4h-4.8V21H21v-2.325h-2.541V4.725z",
	clipRule: "evenodd"
})), Ka = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhone_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.733 12.373c-.382.679-1.125 1.154-1.988 1.274-1.66.231-3.792-.788-6.198-3.193-2.94-2.94-3.36-4.993-3.193-6.198.119-.863.595-1.606 1.274-1.988a1.13 1.13 0 0 1 1.532.406l1.293 2.155a1.136 1.136 0 0 1-.171 1.39l-.606.624c.448.728.957 1.345 1.547 1.934a12.6 12.6 0 0 0 1.887 1.558l.675-.621a1.13 1.13 0 0 1 1.386-.168l2.155 1.293c.53.32.71.993.407 1.534"
})), qa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhone_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.88 17.248c-.459.814-1.35 1.384-2.386 1.528-1.992.278-4.55-.945-7.438-3.831-3.528-3.528-4.03-5.992-3.831-7.438.143-1.035.714-1.927 1.529-2.385a1.356 1.356 0 0 1 1.838.487l1.552 2.586a1.36 1.36 0 0 1-.206 1.668l-.727.749a12.5 12.5 0 0 0 1.857 2.32 15 15 0 0 0 2.264 1.87l.81-.745a1.36 1.36 0 0 1 1.663-.202l2.586 1.552c.638.384.852 1.191.489 1.84"
})), Ja = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhoneHorisontal_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.361 9.69c-.2-.714-.02-1.534.48-2.195.963-1.273 3.083-2.022 6.32-2.023 3.958 0 5.621 1.1 6.32 2.022.501.66.68 1.48.48 2.195a1.076 1.076 0 0 1-1.304.758l-2.32-.58a1.08 1.08 0 0 1-.82-1.05l-.012-.828a10 10 0 0 0-2.343-.26c-.793-.001-1.552.072-2.318.22l-.037.873c.002.493-.335.925-.82 1.046l-2.32.58a1.08 1.08 0 0 1-1.306-.758"
})), Ya = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhoneHorisontal_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1.282 13.967c-.317-1.135-.03-2.438.764-3.49 1.53-2.022 4.9-3.213 10.046-3.214 6.29 0 8.934 1.747 10.046 3.213.796 1.05 1.081 2.355.763 3.49a1.71 1.71 0 0 1-2.073 1.204l-3.688-.921a1.72 1.72 0 0 1-1.304-1.67l-.02-1.316a15.7 15.7 0 0 0-3.723-.414c-1.261 0-2.467.116-3.685.352l-.058 1.387a1.71 1.71 0 0 1-1.303 1.662l-3.688.923a1.717 1.717 0 0 1-2.077-1.206"
})), Xa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhoneHorisontal_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2.603 18.46c-.397-1.42-.039-3.048.955-4.363 1.91-2.528 6.124-4.017 12.557-4.019 7.863 0 11.168 2.184 12.557 4.018.995 1.313 1.352 2.942.954 4.361a2.14 2.14 0 0 1-2.591 1.506l-4.61-1.152a2.15 2.15 0 0 1-1.63-2.087l-.024-1.645c-1.573-.374-3.078-.519-4.655-.517a24 24 0 0 0-4.606.44l-.073 1.733a2.14 2.14 0 0 1-1.629 2.078l-4.61 1.153a2.146 2.146 0 0 1-2.595-1.507"
})), Za = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhoneTalk_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.119 1.67a.46.46 0 0 1 .357-.546 5.95 5.95 0 0 1 5.214 1.42 5.95 5.95 0 0 1 1.888 5.062.46.46 0 1 1-.916-.105 5.02 5.02 0 0 0-1.594-4.277 5.03 5.03 0 0 0-4.404-1.197.46.46 0 0 1-.545-.357M12.61 13.08c-.388.69-1.144 1.174-2.023 1.296-1.689.235-3.858-.802-6.306-3.249C1.289 8.136.863 6.047 1.03 4.821c.122-.878.606-1.634 1.297-2.022a1.15 1.15 0 0 1 1.559.413l1.316 2.192a1.156 1.156 0 0 1-.174 1.415l-.617.634c.456.741.974 1.369 1.574 1.968.6.6 1.228 1.118 1.92 1.585l.687-.632a1.15 1.15 0 0 1 1.41-.17l2.193 1.315c.54.325.723 1.01.414 1.56"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.388 3.785a.461.461 0 1 0 .353.853 2.49 2.49 0 0 1 2.625.451c.705.643.974 1.653.69 2.573a.461.461 0 0 0 .88.274 3.42 3.42 0 0 0-.948-3.528 3.42 3.42 0 0 0-3.6-.623"
})), Qa = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPhoneTalk_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.284 4.835a.55.55 0 0 1 .425-.649c2.22-.46 4.54.168 6.207 1.69a7.09 7.09 0 0 1 2.248 6.026.548.548 0 1 1-1.09-.125 5.98 5.98 0 0 0-1.898-5.09 5.98 5.98 0 0 0-5.243-1.427.55.55 0 0 1-.649-.425M17.822 18.418c-.463.823-1.363 1.398-2.408 1.543-2.011.28-4.594-.954-7.508-3.867-3.562-3.56-4.07-6.047-3.868-7.507.144-1.045.72-1.945 1.543-2.408a1.37 1.37 0 0 1 1.856.492l1.566 2.61a1.376 1.376 0 0 1-.207 1.684l-.734.755c.543.882 1.16 1.63 1.874 2.343a15.3 15.3 0 0 0 2.286 1.887l.817-.752a1.37 1.37 0 0 1 1.68-.204l2.61 1.566c.643.388.86 1.203.493 1.858"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.605 7.354a.55.55 0 1 0 .42 1.014 2.97 2.97 0 0 1 3.125.538 2.97 2.97 0 0 1 .82 3.063.55.55 0 0 0 1.05.326 4.07 4.07 0 0 0-1.13-4.2 4.07 4.07 0 0 0-4.285-.741"
})), $a = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPin_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.435.525a.7.7 0 0 1 .99 0l5.05 5.05a.7.7 0 1 1-.99.99l-1.134-1.134-2.938 3.905q.161.516.207 1.044c.106 1.22-.277 2.348-1.064 3.135l-3.04-3.04L4.04 12.95a.7.7 0 0 1-.99-.99l2.475-2.475-3.04-3.04C3.272 5.656 4.4 5.273 5.62 5.38c.35.03.701.1 1.044.208L10.57 2.65 9.435 1.515a.7.7 0 0 1 0-.99",
	clipRule: "evenodd"
})), eo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPin_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.145 8.607a7 7 0 0 0-1.473-.279c-1.724-.132-3.325.425-4.45 1.55l4.242 4.243-3.535 3.536a1 1 0 1 0 1.414 1.414l3.536-3.536 4.242 4.243c1.126-1.125 1.683-2.726 1.55-4.45a7 7 0 0 0-.278-1.473l4.21-5.565 1.59 1.589a1 1 0 0 0 1.414-1.415L19.07 4.93l-3.535-3.536a1 1 0 0 0-1.415 1.415l1.589 1.588z",
	clipRule: "evenodd"
})), to = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlay_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m14.087 8.999-8.543 4.876a1.15 1.15 0 0 1-1.721-.999V3.124a1.15 1.15 0 0 1 1.72-.999l8.542 4.877a1.15 1.15 0 0 1 .002 1.997"
})), no = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlay_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M21.13 13.498 8.317 20.812c-1.152.657-2.582-.174-2.582-1.498V4.686c0-1.324 1.43-2.155 2.58-1.498l12.814 7.314c1.162.662 1.162 2.334.003 2.996"
})), ro = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlayRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.05-6.567a.5.5 0 0 0 0-.866l-2.7-1.559a.5.5 0 0 0-.75.433V9.56a.5.5 0 0 0 .75.433z",
	clipRule: "evenodd"
})), io = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlayRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-1.25-6.969 4.5-2.598a.5.5 0 0 0 0-.866l-4.5-2.598a.5.5 0 0 0-.75.433v5.196a.5.5 0 0 0 .75.433",
	clipRule: "evenodd"
})), ao = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlus_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8.8 3.475a.8.8 0 0 0-1.6 0V7.2H3.475a.8.8 0 0 0 0 1.6H7.2v3.725a.8.8 0 1 0 1.6 0V8.8h3.725a.8.8 0 1 0 0-1.6H8.8z",
	clipRule: "evenodd"
})), oo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPlus_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M19.071 13a1 1 0 1 0 0-2H13V4.929a1 1 0 1 0-2 0V11H4.929a1 1 0 1 0 0 2h6.07v6.071a1 1 0 1 0 2 0V13z",
	clipRule: "evenodd"
})), so = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPresentationOff_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2.244.636a.5.5 0 0 0-.707.707l.787.787A1.99 1.99 0 0 0 1 4v6a2 2 0 0 0 2 2h9.193l1.754 1.754a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707zM3 10.5a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h.694l6.999 7zm7.333 2.5H5.667l-.447 1.342a.5.5 0 0 0 .474.658h4.613a.5.5 0 0 0 .474-.658zM5.022 2H13a2 2 0 0 1 2 2v6c0 .547-.221 1.042-.576 1.403l-1.062-1.062A.5.5 0 0 0 13.5 10V4a.5.5 0 0 0-.5-.5H6.522z",
	clipRule: "evenodd"
})), co = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPresentationOff_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.75 19h-5.5l-.726 2.177a.625.625 0 0 0 .593.823h5.766a.625.625 0 0 0 .593-.823zM4.124 2.24a.625.625 0 0 0-.884.884l1.032 1.032A2.58 2.58 0 0 0 2.5 6.6v8.8A2.6 2.6 0 0 0 5.1 18h13.016l1.969 1.97a.623.623 0 0 0 .884 0 .625.625 0 0 0 0-.884zM5.1 16a.6.6 0 0 1-.6-.6V6.6a.6.6 0 0 1 .6-.6h1.017l9.999 10zM18.9 4H7.652l2 2H18.9a.6.6 0 0 1 .6.6v8.8a.6.6 0 0 1-.115.334l1.422 1.422A2.59 2.59 0 0 0 21.5 15.4V6.6A2.6 2.6 0 0 0 18.9 4"
})), lo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPresentationOn_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m10 9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm0-7H3v6h10zm-2.667 9H5.667l-.447 1.342a.5.5 0 0 0 .474.658h4.613a.5.5 0 0 0 .474-.658z",
	clipRule: "evenodd"
})), uo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconPresentationOn_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.75 19h-5.5l-.726 2.177a.625.625 0 0 0 .593.823h5.766a.625.625 0 0 0 .593-.823zM18.9 4H5.1a2.6 2.6 0 0 0-2.6 2.6v8.8A2.6 2.6 0 0 0 5.1 18h13.8a2.6 2.6 0 0 0 2.6-2.6V6.6A2.6 2.6 0 0 0 18.9 4M20 15.4a1.1 1.1 0 0 1-1.1 1.1H5.1A1.1 1.1 0 0 1 4 15.4V6.6a1.1 1.1 0 0 1 1.1-1.1h13.8A1.1 1.1 0 0 1 20 6.6zM5.5 15h13V7h-13z"
})), fo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRaiseHand_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.33 5.845c-.485-.13-.988.145-1.122.614l-.73 2.551-.88-.235 1.46-5.101a.88.88 0 0 0-.635-1.086c-.486-.13-.99.146-1.123.615L9.838 8.304l-.88-.236 1.704-5.951a.88.88 0 0 0-.636-1.085c-.486-.13-.989.146-1.124.616l-1.704 5.95-.88-.235 1.462-5.1a.88.88 0 0 0-.636-1.087c-.486-.13-.99.146-1.124.616l-2.028 7.08c-.107.374-.626.376-.716-.003-.07-.296-.288-1.399-.443-2.19-.092-.474-.556-.79-1.049-.717A.9.9 0 0 0 1 6.846c.003.677.014 1.686.053 2.528.149 3.283 3.498 4.8 5.123 5.235 2.002.536 3.937.598 5.397-.303 1.005-.619 1.8-1.813 2.182-3.146l1.211-4.231a.877.877 0 0 0-.635-1.084"
})), po = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRaiseHand_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M21.947 8.959a1.433 1.433 0 0 0-1.764 1.01l-1.149 4.19-1.382-.386 2.295-8.38a1.45 1.45 0 0 0-1-1.784 1.433 1.433 0 0 0-1.765 1.01L14.887 13l-1.383-.386 2.679-9.778a1.45 1.45 0 0 0-1-1.783 1.433 1.433 0 0 0-1.765 1.01L10.74 11.84l-1.382-.386 2.295-8.381a1.45 1.45 0 0 0-1-1.783 1.43 1.43 0 0 0-1.764 1.01c-.21.772-3.018 11.016-3.186 11.632s-.985.618-1.125-.005c-.11-.485-.453-2.297-.696-3.597a1.455 1.455 0 0 0-1.65-1.178A1.46 1.46 0 0 0 1 10.602c.005 1.113.023 2.77.083 4.154.234 5.393 5.498 7.887 8.05 8.601 3.147.88 6.187.983 8.482-.495 1.58-1.018 2.828-2.979 3.428-5.168l1.905-6.952a1.45 1.45 0 0 0-1-1.783"
})), mo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRaiseHand_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M28.058 11.484c-.926-.273-1.883.305-2.14 1.289l-1.391 5.343-1.676-.492s2.527-9.705 2.782-10.689-.287-2.002-1.213-2.274c-.925-.273-1.883.305-2.139 1.289l-2.782 10.688-1.676-.493 3.247-12.47c.257-.983-.287-2.001-1.212-2.274-.926-.273-1.883.305-2.14 1.289l-3.245 12.467-1.676-.493S15.324 4.96 15.58 3.976s-.285-2.002-1.21-2.274c-.926-.273-1.885.305-2.14 1.289L8.367 17.825c-.204.785-1.193.788-1.364-.006-.134-.618-.549-2.93-.843-4.588-.177-.991-1.061-1.656-2-1.502-.862.14-1.498.924-1.493 1.85.006 1.42.027 3.533.1 5.298.284 6.879 6.664 10.06 9.758 10.97 3.815 1.122 7.499 1.254 10.28-.632 1.915-1.298 3.43-3.799 4.157-6.59l2.308-8.867c.256-.984-.287-2.003-1.212-2.274"
})), ho = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRecording_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2 3C.895 3 0 3.876 0 4.956v7.088C0 13.124.895 14 2 14h12c1.105 0 2-.876 2-1.956V4.956C16 3.876 15.105 3 14 3zm11.253 4.822h.997a1.9 1.9 0 0 0-.219-.697 1.7 1.7 0 0 0-.437-.515 1.9 1.9 0 0 0-.617-.322 2.5 2.5 0 0 0-.751-.11q-.616 0-1.107.274a1.97 1.97 0 0 0-.78.79q-.285.519-.286 1.258 0 .738.282 1.256.285.519.775.793.492.273 1.116.273.448 0 .803-.13.359-.132.615-.358.26-.227.412-.514a1.7 1.7 0 0 0 .194-.6l-.997-.005a.92.92 0 0 1-.342.563 1 1 0 0 1-.303.148q-.168.05-.367.05-.352 0-.621-.167a1.1 1.1 0 0 1-.42-.497q-.147-.329-.147-.812 0-.47.148-.8.147-.33.416-.502.27-.175.631-.175.201 0 .372.055a1 1 0 0 1 .305.16q.132.103.216.251a.9.9 0 0 1 .112.333M6.208 6.24v4.52H9.36v-.788H7.194v-1.08H9.19v-.787H7.194V7.028h2.157V6.24zM2 10.76V6.24h1.84q.528 0 .902.183.375.18.571.514.2.33.199.78 0 .45-.2.774a1.3 1.3 0 0 1-.624.513l.99 1.756H4.589l-.883-1.602h-.72v1.602zm.986-2.37h.67q.282 0 .469-.075a.55.55 0 0 0 .278-.226.7.7 0 0 0 .093-.373.7.7 0 0 0-.093-.38.57.57 0 0 0-.28-.233 1.2 1.2 0 0 0-.472-.082h-.665z",
	clipRule: "evenodd"
})), go = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRecording_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 3C1.343 3 0 4.433 0 6.2v11.6C0 19.567 1.343 21 3 21h18c1.657 0 3-1.433 3-3.2V6.2C24 4.433 22.657 3 21 3zm16.879 7.891h1.496a3.3 3.3 0 0 0-.328-1.141 2.7 2.7 0 0 0-.656-.842 2.8 2.8 0 0 0-.925-.527 3.4 3.4 0 0 0-1.128-.181q-.922 0-1.66.448-.738.444-1.168 1.293T15.08 12q0 1.207.423 2.055.427.85 1.162 1.297.738.448 1.673.448.673 0 1.206-.213a2.89 2.89 0 0 0 1.54-1.427q.232-.473.291-.982l-1.496-.008a1.6 1.6 0 0 1-.185.528 1.4 1.4 0 0 1-.328.393 1.4 1.4 0 0 1-.454.243 1.8 1.8 0 0 1-.55.082q-.53 0-.932-.274-.404-.275-.629-.813-.222-.538-.222-1.329 0-.77.222-1.308.222-.54.625-.823.403-.285.946-.286.3 0 .557.09.26.092.458.26.198.17.325.413.126.238.167.545M9.313 8.301V15.7h4.727v-1.29h-3.248v-1.766h2.992v-1.29h-2.992V9.591h3.235V8.3zM3 15.7V8.3h2.76q.793 0 1.353.3.563.296.857.842.297.54.297 1.275 0 .736-.3 1.268a2 2 0 0 1-.935.839l1.485 2.874H6.884l-1.325-2.623h-1.08V15.7zm1.48-3.88h1.003q.424 0 .704-.122a.85.85 0 0 0 .417-.369q.14-.246.14-.61 0-.369-.14-.622a.88.88 0 0 0-.42-.383q-.28-.133-.707-.133h-.998z",
	clipRule: "evenodd"
})), _o = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRefresh_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.626 1.631c1.663 0 4.235 1.205 5.595 2.333l.861-2.643A.471.471 0 0 1 15 1.48l-.035 5.078a.474.474 0 0 1-.475.472l-5.037-.035a.476.476 0 0 1-.144-.928l2.312-.784.003.003.456-.156c-1.613-1.218-3.14-1.828-4.454-1.828-2.745 0-4.976 2.248-4.976 5.014s2.23 5.013 4.976 5.013a4.92 4.92 0 0 0 4.624-3.163l.025-.066.026-.072.16-.423a.816.816 0 0 1 1.054-.48c.423.161.604.64.476 1.063l-.053.143C13.089 13.037 10.594 15 7.626 15 3.96 15 1 12.009 1 8.316S3.96 1.63 7.626 1.63"
})), vo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRefresh_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.519 3.812c2.138 0 5.445 1.548 7.194 3l1.107-3.4a.606.606 0 0 1 1.18.205l-.045 6.529a.61.61 0 0 1-.61.607l-6.476-.045a.61.61 0 0 1-.596-.517.61.61 0 0 1 .41-.676l2.973-1.008.003.004.587-.201c-2.073-1.567-4.038-2.35-5.727-2.35-3.53 0-6.397 2.89-6.397 6.446s2.868 6.446 6.397 6.446a6.33 6.33 0 0 0 5.945-4.066l.032-.086.033-.093h.002l.204-.543a1.05 1.05 0 0 1 1.356-.617c.543.207.776.823.612 1.367l-.069.183C18.544 18.477 15.335 21 11.52 21 6.806 21 3 17.154 3 12.406s3.806-8.594 8.519-8.594"
})), yo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconRemoteControl_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1m-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M7.05 6.05l1.41 1.41a5.02 5.02 0 0 1 7.08 0l1.41-1.41A6.98 6.98 0 0 0 12 4c-1.93 0-3.68.78-4.95 2.05M12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41A9 9 0 0 1 12 2c2.49 0 4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0"
})), bo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconScreenRotation_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.5 6.167a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5zm-.75 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M12.407 4.89h-2.371a.57.57 0 0 1-.423-.17.57.57 0 0 1-.17-.423q0-.252.17-.423a.57.57 0 0 1 .423-.17h.533a3.95 3.95 0 0 0-1.334-.882 4.2 4.2 0 0 0-1.57-.304q-1.053 0-1.972.497A4.04 4.04 0 0 0 4.211 4.37q-.207.297-.444.34a.7.7 0 0 1-.445-.058.57.57 0 0 1-.289-.312.43.43 0 0 1 .037-.4 5.26 5.26 0 0 1 1.934-1.904 5.24 5.24 0 0 1 2.66-.704 5.3 5.3 0 0 1 4.15 1.986V1.926q0-.253.17-.423a.57.57 0 0 1 .423-.17q.252 0 .422.17.17.171.17.423v2.37a.57.57 0 0 1-.17.423.57.57 0 0 1-.422.17"
})), xo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconScreenRotation_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M19 9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zm-1.375 5a1.06 1.06 0 1 0 0 2.122 1.06 1.06 0 0 0 0-2.121M18.61 7.335h-3.556a.86.86 0 0 1-.634-.255.86.86 0 0 1-.256-.634.86.86 0 0 1 .256-.633.86.86 0 0 1 .634-.256h.8a5.9 5.9 0 0 0-2-1.323 6.3 6.3 0 0 0-2.357-.456 6.1 6.1 0 0 0-2.957.745 6.05 6.05 0 0 0-2.223 2.034q-.312.445-.667.512-.356.066-.667-.09a.86.86 0 0 1-.433-.466.64.64 0 0 1 .055-.6 7.9 7.9 0 0 1 2.901-2.857A7.86 7.86 0 0 1 11.496 2q1.823 0 3.458.778a7.8 7.8 0 0 1 2.767 2.2V2.89a.86.86 0 0 1 .256-.633A.86.86 0 0 1 18.61 2a.86.86 0 0 1 .634.256.86.86 0 0 1 .256.633v3.557a.86.86 0 0 1-.256.634.86.86 0 0 1-.634.255"
})), So = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSearch_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11.006 9.805h-.633l-.224-.216a5.18 5.18 0 0 0 1.257-3.386 5.203 5.203 0 1 0-5.203 5.203 5.18 5.18 0 0 0 3.386-1.257l.216.224v.633L13.807 15 15 13.807zm-4.803 0a3.597 3.597 0 0 1-3.602-3.602 3.597 3.597 0 0 1 3.602-3.602 3.597 3.597 0 0 1 3.602 3.602 3.597 3.597 0 0 1-3.602 3.602"
})), Co = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSearch_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
})), wo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSend_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1 14v-4l6-2-6-2V2l15 6z"
})), To = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSend_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M3 20v-6l8-2-8-2V4l19 8z"
})), Eo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSettings_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m14.571 6.939-1.095-.156a1.11 1.11 0 0 1-.872-.681l-.005-.012a1.12 1.12 0 0 1 .134-1.101l.664-.885a.5.5 0 0 0-.046-.654l-.802-.8a.5.5 0 0 0-.654-.046l-.885.664a1.11 1.11 0 0 1-1.112.129 1.12 1.12 0 0 1-.68-.872l-.157-1.096A.5.5 0 0 0 8.566 1H7.434a.5.5 0 0 0-.495.429l-.157 1.096c-.056.391-.315.72-.68.872l-.012.004a1.12 1.12 0 0 1-1.101-.134l-.885-.664a.5.5 0 0 0-.653.047l-.801.801a.5.5 0 0 0-.047.653l.664.885c.238.318.287.735.134 1.101l-.004.012a1.12 1.12 0 0 1-.872.68l-1.096.157A.5.5 0 0 0 1 7.434v1.133a.5.5 0 0 0 .429.495l1.095.156a1.11 1.11 0 0 1 .877.692c.153.366.104.783-.134 1.101l-.664.885a.5.5 0 0 0 .046.654l.801.801a.5.5 0 0 0 .654.046l.885-.664a1.11 1.11 0 0 1 1.101-.134l.012.005c.365.151.625.481.681.872l.156 1.095a.5.5 0 0 0 .495.429h1.133a.5.5 0 0 0 .495-.429l.156-1.095c.056-.391.315-.721.681-.872l.012-.005a1.12 1.12 0 0 1 1.101.134l.885.664a.5.5 0 0 0 .654-.046l.801-.801a.5.5 0 0 0 .046-.654l-.664-.885A1.11 1.11 0 0 1 12.6 9.91l.005-.012c.151-.365.481-.625.872-.681l1.095-.156A.5.5 0 0 0 15 8.566V7.434a.5.5 0 0 0-.429-.495M8 10.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
})), Do = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSettings_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m21.387 10.484-1.565-.224a1.6 1.6 0 0 1-1.246-.972l-.007-.016a1.59 1.59 0 0 1 .192-1.572l.948-1.265a.716.716 0 0 0-.066-.934l-1.144-1.144a.714.714 0 0 0-.934-.066l-1.265.948a1.6 1.6 0 0 1-1.572.192l-.016-.007a1.59 1.59 0 0 1-.972-1.246l-.223-1.565A.715.715 0 0 0 12.809 2h-1.618a.714.714 0 0 0-.707.613l-.224 1.565a1.6 1.6 0 0 1-.972 1.246l-.016.006a1.6 1.6 0 0 1-1.573-.191L6.435 4.29a.714.714 0 0 0-.934.067L4.357 5.501a.714.714 0 0 0-.067.934L5.238 7.7c.34.453.409 1.049.192 1.572l-.006.016a1.59 1.59 0 0 1-1.246.972l-1.565.224a.71.71 0 0 0-.613.707v1.618c0 .356.261.657.613.707l1.565.224c.559.08 1.03.451 1.246.972l.007.016a1.59 1.59 0 0 1-.192 1.572l-.949 1.265a.716.716 0 0 0 .066.934L5.5 19.643c.251.251.649.28.934.066l1.265-.948a1.6 1.6 0 0 1 1.572-.192l.016.007c.522.216.892.687.972 1.246l.224 1.565a.715.715 0 0 0 .708.613h1.618a.71.71 0 0 0 .707-.613l.224-1.565c.08-.559.451-1.03.972-1.246l.016-.007a1.59 1.59 0 0 1 1.572.192l1.265.948a.716.716 0 0 0 .934-.066l1.144-1.144a.714.714 0 0 0 .066-.934l-.948-1.264a1.59 1.59 0 0 1-.192-1.572l.007-.016a1.59 1.59 0 0 1 1.246-.972l1.565-.224a.715.715 0 0 0 .613-.708v-1.618a.71.71 0 0 0-.613-.707M12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5"
})), Oo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSettingsMeeting_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m14.347 4.478.47.067a.214.214 0 0 1 .183.212v.486a.214.214 0 0 1-.183.212l-.47.067a.48.48 0 0 0-.376.297.48.48 0 0 0 .058.471l.284.38a.214.214 0 0 1-.02.28l-.343.343a.215.215 0 0 1-.28.02l-.38-.285a.48.48 0 0 0-.471-.057l-.005.002a.48.48 0 0 0-.292.374l-.067.47a.214.214 0 0 1-.212.183h-.486a.214.214 0 0 1-.212-.184l-.067-.47a.48.48 0 0 0-.291-.373l-.006-.002a.48.48 0 0 0-.471.057l-.38.285a.214.214 0 0 1-.28-.02l-.343-.343a.215.215 0 0 1-.02-.28l.285-.38a.48.48 0 0 0 .055-.476.48.48 0 0 0-.374-.292l-.47-.067A.214.214 0 0 1 9 5.243v-.486c0-.106.078-.197.184-.212l.47-.067a.48.48 0 0 0 .373-.291l.002-.006a.48.48 0 0 0-.057-.471l-.285-.38a.214.214 0 0 1 .02-.28l.343-.343a.214.214 0 0 1 .28-.02l.38.285a.48.48 0 0 0 .471.057h.003l.003-.002a.48.48 0 0 0 .291-.373l.067-.47A.214.214 0 0 1 11.757 2h.486c.106 0 .197.078.212.184l.067.47a.48.48 0 0 0 .296.375.48.48 0 0 0 .472-.057l.38-.285a.214.214 0 0 1 .28.02l.343.343a.215.215 0 0 1 .02.28l-.285.38a.48.48 0 0 0-.057.471l.002.006a.48.48 0 0 0 .374.291M10.929 5a1.071 1.071 0 1 0 2.142 0 1.071 1.071 0 0 0-2.142 0M7.98 5H2.031C.911 5 0 5.934 0 7.083v5.834C0 14.066.911 15 2.031 15h8.938c1.12 0 2.031-.934 2.031-2.083V9.259q-.341.056-.697.056A4.32 4.32 0 0 1 7.98 5m.437 3.645a1.993 1.993 0 0 1-1.99 1.991 1.993 1.993 0 0 1-1.991-1.99c0-1.098.893-1.991 1.99-1.991 1.098 0 1.991.893 1.991 1.99m-1.99 2.843c1.762 0 2.74.412 3.26.967l.01.01c.149.16.38.408.476 1.02a.543.543 0 0 1-.537.624H3.217a.543.543 0 0 1-.537-.623c.095-.604.32-.85.46-1.002l.013-.014c.516-.563 1.497-.982 3.274-.982",
	clipRule: "evenodd"
})), ko = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSettingsMeeting_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.125 7h8.894A6.5 6.5 0 0 0 20 12.826v6.049A3.13 3.13 0 0 1 16.875 22H3.125A3.13 3.13 0 0 1 0 18.875v-8.75A3.13 3.13 0 0 1 3.125 7m6.539 7.987a2.997 2.997 0 0 0 2.994-2.994A2.997 2.997 0 0 0 9.664 9a2.997 2.997 0 0 0-2.994 2.993 2.997 2.997 0 0 0 2.994 2.994m4.903 2.735c-.781-.835-2.253-1.455-4.903-1.455-2.672 0-4.146.631-4.922 1.477l-.02.022c-.21.228-.55.597-.692 1.506-.076.49.311.937.808.937h9.652a.817.817 0 0 0 .807-.937c-.143-.92-.491-1.293-.716-1.535z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m22.724 5.818-.704-.1a.72.72 0 0 1-.564-.446.72.72 0 0 1 .087-.708l.427-.569a.32.32 0 0 0-.03-.42l-.516-.514a.32.32 0 0 0-.42-.03l-.569.427a.72.72 0 0 1-.715.083.72.72 0 0 1-.437-.56l-.1-.705a.32.32 0 0 0-.32-.276h-.727a.32.32 0 0 0-.318.276l-.101.704a.72.72 0 0 1-.437.56q-.004.003-.008.003a.72.72 0 0 1-.708-.086l-.569-.426a.32.32 0 0 0-.42.03l-.514.515a.32.32 0 0 0-.03.42l.426.568a.72.72 0 0 1 .086.708l-.002.008a.72.72 0 0 1-.56.437l-.705.1a.32.32 0 0 0-.276.32v.728c0 .16.118.295.276.318l.704.1a.72.72 0 0 1 .563.445.72.72 0 0 1-.086.708l-.427.569a.32.32 0 0 0 .03.42l.515.515a.32.32 0 0 0 .42.03l.57-.427a.72.72 0 0 1 .707-.086q.004 0 .008.003c.235.097.402.309.438.56l.1.704a.32.32 0 0 0 .318.276h.729c.16 0 .295-.118.318-.276l.1-.704a.72.72 0 0 1 .438-.56l.008-.004a.72.72 0 0 1 .707.087l.57.427a.32.32 0 0 0 .42-.03l.515-.515a.32.32 0 0 0 .03-.42l-.428-.57a.72.72 0 0 1-.086-.707l.003-.008a.72.72 0 0 1 .56-.438l.705-.1A.32.32 0 0 0 23 6.864v-.728a.32.32 0 0 0-.276-.318M18.5 8.108a1.607 1.607 0 1 1 0-3.215 1.607 1.607 0 0 1 0 3.214"
})), Ao = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShare_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M3.8 3A2.8 2.8 0 0 0 1 5.8v4.667a2.8 2.8 0 0 0 2.8 2.8h3.57V8.2L5.092 9.504c-.179.104-.398.042-.515-.146a.53.53 0 0 1 .043-.61l3.09-3.562a.382.382 0 0 1 .58 0l3.09 3.562c.142.163.16.421.043.61-.116.185-.334.25-.514.146L8.63 8.2v5.067h3.57a2.8 2.8 0 0 0 2.8-2.8V5.8A2.8 2.8 0 0 0 12.2 3z"
})), jo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShare_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M4.8 3A4.8 4.8 0 0 0 0 7.8v8.4A4.8 4.8 0 0 0 4.8 21h6.12v-8.883l-3.906 2.287c-.306.182-.682.072-.882-.258a.94.94 0 0 1 .074-1.068l5.297-6.245c.263-.31.73-.31.993 0l5.298 6.245a.94.94 0 0 1 .074 1.068c-.198.326-.572.44-.882.258l-3.906-2.287V21h6.12a4.8 4.8 0 0 0 4.8-4.8V7.8A4.8 4.8 0 0 0 19.2 3z"
})), Mo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShield_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.584 12.209Q5.168 14.387 7.6 15q2.432-.613 4.016-2.791Q13.2 10.029 13.2 7.37V3.1L7.6 1 2 3.1v4.27q0 2.66 1.584 4.839m6.332-6.091a.402.402 0 1 1 .569.569L7.289 9.882a.4.4 0 0 1-.57 0L5.119 8.28a.402.402 0 1 1 .569-.569L7.004 9.03z",
	clipRule: "evenodd"
})), No = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShield_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M6.263 18.013Q8.525 21.124 12 22q3.476-.875 5.738-3.988T20 11.1V5l-8-3-8 3v6.1q0 3.8 2.263 6.913m9.34-9.807a.703.703 0 1 1 .995.996l-5.592 5.591a.704.704 0 0 1-.996 0L7.207 11.99a.703.703 0 1 1 .995-.996l2.306 2.307z",
	clipRule: "evenodd"
})), Po = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShuffle_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m8.872 1.966 2.792.912L1.58 12.673a.943.943 0 0 0 0 1.363 1.01 1.01 0 0 0 1.402 0L13.066 4.24l.938 2.712c.08.232.325.373.567.333a.5.5 0 0 0 .43-.49V1.496A.503.503 0 0 0 14.488 1H9.035a.51.51 0 0 0-.505.416c-.04.24.104.473.342.55m5.133 7.08-.938 2.713-2.835-2.754a1.01 1.01 0 0 0-1.402 0 .943.943 0 0 0 0 1.362l2.835 2.754-2.792.912a.5.5 0 0 0-.342.55c.04.242.254.417.503.417h5.455c.283 0 .51-.222.51-.496v-5.3a.5.5 0 0 0-.428-.49.51.51 0 0 0-.566.333M1.287 1.686a.944.944 0 0 0 .007 1.362l3.93 3.778c.39.374 1.018.371 1.403-.007a.944.944 0 0 0-.007-1.363L2.69 1.677a1.01 1.01 0 0 0-1.403.008",
	clipRule: "evenodd"
})), Fo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconShuffle_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "m13.121 4.312 3.59 1.237L3.746 18.842a1.33 1.33 0 0 0 0 1.85 1.25 1.25 0 0 0 1.803 0L18.514 7.396l1.206 3.681a.66.66 0 0 0 .728.452.67.67 0 0 0 .552-.665V3.673A.664.664 0 0 0 20.343 3H13.33a.664.664 0 0 0-.649.565.675.675 0 0 0 .44.747m6.6 9.608-1.207 3.681-3.644-3.737a1.25 1.25 0 0 0-1.803 0 1.33 1.33 0 0 0 0 1.849l3.644 3.737-3.589 1.237a.68.68 0 0 0-.44.747.66.66 0 0 0 .648.566h7.013c.363 0 .657-.3.657-.673v-7.192a.67.67 0 0 0-.551-.666.655.655 0 0 0-.728.451M3.369 3.93a1.33 1.33 0 0 0 .01 1.849l5.052 5.126c.5.508 1.308.504 1.803-.01a1.33 1.33 0 0 0-.01-1.849L5.173 3.92a1.253 1.253 0 0 0-1.803.01",
	clipRule: "evenodd"
})), Io = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSort_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.833 6.352 4.843 3.39a.6.6 0 0 0-.845 0l-2.99 2.962a.59.59 0 0 0 0 .837.6.6 0 0 0 .846 0l1.992-1.973v6.967c0 .332.272.6.606.6a.603.603 0 0 0 .606-.6V5.278l1.93 1.911a.6.6 0 0 0 .845 0 .59.59 0 0 0 0-.837M7.834 9.648l2.989 2.962a.6.6 0 0 0 .845 0l2.99-2.962a.59.59 0 0 0 0-.837.6.6 0 0 0-.845 0l-1.993 1.973V3.817c0-.331-.27-.6-.606-.6a.603.603 0 0 0-.605.6v6.905l-1.93-1.911a.6.6 0 0 0-.845 0 .59.59 0 0 0 0 .837"
})), Lo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSort_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12 14.355a.84.84 0 0 1 0-1.196.86.86 0 0 1 1.208 0l2.757 2.73V6.025c0-.474.387-.857.865-.858.478 0 .866.384.866.858v9.952l2.846-2.818a.86.86 0 0 1 1.208 0 .84.84 0 0 1 0 1.196l-4.271 4.23a.86.86 0 0 1-1.207 0zM2.25 10.841a.84.84 0 0 1 0-1.196l4.271-4.23a.86.86 0 0 1 1.208 0L12 9.644a.84.84 0 0 1 0 1.196.86.86 0 0 1-1.208 0l-2.757-2.73v9.865a.86.86 0 0 1-.865.857.86.86 0 0 1-.865-.857V8.023L3.458 10.84a.86.86 0 0 1-1.208 0"
})), Ro = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerDisabled_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2.037 1.636a.5.5 0 0 1 .707 0l12.408 12.411a.5.5 0 0 1-.707.707l-1.02-1.021a7 7 0 0 1-.637.524.599.599 0 1 1-.702-.972 3 3 0 0 0 .324-.283q.072-.07.146-.138l-1.473-1.473a4.3 4.3 0 0 1-.929.616.6.6 0 0 1-.509-1.087c.216-.101.409-.233.592-.376L7.5 7.807v5.526a.666.666 0 0 1-1.2.4l-2.27-3.028-2.19-.438A1.67 1.67 0 0 1 .5 8.633V7.366c0-.794.561-1.478 1.34-1.634l2.189-.438.411-.548-2.403-2.403a.5.5 0 0 1 0-.707M14.8 8c0 1.19-.34 2.339-.94 3.338l.874.874A7.7 7.7 0 0 0 16 8a7.75 7.75 0 0 0-3.21-6.257.599.599 0 1 0-.702.972A6.54 6.54 0 0 1 14.8 8M6.833 2c.369 0 .667.298.667.667v2.311L5.652 3.13l.648-.863A.67.67 0 0 1 6.833 2m4.681 6a3.25 3.25 0 0 0-1.869-2.92.6.6 0 0 1 .509-1.087A4.45 4.45 0 0 1 12.714 8c0 .631-.139 1.243-.391 1.802l-.933-.933q.122-.421.124-.869",
	clipRule: "evenodd"
})), zo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerDisabled_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.021 4.045a.625.625 0 0 1 .884 0L20.418 19.56a.625.625 0 0 1-.884.884l-1.276-1.276a9 9 0 0 1-.796.655.75.75 0 1 1-.878-1.216c.146-.106.274-.23.403-.353q.09-.087.184-.173l-1.842-1.842a5.3 5.3 0 0 1-1.16.77.751.751 0 0 1-.638-1.359c.27-.126.511-.29.74-.47l-3.42-3.42v6.907a.833.833 0 0 1-1.5.5l-2.839-3.784-2.737-.547A2.084 2.084 0 0 1 2.1 12.792v-1.584c0-.993.701-1.848 1.675-2.043l2.737-.547.513-.684L4.021 4.93a.625.625 0 0 1 0-.884M19.975 12a8.1 8.1 0 0 1-1.175 4.173l1.093 1.093A9.63 9.63 0 0 0 21.476 12a9.69 9.69 0 0 0-4.013-7.822.75.75 0 1 0-.878 1.216A8.18 8.18 0 0 1 19.975 12m-9.958-7.5c.46 0 .833.373.833.833v2.89l-2.31-2.31.81-1.08a.83.83 0 0 1 .667-.333m5.85 7.5a4.06 4.06 0 0 0-2.336-3.65.75.75 0 1 1 .638-1.358 5.56 5.56 0 0 1 3.2 5.01c0 .787-.175 1.553-.49 2.251l-1.167-1.167c.1-.35.155-.714.155-1.086",
	clipRule: "evenodd"
})), Bo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerOff_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.833 2a.67.67 0 0 0-.533.267L4.029 5.294l-2.189.438C1.061 5.888.5 6.572.5 7.366v1.267c0 .794.561 1.478 1.34 1.634l2.19.438 2.27 3.028a.666.666 0 0 0 1.2-.4V2.667A.666.666 0 0 0 6.833 2"
})), Vo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerOff_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M10.017 4.5a.83.83 0 0 0-.667.333L6.512 8.618l-2.737.547A2.084 2.084 0 0 0 2.1 11.208v1.584c0 .993.701 1.848 1.675 2.043l2.737.547 2.838 3.784a.833.833 0 0 0 1.5-.5V5.333a.833.833 0 0 0-.833-.833"
})), Ho = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerOn_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#IconSpeakerOn_16__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M11.953 1.878a.6.6 0 0 1 .837-.135A7.75 7.75 0 0 1 16 8a7.75 7.75 0 0 1-3.21 6.257.599.599 0 1 1-.702-.972A6.54 6.54 0 0 0 14.8 8a6.54 6.54 0 0 0-2.712-5.285.6.6 0 0 1-.135-.837M6.833 2a.67.67 0 0 0-.533.267L4.029 5.294l-2.189.438C1.061 5.888.5 6.572.5 7.366v1.267c0 .794.561 1.478 1.34 1.634l2.19.438 2.27 3.028a.666.666 0 0 0 1.2-.4V2.667A.666.666 0 0 0 6.833 2m3.322 1.993a.6.6 0 0 0-.51 1.087A3.25 3.25 0 0 1 11.514 8a3.25 3.25 0 0 1-1.869 2.92.6.6 0 0 0 .509 1.087A4.45 4.45 0 0 0 12.714 8a4.45 4.45 0 0 0-2.559-4.007",
	clipRule: "evenodd"
})), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconSpeakerOn_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), Uo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpeakerOn_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M16.415 4.347a.75.75 0 0 1 1.047-.169A9.69 9.69 0 0 1 21.475 12a9.68 9.68 0 0 1-4.013 7.822.75.75 0 1 1-.878-1.216A8.17 8.17 0 0 0 19.975 12a8.18 8.18 0 0 0-3.39-6.606.75.75 0 0 1-.17-1.047m-6.398.153a.83.83 0 0 0-.667.333L6.512 8.618l-2.737.547A2.084 2.084 0 0 0 2.1 11.208v1.584c0 .993.701 1.848 1.675 2.043l2.737.547 2.838 3.784a.833.833 0 0 0 1.5-.5V5.333a.833.833 0 0 0-.833-.833m4.151 2.491a.75.75 0 1 0-.637 1.359A4.06 4.06 0 0 1 15.867 12a4.06 4.06 0 0 1-2.336 3.65.75.75 0 0 0 .637 1.36 5.56 5.56 0 0 0 3.2-5.01 5.56 5.56 0 0 0-3.2-5.009",
	clipRule: "evenodd"
})), Wo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpotlight_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("g", {
	fill: "currentColor",
	clipPath: "url(#IconSpotlight_16__a)"
}, /* @__PURE__ */ e.createElement("path", { d: "M0 1.455v2.181h1.455V1.455h2.181V0H1.455A1.4 1.4 0 0 0 .427.427 1.4 1.4 0 0 0 0 1.455M1.455 16h2.181v-1.454H1.455v-2.182H0v2.182q0 .6.427 1.027A1.4 1.4 0 0 0 1.455 16M12.364 14.546V16h2.182a1.4 1.4 0 0 0 1.027-.427A1.4 1.4 0 0 0 16 14.546v-2.182h-1.454v2.182zM14.546 1.455v2.181H16V1.455a1.4 1.4 0 0 0-.427-1.028A1.4 1.4 0 0 0 14.546 0h-2.182v1.455zM8 8.308a2.33 2.33 0 0 0 2.32-2.336A2.33 2.33 0 0 0 8 3.636a2.33 2.33 0 0 0-2.32 2.336A2.33 2.33 0 0 0 8 8.308M11.791 10.427c-.604-.65-1.742-1.133-3.791-1.133-2.066 0-3.206.492-3.806 1.15l-.016.017c-.162.178-.424.466-.534 1.173-.06.382.24.73.624.73h7.464a.634.634 0 0 0 .624-.73c-.11-.717-.38-1.007-.554-1.195z" })), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "IconSpotlight_16__a" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})))), Go = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSpotlight_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1 3v3h2V3h3V1H3q-.824 0-1.412.587A1.93 1.93 0 0 0 1 3M3 23h3v-2H3v-3H1v3q0 .824.587 1.413Q2.176 23 3 23M18 21v2h3q.824 0 1.413-.587Q23 21.825 23 21v-3h-2v3zM21 3v3h2V3q0-.824-.587-1.412A1.93 1.93 0 0 0 21 1h-3v2zM12 12.423c1.76 0 3.19-1.44 3.19-3.212C15.19 7.441 13.757 6 12 6S8.81 7.44 8.81 9.211c0 1.772 1.43 3.212 3.19 3.212M17.213 15.338c-.83-.894-2.396-1.558-5.213-1.558-2.84 0-4.409.676-5.233 1.581l-.022.024c-.223.244-.584.639-.735 1.612A.873.873 0 0 0 6.868 18h10.264c.528 0 .94-.478.858-1.003-.153-.986-.523-1.385-.762-1.643z"
})), Ko = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconStar_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m14.773 5.86-4.28-.622L8.579 1.36a.646.646 0 0 0-1.158 0L5.507 5.238l-4.28.622a.646.646 0 0 0-.358 1.102l3.097 3.019-.731 4.263a.646.646 0 0 0 .937.681L8 12.912l3.828 2.013a.646.646 0 0 0 .937-.681l-.731-4.263 3.097-3.019a.646.646 0 0 0-.358-1.102"
})), qo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconStar_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m21.676 8.943-6.114-.888-2.734-5.54a.923.923 0 0 0-1.655 0l-2.734 5.54-6.115.888a.923.923 0 0 0-.511 1.574l4.424 4.313-1.044 6.09a.923.923 0 0 0 1.339.973L12 19.017l5.469 2.875a.923.923 0 0 0 1.339-.973l-1.044-6.09 4.424-4.313a.922.922 0 0 0-.512-1.573"
})), Jo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconStopRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M5.9 5.2a.7.7 0 0 0-.7.7v4.2a.7.7 0 0 0 .7.7h4.2a.7.7 0 0 0 .7-.7V5.9a.7.7 0 0 0-.7-.7z",
	clipRule: "evenodd"
})), Yo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconStopRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M9 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z",
	clipRule: "evenodd"
})), Xo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSupport_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.588 1.139c-2.812.553-5.04 2.877-5.495 5.707-.527 3.277 1.242 6.214 3.945 7.482a1.244 1.244 0 0 0 2.489-.053 1.25 1.25 0 0 0-2.137-.88A6.03 6.03 0 0 1 2.345 10h1.082a5.04 5.04 0 0 0 1.927 2.227 2.23 2.23 0 0 1 2.766.76 5 5 0 0 0 4.454-2.988h1.334c.495 0 .913-.362.996-.85Q14.999 8.589 15 8a7.01 7.01 0 0 0-8.412-6.861M5.143 6.893a.893.893 0 1 1 1.786 0 .893.893 0 0 1-1.786 0m5.113 3.371c-.036.039-.89.965-2.256.965s-2.22-.925-2.256-.964a.501.501 0 0 1 .74-.673c.005.004.604.637 1.516.637s1.51-.633 1.517-.639a.501.501 0 0 1 .739.674m-.292-2.478a.893.893 0 1 1 0-1.787.893.893 0 0 1 0 1.787M12.899 7A5 5 0 0 0 3.1 7H2.08v-.002c.408-2.51 2.455-4.537 4.968-4.925A6.006 6.006 0 0 1 13.909 7z"
})), Zo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSupport_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.078 1.008c-5.243.207-9.642 4.433-10.046 9.664-.351 4.545 2.216 8.536 6.018 10.321a1.87 1.87 0 0 0 3.742-.081 1.874 1.874 0 0 0-3.208-1.317A9.05 9.05 0 0 1 4.018 14.5h1.619a7.54 7.54 0 0 0 2.881 3.347c.425-.198.898-.31 1.399-.31 1.149 0 2.161.577 2.77 1.454a7.5 7.5 0 0 0 6.682-4.491h1.997c.722 0 1.356-.511 1.48-1.223q.153-.867.154-1.777C23 5.57 18.059.773 12.078 1.008M8.214 9.839a1.339 1.339 0 1 1 2.678 0 1.339 1.339 0 0 1-2.678 0m7.67 5.057c-.053.059-1.335 1.448-3.384 1.448s-3.331-1.389-3.384-1.448a.75.75 0 1 1 1.111-1.007c.006.006.904.955 2.272.955s2.267-.949 2.275-.958a.754.754 0 0 1 1.058-.043.745.745 0 0 1 .052 1.053m-.438-3.717a1.339 1.339 0 1 1 0-2.678 1.339 1.339 0 0 1 0 2.678M19.849 10A7.5 7.5 0 0 0 12.5 4a7.5 7.5 0 0 0-7.349 6H3.622v-.003c.614-3.772 3.676-6.803 7.453-7.387 5.066-.782 9.496 2.694 10.289 7.39z"
})), Qo = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSupportAgent_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("mask", {
	id: "IconSupportAgent_16__a",
	width: 16,
	height: 16,
	x: 0,
	y: 0,
	maskUnits: "userSpaceOnUse",
	style: { maskType: "alpha" }
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h16v16H0z"
})), /* @__PURE__ */ e.createElement("g", { mask: "url(#IconSupportAgent_16__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M7.333 14v-1.333h5.334V7.933q0-1.95-1.359-3.308T8 3.267 4.692 4.625 3.333 7.933V12h-.666q-.55 0-.942-.392a1.28 1.28 0 0 1-.392-.941V9.333q0-.35.175-.658T2 8.183l.05-.883a5.8 5.8 0 0 1 .658-2.1 6.3 6.3 0 0 1 1.317-1.683A5.9 5.9 0 0 1 5.842 2.4 5.9 5.9 0 0 1 8 2q1.133 0 2.15.4a5.985 5.985 0 0 1 3.133 2.783 6.1 6.1 0 0 1 .667 2.1l.05.867q.317.15.492.45t.175.633v1.534q0 .333-.175.633-.176.3-.492.45v.817q0 .55-.392.941a1.28 1.28 0 0 1-.941.392z"
}))), $o = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconSupportAgent_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("mask", {
	id: "IconSupportAgent_24__a",
	width: 24,
	height: 24,
	x: 0,
	y: 0,
	maskUnits: "userSpaceOnUse",
	style: { maskType: "alpha" }
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M0 0h24v24H0z"
})), /* @__PURE__ */ e.createElement("g", { mask: "url(#IconSupportAgent_24__a)" }, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M11 21v-2h8v-7.1q0-2.925-2.038-4.962T12 4.9 7.038 6.937 5 11.9V18H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16v-2q0-.525.263-.988.262-.462.737-.737l.075-1.325a8.7 8.7 0 0 1 .987-3.15 9.5 9.5 0 0 1 1.975-2.525A8.8 8.8 0 0 1 8.763 3.6Q10.3 3 12 3t3.225.6 2.725 1.663a9 9 0 0 1 1.975 2.512q.775 1.45 1 3.15l.075 1.3q.475.225.738.675.262.45.262.95v2.3q0 .5-.262.95t-.738.675V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
}))), es = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTestScriptIcon_16",
	viewBox: "0 0 15 14",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.7 3.526h-1.417a1.9 1.9 0 0 0 .117-.631C11.4 1.846 10.529 1 9.45 1c-.682 0-1.274.341-1.625.853l-.325.423-.325-.43A1.97 1.97 0 0 0 5.55 1C4.471 1 3.6 1.846 3.6 2.895c0 .22.046.436.117.631H2.3c-.721 0-1.293.562-1.293 1.263L1 11.737c0 .7.579 1.263 1.3 1.263h10.4c.722 0 1.3-.562 1.3-1.263V4.789c0-.7-.578-1.263-1.3-1.263M9.45 2.263c.357 0 .65.284.65.632a.643.643 0 0 1-.65.631.643.643 0 0 1-.65-.631c0-.348.292-.632.65-.632m-3.9 0c.357 0 .65.284.65.632a.643.643 0 0 1-.65.631.643.643 0 0 1-.65-.631c0-.348.292-.632.65-.632m7.15 9.474H2.3v-1.263h10.4zm0-3.158H2.3v-3.79h3.302L4.25 6.577l1.053.739L6.85 5.269l.65-.858.65.858 1.547 2.047 1.053-.74L9.398 4.79H12.7z"
})), ts = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTestScriptIcon_24",
	viewBox: "0 0 21 19",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.2 4.368h-1.962c.099-.26.162-.547.162-.842C16.4 2.128 15.194 1 13.7 1c-.945 0-1.764.455-2.25 1.137L11 2.7l-.45-.573A2.76 2.76 0 0 0 8.3 1C6.806 1 5.6 2.128 5.6 3.526c0 .295.063.581.162.842H3.8c-.999 0-1.791.75-1.791 1.685L2 15.316C2 16.25 2.801 17 3.8 17h14.4c.999 0 1.8-.75 1.8-1.684V6.053c0-.935-.801-1.685-1.8-1.685m-4.5-1.684c.495 0 .9.38.9.842 0 .463-.405.842-.9.842s-.9-.379-.9-.842.405-.842.9-.842m-5.4 0c.495 0 .9.38.9.842 0 .463-.405.842-.9.842s-.9-.379-.9-.842.405-.842.9-.842m9.9 12.632H3.8v-1.684h14.4zm0-4.21H3.8V6.052h4.572L6.5 8.436l1.458.985L10.1 6.693l.9-1.146.9 1.146 2.142 2.728 1.458-.985-1.872-2.383H18.2z"
})), ns = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconThumbsDown_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2m4 0v12h4V3z"
})), rs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconThumbsUp_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z"
})), is = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTimer_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5 1.966C5 1.432 5.432 1 5.965 1h5.07a.966.966 0 0 1 0 1.931H9.5v1.536c2.56.454 4.5 2.62 4.5 5.223C14 12.623 11.538 15 8.5 15S3 12.623 3 9.69c0-2.604 1.94-4.77 4.5-5.223V2.93H5.965A.966.966 0 0 1 5 1.966m7.498 5.474-2.73 2.597c-.25.238-.59.326-.905.273a1.04 1.04 0 0 1-.675-.413.97.97 0 0 1-.153-.832c.075-.273.27-.517.56-.65l3.463-1.583c.396-.18.752.31.44.608",
	clipRule: "evenodd"
})), as = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTimer_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.09 2.517C7.09 1.68 7.77 1 8.609 1h7.784a1.517 1.517 0 1 1 0 3.034H8.608c-.838 0-1.517-.679-1.517-1.517m3.865 3.93C6.998 7.162 4 10.566 4 14.656 4 19.264 7.806 23 12.5 23s8.5-3.736 8.5-8.345c0-4.09-2.998-7.494-6.954-8.207V4.035h-3.091zm7.723 4.673L14.46 15.2a1.62 1.62 0 0 1-1.399.431 1.6 1.6 0 0 1-1.043-.65 1.54 1.54 0 0 1-.235-1.307c.116-.43.415-.812.864-1.02L18 10.164c.612-.283 1.162.489.68.956",
	clipRule: "evenodd"
})), os = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTranscript_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.542 1c-1.182 0-2.315.47-3.151 1.305L3.095 6.601a.64.64 0 0 0-.186.45v5.14l-1.723 1.723a.636.636 0 1 0 .9.9l1.718-1.718h5.15c.17 0 .332-.067.451-.187l4.29-4.301A4.457 4.457 0 0 0 10.541 1m1.71 2.742a.69.69 0 0 1 0 .975L8.328 8.631h2.219a.636.636 0 1 1 0 1.273H7.05L5.209 11.74c-.059.063-.09.094-.12.094H4.22c-.068 0-.124 0-.124-.062v-.743c0-.062.01-.103.092-.185l7.089-7.103a.69.69 0 0 1 .975 0",
	clipRule: "evenodd"
})), ss = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTranscript_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15.632 2c-1.689 0-3.308.67-4.502 1.865L4.993 10a.9.9 0 0 0-.266.643v7.343l-2.46 2.461a.909.909 0 1 0 1.285 1.286l2.453-2.454h7.359a.9.9 0 0 0 .643-.267l6.127-6.145A6.367 6.367 0 0 0 15.632 2m2.443 3.917a.985.985 0 0 1 0 1.393l-5.607 5.592h3.168a.91.91 0 1 1 0 1.818h-4.992l-2.632 2.624c-.083.09-.128.135-.172.135H6.601c-.097 0-.177 0-.177-.089v-1.062c0-.088.016-.147.132-.264h.001L16.682 5.916a.985.985 0 0 1 1.393 0",
	clipRule: "evenodd"
})), cs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTranslation_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.25 1c.449 0 .818.338.87.772l.005.103v.875H8a.875.875 0 0 1 .102 1.744L8 4.5l-.906.001c-.128 1.76-.635 3.36-1.411 4.584l-.051.078c.7.287 1.549.488 2.491.56l1.702-3.828c.277-.622 1.097-.686 1.485-.192l.063.093.05.099 3.5 7.875a.874.874 0 0 1-1.55.801l-.048-.09-.547-1.231H8.471l-.547 1.23a.875.875 0 0 1-1.059.48l-.095-.036a.875.875 0 0 1-.48-1.059l.035-.095 1.051-2.366c-1.098-.144-2.105-.444-2.95-.869-.745.614-1.61.965-2.551.965a.875.875 0 0 1-.103-1.744l.103-.006a2.1 2.1 0 0 0 1.034-.29c-.656-.663-1.035-1.458-1.034-2.337a.875.875 0 0 1 1.744-.099l.006.102c0 .378.188.755.527 1.103.618-.934 1.06-2.236 1.186-3.728L1.875 4.5a.875.875 0 0 1-.103-1.744l.103-.006h3.5v-.875c0-.483.392-.875.875-.875m2.999 10.5h2.752l-1.376-3.097z"
})), ls = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTranslation_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.5 2c.64 0 1.169.483 1.241 1.104l.009.146V4.5H12a1.25 1.25 0 0 1 .146 2.491L12 7l-1.295.001c-.182 2.514-.906 4.8-2.016 6.55l-.073.11c1 .41 2.214.697 3.56.8l2.431-5.469c.395-.888 1.567-.979 2.122-.273l.09.133.074.14 5 11.25a1.25 1.25 0 0 1-2.218 1.145l-.068-.13-.78-1.757h-6.154l-.78 1.757c-.26.585-.917.873-1.514.686l-.137-.051a1.25 1.25 0 0 1-.685-1.513l.051-.137 1.501-3.378c-1.568-.206-3.008-.635-4.213-1.242C5.83 16.5 4.594 17 3.25 17a1.25 1.25 0 0 1-.146-2.492l.146-.008c.506 0 1.004-.145 1.478-.413-.938-.95-1.48-2.084-1.478-3.339a1.25 1.25 0 0 1 2.492-.142l.008.146c0 .54.268 1.08.753 1.575.882-1.334 1.514-3.194 1.694-5.326L3.25 7a1.25 1.25 0 0 1-.146-2.491L3.25 4.5h5V3.25C8.25 2.56 8.81 2 9.5 2m4.284 15h3.933l-1.966-4.424z"
})), us = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTrash_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M5.9 2.3v.1H1.7a.7.7 0 1 0 0 1.4h12.6a.7.7 0 1 0 0-1.4h-4.2v-.1a2 2 0 0 0-2-2h-.2a2 2 0 0 0-2 2"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13.6 5.2H2.4v8.5a2 2 0 0 0 2 2h7.2a2 2 0 0 0 2-2zM7.3 8a.7.7 0 1 0-1.4 0v4.9a.7.7 0 1 0 1.4 0zm2.1-.7a.7.7 0 0 1 .7.7v4.9a.7.7 0 0 1-1.4 0V8a.7.7 0 0 1 .7-.7",
	clipRule: "evenodd"
})), ds = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconTrash_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M15 6H3a1 1 0 0 1 0-2h6V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h6a1 1 0 1 1 0 2zm5 2H4v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-9 4a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0zm3-1a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1",
	clipRule: "evenodd"
})), fs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconUnlock_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M9.907 6.385V4.077c0-1.052.821-1.908 1.91-1.908s1.91.856 1.91 1.908v.461H15v-.461C15 2.378 13.574 1 11.817 1S8.634 2.378 8.634 4.077v2.308z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2.637 6.385A.626.626 0 0 0 2 7v7.385c0 .34.285.615.637.615h9.23a.626.626 0 0 0 .637-.615V7a.626.626 0 0 0-.637-.615z"
})), ps = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconUnlock_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M14.165 9.462V5.835c0-1.653 1.263-2.998 2.938-2.998s2.938 1.345 2.938 2.998v.725H22v-.725C22 3.166 19.806 1 17.103 1s-4.897 2.166-4.897 4.835v3.627z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M2.98 9.462c-.542 0-.98.432-.98.967v11.604c0 .534.438.967.98.967h14.2c.541 0 .98-.433.98-.967V10.429a.973.973 0 0 0-.98-.967z"
})), ms = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOff_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1.417 1.661a.5.5 0 0 0-.707.707l1.723 1.723A1.995 1.995 0 0 0 1 6v4a2 2 0 0 0 2 2h7c.09 0 .177-.014.264-.028l.042-.007 2.815 2.815a.5.5 0 0 0 .707-.707zM12 10V6a2 2 0 0 0-2-2H5.17l6.698 6.698c.081-.218.132-.451.132-.698m1-3.5 2.18-1.817a.5.5 0 0 1 .82.385v5.865a.5.5 0 0 1-.82.384L13 9.5z",
	clipRule: "evenodd"
})), hs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOff_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.567 4.076a.625.625 0 0 0-.884.884l2.154 2.154A2.49 2.49 0 0 0 3.046 9.5v4.99a2.5 2.5 0 0 0 2.5 2.5h8.75a2.4 2.4 0 0 0 .382-.034l3.518 3.518a.625.625 0 0 0 .884-.884zM16.796 14.5v-5a2.5 2.5 0 0 0-2.5-2.5H8.258l8.373 8.373c.101-.273.165-.565.165-.873m1.25-4.375 2.725-2.271a.625.625 0 0 1 1.025.48v7.332c0 .53-.618.819-1.025.48l-2.725-2.271z",
	clipRule: "evenodd"
})), gs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOff_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.09 5.577a.834.834 0 0 0-1.18 1.179l2.873 2.872a3.32 3.32 0 0 0-2.388 3.181v6.654a3.333 3.333 0 0 0 3.333 3.333h11.667c.176 0 .341-.019.51-.045l4.69 4.69a.834.834 0 0 0 1.178-1.178zm17.638 13.899v-6.667a3.333 3.333 0 0 0-3.333-3.333h-8.05L21.507 20.64c.135-.364.22-.753.22-1.164m1.667-5.833 3.633-3.028a.834.834 0 0 1 1.367.64v9.776a.833.833 0 0 1-1.367.64l-3.633-3.028z",
	clipRule: "evenodd"
})), _s = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOn_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3 4h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m10 2.5 2.18-1.817a.5.5 0 0 1 .82.385v5.865a.5.5 0 0 1-.82.384L13 9.5z",
	clipRule: "evenodd"
})), vs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOn_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M5.65 7h8.75a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5H5.65a2.5 2.5 0 0 1-2.5-2.5v-5A2.5 2.5 0 0 1 5.65 7m12.5 3.125 2.725-2.271a.625.625 0 0 1 1.025.48v7.332c0 .53-.618.819-1.025.48l-2.725-2.271z",
	clipRule: "evenodd"
})), ys = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoOn_32",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M7.533 9.333H19.2a3.333 3.333 0 0 1 3.333 3.334v6.666a3.333 3.333 0 0 1-3.333 3.334H7.533A3.333 3.333 0 0 1 4.2 19.333v-6.666a3.333 3.333 0 0 1 3.333-3.334M24.2 13.5l3.633-3.028a.834.834 0 0 1 1.367.64v9.776a.833.833 0 0 1-1.367.64L24.2 18.5z",
	clipRule: "evenodd"
})), bs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoSystems_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M10.947 3.061a2.763 2.763 0 1 1-5.527 0 2.763 2.763 0 0 1 5.527 0m-1.274 0a1.488 1.488 0 1 1-2.976 0 1.488 1.488 0 0 1 2.976 0M3.026 2.51h-.11A1.916 1.916 0 0 0 1 4.426v6.485c0 1.058.858 1.915 1.916 1.915h10.168A1.916 1.916 0 0 0 15 10.91V4.425a1.916 1.916 0 0 0-1.916-1.915h-.075l-.035-.001h-.368a.553.553 0 0 0 0 1.105h.17v.001h.308a.81.81 0 0 1 .81.81v6.485a.81.81 0 0 1-.81.81H2.916a.81.81 0 0 1-.81-.81V4.425a.81.81 0 0 1 .81-.81h.31v-.001h.537a.553.553 0 0 0 0-1.105zm2.948 11.053h4.052l.535 1.604a.46.46 0 0 1-.437.607H5.876a.46.46 0 0 1-.437-.607zm2.763-10.5a.553.553 0 1 1-1.105 0 .553.553 0 0 1 1.105 0m-4.62 1.657c.349 0 .66.207.855.497A3.87 3.87 0 0 0 8.185 6.93c1.39 0 2.609-.733 3.29-1.834a.76.76 0 0 1 .636-.377.68.68 0 0 1 .679.68v3.815a1.4 1.4 0 0 1-1.4 1.4H4.61a1.4 1.4 0 0 1-1.4-1.4v-3.59c0-.5.406-.905.906-.905",
	clipRule: "evenodd"
})), xs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconVideoSystems_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M13.053 4.947a.79.79 0 1 1-1.58 0 .79.79 0 0 1 1.58 0"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M16.21 4.947a3.948 3.948 0 1 1-7.895 0 3.948 3.948 0 0 1 7.895 0m-1.82 0a2.126 2.126 0 1 1-4.251 0 2.126 2.126 0 0 1 4.25 0",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "m4.894 4.158-.042.001h-.115A2.737 2.737 0 0 0 2 6.896v9.263a2.737 2.737 0 0 0 2.737 2.737h14.526A2.737 2.737 0 0 0 22 16.159V6.896a2.737 2.737 0 0 0-2.737-2.737h-.116l-.041-.001h-.527a.79.79 0 0 0 0 1.579h.244v.001h.44c.64 0 1.158.518 1.158 1.158v9.263c0 .64-.518 1.158-1.158 1.158H4.737a1.16 1.16 0 0 1-1.158-1.158V6.896c0-.64.518-1.158 1.158-1.158h.441v-.001h.769a.79.79 0 1 0 0-1.579zM9.105 19.949h5.79l.764 2.291a.658.658 0 0 1-.624.866h-6.07a.658.658 0 0 1-.624-.866z"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M6.452 7.316c.5 0 .943.295 1.222.71a5.52 5.52 0 0 0 4.59 2.448 5.52 5.52 0 0 0 4.701-2.62c.198-.318.533-.538.907-.538a.97.97 0 0 1 .97.97v5.451a2 2 0 0 1-2 2H7.159a2 2 0 0 1-2-2V8.61c0-.715.58-1.294 1.294-1.294"
})), Ss = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWaiting_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M3.227 4.364h6.046q-.06.293-.061.606a3.03 3.03 0 0 0 4.243 2.778v3.813c0 1.044-.85 1.893-1.895 1.893H3.227a1.896 1.896 0 0 1-1.894-1.893V6.258c0-1.045.85-1.894 1.894-1.894m3.963 4.84c1.001 0 1.815-.814 1.815-1.814S8.19 5.576 7.19 5.576s-1.814.813-1.814 1.814c0 1 .814 1.814 1.814 1.814m2.972 1.658c-.474-.506-1.366-.882-2.972-.882-1.62 0-2.513.383-2.983.895l-.012.013c-.127.139-.333.362-.419.913a.495.495 0 0 0 .49.568h5.85c.3 0 .535-.27.488-.568-.087-.558-.297-.784-.434-.93z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M12.242 2.545a2.424 2.424 0 1 0 0 4.849 2.424 2.424 0 0 0 0-4.849m1.288 3.132a.26.26 0 0 1-.352.102l-1.06-.582a.26.26 0 0 1-.135-.227V3.238a.26.26 0 0 1 .52 0v1.578l.925.508a.26.26 0 0 1 .102.353"
})), Cs = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWaiting_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("circle", {
	cx: 17.6,
	cy: 7.6,
	r: 3.6,
	fill: "currentColor"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M4.84 6.546h9.07q-.091.44-.092.909a4.546 4.546 0 0 0 6.364 4.167v5.719a2.844 2.844 0 0 1-2.841 2.84H4.84A2.844 2.844 0 0 1 2 17.342V9.386a2.844 2.844 0 0 1 2.84-2.84m5.946 7.26a2.724 2.724 0 0 0 2.72-2.721c0-1.5-1.22-2.721-2.72-2.721s-2.723 1.22-2.723 2.72a2.725 2.725 0 0 0 2.723 2.723m4.456 2.487c-.71-.76-2.048-1.323-4.457-1.323-2.428 0-3.77.574-4.474 1.343l-.018.02c-.191.207-.5.543-.629 1.37a.743.743 0 0 0 .734.85h8.775a.743.743 0 0 0 .734-.851c-.13-.837-.447-1.176-.652-1.396z",
	clipRule: "evenodd"
}), /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	d: "M18.364 3.818a3.636 3.636 0 1 0 0 7.273 3.636 3.636 0 0 0 0-7.273m1.932 4.697a.39.39 0 0 1-.53.154l-1.59-.873a.39.39 0 0 1-.202-.341V4.857a.39.39 0 0 1 .78 0v2.367l1.387.763a.39.39 0 0 1 .155.528"
})), ws = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWarning_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M9.278 12.867c0 .626-.507 1.133-1.133 1.133h-.012a1.133 1.133 0 1 1 0-2.267h.012c.626 0 1.133.508 1.133 1.134m-1.133-3.4A1.133 1.133 0 0 1 7.01 8.333v-5.2a1.133 1.133 0 0 1 2.267 0v5.2c0 .626-.507 1.134-1.133 1.134",
	clipRule: "evenodd"
})), Ts = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWarning_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M13.417 19.3a1.7 1.7 0 0 1-1.7 1.7H11.7a1.7 1.7 0 1 1 0-3.4h.017a1.7 1.7 0 0 1 1.7 1.7m-1.7-5.1a1.7 1.7 0 0 1-1.7-1.7V4.7a1.7 1.7 0 1 1 3.4 0v7.8a1.7 1.7 0 0 1-1.7 1.7",
	clipRule: "evenodd"
})), Es = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWarningRound_16",
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.7 2.8a.7.7 0 0 1-.7.7h-.007a.7.7 0 1 1 0-1.4H8a.7.7 0 0 1 .7.7M8 8.7a.7.7 0 0 1-.7-.7V5.2a.7.7 0 1 1 1.4 0V8a.7.7 0 0 1-.7.7",
	clipRule: "evenodd"
})), Ds = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	"data-token-name": "IconWarningRound_24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	fill: "currentColor",
	fillRule: "evenodd",
	d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m11 4a1 1 0 0 1-1 1h-.01a1 1 0 1 1 0-2H12a1 1 0 0 1 1 1m-1-3a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1",
	clipRule: "evenodd"
})), U = {
	IconAdd: {
		size16: Ut,
		size24: Wt,
		size32: Wt
	},
	IconAddSomeone: {
		size16: Gt,
		size24: Kt,
		size32: Kt
	},
	IconAdjust: {
		size16: qt,
		size24: Jt,
		size32: Yt
	},
	IconAdmit: {
		size16: Xt,
		size24: Zt,
		size32: Qt
	},
	IconAiAssistant: {
		size16: $t,
		size24: en,
		size32: en
	},
	IconAlert: {
		size16: tn,
		size24: nn,
		size32: nn
	},
	IconAnalyticsChart: {
		size16: rn,
		size24: an,
		size32: an
	},
	IconAnalyticsProgress: {
		size16: on,
		size24: sn,
		size32: sn
	},
	IconAndroidLogo: {
		size16: cn,
		size24: ln,
		size32: ln
	},
	IconAppleLogo: {
		size16: un,
		size24: dn,
		size32: dn
	},
	IconArrowCornerDown: {
		size16: fn,
		size24: pn,
		size32: pn
	},
	IconArrowDown: {
		size16: mn,
		size24: hn,
		size32: hn
	},
	IconArrowLeft: {
		size16: gn,
		size24: _n,
		size32: _n
	},
	IconArrowLeftRegular: {
		size16: vn,
		size24: yn,
		size32: yn
	},
	IconArrowRight: {
		size16: bn,
		size24: xn,
		size32: xn
	},
	IconArrowUp: {
		size16: Sn,
		size24: Cn,
		size32: Cn
	},
	IconAudioTransmission: {
		size16: wn,
		size24: Tn,
		size32: Tn
	},
	IconAuthenticated: {
		size16: En,
		size24: Dn,
		size32: On
	},
	IconBackgroundBlur: {
		size16: kn,
		size24: An,
		size32: jn
	},
	IconBackgroundBlurLight: {
		size16: Mn,
		size24: Nn,
		size32: Pn
	},
	IconBackgroundBlurStrong: {
		size16: Fn,
		size24: In,
		size32: Ln
	},
	IconBackgroundReplace: {
		size16: Rn,
		size24: zn,
		size32: zn
	},
	IconBackspace: {
		size16: Bn,
		size24: Vn,
		size32: Vn
	},
	IconBackToTop: {
		size16: Hn,
		size24: Un,
		size32: Un
	},
	IconBandwidth: {
		size16: Wn,
		size24: Gn,
		size32: Gn
	},
	IconBell: {
		size16: Kn,
		size24: qn,
		size32: qn
	},
	IconBilling: {
		size16: Jn,
		size24: Yn,
		size32: Yn
	},
	IconBlock: {
		size16: Xn,
		size24: Zn,
		size32: Zn
	},
	IconBluetooth: {
		size16: Qn,
		size24: $n,
		size32: $n
	},
	IconBreakoutRooms: {
		size16: er,
		size24: tr,
		size32: tr
	},
	IconBulletPoint: {
		size16: nr,
		size24: rr,
		size32: rr
	},
	IconCalendar: {
		size16: ir,
		size24: ar,
		size32: ar
	},
	IconChat: {
		size16: or,
		size24: sr,
		size32: sr
	},
	IconCheckmark: {
		size16: cr,
		size24: lr,
		size32: lr
	},
	IconCheckmarkRound: {
		size16: ur,
		size24: dr,
		size32: dr
	},
	IconChevronDown: {
		size16: fr,
		size24: pr,
		size32: pr
	},
	IconChevronLeft: {
		size16: mr,
		size24: hr,
		size32: hr
	},
	IconChevronRight: {
		size16: gr,
		size24: _r,
		size32: _r
	},
	IconChevronUp: {
		size16: vr,
		size24: yr,
		size32: yr
	},
	IconChromeLogo: {
		size16: br,
		size24: xr,
		size32: xr
	},
	IconClock: {
		size16: Sr,
		size24: Cr,
		size32: Cr
	},
	IconClose: {
		size16: wr,
		size24: Tr,
		size32: Tr
	},
	IconColumns: {
		size16: Er,
		size24: Dr,
		size32: Or
	},
	IconConnectionIndicatorHigh: {
		size16: kr,
		size24: kr,
		size32: kr
	},
	IconConnectionIndicatorLow: {
		size16: Ar,
		size24: Ar,
		size32: Ar
	},
	IconConnectionIndicatorMedium: {
		size16: jr,
		size24: jr,
		size32: jr
	},
	IconConnectionIndicatorVeryLow: {
		size16: Mr,
		size24: Mr,
		size32: Mr
	},
	IconCopy: {
		size16: Nr,
		size24: Pr,
		size32: Pr
	},
	IconDeny: {
		size16: Fr,
		size24: Ir,
		size32: Lr
	},
	IconDoubleChevronDown: {
		size16: Rr,
		size24: zr,
		size32: zr
	},
	IconDoubleChevronLeft: {
		size16: Br,
		size24: Vr,
		size32: Vr
	},
	IconDoubleChevronRight: {
		size16: Hr,
		size24: Ur,
		size32: Ur
	},
	IconDoubleChevronUp: {
		size16: Wr,
		size24: Gr,
		size32: Gr
	},
	IconDraggable: {
		size16: Kr,
		size24: qr,
		size32: qr
	},
	IconDtmf: {
		size16: Jr,
		size24: Yr,
		size32: Yr
	},
	IconDualScreen: {
		size16: Xr,
		size24: Zr,
		size32: Zr
	},
	IconEdit: {
		size16: Qr,
		size24: $r,
		size32: $r
	},
	IconEmoji: {
		size16: ei,
		size24: ti,
		size32: ti
	},
	IconEnableshare: {
		size16: ni,
		size24: ri,
		size32: ri
	},
	IconExpand: {
		size16: ii,
		size24: ai,
		size32: ai
	},
	IconExport: {
		size16: oi,
		size24: si,
		size32: si
	},
	IconFecc: {
		size16: ci,
		size24: li,
		size32: li
	},
	IconFirefoxLogo: {
		size16: ui,
		size24: di,
		size32: di
	},
	IconFlipCamera: {
		size16: fi,
		size24: pi,
		size32: mi
	},
	IconFullscreenOff: {
		size16: hi,
		size24: gi,
		size32: _i
	},
	IconFullscreenOn: {
		size16: vi,
		size24: yi,
		size32: bi
	},
	IconGeneric2: {
		size16: xi,
		size24: Si,
		size32: Si
	},
	IconGroup: {
		size16: Ci,
		size24: wi,
		size32: wi
	},
	IconGuest: {
		size16: Ti,
		size24: Ei,
		size32: Ei
	},
	IconHeadset: {
		size16: Di,
		size24: Oi,
		size32: Oi
	},
	IconHelpRound: {
		size16: ki,
		size24: Ai,
		size32: Ai
	},
	IconHome: {
		size16: ji,
		size24: Mi,
		size32: Mi
	},
	IconHospital: {
		size16: Ni,
		size24: Pi,
		size32: Pi
	},
	IconHost: {
		size16: Fi,
		size24: Ii,
		size32: Ii
	},
	IconIconSort: {
		size16: Li,
		size24: Ri,
		size32: Ri
	},
	IconImport: {
		size16: zi,
		size24: Bi,
		size32: Bi
	},
	IconInfoRound: {
		size16: Vi,
		size24: Hi,
		size32: Hi
	},
	IconKey: {
		size16: Ui,
		size24: Wi,
		size32: Wi
	},
	IconLanguage: {
		size16: Gi,
		size24: Ki,
		size32: Ki
	},
	IconLeave: {
		size16: qi,
		size24: Ji,
		size32: Ji
	},
	IconLink: {
		size16: Yi,
		size24: Xi,
		size32: Xi
	},
	IconLiveCaption: {
		size16: Zi,
		size24: Qi,
		size32: Qi
	},
	IconLiveStream: {
		size16: $i,
		size24: ea,
		size32: ea
	},
	IconLiveStreamCloud: {
		size16: ta,
		size24: na,
		size32: na
	},
	IconLocation: {
		size16: ra,
		size24: ia,
		size32: ia
	},
	IconLock: {
		size16: aa,
		size24: oa,
		size32: oa
	},
	IconLowerhand: {
		size16: sa,
		size24: ca,
		size32: ca
	},
	IconMail: {
		size16: la,
		size24: ua,
		size32: ua
	},
	IconMeetingRoom: {
		size16: da,
		size24: fa,
		size32: fa
	},
	IconMeetings: {
		size16: pa,
		size24: ma,
		size32: ma
	},
	IconMicrophoneMutedByHost: {
		size16: ha,
		size24: ga,
		size32: ga
	},
	IconMicrophoneOff: {
		size16: _a,
		size24: va,
		size32: ya
	},
	IconMicrophoneOn: {
		size16: ba,
		size24: xa,
		size32: Sa
	},
	IconMinus: {
		size16: Ca,
		size24: wa,
		size32: wa
	},
	IconMoreHorizontal: {
		size16: Ta,
		size24: Ta,
		size32: Ta
	},
	IconMoreVertical: {
		size16: Ea,
		size24: Da,
		size32: Da
	},
	IconMove: {
		size16: Oa,
		size24: ka,
		size32: ka
	},
	IconNotauthenticated: {
		size16: Aa,
		size24: ja,
		size32: Ma
	},
	IconNotAuthenticated: {
		size16: Na,
		size24: Pa,
		size32: Fa
	},
	IconOpenInNew: {
		size16: Ia,
		size24: La,
		size32: La
	},
	IconParticipant: {
		size16: Ra,
		size24: za,
		size32: za
	},
	IconPasswordHide: {
		size16: Ba,
		size24: Ba,
		size32: Ba
	},
	IconPasswordShow: {
		size16: Va,
		size24: Va,
		size32: Va
	},
	IconPause: {
		size16: Ha,
		size24: Ua,
		size32: Ua
	},
	IconPexip: {
		size16: Wa,
		size24: Wa,
		size32: Wa
	},
	IconPexipLogo: {
		size16: Ga,
		size24: Ga,
		size32: Ga
	},
	IconPhone: {
		size16: Ka,
		size24: qa,
		size32: qa
	},
	IconPhoneHorisontal: {
		size16: Ja,
		size24: Ya,
		size32: Xa
	},
	IconPhoneTalk: {
		size16: Za,
		size24: Qa,
		size32: Qa
	},
	IconPin: {
		size16: $a,
		size24: eo,
		size32: eo
	},
	IconPlay: {
		size16: to,
		size24: no,
		size32: no
	},
	IconPlayRound: {
		size16: ro,
		size24: io,
		size32: io
	},
	IconPlus: {
		size16: ao,
		size24: oo,
		size32: oo
	},
	IconPresentationOff: {
		size16: so,
		size24: co,
		size32: co
	},
	IconPresentationOn: {
		size16: lo,
		size24: uo,
		size32: uo
	},
	IconRaiseHand: {
		size16: fo,
		size24: po,
		size32: mo
	},
	IconRecording: {
		size16: ho,
		size24: go,
		size32: go
	},
	IconRefresh: {
		size16: _o,
		size24: vo,
		size32: vo
	},
	IconRemoteControl: {
		size16: yo,
		size24: yo,
		size32: yo
	},
	IconScreenRotation: {
		size16: bo,
		size24: xo,
		size32: xo
	},
	IconSearch: {
		size16: So,
		size24: Co,
		size32: Co
	},
	IconSend: {
		size16: wo,
		size24: To,
		size32: To
	},
	IconSettings: {
		size16: Eo,
		size24: Do,
		size32: Do
	},
	IconSettingsMeeting: {
		size16: Oo,
		size24: ko,
		size32: ko
	},
	IconShare: {
		size16: Ao,
		size24: jo,
		size32: jo
	},
	IconShield: {
		size16: Mo,
		size24: No,
		size32: No
	},
	IconShuffle: {
		size16: Po,
		size24: Fo,
		size32: Fo
	},
	IconSort: {
		size16: Io,
		size24: Lo,
		size32: Lo
	},
	IconSpeakerDisabled: {
		size16: Ro,
		size24: zo,
		size32: zo
	},
	IconSpeakerOff: {
		size16: Bo,
		size24: Vo,
		size32: Vo
	},
	IconSpeakerOn: {
		size16: Ho,
		size24: Uo,
		size32: Uo
	},
	IconSpotlight: {
		size16: Wo,
		size24: Go,
		size32: Go
	},
	IconStar: {
		size16: Ko,
		size24: qo,
		size32: qo
	},
	IconStopRound: {
		size16: Jo,
		size24: Yo,
		size32: Yo
	},
	IconSupport: {
		size16: Xo,
		size24: Zo,
		size32: Zo
	},
	IconSupportAgent: {
		size16: Qo,
		size24: $o,
		size32: $o
	},
	IconTestScriptIcon: {
		size16: es,
		size24: ts,
		size32: ts
	},
	IconThumbsDown: {
		size16: ns,
		size24: ns,
		size32: ns
	},
	IconThumbsUp: {
		size16: rs,
		size24: rs,
		size32: rs
	},
	IconTimer: {
		size16: is,
		size24: as,
		size32: as
	},
	IconTranscript: {
		size16: os,
		size24: ss,
		size32: ss
	},
	IconTranslation: {
		size16: cs,
		size24: ls,
		size32: ls
	},
	IconTrash: {
		size16: us,
		size24: ds,
		size32: ds
	},
	IconUnlock: {
		size16: fs,
		size24: ps,
		size32: ps
	},
	IconVideoOff: {
		size16: ms,
		size24: hs,
		size32: gs
	},
	IconVideoOn: {
		size16: _s,
		size24: vs,
		size32: ys
	},
	IconVideoSystems: {
		size16: bs,
		size24: xs,
		size32: xs
	},
	IconWaiting: {
		size16: Ss,
		size24: Cs,
		size32: Cs
	},
	IconWarning: {
		size16: ws,
		size24: Ts,
		size32: Ts
	},
	IconWarningRound: {
		size16: Es,
		size24: Ds,
		size32: Ds
	}
}, Os = {
	dark: "_dark_1tbu9_4",
	light: "_light_1tbu9_8",
	mini: "_mini_1tbu9_12",
	compact: "_compact_1tbu9_17",
	small: "_small_1tbu9_22",
	medium: "_medium_1tbu9_27"
}, W = ({ source: e, className: n, size: r = "small", colorScheme: i, ref: a, ...o }) => {
	let s = r === "mini" || r === "compact" ? e.size16 : r === "small" ? e.size24 : e.size32, c = v(i && Os[i], Os[r], n), l = s, u = typeof l == "function" ? l({
		className: c,
		...o
	}) : /*#__PURE__*/ t.createElement(s, {
		className: c,
		...o
	});
	return /*#__PURE__*/ t.createElement(yt, null, u);
}, ks = b({
	name: "announcer:announce",
	describeSubject: () => "[Announcement text omitted]"
}), As = { announcer: "_announcer_flsxf_1" }, js = ({ testId: e = "", ...n }) => {
	let [r, i] = _([]), [a, o] = _([]), s = g([]), l = c((e, t) => {
		t((t) => [...t, e]);
		let n = window.setTimeout(() => {
			t((t) => t.filter((t) => t !== e)), clearTimeout(n), s.current = s.current.filter((e) => e !== n);
		}, e.timeout);
		s.current.push(n);
	}, []), d = c((e) => {
		e.politeness === "assertive" ? l(e, i) : e.politeness === "polite" && l(e, o);
	}, [l]);
	return u(() => (ks.add(d), () => {
		ks.remove(d);
		for (let e of s.current) clearTimeout(e);
		s.current = [];
	}), [d]), /*#__PURE__*/ t.createElement("div", {
		...n,
		className: As.announcer,
		"data-testid": e
	}, /*#__PURE__*/ t.createElement("div", {
		"data-testid": `${e}-polite`,
		"aria-live": "polite",
		role: "log",
		"aria-relevant": "additions"
	}, a.map((e, n) => /*#__PURE__*/ t.createElement("div", { key: n }, e.message))), /*#__PURE__*/ t.createElement("div", {
		"data-testid": `${e}-assertive`,
		"aria-live": "assertive",
		role: "log",
		"aria-relevant": "additions"
	}, r.map((e, n) => /*#__PURE__*/ t.createElement("div", { key: n }, e.message))));
}, Ms = (e, t = "polite", n = 5e3) => {
	ks.emit({
		message: e,
		politeness: t,
		timeout: n
	});
}, Ns = {
	callToAction: "_callToAction_1i5px_4",
	small: "_small_1i5px_17",
	enhancerStart: "_enhancerStart_1i5px_28",
	focus: "_focus_1i5px_32",
	text: "_text_1i5px_52",
	fullWidth: "_fullWidth_1i5px_58"
}, Ps = ({ className: e, enhancerStart: n, isSmall: r, modifier: i, subTitle: a = "", title: o = "", titleHtmlTag: s, ...c }) => /*#__PURE__*/ t.createElement(z, {
	className: v(Ns.callToAction, Ns.focus, i && Ns[i], { [Ns.small]: r }, e),
	...c
}, n && /*#__PURE__*/ t.createElement("span", { className: Ns.enhancerStart }, n), /*#__PURE__*/ t.createElement("span", { className: Ns.text }, s ? /*#__PURE__*/ t.createElement(Ne, {
	htmlTag: s,
	fontVariant: R.H5
}, o) : /*#__PURE__*/ t.createElement(V, { fontVariant: R.H5 }, o), a && !r && /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.Body,
	variant: "subtle"
}, a))), G = /*#__PURE__*/ function(e) {
	return e.BadgeCounterNumber = "badge-counter-number", e.ButtonCloseNotification = "button-close-notification", e.ButtonInteractiveNotification = "button-interactive-notification", e.ButtonModalClose = "button-modal-close", e.ButtonThreeColumnSelector = "button-three-column-selector", e.ButtonCollapsableContainerToggle = "button-collapsable-container-toggle", e.CheckboxCheck = "checkbox-check", e.CheckboxCheckContainer = "checkbox-check-container", e.ConfirmableMultiselectConfirm = "confirmable-multiselect-confirm", e.HeaderCore = "header-core", e.HeaderCoreEnhancers = "header-core-enhancers", e.HeaderCoreDivider = "header-core-divider", e.LineStep = "line-step", e.InputClearButton = "input-clear-button", e.ModalMask = "modal-mask", e.MultiselectView = "multiselect-view", e.MultiselectItem = "multiselect-item", e.MultistepIndicator = "multistep-indicator", e.MultistepIndicatorButton = "multistep-indicator-button", e.Notification = "notification", e.NotificationsList = "notifications-list", e.NotificationTooltipInner = "notification-tooltip-inner", e.NotificationTooltipClose = "notification-tooltip-close", e.NotificationTooltipHeader = "notification-tooltip-header", e.NotificationTooltipText = "notification-tooltip-text", e.NotificationTooltipCta = "notification-tooltip-cta", e.PostMeetingHeader = "PostMeetingHeader", e.SectionAccordionDetails = "section-accordion-details", e.SectionAccordionSummary = "section-accordion-summary", e.SelectIcon = "select-icon", e.SelectChevron = "select-chevron", e.SelectView = "select-view", e.StepNumber = "step-number", e.StepNumberString = "step-number-string", e.StepNumberCheckmark = "step-number-checkmark", e.Tab = "tab", e.TooltipInner = "tooltip-inner", e.UserView = "user-view", e.PrivacyPolicyLink = "privacy-policy-link", e.TermsOfServiceLink = "terms-of-service-link", e.Version = "version", e.NumberStepIncrement = "number-step-increment", e.NumberStepDecrement = "number-step-decrement", e.NumberStepInput = "number-step-input", e.StepNumberWarning = "StepNumberWarning", e.SimpleBarScrollable = "simple-bar-scrollable", e;
}({}), Fs = {
	checkbox: "_checkbox_1mrzn_142",
	spaced: "_spaced_1mrzn_147",
	start: "_start_1mrzn_152",
	checkmark: "_checkmark_1mrzn_152",
	label: "_label_1mrzn_155",
	end: "_end_1mrzn_159",
	disabled: "_disabled_1mrzn_163",
	input: "_input_1mrzn_167",
	hidden: "_hidden_1mrzn_187",
	dark: "_dark_1mrzn_138",
	checked: "_checked_1mrzn_203",
	light: "_light_1mrzn_134"
}, Is = /*#__PURE__*/ t.forwardRef(function({ checked: e, className: n, colorScheme: r, isDisabled: i, label: a, labelComponent: o = V, labelModifier: s = "default", labelPosition: c = "end", name: l, ...u }, d) {
	let f = s === "hidden", p = be("indeterminate", { ...u }), m = `${l}-label`;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: u }) => /*#__PURE__*/ t.createElement("label", {
		id: m,
		className: v(r ?? u, Fs.checkbox, Fs[r ?? u], Fs[c], {
			[Fs.disabled]: i,
			[Fs.spaced]: s === "spaced"
		}, n),
		title: f ? a : void 0
	}, /*#__PURE__*/ t.createElement("input", {
		ref: d,
		className: Fs.input,
		type: "checkbox",
		name: l,
		checked: e,
		disabled: i,
		"aria-labelledby": m,
		...p
	}), /*#__PURE__*/ t.createElement("span", {
		"data-testid": G.CheckboxCheckContainer,
		className: v(Fs.checkmark, { [Fs.checked]: e })
	}, e && /*#__PURE__*/ t.createElement(W, {
		"data-testid": G.CheckboxCheck,
		source: U.IconCheckmark
	})), /*#__PURE__*/ t.createElement(o, {
		variant: i ? "disabled" : "standard",
		className: v(Fs.label, { [Fs.hidden]: f })
	}, a)));
}), Ls = {
	headerWrapper: "_headerWrapper_1d8w3_4",
	relative: "_relative_1d8w3_8",
	absolute: "_absolute_1d8w3_12",
	headerInnerWrapper: "_headerInnerWrapper_1d8w3_16",
	small: "_small_1d8w3_25",
	medium: "_medium_1d8w3_28",
	large: "_large_1d8w3_31",
	start: "_start_1d8w3_35",
	center: "_center_1d8w3_36",
	end: "_end_1d8w3_37"
}, Rs = ({ enhancerStartClassName: e, enhancerStart: n, enhancerMiddle: r, enhancerEnd: i, enhancerFixedWidth: a = !1, hasBottomBorder: o = !0, position: s = "relative", className: c, size: l = "large", ...u }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Ls.headerWrapper, Ls[s], l && Ls[l], c),
	"data-testid": G.HeaderCore,
	...u
}, /*#__PURE__*/ t.createElement("div", {
	className: Ls.headerInnerWrapper,
	"data-testid": G.HeaderCoreEnhancers
}, a ? /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("div", { className: v(Ls.start, e) }, n), r && /*#__PURE__*/ t.createElement("div", { className: Ls.center }, r), /*#__PURE__*/ t.createElement("div", { className: Ls.end }, i)) : /*#__PURE__*/ t.createElement(t.Fragment, null, n, r, i)), o && /*#__PURE__*/ t.createElement(Me, { "data-testid": G.HeaderCoreDivider })), zs = {
	dragAndDropWrapper: "_dragAndDropWrapper_14crg_19",
	dark: "_dark_14crg_27",
	disabled: "_disabled_14crg_35",
	light: "_light_14crg_40",
	error: "_error_14crg_53"
}, Bs = ({ className: e, isDisabled: n, children: r, colorScheme: i, hasError: a, onDrop: o, onDragOver: s, ...c }) => {
	let l = (e) => {
		e.preventDefault(), !n && o?.(e, e.dataTransfer.files && Array.from(e.dataTransfer.files), e.dataTransfer.items && Array.from(e.dataTransfer.items));
	}, u = (e) => {
		e.preventDefault(), !n && s?.(e);
	}, d = a ? zs.error : i === "dark" ? zs.dark : zs.light;
	return /*#__PURE__*/ t.createElement(I, { colorScheme: i }, /*#__PURE__*/ t.createElement(Ae, {
		className: v(zs.dragAndDropWrapper, d, n && zs.disabled, e),
		onDrop: l,
		onDragOver: u,
		isWithShadow: !1,
		...c
	}, r));
}, Vs = {
	fileUploadLabel: "_fileUploadLabel_ut8vl_14",
	fileUploadInput: "_fileUploadInput_ut8vl_18",
	noFocus: "_noFocus_ut8vl_24"
}, Hs = /*#__PURE__*/ o(({ accept: e, ariaLabel: n = "Upload files input", children: r, className: i, id: a, isDisabled: o, multiple: s, onChange: c, testId: l, noFocus: u = !1, ...f }, p) => {
	let m = d(), h = a ?? m;
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("input", {
		className: v(Vs.fileUploadInput, { [Vs.noFocus]: u }),
		onChange: (e) => {
			c(e), e.target.value = "";
		},
		type: "file",
		accept: e,
		multiple: s,
		ref: p,
		id: h,
		disabled: o,
		tabIndex: u ? -1 : 0
	}), /*#__PURE__*/ t.createElement("label", {
		...f,
		className: v(Vs.fileUploadLabel, i),
		htmlFor: h,
		"aria-label": n,
		"data-testid": l
	}, r));
});
Hs.displayName = "FileUpload";
var Us = {
	heading: "_heading_16odr_4",
	small: "_small_16odr_4",
	medium: "_medium_16odr_7",
	subtitle: "_subtitle_16odr_11",
	dark: "_dark_16odr_16",
	light: "_light_16odr_20"
}, Ws = ({ className: e, padding: n = "medium", subtitle: r, title: i, titleFontVariant: a = R.H3, titleHtmlTag: o, colorScheme: s, ...c }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: l }) => {
	let u = s ?? l;
	return /*#__PURE__*/ t.createElement("div", {
		className: v(Us.heading, Us[u], Us[n], e),
		...c
	}, /*#__PURE__*/ t.createElement(I, { colorScheme: u }, /*#__PURE__*/ t.createElement("div", null, o ? /*#__PURE__*/ t.createElement(Ne, {
		htmlTag: o,
		fontVariant: a
	}, i) : /*#__PURE__*/ t.createElement(V, { fontVariant: a }, i)), r && /*#__PURE__*/ t.createElement(V, {
		className: Us.subtitle,
		fontVariant: R.Body,
		variant: "tinted"
	}, r)));
}), Gs = {
	lineHeading: "_lineHeading_1shha_4",
	heading: "_heading_1shha_20"
}, Ks = ({ children: e }) => /*#__PURE__*/ t.createElement("div", { className: Gs.lineHeading }, /*#__PURE__*/ t.createElement("div", { className: Gs.heading }, e)), qs = {
	label: "_label_1kp2n_105",
	standard: "_standard_1kp2n_108",
	inline: "_inline_1kp2n_122",
	hidden: "_hidden_1kp2n_136",
	dark: "_dark_1kp2n_148",
	light: "_light_1kp2n_152"
}, Js = ({ className: e, colorScheme: n, form: r, fontVariant: i = R.BodyBold, id: a, isLabelHidden: o, isLabelInline: s, isUppercase: c, text: l, variant: u = "inherit", ...d }) => /*#__PURE__*/ t.createElement("label", {
	className: v(qs.label, {
		[qs.hidden]: o,
		[qs.inline]: s,
		[qs.standard]: !s
	}, e),
	htmlFor: a,
	form: r,
	...d
}, /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: e }) => /*#__PURE__*/ t.createElement(V, {
	isUppercase: c,
	colorScheme: n ?? e,
	fontVariant: i,
	variant: u
}, l))), K = {
	light: "_light_1lhx4_211",
	dark: "_dark_1lhx4_217",
	container: "_container_1lhx4_223",
	small: "_small_1lhx4_245",
	medium: "_medium_1lhx4_253",
	disabled: "_disabled_1lhx4_261",
	clearButton: "_clearButton_1lhx4_265",
	error: "_error_1lhx4_270",
	errorText: "_errorText_1lhx4_276",
	enhancerStart: "_enhancerStart_1lhx4_280",
	enhancerEnd: "_enhancerEnd_1lhx4_281",
	inputElement: "_inputElement_1lhx4_286",
	dateSelectButton: "_dateSelectButton_1lhx4_336",
	standard: "_standard_1lhx4_341",
	label: "_label_1lhx4_419",
	transparent: "_transparent_1lhx4_432"
}, Ys = /*#__PURE__*/ o(({ containerRef: e, className: n, clearButtonText: r = "Clear", clearButtonVariant: i, colorScheme: a, enhancerEnd: o, enhancerStart: s, errorText: u, hasError: p, id: m, isDisabled: h, label: _, labelModifier: y, name: b, onChange: x, onClear: S, onValueChange: C, showClearButton: w = !1, sizeModifier: T = "medium", testId: E, type: D = "text", value: O, variant: k = "standard", ...A }, j) => {
	let M = d(), N = m ?? M, ee = y === "hidden", P = y === "inline", te = P || ee, ne = g(null), re = () => {
		let e = ne.current;
		S ? S(e?.value ?? "") : C?.(""), e && e.focus();
	}, ie = c((e) => {
		C && C(e.currentTarget.value), x && x(e);
	}, [x, C]), ae = {
		text: _,
		id: N
	};
	f(j, () => ({
		focus: (e) => {
			ne.current && ne.current.focus(e);
		},
		value: ne.current?.value ?? ""
	}));
	let { colorScheme: oe, theme: se } = l(Ce);
	return /*#__PURE__*/ t.createElement("div", { className: v(a ?? oe, K[k], K[a ?? oe], {
		[K.disabled]: h,
		[K.error]: p && !h
	}, n) }, !te && /*#__PURE__*/ t.createElement(Js, {
		className: K.label,
		"data-testid": E ? `${E}-label` : void 0,
		htmlFor: N,
		...ae
	}), /*#__PURE__*/ t.createElement("div", {
		className: v(K.container, {
			[K.small]: T === "small",
			[K.medium]: T === "medium"
		}),
		ref: e
	}, te && /*#__PURE__*/ t.createElement(Js, {
		isLabelHidden: ee,
		isLabelInline: P,
		"data-testid": E ? `${E}-label` : void 0,
		htmlFor: N,
		...ae
	}), s && /*#__PURE__*/ t.createElement("div", { className: v(K.enhancerStart, "mr-2") }, s), /*#__PURE__*/ t.createElement("input", {
		className: v(K.inputElement, {
			[K.small]: T === "small",
			[K.medium]: T === "medium"
		}),
		"data-testid": E,
		disabled: h,
		id: N,
		name: b,
		onChange: ie,
		ref: ne,
		type: D,
		value: O,
		...A
	}), D === "date" && /*#__PURE__*/ t.createElement(W, {
		source: U.IconCalendar,
		className: K.dateSelectButton
	}), o && /*#__PURE__*/ t.createElement("div", { className: K.enhancerEnd }, o), w && !h && /*#__PURE__*/ t.createElement(H, {
		type: "button",
		size: "compact",
		className: K.clearButton,
		onClick: re,
		"aria-label": "Clear input",
		"data-testid": G.InputClearButton,
		variant: i ?? (se === "theme-legacy" ? "transparent" : "translucent"),
		colorScheme: a ?? oe
	}, r)), p && u && /*#__PURE__*/ t.createElement(V, {
		className: v("mt-2", K.errorText),
		variant: "danger",
		role: "alert"
	}, u));
});
Ys.displayName = "Input";
var Xs = (e) => {
	let [t, n] = _(e.value ?? "");
	return [t, {
		...e,
		onChange: (e) => n(e.currentTarget.value),
		value: t
	}];
}, Zs = (e) => m(() => {
	let t = qe(e), n = Je(e), r = "", i = "";
	return Ye(e) || (t && (r = e), n && (i = Xe(e))), {
		logoSrcString: r,
		logoSrcSet: i,
		isLogoSrcSet: n,
		isLogoSrcString: t
	};
}, [e]), Qs = { logo: "_logo_1y8qg_4" }, $s = ({ imageSrc: e, alt: n, className: r, ...i }) => {
	let { logoSrcString: a, logoSrcSet: o, isLogoSrcSet: s } = Zs(e);
	return !a && !o ? null : /*#__PURE__*/ t.createElement("img", {
		srcSet: s ? o : a,
		className: v(r, Qs.logo),
		...i,
		alt: n
	});
}, ec = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 750 202.59",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	d: "M342.71,486.52a42.21,42.21,0,0,0-35.78,18.88V490H280.81V641.3h26.78V586.77c5.05,8.56,16.46,15.88,35.12,15.88,27.88,0,46.54-23,46.54-57.95C389.25,509.57,370.59,486.52,342.71,486.52Zm-8.78,92.78c-16.24,0-27.66-11.54-27.66-34.82,0-23.07,11.42-34.6,27.66-34.6,15.59,0,27.44,9.06,27.44,34.6C361.37,570.23,349.52,579.3,333.93,579.3Zm435.78-92.78a42.21,42.21,0,0,0-35.78,18.88V490H707.81V641.3h26.78V586.77c5,8.56,16.46,15.88,35.12,15.88,27.88,0,46.54-23,46.54-57.95C816.25,509.57,797.59,486.52,769.71,486.52Zm-8.78,92.78c-16.24,0-27.66-11.54-27.66-34.82,0-23.07,11.42-34.6,27.66-34.6,15.59,0,27.44,9.06,27.44,34.6C788.37,570.23,776.52,579.3,760.93,579.3ZM590.32,543.16l41.27,56.2H599.1l-11-16c-5.93-9-10.32-15.36-14.49-21.29-4.61,6.59-8.78,12.51-14.49,21.07l-11,16.25h-29l40.39-56.64L521.17,490h32.05l9.44,14.27c5.93,8.78,9.44,14,13.39,19.75,4.17-5.71,7.47-10.75,13.61-19.75L599.54,490H629ZM650.69,490h26.56V599.36H650.69Zm29.93-34.68A16.65,16.65,0,1,1,664,438.7,16.67,16.67,0,0,1,680.62,455.36ZM915,449.3v24H888v144h27v24H864v-192ZM460.37,581.58c-14.05,0-25.9-8.13-27-30.3h77.27c3.51-36.22-16-64.54-50.93-64.54-30.29,0-52.9,23.05-52.9,58,0,36.44,21.07,57.95,53.34,57.95,28.76,0,44.13-14.93,51.15-31.83l-24.15-9C483.2,571,476,581.58,460.37,581.58Zm-.66-74.86c13.83,0,23.49,8.78,24.37,24.81H434.25C436.22,515.72,446.54,506.72,459.71,506.72ZM165,641.3v-24h27v-144H165v-24h51v192Z",
	fill: "currentColor",
	transform: "translate(-165 -438.7)"
})), tc = {
	logo: "_logo_1glki_4",
	absoluteCenter: "_absoluteCenter_1glki_9",
	dark: "_dark_1glki_15",
	light: "_light_1glki_19",
	tertiary: "_tertiary_1glki_23",
	large: "_large_1glki_27",
	medium: "_medium_1glki_31",
	small: "_small_1glki_35",
	full: "_full_1glki_39"
}, nc = ({ colorScheme: e, size: n, position: r, className: i, ...a }) => {
	let o = r === "absoluteCenter";
	return /*#__PURE__*/ t.createElement(xt, {
		source: ec,
		className: v(tc.logo, e && tc[e], n && tc[n], i, { [tc.absoluteCenter]: o }),
		...a
	});
}, rc = {
	closeButton: "_closeButton_13k8s_13",
	icon: "_icon_13k8s_22"
}, ic = ({ className: e, onClose: n, ...r }) => /*#__PURE__*/ t.createElement(H, {
	className: v(rc.closeButton, e),
	onClick: n,
	size: "none",
	variant: "translucent",
	noHover: !0,
	...r
}, /*#__PURE__*/ t.createElement(W, {
	className: rc.icon,
	size: "compact",
	source: U.IconClose
})), ac = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 20,
	height: 9,
	viewBox: "0 0 20 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	d: "M11.3379 7.79586C10.5773 8.48041 9.42268 8.48041 8.66207 7.79586L-7.86805e-07 1.74846e-06L20 0L11.3379 7.79586Z",
	fill: "white"
})), oc = ({ controlledIsVisible: e, controlledOnChange: t } = {}) => {
	let [n, r] = _(!1), i = e !== void 0;
	return {
		isVisible: i ? e : n,
		setVisible: ({ isVisible: e, isControlled: n = !1 }) => {
			r(!i && e), n && t?.(e);
		}
	};
}, q = {
	tooltipContainer: "_tooltipContainer_8uq7q_4",
	tabOrderGuard: "_tabOrderGuard_8uq7q_9",
	tooltip: "_tooltip_8uq7q_4",
	fade: "_fade_8uq7q_1",
	tooltipArrow: "_tooltipArrow_8uq7q_32",
	tooltipArrowIcon: "_tooltipArrowIcon_8uq7q_57",
	tooltipControl: "_tooltipControl_8uq7q_65",
	tooltipNotification: "_tooltipNotification_8uq7q_71",
	headerWrapper: "_headerWrapper_8uq7q_81",
	cta: "_cta_8uq7q_88",
	closeButton: "_closeButton_8uq7q_93",
	fullWidth: "_fullWidth_8uq7q_99"
}, sc = {
	bottom: "bottom",
	bottomEnd: "bottom end",
	bottomLeft: "bottom left",
	bottomRight: "bottom right",
	bottomStart: "bottom start",
	bottomCenter: "bottom",
	endBottom: "end bottom",
	left: "left",
	right: "right",
	top: "top",
	topEnd: "top end",
	topLeft: "top left",
	topRight: "top right",
	topStart: "top start",
	topCenter: "top"
}, cc = (e) => ({
	bottomStart: "bottomEnd",
	bottomEnd: "bottomStart",
	topStart: "topEnd",
	topEnd: "topStart"
})[e] || e, lc = (e, t) => t ? sc[cc(e)] || "top" : sc[e] || "top", uc = 20, dc = 12, fc = 8, pc = ({ ariaDescribedBy: e, ariaLabel: n, ariaLabelledBy: r, isOpen: i, closeDelay: a, defaultOpen: o, delay: s, id: l, onOpenChange: u, overlayRef: d, crossOffset: f, offset: p = 13, position: m, role: h = "tooltip", targetRef: _, zIndex: v }) => {
	let y = S({
		closeDelay: a,
		defaultOpen: o,
		delay: s,
		isOpen: i,
		onOpenChange: u
	}), b = g(null), x = g(null), T = _ ?? b, E = d ?? x, { triggerProps: D, tooltipProps: O } = C({}, y, T), A = document?.documentElement?.getAttribute("dir") === "rtl", { overlayProps: j, arrowProps: M, placement: N } = k({
		arrowBoundaryOffset: dc,
		arrowSize: uc,
		containerPadding: fc,
		crossOffset: f,
		isOpen: y.isOpen,
		offset: p,
		overlayRef: E,
		placement: lc(m, A),
		shouldFlip: !0,
		targetRef: T
	});
	return {
		targetRef: T,
		overlayRef: E,
		triggerProps: D,
		arrowProps: M,
		placement: N,
		renderTooltip: c((i) => y.isOpen ? /*#__PURE__*/ t.createElement(w, null, /*#__PURE__*/ t.createElement("div", {
			...O,
			...j,
			style: {
				...j.style,
				...v === void 0 ? {} : { zIndex: v },
				maxWidth: "calc(100% - 16px)"
			},
			ref: E,
			id: l,
			role: h,
			...h === "dialog" ? {
				"aria-describedby": e,
				"aria-label": n,
				"aria-labelledby": r
			} : {},
			"data-react-aria-top-layer": "true"
		}, i)) : null, [
			e,
			n,
			r,
			l,
			E,
			j,
			h,
			y.isOpen,
			O,
			v
		])
	};
}, mc = ({ setVisible: e, shouldCloseOnOutsideClick: t }) => {
	let n = g(null), r = g(null), i = g(null), a = g(null), o = g(null), s = c(() => {
		document.activeElement instanceof HTMLElement && o.current?.contains(document.activeElement) && (a.current ? M(a.current).find((e) => e !== n.current) : void 0)?.focus(), e({
			isVisible: !1,
			isControlled: !0
		});
	}, [e]), l = c((e) => {
		e || s();
	}, [s]), u = c(() => {
		t && s();
	}, [t, s]), d = te(u), f = c((e, t) => {
		let n = M(document.body).filter((e) => !e.closest("[data-portal-id]"));
		if (n.length === 0) return;
		let r = e ? n.indexOf(e) : -1;
		r === -1 ? (t === 1 ? n[0] : n.at(-1))?.focus() : n.length !== 1 && n[(r + t + n.length) % n.length]?.focus();
	}, []), p = c((e) => {
		let t = n.current;
		t && f(t, e);
	}, [f]), m = c(() => o.current ? M(o.current).filter((e) => e !== r.current && e !== i.current) : [], []), h = c((e) => {
		f(e.relatedTarget instanceof HTMLElement ? e.relatedTarget : null, 1);
	}, [f]), _ = c((e) => {
		f(e.relatedTarget instanceof HTMLElement ? e.relatedTarget : null, -1);
	}, [f]);
	return {
		close: s,
		handleGuardFocus: c((e) => {
			let t = m();
			if (t.length === 0) {
				let t = e.relatedTarget, n = t instanceof Node && !!(t.compareDocumentPosition(e.currentTarget) & Node.DOCUMENT_POSITION_FOLLOWING);
				p(n ? 1 : -1);
				return;
			}
			let n = e.relatedTarget;
			(!(n instanceof Node) || n.compareDocumentPosition(e.currentTarget) & Node.DOCUMENT_POSITION_FOLLOWING ? t[0] : t.at(-1))?.focus();
		}, [p, m]),
		handleOpenChange: l,
		handleTooltipEndGuardFocus: _,
		handleTooltipKeyDown: c((e) => {
			if (e.key !== "Tab" || !o.current) return;
			let t = m(), n = t.indexOf(e.target), r = e.shiftKey && n === 0, i = !e.shiftKey && n === t.length - 1;
			(r || i) && (e.preventDefault(), p(r ? -1 : 1));
		}, [p, m]),
		handleTooltipStartGuardFocus: h,
		outsideClickRef: d,
		overlayRef: o,
		tabOrderGuardRef: n,
		targetRef: a,
		tooltipEndGuardRef: i,
		tooltipStartGuardRef: r
	};
}, hc = ({ ariaLabel: e, closeButtonAriaLabel: n = "Close tooltip", shouldCloseOnOutsideClick: r = !1, colorScheme: i = "light", position: a = "topRight", header: o, modifier: s, text: c, ctaText: l, ctaFn: u = () => {}, controlledIsVisible: f, controlledOnChange: p, children: m, className: h, mainWrapperClassName: _, isArrowShown: y = !0, testIdInner: b = G.NotificationTooltipInner, testIdCloseButton: S = G.NotificationTooltipClose, stopPointerDownPropagation: C = !1, zIndex: w = "var(--components-z-index-tooltip)" }) => {
	let { isVisible: T, setVisible: E } = oc({
		controlledIsVisible: f,
		controlledOnChange: p
	}), D = g(x()), O = d(), k = d(), { close: A, handleGuardFocus: j, handleOpenChange: M, handleTooltipEndGuardFocus: N, handleTooltipKeyDown: ee, handleTooltipStartGuardFocus: P, outsideClickRef: te, overlayRef: ne, tabOrderGuardRef: re, targetRef: ie, tooltipEndGuardRef: ae, tooltipStartGuardRef: oe } = mc({
		setVisible: E,
		shouldCloseOnOutsideClick: r
	}), { arrowProps: se, placement: ce, renderTooltip: le } = pc({
		ariaDescribedBy: (e || o) && c ? k : void 0,
		ariaLabel: e,
		ariaLabelledBy: e ? void 0 : o ? O : k,
		id: D.current,
		isOpen: T,
		onOpenChange: M,
		overlayRef: ne,
		position: a,
		role: "dialog",
		targetRef: ie,
		zIndex: w
	}), ue = /*#__PURE__*/ t.createElement(I, { colorScheme: i }, /*#__PURE__*/ t.createElement(Ae, {
		"data-portal-id": D.current,
		ref: te,
		className: v(q.tooltip, q.tooltipNotification, s && q[s], h),
		"data-placement": ce,
		"data-testid": b,
		onKeyDownCapture: ee,
		onPointerDownCapture: C ? (e) => e.stopPropagation() : void 0
	}, /*#__PURE__*/ t.createElement("span", {
		ref: oe,
		tabIndex: 0,
		onFocus: P,
		className: q.tabOrderGuard
	}), o && /*#__PURE__*/ t.createElement("div", { className: q.headerWrapper }, typeof o == "string" ? /*#__PURE__*/ t.createElement(V, {
		id: O,
		fontVariant: R.BodyBold,
		"data-testid": G.NotificationTooltipHeader
	}, o) : /*#__PURE__*/ t.createElement("div", {
		id: O,
		"data-testid": G.NotificationTooltipHeader
	}, o), /*#__PURE__*/ t.createElement(ic, {
		className: q.closeButton,
		"data-testid": S,
		onClose: A,
		"aria-label": n
	})), /*#__PURE__*/ t.createElement(V, {
		id: k,
		fontVariant: R.Body,
		"data-testid": G.NotificationTooltipText
	}, c), l && (typeof l == "string" ? /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		size: "none",
		fontVariant: R.BodyLink,
		useTextComponent: !0,
		underlineText: !0,
		onClick: u,
		className: q.cta,
		"data-testid": G.NotificationTooltipCta
	}, l) : l), y && /*#__PURE__*/ t.createElement("div", {
		className: q.tooltipArrow,
		...se
	}, /*#__PURE__*/ t.createElement(xt, {
		source: ac,
		className: q.tooltipArrowIcon
	})), /*#__PURE__*/ t.createElement("span", {
		ref: ae,
		tabIndex: 0,
		onFocus: N,
		className: q.tabOrderGuard
	})));
	return /*#__PURE__*/ t.createElement("div", {
		"data-portal-origin-id": D.current,
		...T ? {
			role: "group",
			"aria-label": e,
			"aria-labelledby": e ? void 0 : o ? O : k,
			"aria-describedby": (e || o) && c ? k : void 0,
			"aria-details": D.current,
			"aria-owns": D.current
		} : {},
		ref: ie,
		className: v(q.tooltipContainer, s && q[s], _)
	}, m, T && /*#__PURE__*/ t.createElement("span", {
		ref: re,
		tabIndex: 0,
		onFocus: j,
		className: q.tabOrderGuard
	}), le(ue));
}, gc = ({ colorScheme: e = "light", position: n = "topRight", controlledIsVisible: r, controlledOnChange: i, children: a, className: o, content: s, isHoverEnabled: c = !0, isArrowShown: l = !0, mainWrapperClassName: u, wrapperClassName: d, ...f }) => {
	let { isVisible: p, setVisible: m } = oc({
		controlledIsVisible: r,
		controlledOnChange: i
	}), h = !!i, { targetRef: g, arrowProps: _, placement: y, renderTooltip: b } = pc({
		isOpen: p,
		position: n
	}), x = /*#__PURE__*/ t.createElement(I, { colorScheme: e }, /*#__PURE__*/ t.createElement("div", {
		className: v(q.tooltip, o),
		"data-placement": y,
		...f
	}, s, l && /*#__PURE__*/ t.createElement("div", {
		className: q.tooltipArrow,
		..._
	}, /*#__PURE__*/ t.createElement(xt, {
		source: ac,
		className: q.tooltipArrowIcon
	}))));
	return /*#__PURE__*/ t.createElement("div", {
		ref: g,
		className: v(q.tooltipContainer, u)
	}, /*#__PURE__*/ t.createElement("div", {
		className: d,
		onMouseEnter: () => c && m({
			isVisible: !0,
			isControlled: h
		}),
		onMouseLeave: () => c && m({
			isVisible: !1,
			isControlled: h
		})
	}, a), b(x));
}, _c = {
	pill: "_pill_19h3r_105",
	dark: "_dark_19h3r_123",
	danger: "_danger_19h3r_127",
	light: "_light_19h3r_132",
	closeButton: "_closeButton_19h3r_141"
}, vc = ({ children: e, className: n, closeButtonAriaLabel: r = "Close tooltip", colorScheme: i, isDanger: a = !1, onClose: o, testIdCloseButton: s, ...c }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: l }) => /*#__PURE__*/ t.createElement("div", {
	className: v(_c.pill, _c[i ?? l], { [_c.danger]: a }, n),
	...c
}, e, o && /*#__PURE__*/ t.createElement(ic, {
	className: _c.closeButton,
	onClose: o,
	"data-testid": s,
	colorScheme: i,
	"aria-label": r
}))), yc = { wrapper: "_wrapper_55j2z_4" }, bc = ({ children: e, className: n, colorScheme: r, title: i, subtitle: a, hasDivider: o = !0, ...s }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: c }) => {
	let l = r ?? c;
	return /*#__PURE__*/ t.createElement(I, { colorScheme: l }, /*#__PURE__*/ t.createElement("div", {
		className: v(n, yc.wrapper),
		...s
	}, /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement("div", null, typeof i == "string" ? /*#__PURE__*/ t.createElement(V, { fontVariant: a ? R.BodyBold : R.Body }, i) : i), /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.Small,
		colorScheme: l
	}, a)), e && /*#__PURE__*/ t.createElement("div", { className: "ms-auto" }, e)), o && /*#__PURE__*/ t.createElement(Me, null));
}), xc = {
	wrap: "_wrap_1o7be_105",
	spaced: "_spaced_1o7be_110",
	start: "_start_1o7be_115",
	indicator: "_indicator_1o7be_115",
	label: "_label_1o7be_118",
	end: "_end_1o7be_122",
	input: "_input_1o7be_126",
	dot: "_dot_1o7be_147",
	dark: "_dark_1o7be_157",
	checked: "_checked_1o7be_161",
	disabled: "_disabled_1o7be_164",
	light: "_light_1o7be_172"
}, Sc = /*#__PURE__*/ o(({ checked: e, className: n, colorScheme: r, groupName: i, id: a, isDisabled: o, label: s, labelModifier: c, labelPosition: l = "end", value: u, onChange: f, onValueChange: p, ...m }, h) => {
	let g = d(), _ = a ?? g, y = c === "hidden", b = (e) => {
		p?.(e.currentTarget.checked), f?.(e);
	};
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: a }) => /*#__PURE__*/ t.createElement("label", {
		className: v(xc.wrap, xc[r ?? a], xc[l], {
			[xc.disabled]: o,
			[xc.spaced]: c === "spaced"
		}, n),
		title: y ? s : void 0
	}, /*#__PURE__*/ t.createElement("input", {
		checked: e,
		className: xc.input,
		name: i,
		onChange: b,
		value: u,
		ref: h,
		...m,
		id: _,
		type: "radio",
		disabled: o
	}), /*#__PURE__*/ t.createElement("div", {
		"aria-hidden": "true",
		role: "presentation",
		className: v(xc.indicator, { [xc.checked]: e })
	}, /*#__PURE__*/ t.createElement("div", {
		role: "presentation",
		className: xc.dot
	})), /*#__PURE__*/ t.createElement(Js, {
		className: v(xc.label, "mb-0"),
		isLabelHidden: y,
		text: s,
		variant: o ? "disabled" : "standard",
		id: _
	})));
});
Sc.displayName = "RadioButton";
var Cc = { scrollbars: "_scrollbars_1glps_9" }, wc = /*#__PURE__*/ o(({ autoHide: e, children: n, className: r, onScroll: i, scrollElementRef: a, scrollElementTabIndex: o = 0, ...s }, c) => {
	let l = g(null);
	return u(() => {
		let e = l, t = (e) => {
			i?.(e);
		};
		return e.current?.addEventListener("scroll", t), () => e.current?.removeEventListener("scroll", t);
	}, [i]), /*#__PURE__*/ t.createElement(re, {
		className: v(Cc.scrollbars, r),
		ref: c,
		scrollableNodeProps: {
			ref: (e) => {
				e && (e.tabIndex = o), l.current = e, a && (a.current = e);
			},
			"data-testid": G.SimpleBarScrollable
		},
		autoHide: e !== "never",
		...s
	}, n);
});
wc.displayName = "Scrollbars";
var Tc = {
	wrap: "_wrap_19ztu_25",
	indicator: "_indicator_19ztu_29",
	arrow: "_arrow_19ztu_29",
	small: "_small_19ztu_34",
	large: "_large_19ztu_38",
	success: "_success_19ztu_42",
	danger: "_danger_19ztu_46",
	busy: "_busy_19ztu_50",
	warning: "_warning_19ztu_54",
	down: "_down_19ztu_82"
}, Ec = ({ className: e, color: n, role: r, size: i = "small", type: a = "circle", variant: o, ...s }) => {
	let c = a.includes("arrow"), l = {
		circle: {
			backgroundColor: n,
			boxShadow: `0px 0px 10px ${n}`
		},
		arrow: { borderColor: `transparent transparent ${n} transparent` }
	};
	return /*#__PURE__*/ t.createElement("div", {
		className: v(Tc.wrap, e),
		role: r,
		...s
	}, /*#__PURE__*/ t.createElement("div", {
		className: v(Tc.indicator, Tc[i], o && Tc[o], {
			[Tc.arrow]: c,
			[Tc.down]: a === "arrowDown"
		}),
		style: n ? l[c ? "arrow" : "circle"] : {},
		"data-testid": `indicator-${a}`
	}));
}, Dc = {
	stepNumber: "_stepNumber_1k028_27",
	dark: "_dark_1k028_38",
	disabled: "_disabled_1k028_42",
	completed: "_completed_1k028_47",
	failed: "_failed_1k028_52",
	active: "_active_1k028_57",
	light: "_light_1k028_63"
}, Oc = ({ className: e, colorScheme: n, isActive: r, isCompleted: i, isFailed: a, isDisabled: o, stepNumber: s, ...c }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: l }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Dc.stepNumber, Dc[n ?? l], {
		[Dc.active]: r,
		[Dc.completed]: i,
		[Dc.disabled]: o,
		[Dc.failed]: a
	}, e),
	"data-testid": G.StepNumber,
	...c
}, /*#__PURE__*/ t.createElement(V, {
	variant: "inherit",
	fontVariant: R.BodyBold,
	"data-testid": G.StepNumberString
}, i ? /*#__PURE__*/ t.createElement(W, {
	"data-testid": G.StepNumberCheckmark,
	source: U.IconCheckmark,
	size: "mini",
	className: "d-flex"
}) : a ? /*#__PURE__*/ t.createElement(W, {
	"data-testid": G.StepNumberWarning,
	source: U.IconWarning,
	size: "mini",
	className: "d-flex"
}) : s))), kc = ({ textareaElement: e, textareaValue: t, enabled: n, maxHeight: r }) => {
	u(() => {
		if (e && n) {
			e.style.height = "0px";
			let t = e.scrollHeight, n = typeof r == "number" && t > r ? r : t + 1;
			e.style.height = `${n}px`;
		}
	}, [
		e,
		t,
		r,
		n
	]);
}, Ac = {
	wrap: "_wrap_1413c_155",
	textarea: "_textarea_1413c_160",
	errorText: "_errorText_1413c_197",
	dark: "_dark_1413c_201",
	clearButton: "_clearButton_1413c_222",
	error: "_error_1413c_197",
	disabled: "_disabled_1413c_239",
	light: "_light_1413c_266",
	resizeNone: "_resizeNone_1413c_331",
	resizeBoth: "_resizeBoth_1413c_335",
	resizeV: "_resizeV_1413c_339",
	resizeH: "_resizeH_1413c_343"
}, jc = /*#__PURE__*/ o(({ className: e, textareaClassname: n, colorScheme: r, errorText: i, hasError: a, id: o, isDisabled: s, isAutoResize: l = !1, autoResizeMaxHeight: u, label: p, isLabelHidden: m = !1, name: h, onChange: g, onValueChange: y, value: b, resize: x = "resizeNone", rows: S = 4, ...C }, w) => {
	let T = d(), E = o ?? T, [D, O] = _(null);
	kc({
		textareaElement: D,
		textareaValue: b,
		maxHeight: u,
		enabled: l
	});
	let k = c((e) => {
		y && y(e.currentTarget.value), g && g(e);
	}, [g, y]), A = {
		text: p,
		id: E
	};
	return f(w, () => ({
		focus: () => {
			D && D.focus();
		},
		value: D?.value
	}), [D]), /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: o }) => /*#__PURE__*/ t.createElement("label", { className: v(Ac.wrap, Ac[r ?? o], {
		[Ac.disabled]: s,
		[Ac.error]: a && !s
	}, e) }, /*#__PURE__*/ t.createElement(Js, {
		isLabelHidden: m,
		...A
	}), /*#__PURE__*/ t.createElement("textarea", {
		rows: S,
		id: E,
		name: h,
		onChange: k,
		ref: O,
		value: b,
		className: v(Ac.textarea, n, Ac[x]),
		disabled: s,
		...C
	}), a && i && /*#__PURE__*/ t.createElement(V, {
		className: v("mt-2", Ac.errorText),
		variant: "danger",
		role: "alert"
	}, i)));
});
jc.displayName = "TextArea";
var Mc = {
	underline: "_underline_1a3e2_4",
	textLink: "_textLink_1a3e2_8",
	textLinkContent: "_textLinkContent_1a3e2_22",
	truncateWrap: "_truncateWrap_1a3e2_29",
	dark: "_dark_1a3e2_38",
	link: "_link_1a3e2_38",
	light: "_light_1a3e2_41",
	disabled: "_disabled_1a3e2_45",
	truncated: "_truncated_1a3e2_49",
	uppercase: "_uppercase_1a3e2_56"
}, Nc = ({ colorScheme: e, children: n, className: r, disabled: i, fontVariant: a, isDisabled: o, isUnderlined: s, isTruncated: c = !1, isUppercase: l, htmlTag: u, target: d, variant: f = "link", textStyle: p, textClassName: m, ...h }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: g }) => {
	let _ = e ?? g;
	return /*#__PURE__*/ t.createElement(z, {
		className: v(Mc.textLink, Mc[_], f === "link" && Mc[f], {
			[Mc.truncateWrap]: c,
			[Mc.disabled]: o || i
		}, r),
		target: d,
		disabled: o,
		htmlTag: o ? "div" : u,
		rel: d === "_blank" ? "noreferrer noopener" : "",
		...h
	}, /*#__PURE__*/ t.createElement(V, {
		className: v(Mc.textLinkContent, { [Mc.underline]: s }, m),
		colorScheme: _,
		fontVariant: a,
		isTruncated: c,
		isUppercase: l,
		style: p,
		variant: f
	}, n));
}), Pc = {
	row: "_row_p7k6r_4",
	noneSpacing: "_noneSpacing_p7k6r_10",
	compactSpacing: "_compactSpacing_p7k6r_15",
	smallSpacing: "_smallSpacing_p7k6r_20",
	mediumSpacing: "_mediumSpacing_p7k6r_25",
	largeSpacing: "_largeSpacing_p7k6r_30"
}, Fc = ({ children: e, className: n, spacing: r = "small", ...i }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Pc.row, Pc[ye(r)], n),
	...i
}, e), Ic = {
	wrapper: "_wrapper_v0nfr_4",
	border: "_border_v0nfr_11",
	inner: "_inner_v0nfr_16",
	dark: "_dark_v0nfr_21",
	hovered: "_hovered_v0nfr_34",
	disabled: "_disabled_v0nfr_46",
	light: "_light_v0nfr_54",
	small: "_small_v0nfr_119",
	medium: "_medium_v0nfr_126",
	large: "_large_v0nfr_140"
}, Lc = ({ children: e, className: n, colorScheme: r, hasBorder: i = !0, isDisabled: a, isHovered: o, sizeModifier: s = "large", href: c, onClick: l, ...u }) => {
	let d = !c && !l ? "div" : void 0, f = d === "div" || c && c !== "#" && !a ? void 0 : "button";
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: p }) => /*#__PURE__*/ t.createElement(z, {
		className: v(Ic.wrapper, Ic[r ?? p], s && Ic[s], { [Ic.disabled]: a }, { [Ic.hovered]: o }, n),
		disabled: a,
		href: c,
		htmlTag: d,
		onClick: l,
		type: f,
		...u
	}, /*#__PURE__*/ t.createElement(Fc, {
		spacing: "none",
		className: v(Ic.inner, { [Ic.border]: i })
	}, e)));
}, Rc = {
	listLink: "_listLink_1bsc4_4",
	hoverIcon: "_hoverIcon_1bsc4_4",
	startAlignedIconTextContainer: "_startAlignedIconTextContainer_1bsc4_13"
}, zc = ({ children: e, className: n, hasBorder: r = !1, icon: i, iconAlignedStart: a, iconClassName: o, iconColor: s, iconSize: c = "compact", isFixedIcon: l = !1, sizeModifier: u = "small", variant: d, ...f }) => {
	let p = /*#__PURE__*/ t.createElement(V, { variant: d }, e), m = i && /*#__PURE__*/ t.createElement(W, {
		className: v({ [Rc.hoverIcon]: !l }, "flex-shrink-0", o),
		color: s,
		source: i,
		size: c
	});
	return /*#__PURE__*/ t.createElement(Lc, {
		hasBorder: r,
		sizeModifier: u,
		className: v(Rc.listLink, n),
		...f
	}, a ? /*#__PURE__*/ t.createElement("div", { className: Rc.startAlignedIconTextContainer }, m, p) : /*#__PURE__*/ t.createElement(t.Fragment, null, p, m));
}, Bc = {
	light: "_light_1e54u_16",
	dark: "_dark_1e54u_17",
	wrap: "_wrap_1e54u_21",
	bar: "_bar_1e54u_30",
	good: "_good_1e54u_40",
	warn: "_warn_1e54u_44",
	danger: "_danger_1e54u_48",
	primary: "_primary_1e54u_52"
}, Vc = /*#__PURE__*/ function(e) {
	return e.Good = "good", e.Warn = "warn", e.Danger = "danger", e.Primary = "primary", e;
}({}), Hc = ({ backgroundClassName: e, barClassName: n, barColor: r = "good", colorScheme: i, progress: a, style: o, ...s }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: c }) => /*#__PURE__*/ t.createElement("div", {
	className: v(i ?? c, Bc.wrap, Bc[i ?? c], e),
	...s
}, /*#__PURE__*/ t.createElement("div", {
	className: v(Bc.bar, Bc[r] ?? Bc.good, n),
	style: {
		transform: `translateX(${a > 100 ? 100 : Math.round(a)}%)`,
		...o
	}
}))), Uc = {
	dark: "_dark_19qmu_13",
	light: "_light_19qmu_32",
	input: "_input_19qmu_281",
	container: "_container_19qmu_286",
	spaced: "_spaced_19qmu_291",
	end: "_end_19qmu_295",
	label: "_label_19qmu_295",
	start: "_start_19qmu_298",
	toggle: "_toggle_19qmu_298",
	small: "_small_19qmu_322",
	hidden: "_hidden_19qmu_343",
	indicator: "_indicator_19qmu_355",
	checked: "_checked_19qmu_369"
}, Wc = ({ as: e = "div", checked: n, children: r, className: i, label: a, labelClassName: o, labelPosition: s = "end", labelModifier: c, labelFontWeight: l, isSmall: u, colorScheme: d, ...f }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: p }) => /*#__PURE__*/ t.createElement(e, {
	...f,
	className: v(d ?? p, Uc.container, Uc[d ?? p], s && Uc[s], {
		[Uc.small]: u,
		[Uc.spaced]: c === "spaced"
	}, i)
}, r, /*#__PURE__*/ t.createElement("div", { className: v(Uc.toggle, { [Uc.checked]: n }) }, /*#__PURE__*/ t.createElement("div", { className: Uc.indicator })), /*#__PURE__*/ t.createElement(V, {
	fontVariant: l === "bold" ? R.BodyBold : R.Body,
	className: v(Uc.label, o, { [Uc.hidden]: c === "hidden" })
}, a))), Gc = ({ checked: e, className: n, label: r, labelClassName: i, labelPosition: a = "end", labelModifier: o, labelFontWeight: s, onChange: c, isSmall: l, colorScheme: u, ...d }) => {
	let { onKeyDown: f } = ee((e) => {
		c(!e.currentTarget.checked);
	});
	return /*#__PURE__*/ t.createElement(Wc, {
		as: "label",
		checked: e,
		className: n,
		label: r,
		labelClassName: i,
		labelPosition: a,
		labelModifier: o,
		labelFontWeight: s,
		isSmall: l,
		colorScheme: u
	}, /*#__PURE__*/ t.createElement("input", {
		type: "checkbox",
		checked: e,
		className: Uc.input,
		onChange: (e) => c(e.currentTarget.checked),
		onKeyDown: f,
		...d
	}));
}, Kc = ({ children: e, className: n, closeDelay: r = 0, colorScheme: i = "light", crossOffset: a, defaultOpen: o, delay: s = 500, isTooltipEnabled: c = !0, offset: l = 4, position: u = "top", text: d, tooltipContainerClassName: f, ...p }) => {
	let { targetRef: h, triggerProps: g, placement: _, renderTooltip: y } = pc({
		closeDelay: r,
		crossOffset: a,
		defaultOpen: o,
		delay: s,
		offset: l,
		position: u
	}), b = m(() => /*#__PURE__*/ t.createElement(I, { colorScheme: i }, /*#__PURE__*/ t.createElement(Ae, {
		className: v(q.tooltip, q.tooltipControl, n),
		"data-placement": _,
		"data-testid": "tooltip-inner"
	}, typeof d == "string" ? /*#__PURE__*/ t.createElement(V, null, d) : d)), [
		n,
		i,
		_,
		d
	]);
	return c ? /*#__PURE__*/ t.createElement("div", {
		className: v(q.tooltipContainer, f),
		ref: h,
		...p
	}, t.Children.map(e, (e) => /*#__PURE__*/ t.isValidElement(e) ? /*#__PURE__*/ t.cloneElement(e, { ...ie(e.props, g) }) : e), y(b)) : /*#__PURE__*/ t.createElement(t.Fragment, null, e);
}, qc = {
	light: "_light_n8y1r_105",
	dark: "_dark_n8y1r_111",
	video: "_video_n8y1r_117",
	mirrored: "_mirrored_n8y1r_131"
}, Jc = (e, t) => {
	e?.paused && e.play().catch((e) => {
		t?.(e);
	});
}, Yc = /*#__PURE__*/ t.forwardRef(({ srcObject: e, sinkId: n, captionsSrc: r, captionsSrcLang: i, className: a, autoPlay: o = !0, isMirrored: s = !1, playsInline: l = !0, textTrackKind: d, muted: p, onPictureInPictureChange: m, onFailedToResume: h, renderVideo: y, ...b }, x) => {
	let S = g(null), [C, w] = _(null), T = c((e) => {
		S.current = e, w(e);
	}, []), E = c((e) => {
		h?.(e instanceof Error ? e : Error("Video operation failed", { cause: e }));
	}, [h]);
	f(x, () => ({
		resume: () => Jc(S.current, h),
		focus: () => S.current?.focus()
	})), u(() => {
		let e = C, t = !1, n = () => m?.(!0), r = () => {
			setTimeout(() => {
				t || Jc(e, h);
			}, 0), m?.(!1);
		};
		return e?.addEventListener("enterpictureinpicture", n), e?.addEventListener("leavepictureinpicture", r), () => {
			t = !0, e?.removeEventListener("enterpictureinpicture", n), e?.removeEventListener("leavepictureinpicture", r), e && document.pictureInPictureElement === e && document.exitPictureInPicture?.().then(() => {
				m?.(!1);
			}).catch(E);
		};
	}, [
		C,
		m,
		h,
		E
	]), u(() => {
		if (C) return C.srcObject = e ?? null, () => {
			C.srcObject = null;
		};
	}, [C, e]), u(() => {
		if (!C || !e?.getAudioTracks().length) return;
		let t = !0;
		return C.setSinkId?.(n ?? "").catch((e) => {
			t && E(e);
		}), () => {
			t = !1;
		};
	}, [
		C,
		n,
		e,
		E
	]), u(() => {
		let t = C, n = () => Jc(t, h), [r] = e?.getTracks() ?? [];
		return t?.addEventListener("suspend", n), t?.addEventListener("pause", n), r?.addEventListener("unmute", n), () => {
			t?.removeEventListener("suspend", n), t?.removeEventListener("pause", n), r?.removeEventListener("unmute", n);
		};
	}, [
		C,
		e,
		h
	]);
	let D = () => {
		S.current && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && (p ? (S.current.muted = !0, Jc(S.current, h)) : S.current.muted = !1);
	};
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: e }) => {
		let n = /*#__PURE__*/ t.createElement("video", {
			ref: T,
			autoPlay: o,
			muted: p,
			playsInline: l,
			className: v(qc.video, e, { [qc.mirrored]: s }, a),
			onCanPlay: D,
			...b
		}, d && /*#__PURE__*/ t.createElement("track", {
			kind: d,
			src: r,
			srcLang: i,
			default: !0
		}));
		return y ? y(n) : n;
	});
});
Yc.displayName = "Video";
// src/components/elements/Audio/Audio.tsx
var Xc = /*#__PURE__*/ o(({ src: e, srcObject: n, captionsSrc: r, captionsSrcLang: i, sinkId: a, play: o, controls: s = !1, onFailure: c = ae, onSuccess: l = ae, ...d }, f) => {
	let p = g(null);
	return u(() => {
		p.current?.setSinkId?.(a ?? "").catch(c);
	}, [a, c]), u(() => {
		p.current && n && (p.current.srcObject = n, p.current.setSinkId?.(a ?? "").catch(c));
	}, [
		a,
		n,
		c
	]), u(() => {
		o !== void 0 && (async (e) => {
			try {
				e ? (await p.current?.play(), p.current && l(p.current)) : p.current?.pause();
			} catch (e) {
				c(e);
			}
		})(o);
	}, [
		c,
		l,
		o
	]), /*#__PURE__*/ t.createElement("audio", {
		ref: (e) => {
			f && ("current" in f ? f.current = e : f(e)), p.current = e;
		},
		src: e,
		controls: s,
		...d
	}, r && /*#__PURE__*/ t.createElement("track", {
		kind: "captions",
		src: r,
		srcLang: i
	}));
}), Zc = (e, t) => {
	let [n, r] = _(!1);
	return u(() => {
		t && e > 0 && r(!0);
	}, [e, t]), u(() => {
		let e;
		return t && n && (e = window.setTimeout(() => {
			r(!1);
		}, 800)), () => clearTimeout(e);
	}, [n, t]), n;
}, Qc = (e) => {
	let [t, n] = _(e);
	return u(() => {
		e > 0 && n(e);
	}, [e]), t;
}, $c = {
	wrapper: "_wrapper_10wzf_18",
	truncated: "_truncated_10wzf_23",
	number: "_number_10wzf_23",
	counter: "_counter_10wzf_27",
	visible: "_visible_10wzf_47",
	animated: "_animated_10wzf_51",
	pulse: "_pulse_10wzf_1",
	info: "_info_10wzf_63",
	notification: "_notification_10wzf_73"
}, el = ({ number: e = 0, isVisible: n, variant: r = "notification", shouldAnimate: i = !0, isTruncated: a = !1, badgeClassName: o, childrenWrapperClassName: s, children: c, ...l }) => {
	let u = Zc(e, i), d = Qc(e);
	return /*#__PURE__*/ t.createElement("div", {
		...l,
		className: v($c.wrapper, { [$c.truncated]: a }, l.className)
	}, c && /*#__PURE__*/ t.createElement("div", { className: s }, c), /*#__PURE__*/ t.createElement("div", {
		"data-testid": G.BadgeCounterNumber,
		className: v($c.counter, $c[r], {
			[$c.animated]: u,
			[$c.visible]: n,
			[$c.truncated]: a
		}, o)
	}, /*#__PURE__*/ t.createElement(V, {
		colorScheme: r === "info" ? "light" : "dark",
		fontVariant: R.SmallBold,
		className: $c.number
	}, d)));
}, tl = (e, n) => e.includes("\n") ? e.split("\n").map((e) => /*#__PURE__*/ t.createElement(t.Fragment, { key: `${e}:${n}` }, e, /*#__PURE__*/ t.createElement("br", null))) : e, nl = /* @__PURE__ */ new Set(/* @__PURE__ */ "com.org.net.edu.gov.mil.int.info.biz.name.pro.aero.coop.museum.app.dev.io.co.me.tv.cc.ws.mobi.asia.tel.jobs.travel.cloud.ai.blog.shop.store.site.online.tech.xyz.top.live.space.fun.icu.one.website.ac.ad.ae.af.ag.al.am.ao.aq.ar.as.at.au.aw.ax.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bm.bn.bo.br.bs.bt.bw.by.bz.ca.cd.cf.cg.ch.ci.ck.cl.cm.cn.cr.cu.cv.cw.cx.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.er.es.et.eu.fi.fj.fk.fm.fo.fr.ga.gb.gd.ge.gf.gg.gh.gi.gl.gm.gn.gp.gq.gr.gs.gt.gu.gw.gy.hk.hm.hn.hr.ht.hu.id.ie.il.im.in.iq.ir.is.it.je.jm.jo.jp.ke.kg.kh.ki.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.lr.ls.lt.lu.lv.ly.ma.mc.md.mg.mh.mk.ml.mm.mn.mo.mp.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.no.np.nr.nu.nz.om.pa.pe.pf.pg.ph.pk.pl.pm.pn.pr.ps.pt.pw.py.qa.re.ro.rs.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sk.sl.sm.sn.so.sr.ss.st.su.sv.sx.sy.sz.tc.td.tf.tg.th.tj.tk.tl.tm.tn.to.tr.tt.tw.tz.ua.ug.uk.us.uy.uz.va.vc.ve.vg.vi.vn.vu.wf.ws.ye.yt.za.zm.zw".split(".")), rl = /(https?|ftp?:\/\/[^\s]+)/im, il = /((?:https?:\/\/|ftp?:\/\/|\d{1,3}(?:\.\d{1,3}){3}|[a-zA-Z0-9-]+\.{1}[a-zA-Z0-9-]{2,63})(?:[^\s.]+|\.{1}[a-zA-Z0-9-]{2,63})*)/im, al = (e) => {
	let t = e.split(/[/?#:]/)[0] ?? e;
	if (/^[\d.]+$/.test(t)) return !1;
	let n = t.split("."), r = (n[n.length - 1] ?? "").toLowerCase();
	return n[0]?.toLowerCase() === "www" || nl.has(r);
}, ol = (e) => e.split(il).filter(Boolean), sl = (e) => !rl.test(e), cl = (e) => ol(e).map((e, t) => il.test(e) ? sl(e) ? al(e) ? {
	id: t,
	linkType: "tld",
	value: e,
	url: `http://${e.replace(/(\/\/)/m, "")}`
} : {
	id: t,
	linkType: "text",
	value: e
} : {
	id: t,
	linkType: "url",
	value: e,
	url: e
} : {
	id: t,
	linkType: "text",
	value: e
}), ll = ({ text: e, ...n }) => {
	let r = m(() => cl(e), [e]);
	return /*#__PURE__*/ t.createElement(t.Fragment, null, r.map((e) => e.linkType === "text" ? tl(e.value, e.id) : /*#__PURE__*/ t.createElement(Nc, {
		key: e.id,
		href: e.url,
		target: "_blank",
		...n
	}, e.value)));
}, ul = {
	enter: "Enter",
	escape: "Escape",
	arrowUp: "ArrowUp",
	arrowRight: "ArrowRight",
	arrowDown: "ArrowDown",
	arrowLeft: "ArrowLeft",
	home: "Home",
	end: "End"
}, dl = {
	light: "_light_muqen_108",
	dark: "_dark_muqen_114",
	draggable: "_draggable_muqen_120",
	dragging: "_dragging_muqen_129",
	shadowFocus: "_shadowFocus_muqen_138"
}, fl = {}, pl = /*#__PURE__*/ function(e) {
	return e[e.NONE = 0] = "NONE", e[e.VERTICAL = 1] = "VERTICAL", e[e.HORIZONTAL = 2] = "HORIZONTAL", e;
}({}), ml = (e, t) => {
	let n = e.getBoundingClientRect().bottom, r = e.getBoundingClientRect().top, i = t.getBoundingClientRect().bottom, a = t.getBoundingClientRect().top;
	return n >= i ? "DOWN" : r <= a ? "UP" : "STOP";
}, hl = (e) => {
	let [t, n] = _(null);
	return [t, c((t) => {
		n(t), typeof e == "function" ? e(t) : e && (e.current = t);
	}, [e])];
}, gl = /*#__PURE__*/ t.forwardRef(({ alignWithFloatRootTrigger: e, ariaLabel: n = "Draggable", beforeReposition: r, floatRoot: i = void 0, floatRootInset: a = fl, isDisabled: o = !1, isMoveableWithArrowKeys: s = !1, lockStyle: c = 0, onPointerMoveExtra: l, onPointerUpExtra: d, onReposition: f, pointerCapture: p = !1, pointerCaptureTarget: m, scrollElementRef: h, scrollOffset: y = 10, scrollTimer: b = 30, shouldCaptureClick: x = !0, showFocus: S = !0, children: C, className: w, testId: T, ...E }, D) => {
	let [O, k] = hl(D), [A, j] = _(!1), M = g(!1), N = g(a);
	return u(() => {
		N.current = a;
	}, [a]), u(() => {
		if (!O) return;
		let t = O;
		if (j(!1), M.current = !1, o) return;
		let n = t.getBoundingClientRect(), a = h?.current ?? void 0, u = 0, g = 0, _ = 0, v = 0, x, S = 0, C = 0, w = a?.scrollTop, T = "STOP", E, D = !1, k = !1, A = () => {
			document.removeEventListener("pointermove", ae), document.removeEventListener("pointerup", de), document.removeEventListener("keyup", fe);
		}, ee = () => {
			clearInterval(E), D = !1, T = "STOP";
		}, P = () => {
			t.style.left = `${(t.offsetLeft + _) / window.innerWidth * 100}%`, t.style.top = `${(t.offsetTop + v) / window.innerHeight * 100}%`;
		}, te = () => {
			n = t.getBoundingClientRect(), x = t.offsetParent?.getBoundingClientRect(), S = x?.left ?? 0, C = x?.top ?? 0, r && (r(t), n = t.getBoundingClientRect()), t.style.left = `${n.left - S}px`, t.style.top = `${n.top - C}px`, t.style.removeProperty("right"), t.style.removeProperty("bottom"), t.style.removeProperty("translate"), t.style.transform = "none";
		};
		t.addEventListener("pointerdown", ie), s && t.addEventListener("keydown", re), a?.addEventListener("scroll", oe);
		function ne(e) {
			j(e), k = e;
		}
		function re(e) {
			let n = e.target, r = n instanceof Element ? n.closest("[data-drag-handle]") : null;
			if (n !== t && (!r || !t.contains(r)) || e.key !== ul.arrowUp && e.key !== ul.arrowRight && e.key !== ul.arrowDown && e.key !== ul.arrowLeft) return;
			e.preventDefault(), document.addEventListener("keyup", fe), e.repeat || te(), l && l(t);
			let i = e.shiftKey ? 10 : 1;
			switch (e.key) {
				case ul.arrowUp:
					v = -10 * i;
					break;
				case ul.arrowRight:
					_ = 10 * i;
					break;
				case ul.arrowDown:
					v = 10 * i;
					break;
				case ul.arrowLeft:
					_ = -10 * i;
					break;
				default: return;
			}
			P(), (_ || v) && (M.current = !0), _ = 0, v = 0;
		}
		function ie(e) {
			let n = e.target;
			if (n instanceof Element) {
				let e = !!n.closest("[data-drag-handle]");
				if (n.closest("[data-no-drag]") && !e) return;
			}
			p && (m ?? t).setPointerCapture(e.pointerId), e.preventDefault(), e.stopPropagation(), e.button === 0 && (ne(!0), te(), u = e.clientX, g = e.clientY, document.addEventListener("pointermove", ae), document.addEventListener("pointerup", de));
		}
		function ae(e) {
			l && l(t), c !== 1 && (_ = e.clientX - u), c !== 2 && (v = e.clientY - g), a ? (T = ml(t, a), T === "STOP" ? (t.style.transform = `translate(${_}px, ${v}px)`, D && ee()) : D || (D = !0, E = window.setInterval(() => {
				if (a) switch ((T === "UP" && a.scrollTop === 0 || T === "DOWN" && a.scrollHeight - a.clientHeight - a.scrollTop <= 1) && (T = "STOP"), T) {
					case "DOWN":
						a.scrollTop += y;
						break;
					case "UP":
						a.scrollTop -= y;
						break;
					case "STOP": t.style.transform = `translate(${_}px, ${v}px)`, ee();
				}
			}, b))) : t.style.transform = `translate(${_}px, ${v}px)`;
		}
		function oe() {
			if (a?.scrollTop !== void 0) {
				if (k && w !== void 0) {
					let e = a.scrollTop - w;
					c !== 2 && (v += e, g -= e), t.style.transform = `translate(${_}px, ${v}px)`;
				}
				w = a.scrollTop;
			}
		}
		let se = () => {
			let e = !1, r = !1, a = !1, o = !1, s = { overflow: !1 };
			if (i?.current) {
				n = t.getBoundingClientRect();
				let c = i.current.getBoundingClientRect(), l = N.current.top ?? 0, u = N.current.bottom ?? 0, d = N.current.left ?? 0, f = N.current.right ?? 0;
				n.left < c.left + d && (t.style.left = `${i.current.offsetLeft - S + d}px`, a = !0), n.right > c.right - f && (t.style.left = `${c.right - t.offsetWidth - S - f}px`, o = !0), n.top < c.top + l && (t.style.top = `${i.current.offsetTop - C + l}px`, e = !0), n.bottom > c.bottom - u && (t.style.top = `${c.bottom - t.offsetHeight - C - u}px`, r = !0), s = {
					overflow: e || r || a || o,
					top: e,
					bottom: r,
					left: a,
					right: o
				}, s.overflow && P();
			}
			return s;
		};
		e && (e.current = () => {
			let e = se();
			f && f(t, e);
		});
		function ce() {
			n.left + n.width / 2 > window.innerWidth / 2 && (t.style.right = `${(window.innerWidth - n.right) / window.innerWidth * 100}%`, t.style.left = "auto");
		}
		function le() {
			n.top + n.height / 2 > window.innerHeight / 2 && (t.style.bottom = `${(window.innerHeight - n.bottom) / window.innerHeight * 100}%`, t.style.top = "auto");
		}
		let ue = () => {
			ee(), d && d(t), P(), t.style.removeProperty("transform"), (_ || v) && (M.current = !0), _ = 0, v = 0, A();
			let e = se();
			e.overflow || (ce(), le()), ne(!1), f && f(t, e);
		};
		function de(e) {
			p && (m ?? t).releasePointerCapture(e.pointerId), ue();
		}
		function fe() {
			ue();
		}
		return () => {
			A(), t.removeEventListener("pointerdown", ie), s && t.removeEventListener("keydown", re), a?.removeEventListener("scroll", oe), ee(), t.style.removeProperty("transform"), k && d?.(t);
		};
	}, [
		o,
		s,
		i,
		r,
		f,
		d,
		e,
		l,
		b,
		y,
		c,
		p,
		h,
		m,
		O
	]), /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: e }) => /*#__PURE__*/ t.createElement("div", {
		role: "region",
		"aria-label": n,
		tabIndex: s ? 0 : -1,
		ref: k,
		className: v(e, {
			[dl.draggable]: !o,
			[dl.dragging]: A,
			[dl.shadowFocus]: s && S
		}, w),
		"data-dragging": A ? !0 : void 0,
		"data-testid": T,
		onClickCapture: x ? (e) => {
			M.current &&= (e.stopPropagation(), e.preventDefault(), !1);
		} : void 0,
		...E
	}, C));
});
gl.displayName = "Draggable";
var _l = {
	box: "_box_kq00y_4",
	fillHeight: "_fillHeight_kq00y_8",
	"overflow-hidden": "_overflow-hidden_kq00y_14",
	overflowHidden: "_overflow-hidden_kq00y_14",
	nonePadding: "_nonePadding_kq00y_18",
	compactPadding: "_compactPadding_kq00y_22",
	smallPadding: "_smallPadding_kq00y_26",
	mediumPadding: "_mediumPadding_kq00y_30",
	largePadding: "_largePadding_kq00y_34",
	scrollbar: "_scrollbar_kq00y_38"
}, vl = /*#__PURE__*/ t.forwardRef(({ fillHeight: e = !0, hasFooterShadow: n = !0, headerContent: r, headerContentBelowDivider: i, footerContent: a, padding: o = "small", headerPadding: s = o, footerPadding: c = o, overflowHidden: l = !1, withScrollbars: u = !0, scrollbarRef: f, children: p, scrollElementRef: m, scrollElementClassname: h, scrollbarsClassname: g, onScroll: _, className: y, ...b }, x) => {
	let S = d();
	return /*#__PURE__*/ t.createElement(Ae, {
		hasFooterShadow: n,
		className: v(_l.box, { [_l.fillHeight]: e }, { [_l.overflowHidden]: l }, y),
		padding: "none",
		headerContent: r,
		headerContentBelowDivider: i,
		footerContent: a,
		footerPadding: c,
		headerPadding: s,
		ref: x,
		...b
	}, p && u ? /*#__PURE__*/ t.createElement(wc, {
		ref: f,
		scrollElementRef: m,
		className: v(_l.scrollbar, g),
		ariaLabel: `Scrollable panel content ${S}`,
		onScroll: _
	}, /*#__PURE__*/ t.createElement("div", { className: v(_l[ve(o)], h) }, p)) : p);
});
vl.displayName = "Panel";
var yl = {
	light: "_light_s3w3u_108",
	dark: "_dark_s3w3u_114",
	notification: "_notification_s3w3u_120",
	open: "_open_s3w3u_134",
	close: "_close_s3w3u_137",
	contentAndCloseButtonContainer: "_contentAndCloseButtonContainer_s3w3u_142",
	closeButton: "_closeButton_s3w3u_147",
	buttonsContainer: "_buttonsContainer_s3w3u_154",
	content: "_content_s3w3u_142",
	interactiveNotification: "_interactiveNotification_s3w3u_172",
	interactiveNotificationFocus: "_interactiveNotificationFocus_s3w3u_184",
	iconAndTextContainer: "_iconAndTextContainer_s3w3u_198",
	icon: "_icon_s3w3u_198",
	text: "_text_s3w3u_207",
	avatar: "_avatar_s3w3u_212"
}, bl = ({ isClosable: e = !1, size: n = "medium", id: r, text: i, icon: a, avatarDisplayName: o, buttons: s, closeTimeout: l, closeAt: f, revision: m, handleClose: h, group: y, onClick: b }) => {
	let [x, S] = _("closed"), C = d(), w = g(void 0), T = g(void 0), E = g(!1), D = g(!1), O = g({
		closeAt: f,
		closeTimeout: l,
		revision: m,
		version: 0
	}), k = g(void 0), A = c(() => {
		k.current = O.current.version, S("closing");
	}, []), j = c(() => {
		window.clearTimeout(T.current), T.current = void 0;
	}, []), M = c((e = w.current) => {
		j(), e !== void 0 && (T.current = window.setTimeout(A, e));
	}, [j, A]), N = () => {
		!E.current && !D.current && M();
	}, { hoverProps: ee } = ce({
		onHoverStart: () => {
			E.current = !0, j();
		},
		onHoverEnd: () => {
			E.current = !1, N();
		}
	}), { focusWithinProps: P } = se({
		onFocusWithin: () => {
			D.current = !0, j();
		},
		onBlurWithin: () => {
			D.current = !1, N();
		}
	}), te = s?.map(({ onClick: e, text: i, variant: a, closeNotificationOnClick: o }) => /*#__PURE__*/ t.createElement(H, {
		key: i,
		onClick: (t) => {
			t.stopPropagation(), e(r), o !== !1 && A();
		},
		size: n,
		colorScheme: "light",
		variant: a
	}, i));
	return p(() => {
		let e = O.current;
		(e.closeAt !== f || e.closeTimeout !== l || e.revision !== m) && (O.current = {
			closeAt: f,
			closeTimeout: l,
			revision: m,
			version: e.version + 1
		}, S((e) => e === "closing" ? "open" : e));
		let t = f === void 0 ? l : Math.max(f - Date.now(), 0);
		return w.current = l ?? t, !E.current && !D.current && M(t), j;
	}, [
		j,
		f,
		l,
		m,
		M
	]), u(() => {
		S("opening");
	}, []), /*#__PURE__*/ t.createElement("div", {
		...ee,
		...P,
		"data-testid": G.Notification,
		onTransitionEnd: () => {
			switch (x) {
				case "opening": return S("open");
				case "closing":
					if (k.current !== O.current.version) return;
					h(r, y);
					return;
			}
		},
		className: v(yl.notification, {
			[yl.open]: x === "opening" || x === "open",
			[yl.close]: x === "closing"
		})
	}, b && /*#__PURE__*/ t.createElement(z, {
		"data-testid": G.ButtonInteractiveNotification,
		"aria-labelledby": C,
		className: yl.interactiveNotification,
		focusClassName: yl.interactiveNotificationFocus,
		htmlTag: "button",
		onClick: () => {
			b(r), A();
		},
		type: "button"
	}), /*#__PURE__*/ t.createElement("div", { className: yl.contentAndCloseButtonContainer }, /*#__PURE__*/ t.createElement("div", { className: yl.content }, /*#__PURE__*/ t.createElement("div", { className: yl.iconAndTextContainer }, a && !o && /*#__PURE__*/ t.createElement(W, {
		className: yl.icon,
		source: a
	}), o && /*#__PURE__*/ t.createElement(rf, {
		className: yl.avatar,
		colorScheme: "light",
		displayName: o,
		sizeModifier: "md",
		type: Jd.Initials
	}), /*#__PURE__*/ t.createElement("div", { className: yl.text }, /*#__PURE__*/ t.createElement("span", { id: C }, typeof i == "string" ? /*#__PURE__*/ t.createElement(V, {
		colorScheme: "light",
		fontVariant: R.Body
	}, i) : i)))), e && /*#__PURE__*/ t.createElement(H, {
		className: yl.closeButton,
		onClick: (e) => {
			A(), e.stopPropagation();
		},
		colorScheme: "light",
		size: "small",
		variant: "transparent",
		modifier: "square",
		"aria-label": "close notification",
		"data-testid": G.ButtonCloseNotification
	}, /*#__PURE__*/ t.createElement(W, {
		source: U.IconClose,
		size: "small"
	}))), te && /*#__PURE__*/ t.createElement("div", { className: yl.buttonsContainer }, te));
}, xl = (e) => ({ focusFrom: c(() => {
	if (e) {
		let t = e.tabIndex;
		e.tabIndex = -1, e.focus(), e.tabIndex = t;
	}
}, [e]) }), Sl = ({ children: e }) => /*#__PURE__*/ le(e, document.body), Cl = (() => {
	let e = [], t = (t) => {
		let n = e.indexOf(t);
		n !== -1 && e.splice(n, 1);
	};
	return {
		add: (n) => (e.push(n), () => {
			t(n);
		}),
		isLast: (t) => e.length ? e[e.length - 1] === t : !1,
		remove: t
	};
})(), wl = (e) => {
	let t = (e) => e?.dataset?.focusRoot === "1";
	return (() => {
		let n = e;
		for (; n;) {
			if (t(n)) return n;
			n = n.parentElement;
		}
	})();
}, Tl = (e) => {
	let t = M(e, { includeContainer: !1 });
	t.length ? El(t[0], e) : El(e);
}, El = (e, t) => {
	e !== document.activeElement && (e?.focus ? e?.focus() : El(t));
}, Dl = (e, t) => {
	let n = (n) => {
		if (n.key?.toLowerCase() !== "tab" || !Cl.isLast(t)) return;
		let r = M(e, { includeContainer: !1 }), i = r[r.length - 1], a = r[0];
		r.length === 0 ? El(e) : n.shiftKey ? n.target === a && (El(i), n.preventDefault()) : n.target === i && (El(a), n.preventDefault());
	};
	return [() => {
		document.addEventListener("keydown", n);
	}, () => {
		document.removeEventListener("keydown", n);
	}];
}, Ol = (e = !0) => {
	let t = g(x()), n = g(null), r = g(null), i = g(!1);
	u(() => {
		i.current = e;
	}, [e]), !i.current && e && (n.current = document.activeElement);
	let a = c((t) => {
		r.current = t, e && t && (t.setAttribute("data-focus-root", "1"), t.contains(document.activeElement) || Tl(t));
	}, [e]);
	return u(() => {
		let i = r.current, a = t.current;
		if (!e || !i) return;
		let [o, s] = Dl(i, a);
		Cl.add(a), o?.();
		let c = n.current;
		return () => {
			Cl.remove(a), s?.();
			let e = document.activeElement, t = wl(e), r = t && t === i, o = e && j(e);
			n.current = null, !(!c || !r && o) && c.focus?.();
		};
	}, [e]), {
		focusTrapRef: r,
		setFocusTrapRef: a
	};
}, kl = {
	modalWrapper: "_modalWrapper_tj5hq_4",
	modalMask: "_modalMask_tj5hq_18",
	fade: "_fade_tj5hq_1",
	alternativeModalMaskColor: "_alternativeModalMaskColor_tj5hq_33",
	modal: "_modal_tj5hq_4",
	compact: "_compact_tj5hq_47",
	small: "_small_tj5hq_50",
	medium: "_medium_tj5hq_53",
	large: "_large_tj5hq_56",
	auto: "_auto_tj5hq_59",
	closeButton: "_closeButton_tj5hq_63",
	closeButtonIcon: "_closeButtonIcon_tj5hq_74",
	nonePadding: "_nonePadding_tj5hq_96",
	compactPadding: "_compactPadding_tj5hq_100",
	smallPadding: "_smallPadding_tj5hq_104",
	mediumPadding: "_mediumPadding_tj5hq_108",
	largePadding: "_largePadding_tj5hq_112",
	overlay: "_overlay_tj5hq_116",
	slide: "_slide_tj5hq_1",
	positioned: "_positioned_tj5hq_125",
	scrollbars: "_scrollbars_tj5hq_129",
	keycap: "_keycap_tj5hq_135"
}, Al = /*#__PURE__*/ function(e) {
	return e.Overlay = "overlay", e.Positioned = "positioned", e;
}({}), jl = ({ children: e, ...n }) => /*#__PURE__*/ t.createElement("div", n, e), Ml = /*#__PURE__*/ t.forwardRef(({ canDrag: e = !1, children: n, className: r, closeButton: i = ic, closeButtonAriaLabel: a = "Close tooltip", closeOnOutsideClick: o = !0, colorScheme: s = "light", footerContent: c, footerPadding: d, hasBackground: p, hasFooterShadow: m, headerContent: h, headerPadding: g, isOpen: y = !1, modalType: b = "overlay", onClose: x, padding: S = "medium", scrollbarsAriaLabel: C, sizeModifier: w = "small", style: T, testIdCloseButton: E = G.ButtonModalClose, uniqueTitle: D, withCloseButton: O = !1, withMask: k = !0, withAlternativeMaskColor: A = !1, withScrollbars: j = !0, wrapperClassName: M, presentationElementClassName: N, zIndex: ee, ...P }, ne) => {
	let re = te(() => {
		o && x?.();
	}), { focusTrapRef: ie, setFocusTrapRef: ae } = Ol(y), oe = t.useRef(null), [se, ce] = _(null), { focusFrom: le } = xl(se), ue = j ? wc : jl;
	f(ne, () => ({ focus: () => {
		ie.current instanceof HTMLElement ? Tl(ie.current) : se && le();
	} })), u(() => {
		let e = (e) => {
			e.key === "Escape" && x?.();
		};
		return y ? document.addEventListener("keydown", e) : document.removeEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [y, x]);
	let { colorScheme: de } = l(Ce), fe = /*#__PURE__*/ t.createElement(I, { colorScheme: s ?? de }, /*#__PURE__*/ t.createElement(Ae, {
		className: v(kl.modal, kl[b], w !== "none" && kl[w], !e && r),
		ref: b === "positioned" ? (e) => {
			ce(e);
		} : ae,
		hasBackground: p,
		headerContent: h,
		footerContent: c,
		headerPadding: g,
		footerPadding: d,
		hasFooterShadow: m,
		...!e && { style: T }
	}, /*#__PURE__*/ t.createElement(ue, {
		className: kl.scrollbars,
		...j ? { ariaLabel: C } : { "aria-label": C }
	}, /*#__PURE__*/ t.createElement("div", {
		role: "presentation",
		ref: re,
		className: v(kl[ve(S)], N)
	}, /*#__PURE__*/ t.createElement("div", {
		role: "dialog",
		"aria-modal": "true",
		"aria-label": D
	}, O && /*#__PURE__*/ t.createElement(i, {
		"aria-label": a,
		className: kl.closeButton,
		"data-testid": E,
		onClose: x
	}), n)))));
	return e && (fe = /*#__PURE__*/ t.createElement(gl, {
		className: r,
		style: T,
		floatRoot: oe
	}, fe)), k && (fe = /*#__PURE__*/ t.createElement("div", {
		role: "presentation",
		className: v(kl.modalMask, { [kl.alternativeModalMaskColor]: A }, M),
		"data-testid": G.ModalMask
	}, fe)), y ? /*#__PURE__*/ t.createElement(Sl, null, /*#__PURE__*/ t.createElement("div", {
		className: kl.modalWrapper,
		role: "region",
		ref: oe,
		"data-react-aria-top-layer": "true",
		...P,
		...ee === void 0 ? {} : { style: { zIndex: ee } }
	}, fe)) : null;
});
Ml.displayName = "Modal";
var Nl = ({ className: e, colorScheme: n, hotkeyLabel: r, keyCap: i, onClose: a, ...o }) => /*#__PURE__*/ t.createElement(Pl, {
	className: e,
	hotkeyLabel: r,
	keyCap: i,
	...o
}, /*#__PURE__*/ t.createElement(ic, {
	colorScheme: n,
	onClose: a
})), Pl = ({ children: e, className: n, delay: r = 0, hotkeyLabel: i, keyCap: a = "ESC", position: o = "bottomEnd", ...s }) => /*#__PURE__*/ t.createElement(Kc, {
	delay: r,
	position: o,
	text: /*#__PURE__*/ t.createElement(Fl, {
		label: i,
		keyCap: a
	}),
	tooltipContainerClassName: n,
	...s
}, e), Fl = ({ label: e, keyCap: n }) => /*#__PURE__*/ t.createElement("div", { className: "d-inline-flex items-center gap-1" }, /*#__PURE__*/ t.createElement(V, null, e), /*#__PURE__*/ t.createElement("div", { className: kl.keycap }, /*#__PURE__*/ t.createElement(V, { fontVariant: R.Small }, n))), Il = {
	list: "_list_1kobu_4",
	noneSpacing: "_noneSpacing_1kobu_9",
	compactSpacing: "_compactSpacing_1kobu_16",
	smallSpacing: "_smallSpacing_1kobu_23",
	mediumSpacing: "_mediumSpacing_1kobu_30",
	largeSpacing: "_largeSpacing_1kobu_37"
}, Ll = ({ children: e, className: n, spacing: r = "small", ...i }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Il.list, Il[ye(r)], n),
	...i
}, e), Rl = ({ enhancerEnd: e, version: n, headingText: r = "About Pexip", privacyPolicyLinkText: i = "Privacy Policy", privacyPolicyUrl: a = "https://pexip.com/privacy-policy/", termsOfServiceLinkText: o = "Terms of Service", termsOfServiceUrl: s = "https://pexip.com/terms-of-service/", ...c }) => /*#__PURE__*/ t.createElement(Ll, {
	className: "ml-3 mr-3 mb-2",
	...c
}, r && /*#__PURE__*/ t.createElement(Fc, null, /*#__PURE__*/ t.createElement(Ne, {
	className: "mb-3 mt-2",
	fontVariant: R.H5,
	htmlTag: "h1"
}, r)), a && i && /*#__PURE__*/ t.createElement(Fc, { spacing: "small" }, /*#__PURE__*/ t.createElement(Nc, {
	href: a,
	target: "_blank",
	"data-testid": G.PrivacyPolicyLink
}, i)), o && s && /*#__PURE__*/ t.createElement(Fc, { spacing: "small" }, /*#__PURE__*/ t.createElement(Nc, {
	href: s,
	target: "_blank",
	"data-testid": G.TermsOfServiceLink
}, o)), /*#__PURE__*/ t.createElement(Me, { className: "mt-5 mb-3" }), /*#__PURE__*/ t.createElement(V, { "data-testid": G.Version }, "Version: ", n), e), zl = we(Ml, "light"), Bl = ({ className: e, isOpen: n = !1, onClose: r, version: i, headingText: a, privacyPolicyUrl: o, privacyPolicyLinkText: s, termsOfServiceUrl: c, termsOfServiceLinkText: l, aboutTextEnhancerEnd: u, ...d }) => /*#__PURE__*/ t.createElement(zl, {
	padding: "none",
	onClose: r,
	isOpen: n,
	withCloseButton: !0,
	className: e,
	...d
}, /*#__PURE__*/ t.createElement(Rl, {
	version: i,
	headingText: a,
	privacyPolicyUrl: o,
	privacyPolicyLinkText: s,
	termsOfServiceUrl: c,
	termsOfServiceLinkText: l,
	enhancerEnd: u
})), Vl = (e) => (t) => {
	t.key === "Enter" && e(t);
}, Hl = {
	chevron: "_chevron_ansc0_4",
	toggle: "_toggle_ansc0_12",
	summary: "_summary_ansc0_16",
	content: "_content_ansc0_24",
	expanded: "_expanded_ansc0_29",
	accordionButton: "_accordionButton_ansc0_33",
	dark: "_dark_ansc0_40",
	meta: "_meta_ansc0_47",
	light: "_light_ansc0_51"
}, Ul = ({ canOnlyToggleWithTitle: e, children: n, className: r, isExpanded: i, onExpand: a, ...o }) => {
	let s = v(Hl.summary, r);
	return e ? /*#__PURE__*/ t.createElement("div", { className: s }, n) : /*#__PURE__*/ t.createElement(z, {
		className: s,
		"aria-expanded": i,
		onClick: a,
		onKeyDown: Vl(a),
		...o
	}, n);
}, Wl = ({ isExpanded: e }) => {
	let n = e ? U.IconChevronDown : U.IconChevronRight;
	return /*#__PURE__*/ t.createElement(W, {
		size: "compact",
		source: n,
		className: v(Hl.chevron, "me-2")
	});
}, Gl = ({ children: e, isExpanded: n, canOnlyToggleWithTitle: r, onExpand: i }) => {
	let a = () => /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Wl, { isExpanded: n }), e);
	return r ? /*#__PURE__*/ t.createElement(z, {
		className: Hl.accordionButton,
		"aria-expanded": n,
		onClick: i,
		onKeyDown: Vl(i)
	}, /*#__PURE__*/ t.createElement(a, null)) : /*#__PURE__*/ t.createElement("div", { className: Hl.accordionButton }, /*#__PURE__*/ t.createElement(a, null));
}, Kl = ({ meta: e }) => {
	let n = "d-inline ms-2";
	return typeof e == "string" ? /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.BodyBold,
		className: v(Hl.meta, n)
	}, e) : /*#__PURE__*/ t.createElement("div", { className: n }, e);
}, ql = ({ canOnlyToggleWithTitle: e, children: n, enhancerEnd: r, meta: i, isExpanded: a, onExpand: o, className: s, ...c }) => /*#__PURE__*/ t.createElement(Ul, {
	canOnlyToggleWithTitle: e,
	className: s,
	isExpanded: a,
	onExpand: o,
	...c
}, /*#__PURE__*/ t.createElement("div", { className: "d-flex align-items-center" }, /*#__PURE__*/ t.createElement(Gl, {
	canOnlyToggleWithTitle: e,
	isExpanded: a,
	onExpand: o
}, n), /*#__PURE__*/ t.createElement(Kl, { meta: i }), /*#__PURE__*/ t.createElement("div", { className: "ml-auto" }, r))), Jl = ({ buttonClassName: e, canOnlyToggleWithTitle: n, children: r, className: i, colorScheme: a, contentClassName: o, dataTestId: s, enhancerEnd: c, isExpanded: l = !1, meta: d, onToggle: f, title: p, ...m }) => {
	let [h, g] = _(l), y = ne(h), b = (e) => {
		e.preventDefault(), g((e) => !e);
	};
	return u(() => {
		h !== (y || !1) && f?.(h);
	}, [
		f,
		h,
		y
	]), /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: l }) => /*#__PURE__*/ t.createElement("div", {
		role: "group",
		className: v(Hl[a ?? l], i),
		...m
	}, /*#__PURE__*/ t.createElement(ql, {
		canOnlyToggleWithTitle: n,
		meta: d,
		isExpanded: h,
		onExpand: b,
		className: e,
		enhancerEnd: c,
		"data-testid": s
	}, typeof p == "string" ? /*#__PURE__*/ t.createElement(V, { fontVariant: R.BodyBold }, p) : p), /*#__PURE__*/ t.createElement("div", { className: v(Hl.content, { [Hl.expanded]: h }, o) }, r)));
}, Yl = {
	secondaryWrapper: "_secondaryWrapper_1plhf_4",
	statusWrapper: "_statusWrapper_1plhf_10",
	statusItem: "_statusItem_1plhf_18",
	eventsList: "_eventsList_1plhf_22",
	eventItem: "_eventItem_1plhf_26",
	contentWrapper: "_contentWrapper_1plhf_32",
	disabled: "_disabled_1plhf_42"
}, Xl = ({ actionButton: e, disabled: n = !1, eventsItems: r, eventsTitle: i, statusItems: a, title: o, titleEnhancerStart: s }) => /*#__PURE__*/ t.createElement(Fe, {
	title: o,
	titleEnhancerStart: s,
	secondaryComponent: /*#__PURE__*/ t.createElement("div", { className: v(Yl.secondaryWrapper, n && Yl.disabled, "p-4") }, a.map((e) => /*#__PURE__*/ t.createElement("div", {
		className: Yl.statusWrapper,
		key: `${e.label}${e.content}`
	}, /*#__PURE__*/ t.createElement(V, {
		variant: "inherit",
		fontVariant: R.Body,
		className: Yl.statusItem
	}, e.label), /*#__PURE__*/ t.createElement(V, {
		variant: "inherit",
		fontVariant: R.BodyBold,
		className: Yl.statusItem
	}, e.content))))
}, /*#__PURE__*/ t.createElement("div", { className: v(Yl.contentWrapper, n && Yl.disabled, "p-4") }, /*#__PURE__*/ t.createElement(Ne, {
	className: "mb-2",
	htmlTag: "h3",
	variant: "inherit",
	fontVariant: R.H5
}, i), /*#__PURE__*/ t.createElement(Ll, {
	spacing: "none",
	className: Yl.eventsList
}, r.map((e) => /*#__PURE__*/ t.createElement(Fc, { key: e.label }, /*#__PURE__*/ t.createElement(Nc, {
	onClick: e.action,
	isUnderlined: !!e.action,
	className: Yl.eventItem
}, e.label)))), /*#__PURE__*/ t.createElement(Nc, {
	variant: "inherit",
	fontVariant: R.BodyBold,
	isDisabled: !0,
	onClick: e.action
}, e.label))), Zl = { wrapper: "_wrapper_16uxo_4" }, Ql = {
	width: 16,
	height: 9
}, $l = ({ children: e, className: n, dimensions: r = Ql, isActive: i = !0, style: a, ...o }) => {
	let s = i ? {
		"--aspect-ratio-height": r.height,
		"--aspect-ratio-width": r.width
	} : void 0;
	return /*#__PURE__*/ t.createElement("div", {
		style: {
			...a,
			...s
		},
		className: v(Zl.wrapper, n),
		...o
	}, e);
}, eu = {
	bar: "_bar_19iud_4",
	absoluteTop: "_absoluteTop_19iud_12",
	absoluteBottom: "_absoluteBottom_19iud_17",
	relative: "_relative_19iud_22",
	row: "_row_19iud_26",
	rowReverse: "_rowReverse_19iud_30",
	column: "_column_19iud_34",
	columnReverse: "_columnReverse_19iud_38",
	spaceBetween: "_spaceBetween_19iud_42",
	center: "_center_19iud_46",
	nonePadding: "_nonePadding_19iud_50",
	compactPadding: "_compactPadding_19iud_54",
	smallPadding: "_smallPadding_19iud_58",
	mediumPadding: "_mediumPadding_19iud_62",
	largePadding: "_largePadding_19iud_66"
}, tu = ({ children: e, className: n, position: r = "relative", padding: i = "none", flexDirection: a = "row", justifyContent: o = "spaceBetween", ...s }) => /*#__PURE__*/ t.createElement("div", {
	className: v(eu.bar, eu[ve(i)], eu[r], eu[a], eu[o], n),
	...s
}, e), nu = {
	wrapper: "_wrapper_1f5cx_14",
	list: "_list_1f5cx_20",
	listItem: "_listItem_1f5cx_27",
	crumbLabel: "_crumbLabel_1f5cx_30",
	crumbLink: "_crumbLink_1f5cx_43"
}, ru = (e, t, n) => {
	e.preventDefault(), t.action ? t.action() : t.url && n(t.url);
}, iu = ({ className: e, crumbs: n, enhancerEnd: r, enhancerStart: i, handleNavigate: a }) => {
	let o = [...n].reverse().slice(1).find((e) => e.url || e.action);
	return /*#__PURE__*/ t.createElement("nav", {
		className: v(e, nu.wrapper),
		"aria-label": "breadcrumbs"
	}, i, (o?.url || o?.action) && /*#__PURE__*/ t.createElement(H, {
		href: o.url,
		onClick: (e) => ru(e, o, a),
		htmlTag: "a",
		size: "none",
		variant: "transparent",
		className: "mr-3",
		"aria-label": `Go back to ${o.label}`
	}, /*#__PURE__*/ t.createElement(W, {
		source: U.IconArrowLeftRegular,
		size: "medium"
	})), /*#__PURE__*/ t.createElement("ul", { className: nu.list }, n.map((e) => /*#__PURE__*/ t.createElement("li", {
		key: `${e.label}${e.url}`,
		className: nu.listItem
	}, e.action ?? e.url ? /*#__PURE__*/ t.createElement(z, {
		className: nu.crumbLink,
		href: e.url,
		htmlTag: "a",
		onClick: (t) => ru(t, e, a)
	}, /*#__PURE__*/ t.createElement(au, { label: e.label })) : /*#__PURE__*/ t.createElement(au, { label: e.label })))), r);
}, au = ({ label: e }) => /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.BodyBold,
	className: nu.crumbLabel
}, e), ou = {
	svg: "_svg_1ww8x_4",
	circle: "_circle_1ww8x_13",
	timer: "_timer_1ww8x_1"
}, su = ({ duration: e = 60, className: n, ...r }) => {
	let i = m(() => e, []);
	return /*#__PURE__*/ t.createElement("svg", {
		viewBox: "0 0 32 32",
		className: v(ou.svg, n),
		role: "img",
		"aria-label": "timer",
		...r
	}, /*#__PURE__*/ t.createElement("circle", {
		r: "16",
		cx: "16",
		cy: "16",
		className: ou.circle,
		style: { animationDuration: `${i}s` }
	}));
}, cu = {
	countdownWrapper: "_countdownWrapper_nht8u_11",
	countdownNumber: "_countdownNumber_nht8u_20",
	svg: "_svg_nht8u_24",
	circleMain: "_circleMain_nht8u_33",
	circleBackground: "_circleBackground_nht8u_34",
	countdown: "_countdown_nht8u_11",
	animateCountdown: "_animateCountdown_nht8u_1"
}, lu = ({ className: e }) => /*#__PURE__*/ t.createElement("circle", {
	className: e,
	r: "35",
	cx: "40",
	cy: "40"
}), uu = ({ currentCount: e = 0, startCountFrom: n = 5, shouldStartCountDown: r }) => (u(() => {
	document.documentElement.style.setProperty("--countdown-animation-duration", `${n}`);
}, [n]), /*#__PURE__*/ t.createElement("div", {
	"aria-label": String(e),
	className: cu.countdownWrapper,
	role: "timer"
}, /*#__PURE__*/ t.createElement(V, {
	"aria-hidden": "true",
	className: cu.countdownNumber,
	colorScheme: "light",
	fontVariant: R.H1
}, e), /*#__PURE__*/ t.createElement("svg", {
	"aria-hidden": "true",
	className: cu.svg,
	focusable: "false"
}, /*#__PURE__*/ t.createElement(lu, { className: v(cu.circleBackground, r ? cu.countdown : "") }), /*#__PURE__*/ t.createElement(lu, { className: v(cu.circleMain, r ? cu.countdown : "") })))), du = ({ currentCount: e, startCountFrom: n = 5, msInterval: r = 1e3, shouldStartCountDown: i }) => {
	let { startCountDown: a, currentCount: o } = N({
		startCountFrom: n,
		enabled: i,
		msInterval: r
	});
	return u(() => {
		i && e === void 0 && a();
	}, [
		e,
		i,
		a
	]), /*#__PURE__*/ t.createElement(uu, {
		startCountFrom: n,
		shouldStartCountDown: i,
		currentCount: e ?? o
	});
}, fu = {
	light: "_light_1c40t_208",
	dark: "_dark_1c40t_214",
	tabs: "_tabs_1c40t_220",
	small: "_small_1c40t_232",
	underline: "_underline_1c40t_235",
	tab: "_tab_1c40t_220",
	active: "_active_1c40t_255",
	canClickActive: "_canClickActive_1c40t_255",
	large: "_large_1c40t_270",
	medium: "_medium_1c40t_273"
}, pu = ({ allowActiveTabToBeClicked: e = !1, tabs: n, selectedTabID: r, onTabChange: i, className: a, sizeModifier: o = "large", variant: s = "pill" }) => {
	let c = g(/* @__PURE__ */ new Map()), l = (e) => {
		let t = n.at(e % n.length);
		t && t.id !== r && (c.current.get(t.id)?.focus(), i(t.id));
	}, u = (e, t) => {
		switch (e.key) {
			case ul.arrowRight:
				l(t + 1);
				break;
			case ul.arrowLeft:
				l(t - 1 < 0 ? n.length - 1 : t - 1);
				break;
			case ul.home:
				l(0);
				break;
			case ul.end:
				l(n.length - 1);
				break;
			default: return;
		}
		e.preventDefault();
	}, d = n.length > 1;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: l }) => /*#__PURE__*/ t.createElement("div", {
		role: "tablist",
		className: v(l, fu[l], fu[o], fu.tabs, s === "underline" && fu.underline, a)
	}, n.map(({ name: n, id: a, textEndContent: f, testId: p }, m) => {
		let h = a === r;
		return /*#__PURE__*/ t.createElement("button", {
			type: "button",
			"data-testid": p,
			onClick: () => {
				(!h || e) && i(a);
			},
			onKeyDown: (e) => u(e, m),
			ref: (e) => {
				e ? c.current.set(a, e) : c.current.delete(a);
			},
			role: "tab",
			"aria-selected": h,
			tabIndex: h && d ? 0 : -1,
			key: a,
			className: v(fu.tab, fu[l], fu[o], {
				[fu.active]: h,
				[fu.canClickActive]: e,
				[fu.underline]: s === "underline"
			})
		}, /*#__PURE__*/ t.createElement(V, {
			fontVariant: o === "small" ? R.SmallBold : R.BodyBold,
			className: v({ "p-relative": !!f })
		}, n, f));
	})));
}, mu = {
	wrap: "_wrap_yqav1_4",
	buttonContainer: "_buttonContainer_yqav1_10",
	dropContent: "_dropContent_yqav1_17",
	fade: "_fade_yqav1_1",
	contentTextNoWrap: "_contentTextNoWrap_yqav1_25",
	topLeft: "_topLeft_yqav1_30",
	bottomLeft: "_bottomLeft_yqav1_31",
	topRight: "_topRight_yqav1_35",
	bottomRight: "_bottomRight_yqav1_36",
	topMiddle: "_topMiddle_yqav1_42",
	bottomMiddle: "_bottomMiddle_yqav1_53",
	middleLeft: "_middleLeft_yqav1_62",
	middleRight: "_middleRight_yqav1_63",
	limitSize: "_limitSize_yqav1_84",
	row: "_row_yqav1_89",
	rowReverse: "_rowReverse_yqav1_93",
	column: "_column_yqav1_97",
	columnReverse: "_columnReverse_yqav1_101"
}, hu = ({ buttonClassName: e, buttonLabel: n = "Toggle drop content", canCloseOutside: r = !0, children: i, className: a, closeOnEscape: o = !1, content: s, contentClassName: l, dropContentRole: d, dropContentLabel: f, interactiveElement: p, isContentTextWrapped: h = !1, isDisabled: y, isOpen: b = !1, limitSize: x = !1, onClose: S, onContainerClick: C, onContentVisibilityChange: w, onOutsideClose: T, position: E = "bottomLeft", flexDirection: D = "row", anchorRef: O, ...k }) => {
	let [A, j] = _(b), M = g(k);
	M.current = k;
	let N = c(() => {
		S?.(), j(!1);
	}, [S]), ee = c(() => {
		r && (N(), T?.());
	}, [
		r,
		T,
		N
	]);
	u(() => {
		let e = (e) => {
			e.key === ul.escape && N();
		};
		return e && (A ? document.addEventListener("keydown", e, !0) : document.removeEventListener("keydown", e, !0)), () => e && document.removeEventListener("keydown", e, !0);
	}, [
		o,
		N,
		A
	]);
	let P = c((e) => {
		C?.(), A && S?.(), j((e) => !e), e.stopPropagation();
	}, [
		A,
		S,
		C
	]), ne = c((e) => e.stopPropagation(), []), re = (e) => {
		e.stopPropagation(), S?.(), j(!1);
	}, ie = g(w);
	ie.current = w, u(() => {
		ie.current?.(A);
	}, [A]);
	let ae = te(ee, O), oe = m(() => /*#__PURE__*/ t.createElement(t.Fragment, null, typeof i == "function" ? i(A) : i), [i, A]), se = m(() => p?.({
		"aria-label": n,
		children: oe,
		className: v(mu.buttonContainer, e),
		onClick: P,
		onKeyDown: ne,
		...M.current
	}, A) ?? /*#__PURE__*/ t.createElement(z, {
		"aria-label": n,
		className: v(mu.buttonContainer, e),
		onClick: P,
		onKeyDown: ne,
		...M.current
	}, oe), [
		e,
		n,
		ne,
		P,
		p,
		A,
		oe
	]);
	return y ? /*#__PURE__*/ t.createElement("div", {
		className: v(mu.wrap, a),
		ref: O ?? ae
	}, oe) : /*#__PURE__*/ t.createElement("div", {
		className: v(mu.wrap, a),
		ref: O ?? ae
	}, se, A && /*#__PURE__*/ t.createElement("div", {
		"aria-label": f,
		role: d,
		className: v(mu.dropContent, mu[E], mu[D], {
			[mu.contentTextNoWrap]: !h,
			[mu.limitSize]: x
		}, l)
	}, typeof s == "function" ? s(re) : s));
}, J = {
	dark: "_dark_tsp7p_20",
	light: "_light_tsp7p_46",
	container: "_container_tsp7p_290",
	errorText: "_errorText_tsp7p_291",
	containerWrapContent: "_containerWrapContent_tsp7p_295",
	selectWrapper: "_selectWrapper_tsp7p_299",
	fullWidth: "_fullWidth_tsp7p_305",
	view: "_view_tsp7p_308",
	select: "_select_tsp7p_299",
	compact: "_compact_tsp7p_365",
	small: "_small_tsp7p_369",
	medium: "_medium_tsp7p_372",
	hasIcon: "_hasIcon_tsp7p_375",
	textWrapper: "_textWrapper_tsp7p_379",
	label: "_label_tsp7p_386",
	text: "_text_tsp7p_379",
	icon: "_icon_tsp7p_394",
	chevron: "_chevron_tsp7p_395",
	error: "_error_tsp7p_291",
	inlineLabel: "_inlineLabel_tsp7p_447",
	disabled: "_disabled_tsp7p_464"
}, Y = {
	fullWidth: "_fullWidth_8i4we_12",
	button: "_button_8i4we_16",
	wrapper: "_wrapper_8i4we_20",
	menu: "_menu_8i4we_25",
	checkboxWrapper: "_checkboxWrapper_8i4we_29",
	dropContentFullWidth: "_dropContentFullWidth_8i4we_34",
	textWrapper: "_textWrapper_8i4we_41"
}, gu = ({ buttonType: e, className: n, colorScheme: r, dropContentPosition: i, errorText: a, hasError: o, iconType: s, isDisabled: c, isFullWidth: l, isOpen: u = !1, isTruncated: d = !1, label: f, labelModifier: p, menuComponent: m, multipleSelectionText: h = "selected", noSelectionText: g, onContentVisibilityChange: _, onOutsideClose: y, options: b, sizeModifier: x = "medium", testId: S, value: C = [], wrapContent: w = !1 }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: T }) => /*#__PURE__*/ t.createElement("div", { className: v(r ?? T, J[r ?? T], { [Y.fullWidth]: l }) }, /*#__PURE__*/ t.createElement(hu, {
	buttonLabel: f,
	type: e,
	className: v(Y.fullWidth, n),
	content: m,
	contentClassName: v({ [Y.fullWidth]: l }),
	isOpen: b.length > 0 && u,
	isDisabled: c,
	onOutsideClose: y,
	onContentVisibilityChange: _,
	position: i,
	interactiveElement: (e) => /*#__PURE__*/ t.createElement(z, {
		...e,
		className: v(r ?? T, J.container, J[r ?? T], Y.button, {
			[Y.fullWidth]: l,
			[J.disabled]: c,
			[J.error]: o && !c,
			[J.containerWrapContent]: w
		}),
		"data-testid": S
	}, /*#__PURE__*/ t.createElement(_u, {
		iconType: s,
		isDisabled: c,
		isFullWidth: l,
		isTruncated: d,
		labelModifier: p,
		multipleSelectionText: h,
		noSelectionText: g,
		options: b,
		selectLabel: f,
		sizeModifier: x,
		value: C
	}))
}), o && a && /*#__PURE__*/ t.createElement(V, {
	className: v("mt-2", J.errorText),
	variant: "danger"
}, a))), _u = ({ iconType: e, isDisabled: n, isFullWidth: r, isTruncated: i, labelModifier: a, multipleSelectionText: o, noSelectionText: s, options: c, selectLabel: l, sizeModifier: u, value: d }) => {
	let f = a === "hidden", p = a === "inline", m = (e) => c.find((t) => t.id === e)?.label ?? e, h = p || f, g = { text: l }, _ = () => d.length === 1 ? m(d[0]) : d.length > 1 && !i ? d.map((e) => m(e)).join(", ") : d.length === 0 && !s || d.length > 1 ? `${d.length} ${o}` : s;
	return /*#__PURE__*/ t.createElement(t.Fragment, null, !h && /*#__PURE__*/ t.createElement(Js, {
		className: v(J.label),
		...g
	}), /*#__PURE__*/ t.createElement(z, {
		className: v(J.selectWrapper, { [Y.fullWidth]: r }),
		htmlTag: "div",
		disabled: n
	}, /*#__PURE__*/ t.createElement("div", {
		className: v(J.view, J[u], { [J.hasIcon]: !!e }),
		"data-testid": G.MultiselectView
	}, h && /*#__PURE__*/ t.createElement(Js, {
		className: v(J.inlineLabel),
		isLabelHidden: f,
		isLabelInline: p,
		...g
	}), !!e && /*#__PURE__*/ t.createElement(W, {
		size: "compact",
		source: e,
		className: J.icon
	}), /*#__PURE__*/ t.createElement("div", { className: v(J.textWrapper, Y.textWrapper) }, /*#__PURE__*/ t.createElement("span", { className: J.text }, _())), /*#__PURE__*/ t.createElement(W, {
		size: u === "medium" ? "compact" : "mini",
		source: U.IconChevronDown,
		className: J.chevron
	}))));
}, vu = we(Ae, "light"), yu = ({ descriptionFontVariant: e, isFullWidth: n, labelFontVariant: r, menuTestId: i, onSelectChange: a, options: o, value: s = [], ...c }) => /*#__PURE__*/ t.createElement(gu, {
	options: o,
	value: s,
	isFullWidth: n,
	menuComponent: /*#__PURE__*/ t.createElement(xu, {
		descriptionFontVariant: e,
		isFullWidth: n,
		labelFontVariant: r,
		onChange: ({ id: e, checked: t }) => {
			let n = [];
			!s.includes(e) && t ? n = [...s, e] : s.includes(e) && !t && (n = s.filter((t) => t !== e)), a(n.map((e) => ({
				id: e,
				label: o.find((t) => t.id === e)?.label ?? "No label"
			})));
		},
		options: o,
		selection: s,
		testId: i
	}),
	...c
}), bu = ({ children: e, className: n, description: r, descriptionFontVariant: i = R.Body, ...a }) => /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(V, {
	...a,
	className: n
}, e), r && /*#__PURE__*/ t.createElement(V, {
	...a,
	className: v("d-block mb-1", n),
	fontVariant: i
}, r)), xu = ({ descriptionFontVariant: e, isFullWidth: n = !1, labelComponent: r = bu, labelFontVariant: i, onChange: a, options: o, selection: s, testId: c }) => {
	let l = (e) => {
		a({
			id: e.currentTarget.name,
			checked: e.currentTarget.checked
		});
	};
	return o.length > 0 ? /*#__PURE__*/ t.createElement(vu, {
		className: v(Y.wrapper, { [Y.fullWidth]: n }, "py-3"),
		"data-testid": c
	}, /*#__PURE__*/ t.createElement(wc, { className: v(Y.menu, "pl-4 pr-5 mr-1") }, o.filter((e) => !e.isHidden).map((n, a) => /*#__PURE__*/ t.createElement("div", {
		className: v(Y.checkboxWrapper, { "mb-2": a + 1 !== o.length }),
		key: n.id,
		"data-testid": `${G.MultiselectItem}-${a}`
	}, /*#__PURE__*/ t.createElement(Su, {
		descriptionFontVariant: e,
		isChecked: s.includes(n.id),
		labelComponent: r,
		labelFontVariant: i,
		onChange: l,
		option: n
	}))))) : null;
}, Su = ({ descriptionFontVariant: e, isChecked: n, labelComponent: r, labelFontVariant: i, onChange: a, option: o }) => {
	let s = m(() => ({ children: n, ...a }) => /*#__PURE__*/ t.createElement(r, {
		...a,
		fontVariant: i ?? a.fontVariant,
		description: o.description,
		descriptionFontVariant: e
	}, n), [
		r,
		e,
		i,
		o.description
	]);
	return /*#__PURE__*/ t.createElement(Is, {
		checked: n,
		isDisabled: o.isDisabled,
		label: o.label,
		name: o.id,
		onChange: a,
		role: "menuitemcheckbox",
		labelComponent: s
	});
}, Cu = we(Ae, "light"), wu = ({ buttonType: e, descriptionFontVariant: n, isFullWidth: r, isOpen: i, labelFontVariant: a, menuTestId: o, onConfirm: s, onContentVisibilityChange: c, options: l, value: u = [], ...d }) => {
	let [f, p] = _(u), [m, h] = _(i), g = ({ id: e, checked: t }) => {
		let n = [];
		!f.includes(e) && t ? n = [...f, e] : f.includes(e) && !t && (n = f.filter((t) => t !== e)), p(n);
	}, v = () => {
		let e = f.map((e) => ({
			id: e,
			label: l.find((t) => t.id === e)?.label ?? "No label"
		}));
		h(!1), s(e);
	};
	return /*#__PURE__*/ t.createElement(gu, {
		buttonType: e,
		isFullWidth: r,
		isOpen: m,
		menuComponent: (e) => /*#__PURE__*/ t.createElement(Tu, {
			descriptionFontVariant: n,
			isFullWidth: r,
			labelFontVariant: a,
			onChange: g,
			onConfirm: (t) => {
				v(), e(t);
			},
			options: l,
			selection: f,
			testId: o
		}),
		options: l,
		onOutsideClose: () => p(u),
		onContentVisibilityChange: c,
		value: f,
		...d
	});
}, Tu = ({ descriptionFontVariant: e, isFullWidth: n = !1, labelComponent: r = bu, labelFontVariant: i, onChange: a, onConfirm: o, options: s, selection: c, testId: l }) => {
	let u = (e) => {
		a({
			id: e.currentTarget.name,
			checked: e.currentTarget.checked
		});
	};
	return s.length > 0 ? /*#__PURE__*/ t.createElement(Cu, {
		className: v(Y.wrapper, { [Y.fullWidth]: n }, "py-3"),
		"data-testid": l
	}, /*#__PURE__*/ t.createElement(wc, { className: v(Y.menu, "pl-4 pr-5 mr-1") }, s.filter((e) => !e.isHidden).map((n, a) => /*#__PURE__*/ t.createElement("div", {
		className: v(Y.checkboxWrapper, { "mb-2": a + 1 !== s.length }),
		key: n.id,
		"data-testid": `${G.MultiselectItem}-${a}`
	}, /*#__PURE__*/ t.createElement(Su, {
		descriptionFontVariant: e,
		isChecked: c.includes(n.id),
		labelComponent: r,
		labelFontVariant: i,
		onChange: u,
		option: n
	})))), /*#__PURE__*/ t.createElement("div", { className: "mx-4 mt-2" }, /*#__PURE__*/ t.createElement(H, {
		onClick: o,
		modifier: "fullWidth",
		"data-testid": G.ConfirmableMultiselectConfirm
	}, "Confirm"))) : null;
}, Eu = we(Ml, "light"), Du = ({ cancelButtonText: e, cancelButtonTestid: n, confirmButtonText: r, confirmButtonTestid: i, confirmButtonVariant: a = "primary", description: o, descriptionWordBreak: s, descriptionUrlLinks: c = !0, isOpen: l, onCancel: u, onConfirm: d, title: f, titleWordBreak: p, ...m }) => {
	let h = /*#__PURE__*/ t.createElement(H, {
		onClick: d,
		variant: a,
		size: "medium",
		"data-testid": i,
		modifier: "fullWidth"
	}, r);
	return /*#__PURE__*/ t.createElement(Eu, {
		isOpen: l,
		...m
	}, /*#__PURE__*/ t.createElement(Ll, { spacing: "none" }, /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.H5,
		className: "mb-2",
		wordBreak: p
	}, f), o && /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.Body,
		className: "mb-4",
		wordBreak: s
	}, c ? /*#__PURE__*/ t.createElement(ll, { text: o }) : o), e ? /*#__PURE__*/ t.createElement(Ot, { className: "mt-2" }, /*#__PURE__*/ t.createElement(He, { xs: 6 }, /*#__PURE__*/ t.createElement(H, {
		onClick: u,
		variant: "secondary",
		size: "medium",
		"data-testid": n,
		modifier: "fullWidth"
	}, e)), /*#__PURE__*/ t.createElement(He, { xs: 6 }, h)) : h));
}, Ou = {
	wrapper: "_wrapper_1uegx_4",
	clickCatcher: "_clickCatcher_1uegx_8",
	positionAdjuster: "_positionAdjuster_1uegx_17"
}, ku = ({ children: e, menu: n }) => {
	let [r, i] = _(!1), a = () => i(!1), o = (e) => {
		i(!r), r || e.preventDefault();
	}, s = typeof n == "function" ? n({ onClose: a }) : n;
	return /*#__PURE__*/ t.createElement("div", {
		onContextMenu: o,
		role: "presentation",
		tabIndex: -1,
		className: Ou.wrapper
	}, r && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("div", {
		className: Ou.clickCatcher,
		onClick: a,
		role: "presentation",
		tabIndex: -1
	}), /*#__PURE__*/ t.createElement("div", { className: Ou.positionAdjuster }, s)), e);
}, Au = ({ isPointingUpwards: e, ...n }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: r }) => /*#__PURE__*/ t.createElement(W, {
	colorScheme: r,
	size: "small",
	source: e ? U.IconChevronUp : U.IconChevronDown,
	...n
})), ju = ({ children: e, isOpen: n, ...r }) => /*#__PURE__*/ t.createElement(z, {
	"aria-expanded": n,
	htmlTag: "summary",
	...r
}, e, /*#__PURE__*/ t.createElement(Au, { isPointingUpwards: n })), Mu = ({ children: e, className: n, content: r, isFullWidth: i, isInitiallyOpen: a, onToggle: o, summaryElement: s = ju, ...c }) => {
	let [l, u] = _(a ?? !1);
	return /*#__PURE__*/ t.createElement("details", {
		onToggle: (e) => {
			u(e.currentTarget.open), o?.(e);
		},
		open: l
	}, /*#__PURE__*/ t.createElement(s, {
		className: v("d-flex align-items-center", { "justify-content-space-between": i }, n),
		isOpen: l,
		...c
	}, e), r);
}, Nu = {
	fileUpload: "_fileUpload_mtns5_13",
	button: "_button_mtns5_22",
	disabledDark: "_disabledDark_mtns5_32",
	disabledLight: "_disabledLight_mtns5_37",
	error: "_error_mtns5_42",
	content: "_content_mtns5_47"
}, Pu = "or drag and drop", Fu = /*#__PURE__*/ o(({ accept: e, ariaLabel: n, colorScheme: r = "dark", hasError: i, isDisabled: a, onChange: o, onDrop: s, multiple: c = !1, title: l, subTitle: u = Pu, ...d }, f) => {
	let p = a ? r === "dark" ? Nu.disabledDark : Nu.disabledLight : "";
	return /*#__PURE__*/ t.createElement(Bs, {
		onDrop: s,
		colorScheme: r,
		hasError: i,
		isDisabled: a,
		...d
	}, /*#__PURE__*/ t.createElement(Hs, {
		accept: e,
		className: Nu.fileUpload,
		onChange: o,
		multiple: c,
		ref: f,
		ariaLabel: n,
		colorScheme: r,
		isDisabled: a
	}, /*#__PURE__*/ t.createElement("div", { className: Nu.content }, /*#__PURE__*/ t.createElement("div", { className: Nu.button }, /*#__PURE__*/ t.createElement(W, {
		source: U.IconAdd,
		size: "small",
		className: v(p, i && Nu.error),
		colorScheme: r
	})), l && /*#__PURE__*/ t.createElement(Fc, { className: "pb-0" }, /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.H5,
		className: v(p, i && Nu.error),
		colorScheme: r
	}, l)), u && /*#__PURE__*/ t.createElement(Fc, { className: "pt-0" }, /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.Body,
		className: v(p, i && Nu.error),
		colorScheme: r
	}, u)))));
});
Fu.displayName = "DragAndUploadFiles";
// src/components/modules/Form/Form.tsx
var Iu = ({ children: e, className: n, ...r }) => /*#__PURE__*/ t.createElement("form", {
	className: n,
	...r
}, e), Lu = {
	group: "_group_1wlif_4",
	noneSpacing: "_noneSpacing_1wlif_10",
	compactSpacing: "_compactSpacing_1wlif_14",
	smallSpacing: "_smallSpacing_1wlif_18",
	mediumSpacing: "_mediumSpacing_1wlif_22",
	largeSpacing: "_largeSpacing_1wlif_26",
	fullWidth: "_fullWidth_1wlif_30",
	spaceBetween: "_spaceBetween_1wlif_34",
	center: "_center_1wlif_38",
	normal: "_normal_1wlif_42"
}, Ru = ({ children: e, className: n, modifier: r, spacing: i = "medium", justifyContent: a = "normal", ...o }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Lu.group, Lu[ye(i)], Lu[a], r && Lu[r], n),
	...o
}, e), zu = {
	pill: "_pill_b6d2f_12",
	iconWrapper: "_iconWrapper_b6d2f_19",
	icon: "_icon_b6d2f_19",
	textWrapper: "_textWrapper_b6d2f_32",
	text: "_text_b6d2f_32"
}, Bu = ({ className: e, text: n, ...r }) => /*#__PURE__*/ t.createElement(vc, {
	className: v("align-items-center", zu.pill, e),
	...r
}, /*#__PURE__*/ t.createElement("div", { className: zu.iconWrapper }, /*#__PURE__*/ t.createElement(W, {
	className: zu.icon,
	source: U.IconInfoRound,
	colorScheme: "light"
})), /*#__PURE__*/ t.createElement("div", { className: zu.textWrapper }, /*#__PURE__*/ t.createElement(V, {
	colorScheme: "light",
	className: zu.text
}, n))), Vu = { menu: "_menu_pmbhb_11" }, Hu = ({ fontVariant: e, item: n, variant: r, ...i }) => /*#__PURE__*/ t.createElement(Fc, {
	"aria-checked": n.isAriaChecked,
	"aria-selected": n.isAriaSelected,
	role: n.role,
	...i
}, /*#__PURE__*/ t.createElement(V, {
	className: "px-1",
	fontVariant: e,
	variant: r
}, n.label), n.icon && /*#__PURE__*/ t.createElement(W, {
	color: n.iconColor,
	size: n.iconSize ?? "compact",
	source: n.icon
})), Uu = ({ item: e }) => {
	let n = e.linkWrapper;
	return e.url || e.clickAction || e.isDisabled ? /*#__PURE__*/ t.createElement(zc, {
		"aria-checked": e.isAriaChecked,
		"aria-label": !n && e.target === "_blank" ? `${e.label} (Opens in a new tab)` : void 0,
		"aria-selected": e.isAriaSelected,
		"data-testid": e.testId,
		href: n ? void 0 : e.url,
		icon: e.icon,
		iconAlignedStart: e.iconAlignedStart,
		iconColor: e.iconColor,
		iconSize: e.iconSize,
		isDisabled: e.isDisabled,
		isFixedIcon: e.isFixedIcon,
		onClick: e.clickAction,
		role: e.role,
		target: n ? void 0 : e.target,
		variant: e.variant ?? "inherit"
	}, e.label) : /*#__PURE__*/ t.createElement(Hu, { item: e });
}, Wu = (e) => e.map((e) => String(e.label)).join(":"), Gu = ({ children: e, className: n, colorScheme: r = "light", testId: i }) => /*#__PURE__*/ t.createElement(I, { colorScheme: r }, /*#__PURE__*/ t.createElement(Ae, {
	"data-testid": i,
	className: v(Vu.menu, n)
}, e)), Ku = ({ className: e, colorScheme: n = "light", isAriaMultiSelectable: i, menuContent: a, menuEntryComponent: o = Uu, onPointerDownCapture: s, role: c = "menu", tabIndex: l, testId: u, wrapperComponent: d = Gu }) => {
	let f = !Array.isArray(a), p = Object.entries(a);
	return /*#__PURE__*/ t.createElement(d, {
		className: e,
		colorScheme: n,
		testId: u
	}, p.map(([e, n], a) => {
		let u = p.length - 1 === a;
		return /*#__PURE__*/ t.createElement(r, { key: Wu(n) }, f && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("div", { className: "p-2" }, /*#__PURE__*/ t.createElement(V, { fontVariant: R.BodyBold }, e)), /*#__PURE__*/ t.createElement("div", { className: "px-2" }, /*#__PURE__*/ t.createElement(Me, { role: "separator" }))), /*#__PURE__*/ t.createElement(Ll, {
			onPointerDownCapture: s,
			"aria-multiselectable": i,
			className: "p-1",
			role: c,
			spacing: "compact",
			tabIndex: l
		}, n.map((e, n) => {
			let r = e.linkWrapper;
			return r ? /*#__PURE__*/ t.createElement(r, { key: `${e.label}-wrapper-${n}` }, /*#__PURE__*/ t.createElement(o, { item: e })) : /*#__PURE__*/ t.createElement(o, {
				key: `${e.label}-entry-${n}`,
				item: e
			});
		})), !u && /*#__PURE__*/ t.createElement("div", { className: "px-2" }, /*#__PURE__*/ t.createElement(Me, { role: "separator" })));
	}));
}, qu = {
	line: "_line_ik17u_25",
	dark: "_dark_ik17u_32",
	disabled: "_disabled_ik17u_35",
	completed: "_completed_ik17u_38",
	failed: "_failed_ik17u_41",
	active: "_active_ik17u_44",
	light: "_light_ik17u_48"
}, Ju = ({ className: e, colorScheme: n, isActive: r, isCompleted: i, isDisabled: a, isFailed: o, ...s }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: c }) => /*#__PURE__*/ t.createElement("div", {
	className: v(qu.line, qu[n ?? c], {
		[qu.active]: r,
		[qu.completed]: i,
		[qu.disabled]: a,
		[qu.failed]: o
	}, e),
	"data-testid": G.LineStep,
	...s
})), Yu = (e, t) => {
	let n = Math.max(0, e);
	return n > t ? t : n;
}, Xu = ({ steps: e, stepIndex: t }) => {
	let n = e.findIndex((e, n) => n >= t && !e.isDisabled);
	return Yu(~n ? n : t, e.length - 1);
}, Zu = ({ isDisabled: e }) => e ? "disabled" : "standard", Qu = {
	multistepIndicatorWrapper: "_multistepIndicatorWrapper_1jax0_4",
	isStepNameHidden: "_isStepNameHidden_1jax0_10",
	lineStepperWrapper: "_lineStepperWrapper_1jax0_14",
	lineStepListItem: "_lineStepListItem_1jax0_19",
	lineStepButton: "_lineStepButton_1jax0_23",
	truncated: "_truncated_1jax0_27",
	item: "_item_1jax0_32",
	itemButton: "_itemButton_1jax0_36",
	text: "_text_1jax0_39",
	number: "_number_1jax0_43",
	noHover: "_noHover_1jax0_52"
}, $u = ({ isActive: e, isCompleted: n, isFailed: r, isCurrent: i, isDisabled: a, isStepNameTruncated: o, isStepNameHidden: s, label: c, stepNumber: l }) => /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Oc, {
	className: v(Qu.number, { "mr-2": !s }),
	isActive: e || i,
	isCompleted: n,
	isFailed: r,
	isDisabled: a,
	stepNumber: l
}), !s && /*#__PURE__*/ t.createElement(V, {
	isTruncated: o,
	className: Qu.text,
	fontVariant: R.BodyBold,
	variant: Zu({ isDisabled: a })
}, c)), ed = "step", td = ({ className: e, isCurrent: n, isStepNameTruncated: r, isStepNameHidden: i, step: a, stepIndex: o, variant: s, onStepChange: c }) => {
	let { isActive: l, isDisabled: d, url: f, isCompleted: p, isFailed: m, isSelectable: h, label: _, onClick: y } = a, b = d || !n && !l && !h, x = g(null), S = im();
	u(() => {
		S && n && x.current && x.current.focus();
	}, [n, S]);
	let C = o + 1, w = s === "line" ? _ || `${ed} ${C}` : i ? `${C} ${_}`.trim() : void 0;
	return /*#__PURE__*/ t.createElement("li", { className: v(Qu.item, {
		[Qu.truncated]: r,
		[Qu.lineStepListItem]: s === "line"
	}, e) }, /*#__PURE__*/ t.createElement(Pt, {
		"aria-current": n ? ed : void 0,
		"aria-label": w,
		"aria-hidden": b,
		tabIndex: b ? -1 : 0,
		"data-testid": `${G.MultistepIndicatorButton}-${o}`,
		disabled: b,
		ref: x,
		className: v(Qu.itemButton, {
			[Qu.noHover]: b,
			[Qu.lineStepButton]: s === "line"
		}, "d-flex align-items-center"),
		onClick: () => {
			d || (c?.(o), y?.());
		},
		href: f,
		htmlTag: s === "line" || !f ? "button" : "a"
	}, s === "ordered-list" ? /*#__PURE__*/ t.createElement($u, {
		isActive: l,
		isCompleted: p,
		isFailed: m,
		isCurrent: n,
		isStepNameTruncated: r,
		isStepNameHidden: i,
		label: _,
		stepNumber: String(C)
	}) : /*#__PURE__*/ t.createElement(Ju, {
		isActive: l || n,
		isCompleted: p,
		isDisabled: d
	})));
}, nd = ({ "aria-label": e, className: n, colorScheme: r, currentStepIndex: i = 0, isStepNameTruncated: a, isStepNameHidden: o = !1, stepClassName: s, steps: c, variant: l = "ordered-list", onStepChange: u }) => {
	let d = Yu(i, c.length - 1);
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: i }) => /*#__PURE__*/ t.createElement(I, { colorScheme: r ?? i }, /*#__PURE__*/ t.createElement("ol", {
		"aria-label": e,
		className: v("d-flex", Qu.multistepIndicatorWrapper, {
			[Qu.lineStepperWrapper]: l === "line",
			[Qu.isStepNameHidden]: o
		}, n),
		"data-testid": G.MultistepIndicator
	}, c.map((e, n) => /*#__PURE__*/ t.createElement(td, {
		className: s,
		isCurrent: n === d,
		isStepNameTruncated: a,
		isStepNameHidden: o,
		key: `${n}-${e.label}`,
		onStepChange: u,
		step: e,
		stepIndex: n,
		variant: l
	})))));
}, rd = {
	wrap: "_wrap_oxd8c_11",
	input: "_input_oxd8c_15",
	button: "_button_oxd8c_35",
	buttonBorderDark: "_buttonBorderDark_oxd8c_40",
	buttonBorderLight: "_buttonBorderLight_oxd8c_44"
}, id = ({ name: e, label: n, colorScheme: r, onChange: i, ariaLabelDecrement: a, labelDecrement: o = "-", ariaLabelIncrement: s, labelIncrement: l = "+", value: u = 0, minValue: d = 0, maxValue: f = Number.MAX_VALUE, isInputReadOnly: p, isDisabled: m, stepValue: h = 1, testIDDecrement: g, testIDIncrement: _, testIDInput: y }) => {
	let b = c((e) => Math.min(Math.max(e, d), f), [d, f]), x = c((e) => {
		let t = b(u + e);
		!m && i(t);
	}, [
		u,
		b,
		i,
		m
	]), S = (e) => {
		i(b(Number(e)));
	};
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: i }) => {
		let c = r || i;
		return /*#__PURE__*/ t.createElement("div", { className: rd.wrap }, /*#__PURE__*/ t.createElement(H, {
			className: v(rd.button, c === "dark" ? rd.buttonBorderDark : rd.buttonBorderLight),
			colorScheme: c,
			variant: "translucent",
			onClick: () => x(-h),
			disabled: u === d,
			"data-testid": g ?? G.NumberStepDecrement,
			"aria-label": a,
			isDisabled: m
		}, o), /*#__PURE__*/ t.createElement(Ys, {
			className: rd.input,
			colorScheme: c,
			name: e,
			label: n,
			labelModifier: "hidden",
			type: "number",
			value: String(u),
			"data-testid": y ?? G.NumberStepInput,
			onValueChange: S,
			readOnly: p,
			isDisabled: m
		}), /*#__PURE__*/ t.createElement(H, {
			className: v(rd.button, c === "dark" ? rd.buttonBorderDark : rd.buttonBorderLight),
			colorScheme: c,
			variant: "translucent",
			onClick: () => x(h),
			disabled: u === f,
			"data-testid": _ ?? G.NumberStepIncrement,
			"aria-label": s,
			isDisabled: m
		}, l));
	});
}, ad = { toggleShowPasswordIcon: "_toggleShowPasswordIcon_p5tw9_4" }, od = ({ hidePasswordTitle: e = "Hide password", showPasswordTitle: n = "Show password", ...r }) => {
	let [i, a] = _(!1), o = i ? U.IconPasswordHide : U.IconPasswordShow, s = i ? e : n;
	return /*#__PURE__*/ t.createElement(Ys, {
		...r,
		enhancerEnd: /*#__PURE__*/ t.createElement(H, {
			noHover: !0,
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), a((e) => !e);
			},
			size: "none",
			title: s,
			type: "button",
			variant: "transparent"
		}, /*#__PURE__*/ t.createElement(W, {
			className: v(ad.toggleShowPasswordIcon, "ml-1"),
			source: o
		})),
		type: i ? "text" : "password"
	});
}, sd = (e, t) => {
	let n = Array.from(e.styleSheets);
	for (let e of n) try {
		if (e.cssRules && e.cssRules.length > 0) {
			let n = t.document.createElement("style");
			for (let r of Array.from(e.cssRules)) n.appendChild(t.document.createTextNode(r.cssText));
			t.document.head.appendChild(n);
		} else if (e.href) {
			let n = t.document.createElement("link");
			n.rel = "stylesheet", n.href = e.href, t.document.head.appendChild(n);
		}
	} catch (n) {
		if (n instanceof DOMException && n.name === "SecurityError") {
			if (e.href) {
				let n = t.document.createElement("link");
				n.rel = "stylesheet", n.href = e.href, t.document.head.appendChild(n);
			}
		} else throw n;
	}
}, cd = "about:blank", ld = (e = "") => window.open(cd, "", e), ud = { close: async (e) => {
	e.close();
} }, dd = ud, fd = (e) => {
	dd = e ?? ud;
}, pd = (e) => {
	dd.close(e).catch(() => void 0);
}, md = 1e3, hd = ({ children: e, remotePopOut: t, title: n, onUnload: r }) => {
	let [i] = _(() => document.createElement("div")), a = g(null);
	return u(() => {
		t && (a.current = t), a.current ||= ld(), a.current && (a.current.document.title = n ?? "Pexip One");
	}, [t, n]), u(() => {
		let e = a.current;
		if (!e) return;
		let t, n = !1, o = () => {
			n || (n = !0, t !== void 0 && (window.clearInterval(t), t = void 0), e.removeEventListener("beforeunload", o), window.removeEventListener("beforeunload", o), e.closed || pd(e), typeof r == "function" && r());
		};
		return e.document.body.appendChild(i), sd(document, e), e.addEventListener("beforeunload", o), window.addEventListener("beforeunload", o), t = window.setInterval(() => {
			e.closed && o();
		}, md), () => o();
	}, [i, r]), i ? /*#__PURE__*/ le(e, i) : null;
}, gd = {
	wrap: "_wrap_rw770_12",
	labelWrapper: "_labelWrapper_rw770_17",
	contentWrap: "_contentWrap_rw770_21",
	input: "_input_rw770_29",
	actions: "_actions_rw770_34",
	errorText: "_errorText_rw770_38"
}, _d = ({ children: e = "", className: n, errorText: r, hasError: i, label: a, labelEnhanceEnd: o, ...s }) => /*#__PURE__*/ t.createElement("div", {
	className: v(gd.wrap, n),
	...s
}, /*#__PURE__*/ t.createElement("span", { className: v(gd.labelWrapper, "d-flex align-items-center") }, /*#__PURE__*/ t.createElement(Js, {
	isUppercase: !0,
	className: "mb-0 mr-1",
	text: a,
	fontVariant: R.SmallBold,
	variant: "subtle"
}), o), /*#__PURE__*/ t.createElement("div", { className: gd.contentWrap }, e), i && r && /*#__PURE__*/ t.createElement(V, {
	className: v("mt-2", gd.errorText),
	variant: "danger",
	role: "alert"
}, r)), vd = ({ confirmLabel: e = "Save", className: n, initialValue: r = "", denyAlertText: i = "Are you sure you want to cancel?", denyLabel: a = "Cancel", hasError: o, errorText: s, id: c, isEditing: l, isConfirmDisabled: f, isReadOnly: p, label: m, labelEnhanceEnd: h, modifyLabel: v = "Edit", name: y, overrideInputValue: b, placeholder: x, shouldShowDenyAlert: S, type: C, renderText: w = V, onChange: T, onConfirm: E, onEditingStateChange: D }) => {
	let [O, k] = _(r), [A, j] = _(l), M = g(null), N = d(), ee = c ?? N;
	u(() => {
		b && k(b);
	}, [b]);
	let P = (e) => {
		T && T(e), k(e.target.value);
	}, te = () => {
		j(!1), D?.(!1), E?.(O);
	}, ne = () => {
		let e = r === O, t = S && r !== O && confirm(i);
		(!S || e || t) && (k(r), j(!1), D?.(!1));
	}, re = () => {
		j(!0), D?.(!0);
	};
	u(() => {
		A && M.current?.focus();
	}, [A]);
	let ie = /*#__PURE__*/ t.createElement(t.Fragment, null, (p || !A) && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(w, { "data-testid": "text-saved" }, r ?? x), !p && /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		onClick: re,
		"data-testid": "btn-modify"
	}, v)), !p && A && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Ys, {
		ref: M,
		className: gd.input,
		id: ee,
		name: y,
		type: C,
		value: O,
		label: m,
		labelModifier: "hidden",
		onChange: P,
		hasError: o,
		placeholder: x,
		onKeyDown: Vl(te),
		sizeModifier: "small"
	}), /*#__PURE__*/ t.createElement("div", { className: gd.actions }, E && /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		onClick: ne,
		"data-testid": "btn-deny"
	}, a), /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		isDisabled: f,
		onClick: te,
		"data-testid": "btn-confirm"
	}, e))));
	return /*#__PURE__*/ t.createElement(_d, {
		className: n,
		errorText: s,
		hasError: o,
		label: m,
		labelEnhanceEnd: h
	}, ie);
}, yd = ({ confirmLabel: e = "Save", className: n, denyAlertText: r = "Are you sure you want to cancel?", denyLabel: i = "Cancel", hasError: a, errorText: o, isEditing: s, isReadOnly: c, label: l, labelEnhanceEnd: u, modifyLabel: d = "Edit", noSelectionLabel: f = "--", options: p = [], shouldShowDenyAlert: m, value: h = [], onChange: g, onConfirm: v }) => {
	let [y, b] = t.useState(h), [x, S] = _(s), C = (e) => e.map((e) => ({
		id: e,
		label: p.find((t) => t.id === e)?.label ?? e
	})), w = /*#__PURE__*/ t.createElement(t.Fragment, null, (c || !x) && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(V, { "data-testid": "preference-multiselect-label" }, C(h).map((e) => e.label).join(", ") || f), !c && /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		onClick: () => {
			b(h), S(!0);
		},
		"data-testid": "btn-modify"
	}, d)), !c && x && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(yu, {
		className: gd.input,
		value: y,
		label: l,
		isFullWidth: !0,
		labelModifier: "hidden",
		onSelectChange: (e) => {
			g && g(e), b(e.map((e) => e.id));
		},
		hasError: a,
		sizeModifier: "small",
		options: p,
		isOpen: !0
	}), /*#__PURE__*/ t.createElement("div", { className: gd.actions }, v && /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		onClick: () => {
			let e = h === y, t = h !== y && confirm(r);
			(!m || e || t) && (S(!1), b(h));
		},
		"data-testid": "btn-deny"
	}, i), /*#__PURE__*/ t.createElement(H, {
		variant: "text",
		onClick: () => {
			S(!1);
			let e = C(y);
			v?.(e);
		},
		"data-testid": "btn-confirm"
	}, e))));
	return /*#__PURE__*/ t.createElement(_d, {
		className: n,
		errorText: o,
		hasError: a,
		label: l,
		labelEnhanceEnd: u
	}, w);
}, bd = {
	wrap: "_wrap_1l8nu_4",
	withBorderBottom: "_withBorderBottom_1l8nu_12",
	row: "_row_1l8nu_16",
	rowLeft: "_rowLeft_1l8nu_24",
	rowBottom: "_rowBottom_1l8nu_30"
}, xd = ({ className: e, description: n, descriptionVariant: r = "tinted", label: i, labelVariant: a = "standard", rowBottom: o, rowLeft: s, withBorderBottom: c = !0 }) => {
	let l = d();
	return /*#__PURE__*/ t.createElement("fieldset", {
		className: v(bd.wrap, { [bd.withBorderBottom]: c }, e),
		"aria-labelledby": l
	}, /*#__PURE__*/ t.createElement("div", { className: bd.row }, /*#__PURE__*/ t.createElement("div", { className: "d-flex flex-direction-column" }, i && (typeof i == "string" ? /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.BodyBold,
		variant: a
	}, i) : i), n && (typeof n == "string" ? /*#__PURE__*/ t.createElement(V, { variant: r }, n) : n)), s && /*#__PURE__*/ t.createElement("div", { className: bd.rowLeft }, s)), o && /*#__PURE__*/ t.createElement("div", { className: bd.rowBottom }, o));
}, Sd = ({ searchInputTestId: e, clearButtonTestId: n, inputAriaLabel: r, clearButtonAriaLabel: i, placeHolder: a, name: o = "", label: s = "", onSearchInputChanged: c }) => {
	let [l, d] = _("");
	return u(() => {
		c(l);
	}, [l, c]), /*#__PURE__*/ t.createElement(Ys, {
		autoComplete: "off",
		colorScheme: "light",
		enhancerStart: /*#__PURE__*/ t.createElement(W, {
			source: U.IconSearch,
			size: "compact"
		}),
		enhancerEnd: l !== "" && /*#__PURE__*/ t.createElement(H, {
			"aria-label": i,
			modifier: "square",
			onClick: () => d(""),
			size: "compact",
			variant: "transparent",
			"data-testid": n
		}, /*#__PURE__*/ t.createElement(W, {
			source: U.IconClose,
			size: "compact"
		})),
		type: "text",
		testId: e,
		className: "pb-4",
		placeholder: a,
		value: l,
		onChange: (e) => d(e.target.value),
		variant: "standard",
		name: o,
		label: s,
		"aria-label": r
	});
}, Cd = {
	wrap: "_wrap_4mkm4_16",
	summary: "_summary_4mkm4_20",
	button: "_button_4mkm4_28",
	actionGroup: "_actionGroup_4mkm4_44",
	headingGroup: "_headingGroup_4mkm4_49",
	headingText: "_headingText_4mkm4_53",
	icon: "_icon_4mkm4_64",
	divider: "_divider_4mkm4_69",
	dark: "_dark_4mkm4_73",
	light: "_light_4mkm4_86"
}, wd = ({ buttonClassName: e, children: n, className: r, collapseText: i = "Collapse", colorScheme: a, expandText: o = "Expand", isExpanded: s = !1, onToggle: c, subtitle: l, title: u, titleEnhancerEnd: d }) => {
	let [f, p] = _(s), m = (e) => {
		e.preventDefault(), p((e) => {
			let t = !e;
			return c && c(t), t;
		});
	}, h = f ? i : o;
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: i }) => /*#__PURE__*/ t.createElement("details", {
		className: v(Cd.wrap, r),
		open: f,
		"data-testid": G.SectionAccordionDetails
	}, /*#__PURE__*/ t.createElement("summary", {
		className: Cd.summary,
		onClick: m,
		"data-testid": G.SectionAccordionSummary
	}, /*#__PURE__*/ t.createElement("div", { className: Cd[a ?? i] }, /*#__PURE__*/ t.createElement("div", { className: v(Cd.button, e) }, /*#__PURE__*/ t.createElement("div", { className: Cd.headingGroup }, /*#__PURE__*/ t.createElement("div", { className: "d-flex align-items-center" }, /*#__PURE__*/ t.createElement(V, {
		variant: "inherit",
		className: Cd.headingText,
		fontVariant: R.H3
	}, u), d), typeof l == "string" ? /*#__PURE__*/ t.createElement(V, {
		variant: "inherit",
		className: Cd.headingText
	}, l) : l), /*#__PURE__*/ t.createElement("div", { className: Cd.actionGroup }, /*#__PURE__*/ t.createElement(V, {
		variant: "inherit",
		fontVariant: R.BodyBold
	}, h), /*#__PURE__*/ t.createElement(W, {
		className: Cd.icon,
		source: f ? U.IconDoubleChevronUp : U.IconDoubleChevronDown
	}))), /*#__PURE__*/ t.createElement(Me, { colorScheme: a ?? i }))), f && /*#__PURE__*/ t.createElement("div", { className: "pt-4 pb-3" }, n)));
}, Td = ({ children: e, className: n, colorScheme: r, subtitle: i, subtitleTestId: a, title: o, titleTestId: s, variant: c, ...l }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: u }) => /*#__PURE__*/ t.createElement(I, { colorScheme: r ?? u }, /*#__PURE__*/ t.createElement("section", {
	className: n,
	...l
}, /*#__PURE__*/ t.createElement(We, null, /*#__PURE__*/ t.createElement("div", { className: "mt-5" }, /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.H2,
	variant: c,
	"data-testid": s
}, o)), /*#__PURE__*/ t.createElement("div", { className: "mt-2" }, /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.H6,
	variant: c,
	"data-testid": a
}, i)), e)))), Ed = ({ className: e, colorScheme: n, errorText: r, errorTextTestId: i, hasError: a, iconType: o, id: s, isDisabled: c, isFullWidth: l, label: f, labelModifier: p, onValueChange: m, options: h, sizeModifier: g = "medium", value: _, wrapContent: y = !1, ...b }) => {
	let x = d(), S = s ?? x, C = _ || h[0]?.id, w = p === "hidden", T = p === "inline", E = T || w, D = {
		text: f,
		id: S
	}, O = (e) => {
		_ !== e.currentTarget.value && m(e.currentTarget.value);
	};
	return u(() => {
		a && r && Ms(r, "assertive");
	}, [a, r]), /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: s }) => /*#__PURE__*/ t.createElement("div", { className: v(n ?? s, J.container, J[n ?? s], {
		[J.disabled]: c,
		[J.error]: a && !c,
		[J.containerWrapContent]: y
	}, e) }, !E && /*#__PURE__*/ t.createElement(Js, {
		className: v(J.label),
		...D
	}), /*#__PURE__*/ t.createElement("div", { className: v(J.selectWrapper, { [J.fullWidth]: l }) }, /*#__PURE__*/ t.createElement("select", {
		className: J.select,
		id: S,
		onBlur: O,
		onChange: O,
		value: C,
		disabled: c,
		...b
	}, h.map(({ id: e, label: n, isDisabled: r }) => /*#__PURE__*/ t.createElement("option", {
		disabled: r,
		key: e,
		value: e
	}, n))), /*#__PURE__*/ t.createElement("div", {
		className: v(J.view, J[g], { [J.hasIcon]: !!o }),
		"data-testid": G.SelectView
	}, E && /*#__PURE__*/ t.createElement(Js, {
		className: v(J.inlineLabel),
		isLabelHidden: w,
		isLabelInline: T,
		...D
	}), !!o && /*#__PURE__*/ t.createElement(W, {
		size: "compact",
		source: o,
		className: J.icon,
		"data-testid": G.SelectIcon
	}), /*#__PURE__*/ t.createElement("div", { className: J.textWrapper }, /*#__PURE__*/ t.createElement("span", { className: J.text }, h.find((e) => e.id === C)?.label ?? f)), /*#__PURE__*/ t.createElement(W, {
		size: g === "medium" ? "compact" : "mini",
		source: U.IconChevronDown,
		className: J.chevron,
		"data-testid": G.SelectChevron
	}))), a && r && /*#__PURE__*/ t.createElement(V, {
		className: v("mt-2", J.errorText),
		variant: "danger",
		"data-testid": i
	}, r)));
}, Dd = (e, t) => {
	let { focusFrom: n } = xl(e);
	u(() => {
		t && n();
	}, [t, n]);
}, Od = {
	wrapper: "_wrapper_1p4xd_105",
	open: "_open_1p4xd_120",
	withMask: "_withMask_1p4xd_123",
	sheet: "_sheet_1p4xd_127",
	withShadow: "_withShadow_1p4xd_136",
	heightPortrait: "_heightPortrait_1p4xd_141",
	heightLandscape: "_heightLandscape_1p4xd_146",
	fullWidth: "_fullWidth_1p4xd_150",
	sheetInner: "_sheetInner_1p4xd_160",
	innerFullHeight: "_innerFullHeight_1p4xd_163",
	noMargin: "_noMargin_1p4xd_166",
	closeButton: "_closeButton_1p4xd_170",
	closeButtonIcon: "_closeButtonIcon_1p4xd_177"
}, kd = (e) => e.stopPropagation(), Ad = ({ isFullWidth: e = !1, noMargin: n = !1, isOpen: r = !1, innerFullHeight: i = !1, withMask: a = !0, withShadow: o = !1, closeButtonAriaLabel: s = "Close sheet", onClose: c, children: l, withCloseButton: u = !1, className: d, heightPortrait: f, heightLandscape: p }) => {
	let { ref: m } = jm(r), [h, g] = _(null);
	Dd(h, r);
	let y = f && p ? {
		"--sheet-height-portrait": `${f}dvh`,
		"--sheet-height-landscape": `${p}dvh`
	} : void 0;
	return /*#__PURE__*/ t.createElement("div", {
		ref: m,
		className: v(Od.wrapper, {
			[Od.open]: r,
			[Od.withMask]: a
		}),
		role: "dialog"
	}, /*#__PURE__*/ t.createElement("div", {
		className: v(Od.sheet, d, {
			[Od.fullWidth]: e,
			[Od.heightPortrait]: !!f,
			[Od.heightLandscape]: !!p,
			[Od.withShadow]: o
		}),
		style: y,
		onClick: kd,
		onKeyDown: kd,
		role: "presentation"
	}, /*#__PURE__*/ t.createElement("div", {
		className: v(Od.sheetInner, {
			[Od.noMargin]: n,
			[Od.innerFullHeight]: i
		}),
		ref: g,
		tabIndex: -1
	}, l, u && /*#__PURE__*/ t.createElement(ic, {
		"aria-label": s,
		onClose: c,
		className: Od.closeButton
	}))));
}, X = {
	box: "_box_1owu2_82",
	wrap: "_wrap_1owu2_95",
	dark: "_dark_1owu2_103",
	withHover: "_withHover_1owu2_108",
	rowBottom: "_rowBottom_1owu2_113",
	subtle: "_subtle_1owu2_113",
	inactive: "_inactive_1owu2_113",
	figureCaption: "_figureCaption_1owu2_113",
	figureText: "_figureText_1owu2_114",
	divider: "_divider_1owu2_123",
	icon: "_icon_1owu2_126",
	danger: "_danger_1owu2_130",
	warning: "_warning_1owu2_157",
	success: "_success_1owu2_184",
	light: "_light_1owu2_211",
	row: "_row_1owu2_113",
	flexGrow: "_flexGrow_1owu2_327",
	rowTop: "_rowTop_1owu2_331",
	dividerWrap: "_dividerWrap_1owu2_339",
	caption: "_caption_1owu2_345",
	figure: "_figure_1owu2_113",
	small: "_small_1owu2_349",
	medium: "_medium_1owu2_353"
}, jd = /*#__PURE__*/ function(e) {
	return e.Danger = "danger", e.Success = "success", e.Warning = "warning", e;
}({}), Md = ({ children: e, className: n, colorScheme: r, isWithShadow: i = !1, padding: a = "none", shadowModifier: o = "light", variant: s, withHover: c = !1, ...l }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: u }) => /*#__PURE__*/ t.createElement(Ae, {
	className: v(n, X.box, X[r ?? u], { [X.withHover]: c }, s && X[s]),
	isWithShadow: i,
	padding: a,
	shadowModifier: o,
	...l
}, e)), Nd = ({ className: e, position: n, rowData: r, ...i }) => {
	let { caption: a, captionClassName: o, captionSize: s = "medium", captionTitle: c, figure: l, figureClassName: u, figureSize: d = "medium", figureTitle: f, icon: p, iconColor: m, isActive: h = !0 } = r, g = m ? { style: { color: m } } : { className: X.icon }, _ = typeof a == "string" ? a : "", y = typeof l == "string" ? l : "", b = `${c ?? _} `, x = `${f ?? y} `;
	return /*#__PURE__*/ t.createElement("div", {
		...i,
		className: v(X.row, {
			[X.rowBottom]: n === "bottom",
			[X.rowTop]: n === "top",
			[X.subtle]: d === "small"
		}, e)
	}, p && /*#__PURE__*/ t.createElement("div", g, p), /*#__PURE__*/ t.createElement("figure", { className: v(X.figure, { [X.inactive]: !h }) }, /*#__PURE__*/ t.createElement(V, {
		className: v(X.figureText, X[d], u),
		htmlTag: "span",
		variant: "inherit",
		fontVariant: d === "small" ? R.BodyBold : R.H3,
		title: `${b}${x}`
	}, l), /*#__PURE__*/ t.createElement("figcaption", { className: v(X.caption) }, typeof a == "string" ? /*#__PURE__*/ t.createElement(V, {
		className: v(X.figureCaption, X[s], o),
		variant: "inherit"
	}, a) : a)));
}, Pd = ({ className: e, colorScheme: n, hasDivider: r, rowBottom: i, rowTop: a, shadowModifier: o, variant: s, withHover: c }) => /*#__PURE__*/ t.createElement(Md, {
	className: v(e, X.wrap, { [X.flexGrow]: !!i }),
	colorScheme: n,
	shadowModifier: o,
	variant: s,
	withHover: c
}, /*#__PURE__*/ t.createElement(Nd, {
	position: i ? "top" : void 0,
	rowData: a
}), r && i && /*#__PURE__*/ t.createElement("div", { className: X.dividerWrap }, /*#__PURE__*/ t.createElement(Me, {
	className: X.divider,
	"data-testid": "divider"
})), i && /*#__PURE__*/ t.createElement(Nd, {
	position: "bottom",
	rowData: i
})), Fd = {
	tabList: "_tabList_kxan6_105",
	tabLink: "_tabLink_kxan6_118",
	tabButtonPadding: "_tabButtonPadding_kxan6_142",
	tabName: "_tabName_kxan6_157",
	tabNameContent: "_tabNameContent_kxan6_169",
	tabContent: "_tabContent_kxan6_173",
	none: "_none_kxan6_173",
	compact: "_compact_kxan6_176",
	small: "_small_kxan6_179",
	medium: "_medium_kxan6_182",
	large: "_large_kxan6_185",
	divider: "_divider_kxan6_194"
}, Id = ({ activeContentClassName: e, children: r, className: i, colorScheme: a, customTabNameComponent: o, hasDivider: s = !0, inactiveContentClassName: c = "d-none", initialActiveTabIndex: l = 0, noTabButtonPadding: d, onActiveTabChange: f, renderInactive: p = !1, ...m }) => {
	let [h, g] = _(l), y = n.toArray(r).filter(Boolean), b = o ?? Rd;
	u(() => {
		g(l);
	}, [l]), u(() => {
		f && f(h);
	}, [h, f]);
	let x = y.map((e, n) => /*#__PURE__*/ t.isValidElement(e) && /*#__PURE__*/ t.createElement(b, {
		"aria-selected": h === n,
		"data-active": h === n,
		"data-testid": e.props["data-testid"] ?? `${G.Tab}-${n}`,
		key: e.props.title,
		onClick: () => g(n),
		role: "tab"
	}, /*#__PURE__*/ t.createElement("div", { className: Fd.tabNameContent }, e.props.tabEnhancerStart && /*#__PURE__*/ t.createElement("div", null, e.props.tabEnhancerStart), /*#__PURE__*/ t.createElement("div", null, e.props.title), e.props.tabEnhancerEnd && /*#__PURE__*/ t.createElement("div", null, e.props.tabEnhancerEnd))));
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: n }) => /*#__PURE__*/ t.createElement(I, { colorScheme: a ?? n }, /*#__PURE__*/ t.createElement("div", {
		className: i,
		...m
	}, /*#__PURE__*/ t.createElement("div", {
		role: "tablist",
		className: v(Fd.tabList, { [Fd.tabButtonPadding]: !d })
	}, x), s && /*#__PURE__*/ t.createElement(Me, { className: Fd.divider }), y.map((n, r) => {
		if (!/*#__PURE__*/ t.isValidElement(n)) return null;
		let i = h === r;
		return p ? /*#__PURE__*/ t.createElement("div", {
			key: n.props.title,
			className: v({
				[e ?? ""]: i,
				[c ?? ""]: !i
			})
		}, n) : i ? n : null;
	}))));
}, Ld = ({ children: e, className: n, contentPadding: r = "medium", ...i }) => {
	let { title: a, tabEnhancerStart: o, tabEnhancerEnd: s, "data-testid": c, ...l } = { ...i };
	return /*#__PURE__*/ t.createElement("div", {
		"aria-label": a,
		role: "tabpanel",
		className: v(Fd.tabContent, Fd[r], n),
		...l
	}, e);
}, Rd = ({ children: e, className: n, ...r }) => /*#__PURE__*/ t.createElement("button", {
	className: v(Fd.tabLink, n),
	...r
}, /*#__PURE__*/ t.createElement(V, { className: Fd.tabName }, e)), zd = {
	list: "_list_20q8b_14",
	tag: "_tag_20q8b_20",
	isInteractive: "_isInteractive_20q8b_34",
	isTruncated: "_isTruncated_20q8b_38"
}, Bd = ({ ariaLabel: e, onRemove: n }) => /*#__PURE__*/ t.createElement(H, {
	"aria-label": e,
	className: "ml-1",
	"data-testid": "taglist-item-button",
	noHover: !0,
	onClick: n,
	size: "none",
	variant: "transparent"
}, /*#__PURE__*/ t.createElement(W, {
	size: "compact",
	source: U.IconClose
})), Vd = ({ children: e, onClick: n }) => n ? /*#__PURE__*/ t.createElement(z, { onClick: n }, e) : e, Hd = ({ children: e, className: n, isInteractive: r = !0, isTruncated: i = !1, label: a, onClick: o, onRemove: s, removeLabel: c, title: l, variant: u }) => {
	let d = c ?? `Remove ${a}`;
	return /*#__PURE__*/ t.createElement("div", {
		className: v(zd.tag, {
			[zd.isInteractive]: r || !!o,
			[zd.isTruncated]: i
		}, n),
		title: l
	}, /*#__PURE__*/ t.createElement(Vd, { onClick: o ? () => o(a) : void 0 }, typeof a == "string" && /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.Body,
		isTruncated: i,
		variant: u
	}, a), e), s && /*#__PURE__*/ t.createElement(Bd, {
		ariaLabel: d,
		onRemove: s
	}));
}, Ud = ({ className: e, colorScheme: n = "light", items: r, maxTagsCount: i, variant: a }) => {
	let o = 0, s = [...r];
	if (i && i < r.length) {
		o = r.length - i;
		let e = s.splice(i).map((e) => e.title ?? e.label).join(", ");
		s.push({
			label: `+${o}`,
			title: e
		});
	}
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: r }) => /*#__PURE__*/ t.createElement(I, { colorScheme: n ?? r }, /*#__PURE__*/ t.createElement("ul", { className: v(zd.list, e) }, s.map((e, n) => /*#__PURE__*/ t.createElement("li", {
		className: "d-inline-flex",
		key: `${n}:${e.label}`
	}, /*#__PURE__*/ t.createElement(Hd, {
		...e,
		variant: a
	}))))));
}, Wd = (e, t) => {
	let [n, r] = _(e);
	return u(() => {
		let n;
		return e ? r(!0) : n = window.setTimeout(() => {
			r(!1);
		}, t), () => window.clearTimeout(n);
	}, [e, t]), n;
};
// src/components/modules/TransitionContainer/withTransition.tsx
function Gd(e, n, r = "unmount") {
	return function(i) {
		let { isVisible: a, className: o, ...s } = i, c = Wd(a, n);
		return !c && r === "unmount" ? null : /*#__PURE__*/ t.createElement(e, {
			...s,
			className: v(o, !c && "d-none")
		});
	};
}
var Kd = {
	toast: "_toast_nzlyj_4",
	topCenter: "_topCenter_nzlyj_16",
	"toast-top-in": "_toast-top-in_nzlyj_1",
	toastTopIn: "_toast-top-in_nzlyj_1",
	hidden: "_hidden_nzlyj_21",
	"toast-top-out": "_toast-top-out_nzlyj_1",
	toastTopOut: "_toast-top-out_nzlyj_1",
	bottomCenter: "_bottomCenter_nzlyj_25",
	"toast-bottom-in": "_toast-bottom-in_nzlyj_1",
	toastBottomIn: "_toast-bottom-in_nzlyj_1",
	"toast-bottom-out": "_toast-bottom-out_nzlyj_1",
	toastBottomOut: "_toast-bottom-out_nzlyj_1",
	clickable: "_clickable_nzlyj_35"
}, qd = Gd(({ className: e, colorScheme: n, enhanceStart: r, isClickable: i = !1, isDisplayed: a = !1, message: o, onDismiss: s, position: c = "topCenter", timeout: l = 5e3, ...d }) => {
	let [f, p] = _(a);
	return u(() => p(a), [a]), u(() => {
		let e;
		return f && Ms(o, "assertive"), f && l > 0 && (e = window.setTimeout(() => {
			p(!1), s?.();
		}, l)), () => clearTimeout(e);
	}, [
		f,
		l,
		s,
		o
	]), /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: a }) => /*#__PURE__*/ t.createElement("div", {
		className: v(Kd.toast, Kd[c], { [Kd.hidden]: !f }, e),
		role: "status"
	}, /*#__PURE__*/ t.createElement(vc, {
		className: v("d-flex align-items-center text-center pl-4 pr-4 ml-3 mr-3", { [Kd.clickable]: i || s }),
		onClose: s ? () => {
			p(!1), s();
		} : void 0,
		colorScheme: n ?? a,
		...d
	}, r, /*#__PURE__*/ t.createElement(V, { variant: "inherit" }, o))));
}, 400), Jd = /*#__PURE__*/ function(e) {
	return e.Icon = "icon", e.Image = "image", e.Initials = "initials", e.Number = "number", e;
}({});
// src/utils/string.ts
function Yd(e) {
	let t = e.charCodeAt(0);
	if (t < 55296 || t > 57343) return e.slice(0, 1);
	if (e.length < 2) return "�";
	if (55296 <= t && t <= 56319) {
		let t = e.charCodeAt(1);
		if (t >= 56320 && t <= 57343) return e.slice(0, 2);
	}
	return "�";
}
function Xd(e, t = "") {
	if (!e) return t;
	let n = e.replace(/\(.*?\)/gm, "").split(" ").filter(Boolean).map(Yd);
	return n.splice(1, n.length - 2), n.join("").toUpperCase();
}
var Zd = {
	wrap: "_wrap_1qymo_7",
	compact: "_compact_1qymo_23",
	small: "_small_1qymo_27",
	md: "_md_1qymo_31",
	medium: "_medium_1qymo_35",
	large: "_large_1qymo_39",
	image: "_image_1qymo_43",
	text: "_text_1qymo_48",
	dark: "_dark_1qymo_51",
	border: "_border_1qymo_54",
	noBackground: "_noBackground_1qymo_57",
	light: "_light_1qymo_60"
}, Qd = ({ alt: e, className: n, text: r, iconType: i, iconSize: a = "compact", imageUrl: o, type: s, textVariant: c = "inherit", fontVariant: l = R.BodyBold, title: u, ...d }) => {
	let f = s === "icon", p = s === "text", m = s === "image", h = p || f;
	return /*#__PURE__*/ t.createElement("div", {
		className: v(Zd.wrap, n),
		title: u,
		...d
	}, h && /*#__PURE__*/ t.createElement(V, {
		fontVariant: l,
		variant: c,
		className: v({
			[Zd.text]: p,
			"d-flex": f
		}),
		isTruncated: !0
	}, p && r, f && i && /*#__PURE__*/ t.createElement(W, {
		size: a,
		source: i
	})), m && o && /*#__PURE__*/ t.createElement("img", {
		src: o,
		alt: e,
		className: Zd.image
	}));
}, $d = ({ className: e, colorScheme: n, modifier: r, textVariant: i, sizeModifier: a = "small", ...o }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: s }) => {
	let c = n ?? s, l = n === "dark" ? "subtle" : "tinted";
	return /*#__PURE__*/ t.createElement(I, { colorScheme: c }, /*#__PURE__*/ t.createElement(Qd, {
		className: v(c, Zd[c], Zd[a], {
			[Zd.border]: r === "border",
			[Zd.noBackground]: r === "noBackground"
		}, e),
		textVariant: i ?? l,
		...o
	}));
}), ef = {
	none: "none",
	compact: "smallBold",
	small: "bodyBold",
	md: "bodyBold",
	medium: "h5",
	large: "h3"
}, tf = (e) => ef[e], nf = (e, t = 99) => ({
	isMoreThanMaxNumber: m(() => e > t, [e, t]),
	fontVariant: m(() => e > 9 ? R.SmallBold : R.BodyBold, [e])
}), rf = ({ alt: e, colorScheme: n, displayName: r, iconType: i, imageUrl: a, isActive: o, number: s = 0, sizeModifier: c = "small", title: l, type: u, ...d }) => {
	let f = u === Jd.Image && a, p = u === Jd.Initials, m = u === Jd.Number && !Number.isNaN(s) && s !== void 0, { isMoreThanMaxNumber: h, fontVariant: g } = nf(s), _ = () => m ? {
		type: "text",
		text: h ? "99+" : `+${s}`
	} : f ? {
		type: "image",
		imageUrl: a,
		alt: e ?? ""
	} : r !== void 0 && (p || !f) ? {
		type: "text",
		text: r === "" ? r : Xd(r)
	} : {
		type: "icon",
		iconType: i ?? U.IconMoreHorizontal,
		title: l ?? r ?? "User avatar"
	};
	return /*#__PURE__*/ t.createElement($d, {
		colorScheme: n,
		fontVariant: m ? g : tf(c),
		sizeModifier: c,
		...o ? { "data-user-avatar-active": !0 } : { "data-user-avatar": !0 },
		...d,
		..._()
	});
}, af = {
	mobileButton: "_mobileButton_nz49v_209",
	active: "_active_nz49v_218",
	disabled: "_disabled_nz49v_223"
}, of = () => "inherit", sf = ({ isContentVisible: e, displayName: n, variant: r = "tertiary", isDisabled: i = !1, modifier: a = "disc", colorScheme: o, ...s }) => {
	let c = () => n ? {
		type: "text",
		text: Xd(n)
	} : {
		type: "icon",
		iconType: U.IconSettings
	};
	return /*#__PURE__*/ t.createElement(H, {
		...s,
		isActive: e,
		modifier: a,
		size: "large",
		variant: r,
		colorScheme: o,
		isDisabled: i,
		className: v(af.mobileButton, e && af.active, i && af.disabled)
	}, /*#__PURE__*/ t.createElement($d, {
		modifier: "noBackground",
		textVariant: of(),
		iconSize: "small",
		...c()
	}));
}, cf = ({ className: e, contentClassName: n, displayName: r, colorScheme: i, variant: a = "tertiary", title: o = "Settings", buttonLabel: s = "Toggle settings menu", isDisabled: c = !1, onContentVisibilityChange: l, tooltipPosition: u = "bottomEnd", ...d }) => {
	let [f, p] = t.useState(!0);
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: m }) => /*#__PURE__*/ t.createElement(hu, {
		closeOnEscape: !0,
		className: e,
		contentClassName: n,
		buttonLabel: s,
		onContentVisibilityChange: (e) => {
			p(!e), l?.(e);
		},
		interactiveElement: (e, n) => /*#__PURE__*/ t.createElement(Kc, {
			text: o,
			position: u,
			isTooltipEnabled: f
		}, /*#__PURE__*/ t.createElement(sf, {
			...e,
			isContentVisible: n,
			variant: a,
			colorScheme: i ?? m,
			isDisabled: c,
			displayName: r
		})),
		...d
	}));
}, lf = {
	user: "_user_190uv_4",
	textLeft: "_textLeft_190uv_8",
	userAvatar: "_userAvatar_190uv_13",
	textWrapper: "_textWrapper_190uv_17",
	textItem: "_textItem_190uv_26",
	light: "_light_190uv_29"
}, uf = ({ avatarType: e, email: n, displayName: r, imageUrl: i, order: a = "text-right", colorScheme: o, usernameFontVariant: s = R.BodyBold, className: c, textItemClassName: l, size: u = "small" }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: d }) => /*#__PURE__*/ t.createElement(I, { colorScheme: o ?? d }, /*#__PURE__*/ t.createElement("div", {
	className: v(lf.user, { [lf.textLeft]: a === "text-left" }, c),
	"data-testid": G.UserView
}, /*#__PURE__*/ t.createElement(rf, {
	type: e,
	displayName: r,
	translate: "no",
	imageUrl: i,
	className: lf.userAvatar,
	sizeModifier: u
}), /*#__PURE__*/ t.createElement("div", { className: lf.textWrapper }, /*#__PURE__*/ t.createElement("div", { className: v(lf.textItem, l) }, /*#__PURE__*/ t.createElement(V, {
	fontVariant: s,
	isTruncated: !0,
	translate: "no",
	title: r
}, r)), n && /*#__PURE__*/ t.createElement("div", { className: v(lf.textItem, l) }, /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.Body,
	isTruncated: !0
}, n)))))), Z = {
	videoWrapper: "_videoWrapper_1a0v9_7",
	fullHeight: "_fullHeight_1a0v9_21",
	fullWidth: "_fullWidth_1a0v9_24",
	small: "_small_1a0v9_34",
	large: "_large_1a0v9_38",
	borderRadiusNone: "_borderRadiusNone_1a0v9_43",
	border: "_border_1a0v9_43",
	backgroundNone: "_backgroundNone_1a0v9_52",
	backgroundPrimary: "_backgroundPrimary_1a0v9_56",
	backgroundSecondary: "_backgroundSecondary_1a0v9_60",
	backgroundBlack: "_backgroundBlack_1a0v9_64",
	backgroundLight: "_backgroundLight_1a0v9_68",
	alignCenter: "_alignCenter_1a0v9_72",
	alignEnd: "_alignEnd_1a0v9_76",
	alignStart: "_alignStart_1a0v9_80",
	alignStretch: "_alignStretch_1a0v9_84",
	flexColumn: "_flexColumn_1a0v9_88",
	flexRow: "_flexRow_1a0v9_92",
	justifyEnd: "_justifyEnd_1a0v9_96",
	justifyCenter: "_justifyCenter_1a0v9_100",
	justifyStart: "_justifyStart_1a0v9_104"
}, df = /*#__PURE__*/ t.forwardRef(({ className: e, children: n, background: r = "none", size: i = "medium", borderRadius: a = "box", border: o, alignItems: s, flexDirection: c, justifyContent: l, isFullHeight: u = !1, isFullWidth: d = !1, ...f }, p) => {
	let m = i === "small", h = i === "large", g = i === "full", _ = a === "none", y = r === "none", b = r === "primary", x = r === "secondary", S = r === "black", C = r === "light";
	return /*#__PURE__*/ t.createElement("div", {
		className: v(Z.videoWrapper, {
			[Z.small]: m,
			[Z.large]: h,
			[Z.borderRadiusNone]: _,
			[Z.border]: o,
			[Z.backgroundNone]: y,
			[Z.backgroundPrimary]: b,
			[Z.backgroundSecondary]: x,
			[Z.backgroundBlack]: S,
			[Z.backgroundLight]: C,
			[Z.alignCenter]: s === "center",
			[Z.alignEnd]: s === "flex-end",
			[Z.alignStart]: s === "flex-start",
			[Z.alignStretch]: s === "stretch",
			[Z.flexColumn]: c === "column",
			[Z.flexRow]: c === "row",
			[Z.fullHeight]: u || g,
			[Z.fullWidth]: d || g,
			[Z.justifyEnd]: l === "flex-end",
			[Z.justifyCenter]: l === "center",
			[Z.justifyStart]: l === "flex-start"
		}, e, "videoWrapperGlobal"),
		...f,
		ref: p
	}, n);
});
df.displayName = "VideoWrapper";
// src/components/modules/NotificationToast/NotificationToastSignal.ts
var ff = /* @__PURE__ */ new Set([
	"colorScheme",
	"isClickable",
	"isDanger",
	"isInterrupt",
	"position",
	"testid",
	"timeout"
]), pf = ([e, t]) => ff.has(e) && [
	"string",
	"number",
	"boolean"
].includes(typeof t), mf = (e) => ({
	message: "[Toast text omitted]",
	...typeof e == "object" && e ? Object.fromEntries(Object.entries(e).filter(pf)) : {}
}), hf = b({
	name: "notification:toast",
	describeSubject: (e) => Array.isArray(e) ? e.map(mf) : typeof e == "object" && e && "close" in e && e.close === !0 ? { close: !0 } : mf(e)
}), gf = 3e3, _f = 400, vf = 3400, yf = 0, bf = (e, t) => !(!e || !t || e.colorScheme !== t.colorScheme || e.message !== t.message), xf = (e) => {
	let n = g(void 0), [r, i] = _([]), [a] = r, o = a?.timeout ?? gf;
	if (u(() => hf.add((e) => {
		if (Array.isArray(e)) {
			let t = e.map((e) => ({
				...e,
				id: yf++
			}));
			i((e) => {
				let r = t.filter((e) => e.isInterrupt);
				if (r.length > 0) {
					let i = t.filter((e) => !e.isInterrupt), [a, ...o] = e;
					return a?.timeout === 0 ? [...e, ...i] : (clearTimeout(n.current), n.current = void 0, [
						...r,
						...o,
						...i
					]);
				}
				return e.concat(t);
			});
		} else e.close && i((e) => {
			let [t, ...n] = e;
			return t?.timeout === 0 ? [{
				...t,
				timeout: 1
			}, ...n] : e;
		});
	}), []), u(() => {
		let e = a?.timeout ? a.timeout + _f : vf, t = o === 0;
		r.length > 0 && n.current == null && !t && (n.current = window.setTimeout(() => {
			i((e) => {
				let [t] = e, n = e.slice(1);
				for (; n[0] && bf(t, n[0]);) n = n.slice(1);
				return n;
			}), n.current = void 0;
		}, e));
	}, [
		r,
		a,
		o
	]), a) {
		let n = a.colorScheme ?? "light";
		return /*#__PURE__*/ t.createElement(qd, {
			...e,
			colorScheme: n,
			enhanceStart: a.enhanceStart,
			isDisplayed: !0,
			isDanger: a.isDanger,
			isClickable: a.isClickable,
			isVisible: !0,
			key: a.id,
			message: a.message,
			position: a.position,
			timeout: o,
			"data-testid": a.testid,
			onDismiss: a.onDismiss
		});
	}
	return null;
}, Sf = {
	wrapper: "_wrapper_odjga_12",
	button: "_button_odjga_16",
	reactiveStyles: "_reactiveStyles_odjga_22",
	active: "_active_odjga_22",
	icon: "_icon_odjga_25"
}, Cf = ({ className: e, direction: n = "vertical", isDisabled: r, label: i = "Toggle the menu", menuComponent: a, menuPosition: o = "bottomRight", buttonVariant: s = "translucent", buttonSize: c, buttonModifier: l, reactiveButtonStyles: u = !0, ...d }) => /*#__PURE__*/ t.createElement(hu, {
	buttonLabel: i,
	className: Sf.wrapper,
	content: a,
	"data-testid": "kebab-menu",
	interactiveElement: (i, a) => /*#__PURE__*/ t.createElement(H, {
		...i,
		className: v(i.className, Sf.button, {
			[Sf.reactiveStyles]: u,
			[Sf.active]: a
		}, e),
		isDisabled: r,
		variant: s,
		size: c,
		modifier: l
	}, /*#__PURE__*/ t.createElement(W, {
		source: n === "vertical" ? U.IconMoreVertical : U.IconMoreHorizontal,
		className: v({ [Sf.icon]: u }),
		"data-testid": `kebab-menu-icon-${n}`
	})),
	isDisabled: r,
	position: o,
	...d
}), wf = {
	slider: "_slider_twper_12",
	dark: "_dark_twper_23",
	light: "_light_twper_44"
}, Tf = ({ colorScheme: e, className: n, max: r, min: i, step: a, selectedValue: o = 0, onChange: s }) => /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: c }) => /*#__PURE__*/ t.createElement("input", {
	type: "range",
	className: v(wf.slider, wf[e ?? c], n),
	max: r,
	min: i,
	step: a,
	value: o,
	onChange: s
})), Ef = {
	captionsContainer: "_captionsContainer_mfrkh_114",
	speakers: "_speakers_mfrkh_118",
	captions: "_captions_mfrkh_114",
	timestamp: "_timestamp_mfrkh_120",
	captionsTitle: "_captionsTitle_mfrkh_124"
}, Df = ({ captions: e, speakers: n, className: r, timestamp: i, ...a }) => e ? /*#__PURE__*/ t.createElement("div", { className: v(Ef.captionsContainer, r) }, (n || i) && /*#__PURE__*/ t.createElement("div", { className: Ef.captionsTitle }, n && /*#__PURE__*/ t.createElement(V, {
	fontVariant: R.BodyBold,
	translate: "no",
	className: Ef.speakers,
	htmlTag: "p",
	isTruncated: !0
}, n.join(", ")), i && /*#__PURE__*/ t.createElement(V, {
	variant: "standard",
	htmlTag: "p",
	fontVariant: R.Small,
	className: Ef.timestamp
}, i)), /*#__PURE__*/ t.createElement(V, {
	variant: "standard",
	htmlTag: "p",
	className: v(Ef.captions),
	...a
}, e)) : null, Of = {
	button: "_button_pc9ci_12",
	iconsWrapper: "_iconsWrapper_pc9ci_15",
	overlay: "_overlay_pc9ci_16",
	assetsWrapper: "_assetsWrapper_pc9ci_20",
	previewAsset: "_previewAsset_pc9ci_49",
	previewAssetImg: "_previewAssetImg_pc9ci_59"
}, kf = ({ assets: e }) => /*#__PURE__*/ t.createElement(t.Fragment, null, e?.map((e) => /*#__PURE__*/ t.createElement("figure", {
	key: e.id,
	className: v(Of.previewAsset),
	style: {
		backgroundImage: e.src ? `url('${e.src}')` : void 0,
		backgroundColor: `${e.color}`
	}
}, e.src ? /*#__PURE__*/ t.createElement("img", {
	className: Of.previewAssetImg,
	alt: "A preview of the currently selected asset."
}) : null))), Af = ({ assets: e, className: n, children: r, ...i }) => /*#__PURE__*/ t.createElement(H, {
	variant: "translucent",
	noHover: !0,
	className: v(Of.button, n),
	...i
}, /*#__PURE__*/ t.createElement("div", { className: Of.assetsWrapper }, /*#__PURE__*/ t.createElement(kf, { assets: e })), /*#__PURE__*/ t.createElement("div", { className: Of.overlay }), /*#__PURE__*/ t.createElement("div", { className: Of.iconsWrapper }, /*#__PURE__*/ t.createElement(W, {
	source: U.IconEdit,
	size: "medium"
}), r)), jf = ({ images: e, ...n }) => /*#__PURE__*/ t.createElement(Af, {
	assets: e,
	...n
}), Mf = ({ colors: e, ...n }) => /*#__PURE__*/ t.createElement(Af, {
	assets: e,
	...n
}), Nf = {
	container: "_container_19qgq_4",
	input: "_input_19qgq_9",
	button: "_button_19qgq_16",
	label: "_label_19qgq_20",
	hidden: "_hidden_19qgq_20"
}, Pf = /* @__PURE__ */ new RegExp(/^#(?:[a-fA-F0-9]{2}){3}$/), Ff = ({ defaultValue: e, label: n, onChange: r, ...i }) => {
	if (e && !Pf.test(e)) throw Error("Default color is limited to #rrggbb currently");
	let a = d(), o = g(null), [s, c] = _(e ?? "transparent"), l = () => o.current?.click(), u = (e) => {
		r(e.target.value);
	};
	return /*#__PURE__*/ t.createElement("div", { className: Nf.container }, /*#__PURE__*/ t.createElement("label", { htmlFor: a }, /*#__PURE__*/ t.createElement(V, { className: v(Nf.label, Nf.hidden) }, n)), /*#__PURE__*/ t.createElement("input", {
		...i,
		ref: o,
		className: Nf.input,
		id: a,
		type: "color",
		value: s,
		onChange: (e) => {
			c(e.target.value), u(e);
		}
	}), /*#__PURE__*/ t.createElement(Mf, {
		className: Nf.button,
		htmlTag: "div",
		onClick: l,
		colors: [{
			id: a,
			color: s
		}]
	}));
}, Q = {
	leftPinnedTableSection: "_leftPinnedTableSection_172q9_17",
	rightPinnedTableSection: "_rightPinnedTableSection_172q9_22",
	middleTableSection: "_middleTableSection_172q9_27",
	pinnedColumnsTable: "_pinnedColumnsTable_172q9_30",
	table: "_table_172q9_34",
	tableContent: "_tableContent_172q9_45",
	tableRow: "_tableRow_172q9_49",
	tableCell: "_tableCell_172q9_56",
	tableHead: "_tableHead_172q9_62",
	tableBody: "_tableBody_172q9_65",
	tableRowInner: "_tableRowInner_172q9_73",
	showOnlyOnHover: "_showOnlyOnHover_172q9_96",
	tableHeadCell: "_tableHeadCell_172q9_109",
	sortIndicator: "_sortIndicator_172q9_117",
	isSorted: "_isSorted_172q9_117",
	indicatorArrow: "_indicatorArrow_172q9_121",
	isIndicatorFocused: "_isIndicatorFocused_172q9_124",
	tablePagination: "_tablePagination_172q9_132",
	isSticky: "_isSticky_172q9_143",
	paginationButton: "_paginationButton_172q9_151",
	paginationButtonGroup: "_paginationButtonGroup_172q9_155",
	tablePageIndicator: "_tablePageIndicator_172q9_159",
	rowSelected: "_rowSelected_172q9_167",
	expanderCell: "_expanderCell_172q9_171",
	headCellEnhancer: "_headCellEnhancer_172q9_177",
	isDisabled: "_isDisabled_172q9_181",
	infinityScrollTableBody: "_infinityScrollTableBody_172q9_185"
}, If = ({ hasPinnedColumns: e, className: n, ...r }) => /*#__PURE__*/ t.createElement("div", {
	role: "table",
	className: v(Q.table, { [Q.pinnedColumnsTable]: e }, "d-flex flex-direction-row", n),
	...r
}), Lf = ({ className: e, isDisabled: n, isSelected: r, style: i, ...a }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Q.tableRow, {
		[Q.rowSelected]: r,
		[Q.isDisabled]: n
	}, e),
	role: "row",
	style: i,
	tabIndex: 0,
	...a
}), Rf = ({ children: e, ...n }) => /*#__PURE__*/ t.createElement(Lf, n, /*#__PURE__*/ t.createElement("div", { className: Q.tableRowInner }, e)), zf = ({ className: e, hasInfinityScroll: n = !1, ...r }) => /*#__PURE__*/ t.createElement("div", {
	role: "rowgroup",
	className: v(Q.tableBody, n && Q.infinityScrollTableBody, e),
	...r
}), Bf = ({ className: e, isOnlyShownOnHover: n = !1, ...r }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Q.tableCell, { [Q.showOnlyOnHover]: n }, e),
	...r
}), Vf = ({ className: e, ...n }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Q.tableContent, e),
	...n
}), Hf = ({ className: e, ...n }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Q.tableHead, e),
	role: "rowgroup",
	...n
}), Uf = ({ className: e, isDisabled: n = !1, isSorted: r = !1, ...i }) => /*#__PURE__*/ t.createElement("div", {
	className: v(Q.tableHeadCell, {
		[Q.isSorted]: r && !n,
		[Q.isDisabled]: n
	}, e),
	...i
}), Wf = ({ isSorted: e = !1, isSortDescending: n, ...r }) => /*#__PURE__*/ t.createElement("div", {
	className: Q.sortIndicator,
	...r
}, /*#__PURE__*/ t.createElement("svg", {
	role: "img",
	"aria-label": "Sorting indicator",
	className: "ml-1",
	fill: "none",
	height: "13",
	viewBox: "0 0 10 13",
	width: "10",
	xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ t.createElement("path", {
	className: v(Q.indicatorArrow, { [Q.isIndicatorFocused]: e && !n }),
	d: "M0 8L5 13L10 8H0Z"
}), /*#__PURE__*/ t.createElement("path", {
	className: v(Q.indicatorArrow, { [Q.isIndicatorFocused]: e && n }),
	d: "M10 5L5 -4.37114e-07L0 5L10 5Z"
}))), Gf = ({ isExpanded: e, children: n, textVariant: r = "subtle", ...i }) => {
	let a = e ? U.IconChevronDown : U.IconChevronRight;
	return /*#__PURE__*/ t.createElement(z, {
		className: Q.expanderCell,
		...i
	}, /*#__PURE__*/ t.createElement(W, {
		size: "compact",
		source: a,
		className: "mr-2"
	}), /*#__PURE__*/ t.createElement(V, {
		fontVariant: R.BodyBold,
		isTruncated: !0,
		title: n,
		variant: r
	}, n));
}, Kf = ({ enhanceEnd: e, enhanceStart: n, title: r }) => /*#__PURE__*/ t.createElement("span", { className: "d-flex align-items-center" }, n && /*#__PURE__*/ t.createElement("span", { className: v("mr-1", Q.headCellEnhancer) }, n), /*#__PURE__*/ t.createElement("span", { className: "d-block" }, r), e && /*#__PURE__*/ t.createElement("span", { className: v("ml-1", Q.headCellEnhancer) }, e)), qf = ({ groupChunkSize: e = 5, pageIndex: t, totalPagesCount: n }) => {
	let r = [];
	if (n <= 0) return r;
	let i = Math.max(1, e), a = Math.min(Math.max(0, t), n - 1);
	if (n < i * 3) return [...Array(n).keys()].map((e) => ({ toIndex: e }));
	let o = Math.ceil(n / i), s = n % i, c = [...Array(n).keys()].reduce((e, t) => {
		let n = Math.floor(t / i);
		return s && n === o - 1 ? e[n - 1]?.push(t) : e[n]?.push(t), e;
	}, [...Array(o).keys()].map(() => [])).filter((e) => e.length);
	o = c.length;
	let l = Math.floor(a / i);
	l -= l === o && s ? 1 : 0;
	let u = c[l], d = ({ index: e, anchor: t, isSpacer: n = !1, offset: r = 0 }) => {
		let i = c[e], a = {
			floor: i?.[0],
			ceil: i?.[i?.length - 1]
		}[t] ?? 0;
		return i ? {
			toIndex: a + r,
			isSpacer: n
		} : !1;
	};
	return r = (l === 0 ? [
		u?.map((e) => ({ toIndex: e })),
		d({
			index: l + 1,
			anchor: "floor",
			isSpacer: !0
		}),
		o > 4 && [d({
			index: l + 2,
			anchor: "floor"
		}), d({
			index: l + 3,
			anchor: "floor",
			isSpacer: !0
		})],
		d({
			index: o - 1,
			anchor: "ceil"
		})
	] : l === o - 1 ? [
		d({
			index: 0,
			anchor: "floor"
		}),
		o > 4 && [d({
			index: l - 3,
			anchor: "ceil",
			isSpacer: !0
		}), d({
			index: l - 2,
			anchor: "ceil"
		})],
		d({
			index: l - 1,
			anchor: "ceil",
			isSpacer: !0
		}),
		u?.map((e) => ({ toIndex: e }))
	] : [
		d({
			index: 0,
			anchor: "floor"
		}),
		d({
			index: l - 1,
			anchor: "ceil",
			isSpacer: !0
		}),
		u?.map((e) => ({ toIndex: e })),
		d({
			index: l + 1,
			anchor: "floor",
			isSpacer: !0
		}),
		d({
			index: o - 1,
			anchor: "ceil"
		})
	]).flat().filter(Boolean), r;
}, Jf = ({ isGrouped: e, totalPagesCount: n, pageIndex: r, ...i }) => {
	let a = e ? Xf : Yf;
	return /*#__PURE__*/ t.createElement(a, {
		pageIndex: r,
		totalPagesCount: n,
		...i
	});
}, Yf = ({ isDisabled: e, onClick: n, pageIndex: r, totalPagesCount: i }) => /*#__PURE__*/ t.createElement(t.Fragment, null, [...Array(i).keys()].map((i) => /*#__PURE__*/ t.createElement(Zf, {
	index: i,
	isDisabled: e,
	key: `paginationNav-${i}`,
	onClick: n,
	pageIndex: r
}, i + 1))), Xf = ({ isDisabled: e, onClick: n, pageIndex: r, totalPagesCount: i }) => {
	let a = qf({
		groupChunkSize: Math.min(5, Math.floor(i / 3)),
		pageIndex: r,
		totalPagesCount: i
	});
	return /*#__PURE__*/ t.createElement(t.Fragment, null, a.map((i, a) => {
		let { isSpacer: o, toIndex: s } = i, c = `groupedPaginationNav-${a}`, l = o ? "..." : s + 1;
		return /*#__PURE__*/ t.createElement(Zf, {
			onClick: n,
			index: s,
			isDisabled: e,
			key: c,
			pageIndex: r
		}, l);
	}));
}, Zf = ({ index: e, isDisabled: n, onClick: r, pageIndex: i, children: a }) => /*#__PURE__*/ t.createElement("li", { key: `pagination-${e}` }, /*#__PURE__*/ t.createElement(H, {
	className: "px-3",
	isDisabled: n,
	onClick: () => {
		i !== e && r(e);
	},
	isActive: i === e,
	variant: "neutral"
}, a)), Qf = ({ endCount: e, isDisabled: n, startCount: r, totalCount: i }) => /*#__PURE__*/ t.createElement(V, { variant: n ? "disabled" : "standard" }, "Results: ", r, " - ", e, " of ", i), $f = ({ canNextPage: e, canPreviousPage: n, currentPageSize: r, gotoPage: i, isDisabled: a, isSticky: o, isTablePopulated: s = !0, label: c, maxUngroupedPageButtons: l = 0, nextPage: u, nextPageButtonChildren: d = "Next", pageIndex: f, pageSize: p = 20, previousPage: m, previousPageButtonChildren: h = "Previous", resultsCountComponent: g = Qf, showResultsCount: _ = !0, totalPagesCount: y, totalRows: b }) => {
	if (!s) return null;
	let x = b ? f * p + 1 : 0, S = b ? x + r - 1 : 0, C = y ?? Math.ceil(b / p), w = C > l;
	return /*#__PURE__*/ t.createElement("nav", {
		className: v(Q.tablePagination, { [Q.isSticky]: o }),
		"aria-label": `${c} - table pagination`
	}, _ && /*#__PURE__*/ t.createElement(g, {
		isDisabled: a,
		endCount: S,
		startCount: x,
		totalCount: b
	}), b > p && /*#__PURE__*/ t.createElement("div", { className: Q.paginationButtonGroup }, /*#__PURE__*/ t.createElement(H, {
		className: "mr-1",
		isDisabled: !!a || !n,
		onClick: () => n && m(),
		variant: "neutral"
	}, h), /*#__PURE__*/ t.createElement("ul", { className: Q.tablePageIndicator }, /*#__PURE__*/ t.createElement(Jf, {
		isDisabled: a,
		isGrouped: w,
		onClick: i,
		pageIndex: f,
		totalPagesCount: C
	})), /*#__PURE__*/ t.createElement(H, {
		className: "ml-1",
		isDisabled: !!a || !e,
		onClick: () => e && u(),
		variant: "neutral"
	}, d)));
}, ep = ({ className: e, position: n = "middle", ...r }) => /*#__PURE__*/ t.createElement("div", {
	className: v({
		[Q.leftPinnedTableSection]: n === "left-pinned",
		[Q.middleTableSection]: n === "middle",
		[Q.rightPinnedTableSection]: n === "right-pinned"
	}, e),
	...r
}), tp = b({ name: "ariamenu:open-state" }), $ = {
	light: "_light_1r1fs_208",
	dark: "_dark_1r1fs_214",
	innerMenu: "_innerMenu_1r1fs_220",
	innerMenuScrollbar: "_innerMenuScrollbar_1r1fs_224",
	innerMenuButton: "_innerMenuButton_1r1fs_233",
	innerMenuItem: "_innerMenuItem_1r1fs_238",
	highlighted: "_highlighted_1r1fs_256",
	isDisabled: "_isDisabled_1r1fs_256",
	isDanger: "_isDanger_1r1fs_297",
	innerMenuItemWrapper: "_innerMenuItemWrapper_1r1fs_301",
	innerMenuItemEndIcon: "_innerMenuItemEndIcon_1r1fs_306",
	innerMenuSubMenuIndicator: "_innerMenuSubMenuIndicator_1r1fs_312",
	innerMenuSubMenuIndicatorPushToEnd: "_innerMenuSubMenuIndicatorPushToEnd_1r1fs_316",
	innerMenuHeader: "_innerMenuHeader_1r1fs_320",
	innerMenuBackButton: "_innerMenuBackButton_1r1fs_328",
	innerMenuBackIcon: "_innerMenuBackIcon_1r1fs_332",
	innerMenuContent: "_innerMenuContent_1r1fs_336",
	innerMenuUnderlay: "_innerMenuUnderlay_1r1fs_345",
	innerMenuPopover: "_innerMenuPopover_1r1fs_350",
	divider: "_divider_1r1fs_355",
	innerMenuNavigator: "_innerMenuNavigator_1r1fs_360",
	innerMenuContentContainer: "_innerMenuContentContainer_1r1fs_367"
}, np = ({ item: e, state: n, itemMap: r, itemClassName: i, showSubMenuIndicator: a = !0, restoreFocus: o, onFocusRestored: s }) => {
	let c = t.useRef(null);
	t.useEffect(() => {
		o && c.current && (c.current.focus(), s?.());
	}, [s, o]);
	let { isHovered: l, hoverProps: u } = ce({
		onHoverStart: () => n.selectionManager.setFocusedKey(e.key),
		onHoverEnd: () => {
			n.selectionManager.focusedKey === e.key && n.selectionManager.setFocusedKey(null);
		}
	}), { menuItemProps: d } = fe({ key: e.key }, n, c);
	d.onPointerUp = (e) => {
		e.preventDefault();
	};
	let f = n.selectionManager.focusedKey === e.key, p = r.get(e.key)?.alternativeHoverClassName, m = r.get(e.key)?.alternativeHoverStyle, h = r.get(e.key)?.icon, g = r.get(e.key)?.iconPosition ?? "start", _ = g === "end" && !!h, y = !!r.get(e.key)?.subMenu, b = f || f && !l, x = r.get(e.key)?.isChecked, S = x === void 0 ? {} : {
		role: "menuitemcheckbox",
		"aria-checked": x
	};
	return /*#__PURE__*/ t.createElement(F, null, ({ colorScheme: n }) => /*#__PURE__*/ t.createElement(t.Fragment, null, r.get(e.key)?.withTopDivider && /*#__PURE__*/ t.createElement(Me, {
		role: "separator",
		className: $.divider
	}), /*#__PURE__*/ t.createElement("div", { className: $.innerMenuItemWrapper }, /*#__PURE__*/ t.createElement("div", {
		...d,
		...u,
		"aria-haspopup": y ? "menu" : void 0,
		"data-testid": r.get(e.key)?.testId,
		ref: c,
		style: {
			...r.get(e.key)?.style,
			...b ? m : {}
		},
		className: v($[n], $.innerMenuItem, b ? p ?? $.highlighted : {}, r.get(e.key)?.className, i, {
			[$.isDisabled]: r.get(e.key)?.isDisabled,
			[$.isDanger]: r.get(e.key)?.isDanger
		}),
		"data-active": r.get(e.key)?.isActive,
		...S
	}, g === "start" && h, e.rendered, g === "end" && h && /*#__PURE__*/ t.createElement("span", { className: $.innerMenuItemEndIcon }, h), y && a && /*#__PURE__*/ t.createElement(W, {
		source: U.IconChevronRight,
		size: "compact",
		className: v($.innerMenuSubMenuIndicator, { [$.innerMenuSubMenuIndicatorPushToEnd]: !_ })
	})), r.get(e.key)?.description && /*#__PURE__*/ t.createElement("div", null, r.get(e.key)?.description)), r.get(e.key)?.withBottomDivider && /*#__PURE__*/ t.createElement(Me, {
		role: "separator",
		className: $.divider
	})));
}, rp = (e) => {
	let n = e.filter((e) => !e.testId || (/* @__PURE__ */ t.createElement("span", { "data-testid": e.testId })).type === "span"), r = /* @__PURE__ */ new Map();
	for (let e of n) r.set(e.key, e);
	return {
		visibleItems: n,
		itemMap: r,
		disabledKeys: n.filter((e) => e.isDisabled).map((e) => e.key)
	};
}, ip = ({ items: e, onSelect: n, onClose: r, onNavigateBack: i, ariaProps: a, ariaLabel: o, ariaLabelledBy: s, autoFocus: c, restoreFocusKey: l, onFocusRestored: d, testId: f, menuClassName: p, itemClassName: h, showSubMenuIndicator: _ }) => {
	let { visibleItems: y, itemMap: b, disabledKeys: x } = m(() => rp(e), [e]), S = {
		...a,
		"aria-label": a?.["aria-label"] ?? o,
		"aria-labelledby": a?.["aria-labelledby"] ?? s,
		children: y.map((e) => /*#__PURE__*/ t.createElement(he, {
			textValue: typeof e.label == "string" ? e.label : e.textValue,
			key: e.key
		}, e.label)),
		disabledKeys: x,
		autoFocus: c ?? a?.autoFocus,
		onClose: void 0,
		onAction: (e) => {
			let t = b.get(e);
			t && n(t);
		}
	}, C = ge(S), w = g(null), { menuProps: T } = de(S, C, w);
	u(() => {
		let e = (e) => {
			let t = e.target;
			if (e.key !== "Tab" || !(t instanceof HTMLElement) || t !== document.activeElement || !w.current?.contains(t)) return;
			let n = t.getAttribute("role");
			(n === "menuitem" || n === "menuitemcheckbox" || n === "menuitemradio") && (e.preventDefault(), e.stopPropagation(), r());
		};
		return window.addEventListener("keydown", e, !0), () => {
			window.removeEventListener("keydown", e, !0);
		};
	}, [r]);
	let E = (e) => {
		if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
		let t = getComputedStyle(e.currentTarget).direction === "rtl" ? "ArrowLeft" : "ArrowRight";
		if (e.key === t) {
			let { focusedKey: t } = C.selectionManager, r = t == null ? void 0 : b.get(t);
			r?.subMenu && (e.preventDefault(), e.stopPropagation(), n(r));
		} else i && (e.preventDefault(), e.stopPropagation(), i());
	};
	return /*#__PURE__*/ t.createElement(wc, { className: $.innerMenuScrollbar }, /*#__PURE__*/ t.createElement("div", {
		...T,
		ref: w,
		onKeyDownCapture: E,
		className: v($.innerMenu, "px-2", "py-2", p),
		"data-testid": f
	}, [...C.collection].map((e) => /*#__PURE__*/ t.createElement(np, {
		itemMap: b,
		key: e.key,
		item: e,
		state: C,
		itemClassName: h,
		showSubMenuIndicator: _,
		restoreFocus: e.key === l,
		onFocusRestored: d
	}))));
}, ap = (e, t) => {
	let n = {
		title: e.title,
		ariaLabel: typeof t.label == "string" ? t.label : t.textValue,
		titleTestId: e.titleTestId,
		testId: e.testId,
		backButtonLabel: e.backButtonLabel,
		backButtonTestId: e.backButtonTestId
	};
	return e.items === void 0 ? {
		...n,
		content: e.content
	} : {
		...n,
		items: e.items
	};
}, op = ({ rootItems: e, headerContent: n, menuProps: r, close: i, testId: a, menuClassName: o, itemClassName: s, backButtonLabel: l, onGoBack: f, showSubMenuIndicator: p }) => {
	let [h, y] = _([]), [b, x] = _(), S = m(() => {
		let t = [{ items: e }], n = e;
		for (let e of h) {
			let r = n?.find((t) => t.key === e);
			if (!r?.subMenu) break;
			let i = ap(r.subMenu, r);
			t.push(i), n = i.items;
		}
		return t;
	}, [e, h]), C = S.length - 1;
	u(() => {
		h.length > C && y(h.slice(0, C));
	}, [h, C]);
	let w = S[S.length - 1] ?? { items: e }, T = S.length > 1, E = T && w.content !== void 0, D = T && !!w.title, O = d(), k = g(null), A = c((e) => {
		e.isDisabled || (e.subMenu ? (e.onItemClick?.(), y((t) => [...t, e.key])) : (e.onItemClick?.(), e.closeMenuOnItemClick !== !1 && i()));
	}, [i]), j = c(() => {
		x(void 0);
	}, []), M = c(() => {
		let e = h[h.length - 1];
		e !== void 0 && (x(e), y(h.slice(0, -1))), f?.();
	}, [f, h]);
	return u(() => {
		E && k.current?.focus();
	}, [E]), /*#__PURE__*/ t.createElement("div", { className: $.innerMenuNavigator }, T ? /*#__PURE__*/ t.createElement("div", { className: $.innerMenuHeader }, /*#__PURE__*/ t.createElement(H, {
		"aria-label": w.backButtonLabel ?? l ?? "Go back",
		onClick: M,
		size: "none",
		variant: "translucent",
		"data-testid": w.backButtonTestId,
		className: $.innerMenuBackButton
	}, /*#__PURE__*/ t.createElement(W, {
		size: "small",
		source: U.IconArrowLeftRegular,
		className: $.innerMenuBackIcon
	})), w.title && /*#__PURE__*/ t.createElement(Ne, {
		id: O,
		htmlTag: "h2",
		fontVariant: R.H5,
		"data-testid": w.titleTestId
	}, w.title)) : n && /*#__PURE__*/ t.createElement("div", null, n), /*#__PURE__*/ t.createElement("div", { className: $.innerMenuContentContainer }, w.items === void 0 ? /*#__PURE__*/ t.createElement("div", {
		ref: k,
		tabIndex: -1,
		onKeyDown: (e) => {
			if (e.target !== e.currentTarget || e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
			let t = getComputedStyle(e.currentTarget).direction === "rtl" ? "ArrowRight" : "ArrowLeft";
			e.key === t && (e.preventDefault(), M());
		},
		className: v($.innerMenuContent, o),
		"data-testid": w.testId
	}, typeof w.content == "function" ? w.content({
		close: i,
		goBack: M
	}) : w.content) : /*#__PURE__*/ t.createElement(ip, {
		items: w.items,
		onSelect: A,
		onClose: i,
		ariaProps: T ? void 0 : r,
		ariaLabel: T && !D ? w.ariaLabel : void 0,
		ariaLabelledBy: D ? O : void 0,
		autoFocus: b === void 0 ? T ? "first" : void 0 : !1,
		restoreFocusKey: b,
		onFocusRestored: j,
		testId: T ? w.testId : a,
		menuClassName: o,
		itemClassName: s,
		showSubMenuIndicator: p,
		onNavigateBack: T ? M : void 0
	})));
}, sp = (e, t = !1, n = 0) => {
	let [r, i] = _(void 0), a = g(void 0), o = e instanceof HTMLElement ? e : e && "current" in e ? e.current : null;
	u(() => {
		if (!(e && "current" in e) || e.current !== null) return;
		let t = 0, n = () => {
			t += 100, e.current === null ? t < 3e3 && (a.current = setTimeout(n, 100)) : i(e.current.getBoundingClientRect());
		};
		return a.current = setTimeout(n, 100), () => {
			a.current && clearTimeout(a.current);
		};
	}, [e]), u(() => {
		if (!o) {
			i(void 0);
			return;
		}
		i(o.getBoundingClientRect());
		let e = new ResizeObserver(() => {
			i(o.getBoundingClientRect());
		});
		return e.observe(o), () => {
			e.unobserve(o), e.disconnect();
		};
	}, [o]);
	let s = m(() => oe(() => {
		o && i(o.getBoundingClientRect());
	}, n), [o, n]);
	return u(() => {
		if (t && o) return window.addEventListener("resize", s), () => {
			s.cancel(), window.removeEventListener("resize", s);
		};
	}, [
		t,
		o,
		s
	]), u(() => {
		if (!o || !screen.orientation) return;
		let e = () => {
			o && i(o.getBoundingClientRect());
		};
		return screen.orientation.addEventListener("change", e), () => {
			screen.orientation.removeEventListener("change", e);
		};
	}, [o]), r;
}, cp = (e) => {
	let n = t.useRef(null), { state: r, children: i, colorScheme: a } = e, o = sp(n), s = o ? `calc(100dvh - ${o.top + 10}px)` : void 0, { popoverProps: c, underlayProps: l } = A({
		...e,
		popoverRef: n
	}, r);
	return /*#__PURE__*/ t.createElement(w, null, /*#__PURE__*/ t.createElement("div", {
		...l,
		className: v($.innerMenuUnderlay)
	}), /*#__PURE__*/ t.createElement("div", {
		role: "complementary",
		...c,
		ref: n
	}, /*#__PURE__*/ t.createElement(I, { colorScheme: a ?? "light" }, /*#__PURE__*/ t.createElement(Ae, {
		className: v($.innerMenuPopover),
		style: {
			maxHeight: s,
			overflow: "hidden"
		}
	}, i))));
}, lp = ({ items: e, headerContent: n, button: r, isTriggerDisabled: i, closeMenuOnTriggerDisabled: a, renderButton: o, onOpenChange: s, testId: c, colorScheme: l, popoverPlacement: d, popoverOffset: f, menuClassName: p, itemClassName: m, backButtonLabel: h, onGoBack: g, showSubMenuIndicator: _ }) => {
	let y = me({ onOpenChange: s }), { close: b, isOpen: x } = y;
	u(() => {
		a && i && x && b();
	}, [
		b,
		a,
		i,
		x
	]);
	let S = t.useRef(null), { menuTriggerProps: C, menuProps: w } = pe({
		type: "menu",
		isDisabled: i
	}, y, S), { buttonProps: T } = ue({
		...C,
		isDisabled: i
	}, S), { onPress: E, onPressStart: D, preventFocusOnPress: O, ...k } = C, A = /*#__PURE__*/ t.cloneElement(r, { ...ie(T, k) });
	return /*#__PURE__*/ t.createElement("div", { className: v($.innerMenuButton) }, /*#__PURE__*/ t.createElement("div", { ref: S }, o ? o(A) : A), y.isOpen && /*#__PURE__*/ t.createElement(cp, {
		state: y,
		triggerRef: S,
		colorScheme: l,
		placement: d ?? "bottom start",
		offset: f ?? 8
	}, /*#__PURE__*/ t.createElement(op, {
		rootItems: e,
		headerContent: n,
		menuProps: w,
		close: () => y.close(),
		testId: c,
		menuClassName: p,
		itemClassName: m,
		backButtonLabel: h,
		onGoBack: g,
		showSubMenuIndicator: _
	})));
}, up = ({ items: e, button: n, isTriggerDisabled: r, closeMenuOnTriggerDisabled: i, renderButton: a, headerContent: o, onOpenChange: s, testId: l, colorScheme: d, popoverPlacement: f, popoverOffset: p, menuClassName: m, itemClassName: h, backButtonLabel: _, onGoBack: v, showSubMenuIndicator: y }) => {
	let b = g(!1), x = c((e) => {
		b.current = e, tp.emit(e), s?.(e);
	}, [s]), S = g(x);
	return u(() => {
		S.current = x;
	}, [x]), u(() => () => {
		b.current && S.current(!1);
	}, []), /*#__PURE__*/ t.createElement(lp, {
		items: e,
		button: n,
		isTriggerDisabled: r,
		closeMenuOnTriggerDisabled: i,
		renderButton: a,
		headerContent: o,
		onOpenChange: x,
		testId: l,
		colorScheme: d,
		popoverPlacement: f,
		popoverOffset: p,
		menuClassName: m,
		itemClassName: h,
		backButtonLabel: _,
		onGoBack: v,
		showSubMenuIndicator: y
	});
}, dp = ({ activeColumn: e, columnLabels: n, isDisabled: r, className: i, buttonAriaLabel: a = "Toggle three column selector", onColumnChange: o }) => {
	let [s, c] = _(!1), l = n.map((t, n) => ({
		key: `column-${n + 1}`,
		isActive: e === n + 1,
		label: t,
		onItemClick: () => e !== n + 1 && o(n + 1),
		closeMenuOnItemClick: !0
	}));
	return /*#__PURE__*/ t.createElement(up, {
		onOpenChange: c,
		items: l,
		button: /*#__PURE__*/ t.createElement(H, {
			className: i,
			isActive: s,
			enhancerStart: /*#__PURE__*/ t.createElement(W, { source: U.IconColumns }),
			noEnhancerPadding: !0,
			isDisabled: r,
			"aria-label": a,
			size: "small",
			variant: "transparent",
			modifier: "square",
			"data-testid": G.ButtonThreeColumnSelector
		}),
		popoverPlacement: "bottom right"
	});
}, fp = {
	collapsableContainer: "_collapsableContainer_13u1l_4",
	header: "_header_13u1l_14",
	displayingHeaderEndContent: "_displayingHeaderEndContent_13u1l_19",
	isOpen: "_isOpen_13u1l_22",
	headerStartContent: "_headerStartContent_13u1l_26",
	iconContainer: "_iconContainer_13u1l_31",
	badgeCounter: "_badgeCounter_13u1l_38",
	badgeCounterContainer: "_badgeCounterContainer_13u1l_42",
	content: "_content_13u1l_47",
	headerEndContent: "_headerEndContent_13u1l_54"
}, pp = ({ isOpen: e, badgeCount: n = 0, collapseToggleAriaLabel: r = "Toggle collapsable container", openStyling: i, children: a, onToggle: o, headerEndContent: s, footerContent: c, icon: l, title: u, testId: d, scrollElementRef: f }) => /*#__PURE__*/ t.createElement("div", {
	"data-testid": d,
	className: v(fp.collapsableContainer, e && i)
}, /*#__PURE__*/ t.createElement("div", { className: v(fp.header, {
	[fp.displayingHeaderEndContent]: e && !!s,
	[fp.isOpen]: e
}) }, /*#__PURE__*/ t.createElement("div", { className: fp.headerStartContent }, /*#__PURE__*/ t.createElement(H, {
	onClick: () => o(e),
	"data-testid": G.ButtonCollapsableContainerToggle,
	size: "small",
	modifier: "square",
	variant: "transparent",
	noEnhancerPadding: !0,
	"aria-label": r,
	enhancerStart: /*#__PURE__*/ t.createElement(W, {
		source: e ? U.IconChevronLeft : U.IconChevronRight,
		size: "small"
	})
}), /*#__PURE__*/ t.createElement("div", { className: v(fp.iconContainer, { [fp.isOpen]: e }) }, /*#__PURE__*/ t.createElement(W, {
	source: l,
	size: "small"
}), !e && /*#__PURE__*/ t.createElement(el, {
	className: fp.badgeCounterContainer,
	badgeClassName: fp.badgeCounter,
	variant: "info",
	isVisible: n > 0,
	number: n,
	shouldAnimate: !1
})), e && /*#__PURE__*/ t.createElement(Ne, {
	htmlTag: "h2",
	fontVariant: R.BodyBold
}, /*#__PURE__*/ t.createElement("span", null, u), " ", n > 0 && /*#__PURE__*/ t.createElement("span", null, "(", n, ")"))), e && s && /*#__PURE__*/ t.createElement("div", { className: fp.headerEndContent }, s)), e && /*#__PURE__*/ t.createElement("div", {
	ref: f,
	className: fp.content
}, a), e && c && /*#__PURE__*/ t.createElement(Oe, {
	hasFooterShadow: !0,
	padding: "small"
}, c)), mp = { notificationList: "_notificationList_1ec86_4" }, hp = ({ size: e = "medium", notifications: n, handleClose: r, className: i }) => /*#__PURE__*/ t.createElement("div", {
	"data-testid": G.NotificationsList,
	className: v(mp.notificationList, i)
}, n.map(({ buttons: n, closeAt: i, closeTimeout: a, revision: o, isClosable: s, id: c, group: l, icon: u, avatarDisplayName: d, text: f, onClick: p }) => /*#__PURE__*/ t.createElement(bl, {
	key: c,
	id: c,
	icon: u,
	group: l,
	isClosable: s,
	closeAt: i,
	closeTimeout: a,
	revision: o,
	buttons: n,
	size: e,
	avatarDisplayName: d,
	text: f,
	onClick: p,
	handleClose: r
}))), gp = {
	light: {
		"border/accent": "#0068f4",
		"border/button/danger": "#bb2526",
		"border/button/disabled": "#d2d2d2",
		"border/button/focus": "#71b4ff",
		"border/button/form": "#777777",
		"border/button/secondary": "#323232",
		"border/button/success": "#2c7806",
		"border/button/tertiary": "#c3c4c5",
		"border/checkbo-disabled": "#c3c4c5",
		"border/checkbox-main": "#777777",
		"border/divider-primary": "#dcdcdc",
		"border/divider-secondary": "#e6e6e6",
		"border/divider-ultra": "#989898",
		"border/none": 0,
		"border/primary": "1px",
		"border/secondary": "2px",
		"font/button/accent": "#0068f4",
		"font/button/call-active": "#212121",
		"font/button/call-disabled": "#989898",
		"font/button/call-error": "#ffffff",
		"font/button/call-hover": "#ffffff",
		"font/button/call-main": "#ffffff",
		"font/button/danger-primary": "#ffffff",
		"font/button/danger-tertiary": "#ae191a",
		"font/button/danger-tertiary-hover": "#ffffff",
		"font/button/primary": "#ffffff",
		"font/button/secondary": "#323232",
		"font/button/success-primary": "#ffffff",
		"font/button/success-tertiary": "#256505",
		"font/button/success-tertiary-hover": "#ffffff",
		"font/button/tertiary": "#323232",
		"font/button/tertiary-hover": "#ffffff",
		"font/button/text": "#0156c9",
		"font/button/trans": "#323232",
		"font/button/trans-ultra": "#ffffff",
		"font/charts/line-1": "#0156c9",
		"font/charts/line-10": "#4e9f0d",
		"font/charts/line-11": "#c9e2b5",
		"font/charts/line-12": "#cc6228",
		"font/charts/line-13": "#ffc198",
		"font/charts/line-14": "#f89654",
		"font/charts/line-15": "#ffedd5",
		"font/charts/line-2": "#71b4ff",
		"font/charts/line-3": "#d2d2d2",
		"font/charts/line-4": "#989898",
		"font/charts/line-5": "#494949",
		"font/charts/line-6": "#0068f4",
		"font/charts/line-7": "#cee3ff",
		"font/charts/line-8": "#256505",
		"font/charts/line-9": "#9ad36b",
		"font/icons/clickable-active": "#323232",
		"font/icons/clickable-hover": "#323232",
		"font/icons/clickable-main": "#777777",
		"font/icons/nonclickable-main": "#323232",
		"font/icons/nonclickable-secondary": "#777777",
		"font/text/accent": "#0068f4",
		"font/text/body": "#323232",
		"font/text/danger": "#ae191a",
		"font/text/danger-tertiary": "#d73332",
		"font/text/disabled": "#c3c4c5",
		"font/text/label": "#323232",
		"font/text/link": "#0068f4",
		"font/text/link-active": "#0156c9",
		"font/text/news": "#4338ca",
		"font/text/quaternary": "#989898",
		"font/text/secondary": "#494949",
		"font/text/success": "#2c7806",
		"font/text/success-ultra": "#4e9f0d",
		"font/text/tertiary": "#777777",
		"font/text/title": "#212121",
		"font/text/warning": "#cc6228",
		"font/toggle/off-disabled": "#ffffff",
		"font/toggle/off-hover": "#ffffff",
		"font/toggle/off-main": "#ffffff",
		"font/toggle/on-disabled": "#ffffff",
		"font/toggle/on-hover": "#ffffff",
		"font/toggle/on-main": "#ffffff",
		"radius/md": "16px",
		"radius/none": 0,
		"radius/sm": "8px",
		"radius/xs": "4px",
		"size/button-md": "40px",
		"size/button-sm": "36px",
		"size/button-sx": "30px",
		"size/button-xl": "56px",
		"surface/bcg/accent": "#0068f4",
		"surface/bcg/custom": "#ffffff",
		"surface/bcg/danger-10": "#ffe5e5",
		"surface/bcg/danger-20": "#fecaca",
		"surface/bcg/form": "#f2f2f2",
		"surface/bcg/form-hover": "#e6e6e6",
		"surface/bcg/highlight": "#cee3ff",
		"surface/bcg/highlight-subtle": "#eff6ff",
		"surface/bcg/info": "#e0e7ff",
		"surface/bcg/light": "#d2d2d2",
		"surface/bcg/menu-active": "#dcdcdc",
		"surface/bcg/menu-hover": "#e6e6e6",
		"surface/bcg/menu-main": "#ffffff",
		"surface/bcg/mildwarning": "#fef9c3",
		"surface/bcg/primary": "#ffffff",
		"surface/bcg/secondary": "#f2f2f2",
		"surface/bcg/success": "#e8f7e0",
		"surface/bcg/tertiar-hover": "#f2f2f2",
		"surface/bcg/tertiary": "#f7f7f7",
		"surface/bcg/transparent": "#32323226",
		"surface/bcg/ultralight": "#e6e6e6",
		"surface/bcg/warning": "#ffedd5",
		"surface/button/call/active": "#ffffff",
		"surface/button/call/disabled": "#212121",
		"surface/button/call/enabled-hover": "#d2d2d2",
		"surface/button/call/error": "#d73332",
		"surface/button/call/error-hover": "#bb2526",
		"surface/button/call/hover": "#494949",
		"surface/button/call/main": "#212121",
		"surface/button/danger/primary-active": "#ae191a",
		"surface/button/danger/primary-disabled": "#e6e6e6",
		"surface/button/danger/primary-hover": "#bb2526",
		"surface/button/danger/primary-main": "#d73332",
		"surface/button/danger/tertiary-active": "#bb2526",
		"surface/button/danger/tertiary-disabled": "#ffffff",
		"surface/button/danger/tertiary-hover": "#d73332",
		"surface/button/danger/tertiary-main": "#ffffff",
		"surface/button/primary/active": "#1e40af",
		"surface/button/primary/disabled": "#e6e6e6",
		"surface/button/primary/hover": "#0156c9",
		"surface/button/primary/main": "#0068f4",
		"surface/button/secondary/active": "#dcdcdc",
		"surface/button/secondary/disabled": "#ffffff",
		"surface/button/secondary/hover": "#e6e6e6",
		"surface/button/secondary/main": "#ffffff",
		"surface/button/success/primary-active": "#256505",
		"surface/button/success/primary-disabled": "#e6e6e6",
		"surface/button/success/primary-hover": "#2c7806",
		"surface/button/success/primary-main": "#2c8500",
		"surface/button/success/tertiary-active": "#2c7806",
		"surface/button/success/tertiary-disabled": "#ffffff",
		"surface/button/success/tertiary-hover": "#2c8500",
		"surface/button/success/tertiary-main": "#ffffff",
		"surface/button/tertiary/active": "#0156c9",
		"surface/button/tertiary/disabled": "#ffffff",
		"surface/button/tertiary/hover": "#0068f4",
		"surface/button/tertiary/main": "#ffffff",
		"surface/button/text/active": "#dcdcdc",
		"surface/button/text/disabled": "#ffffff",
		"surface/button/text/hover": "#e6e6e6",
		"surface/button/text/main": "#ffffff",
		"surface/button/trans/active": "#dcdcdc",
		"surface/button/trans/active-ultra": "#323232",
		"surface/button/trans/disabled": "#e6e6e6",
		"surface/button/trans/hover": "#e6e6e6",
		"surface/button/trans/main": "#ffffff99",
		"surface/toggle/off-disabled": "#d2d2d2",
		"surface/toggle/off-hover": "#494949",
		"surface/toggle/off-main": "#777777",
		"surface/toggle/on-disabled": "#4490f6",
		"surface/toggle/on-hover": "#0156c9",
		"surface/toggle/on-main": "#0068f4"
	},
	dark: {
		"border/accent": "#4490f6",
		"border/button/danger": "#d73332",
		"border/button/disabled": "#494949",
		"border/button/focus": "#71b4ff",
		"border/button/form": "#777777",
		"border/button/secondary": "#ffffff",
		"border/button/success": "#2c8500",
		"border/button/tertiary": "#777777",
		"border/checkbo-disabled": "#777777",
		"border/checkbox-main": "#c3c4c5",
		"border/divider-primary": "#494949",
		"border/divider-secondary": "#323232",
		"border/divider-ultra": "#777777",
		"border/none": 0,
		"border/primary": "1px",
		"border/secondary": "2px",
		"font/button/accent": "#4490f6",
		"font/button/call-active": "#212121",
		"font/button/call-disabled": "#989898",
		"font/button/call-error": "#ffffff",
		"font/button/call-hover": "#ffffff",
		"font/button/call-main": "#ffffff",
		"font/button/danger-primary": "#ffffff",
		"font/button/danger-tertiary": "#d73332",
		"font/button/danger-tertiary-hover": "#ffffff",
		"font/button/primary": "#ffffff",
		"font/button/secondary": "#ffffff",
		"font/button/success-primary": "#ffffff",
		"font/button/success-tertiary": "#2c8500",
		"font/button/success-tertiary-hover": "#ffffff",
		"font/button/tertiary": "#ffffff",
		"font/button/tertiary-hover": "#ffffff",
		"font/button/text": "#4490f6",
		"font/button/trans": "#ffffff",
		"font/button/trans-ultra": "#323232",
		"font/charts/line-1": "#ffffff",
		"font/charts/line-10": "#ffffff",
		"font/charts/line-11": "#ffffff",
		"font/charts/line-12": "#ffffff",
		"font/charts/line-13": "#ffffff",
		"font/charts/line-14": "#ffffff",
		"font/charts/line-15": "#ffffff",
		"font/charts/line-2": "#ffffff",
		"font/charts/line-3": "#ffffff",
		"font/charts/line-4": "#ffffff",
		"font/charts/line-5": "#ffffff",
		"font/charts/line-6": "#ffffff",
		"font/charts/line-7": "#ffffff",
		"font/charts/line-8": "#ffffff",
		"font/charts/line-9": "#ffffff",
		"font/icons/clickable-active": "#ffffff",
		"font/icons/clickable-hover": "#ffffff",
		"font/icons/clickable-main": "#c3c4c5",
		"font/icons/nonclickable-main": "#ffffff",
		"font/icons/nonclickable-secondary": "#989898",
		"font/text/accent": "#4490f6",
		"font/text/body": "#f7f7f7",
		"font/text/danger": "#d73332",
		"font/text/danger-tertiary": "#ae191a",
		"font/text/disabled": "#777777",
		"font/text/label": "#f7f7f7",
		"font/text/link": "#4490f6",
		"font/text/link-active": "#0068f4",
		"font/text/news": "#4f46e5",
		"font/text/quaternary": "#989898",
		"font/text/secondary": "#dcdcdc",
		"font/text/success": "#2c8500",
		"font/text/success-ultra": "#4e9f0d",
		"font/text/tertiary": "#d2d2d2",
		"font/text/title": "#ffffff",
		"font/text/warning": "#cc6228",
		"font/toggle/off-disabled": "#ffffff",
		"font/toggle/off-hover": "#ffffff",
		"font/toggle/off-main": "#ffffff",
		"font/toggle/on-disabled": "#ffffff",
		"font/toggle/on-hover": "#ffffff",
		"font/toggle/on-main": "#ffffff",
		"radius/md": 0,
		"radius/none": 0,
		"radius/sm": 0,
		"radius/xs": 0,
		"size/button-md": "40px",
		"size/button-sm": "36px",
		"size/button-sx": "30px",
		"size/button-xl": "56px",
		"surface/bcg/accent": "#4490f6",
		"surface/bcg/custom": "#212121",
		"surface/bcg/danger-10": "#ffe5e5",
		"surface/bcg/danger-20": "#fecaca",
		"surface/bcg/form": "#494949",
		"surface/bcg/form-hover": "#494949",
		"surface/bcg/highlight": "#cee3ff",
		"surface/bcg/highlight-subtle": "#eff6ff",
		"surface/bcg/info": "#e0e7ff",
		"surface/bcg/light": "#989898",
		"surface/bcg/menu-active": "#494949",
		"surface/bcg/menu-hover": "#494949",
		"surface/bcg/menu-main": "#323232",
		"surface/bcg/mildwarning": "#fef9c3",
		"surface/bcg/primary": "#212121",
		"surface/bcg/secondary": "#323232",
		"surface/bcg/success": "#e8f7e0",
		"surface/bcg/tertiar-hover": "#494949",
		"surface/bcg/tertiary": "#323232",
		"surface/bcg/transparent": "#ffffff99",
		"surface/bcg/ultralight": "#494949",
		"surface/bcg/warning": "#ffedd5",
		"surface/button/call/active": "#ffffff",
		"surface/button/call/disabled": "#212121",
		"surface/button/call/enabled-hover": "#d2d2d2",
		"surface/button/call/error": "#d73332",
		"surface/button/call/error-hover": "#bb2526",
		"surface/button/call/hover": "#494949",
		"surface/button/call/main": "#212121",
		"surface/button/danger/primary-active": "#bb2526",
		"surface/button/danger/primary-disabled": "#323232",
		"surface/button/danger/primary-hover": "#d73332",
		"surface/button/danger/primary-main": "#212121",
		"surface/button/danger/tertiary-active": "#bb2526",
		"surface/button/danger/tertiary-disabled": "#323232",
		"surface/button/danger/tertiary-hover": "#d73332",
		"surface/button/danger/tertiary-main": "#212121",
		"surface/button/primary/active": "#0068f4",
		"surface/button/primary/disabled": "#323232",
		"surface/button/primary/hover": "#1c76f0",
		"surface/button/primary/main": "#0068f4",
		"surface/button/secondary/active": "#777777",
		"surface/button/secondary/disabled": "#212121",
		"surface/button/secondary/hover": "#494949",
		"surface/button/secondary/main": "#212121",
		"surface/button/success/primary-active": "#256505",
		"surface/button/success/primary-disabled": "#323232",
		"surface/button/success/primary-hover": "#2c7806",
		"surface/button/success/primary-main": "#2c8500",
		"surface/button/success/tertiary-active": "#2c7806",
		"surface/button/success/tertiary-disabled": "#323232",
		"surface/button/success/tertiary-hover": "#2c8500",
		"surface/button/success/tertiary-main": "#212121",
		"surface/button/tertiary/active": "#0068f4",
		"surface/button/tertiary/disabled": "#212121",
		"surface/button/tertiary/hover": "#1c76f0",
		"surface/button/tertiary/main": "#212121",
		"surface/button/text/active": "#494949",
		"surface/button/text/disabled": "#323232",
		"surface/button/text/hover": "#323232",
		"surface/button/text/main": "#212121",
		"surface/button/trans/active": "#494949",
		"surface/button/trans/active-ultra": "#ffffff",
		"surface/button/trans/disabled": "#323232",
		"surface/button/trans/hover": "#494949",
		"surface/button/trans/main": "#32323226",
		"surface/toggle/off-disabled": "#d2d2d2",
		"surface/toggle/off-hover": "#494949",
		"surface/toggle/off-main": "#0068f4",
		"surface/toggle/on-disabled": "#4490f6",
		"surface/toggle/on-hover": "#0156c9",
		"surface/toggle/on-main": "#0068f4"
	}
}, _p = [
	"bottom",
	"bottomEnd",
	"bottomLeft",
	"bottomRight",
	"bottomStart",
	"endBottom",
	"left",
	"right",
	"top",
	"topEnd",
	"topLeft",
	"topRight",
	"topStart"
], vp = [
	"primary",
	"secondary",
	"tertiary"
], yp = [
	"neutral",
	"translucent",
	"transparent",
	"transparentAlternative",
	"text",
	"danger",
	"dangerBordered",
	"success"
], bp = [...vp, ...yp];
R.H1, R.H2, R.H3, R.H4, R.H5, R.H6;
// src/components/modules/Tabs/hooks/useTabs.ts
var xp = (e) => {
	let [t, n] = _(e);
	return u(() => {
		n(t);
	}, [t]), {
		activeTab: t,
		setActiveTab: n
	};
}, Sp = (e, t) => ({
	...e,
	...t
}), Cp = (e, t) => {
	switch (t.type) {
		case "set-all-steps": return t.steps;
		case "set-step": return e[t.stepIndex] && (e[t.stepIndex] = t.step), e;
		case "complete-step": {
			let { stepIndex: n, options: r } = t, i = [...e], a = i[n];
			return a && (i[n] = Sp(a, {
				isCompleted: r.isCompleted,
				isFailed: !r.isCompleted && a.isFailed,
				isActive: r.activateStep,
				isSelectable: r.isSelectable,
				url: r.activateStep ? void 0 : a.url
			})), i;
		}
		case "fail-step": {
			let { stepIndex: n, options: r } = t, i = [...e], a = i[n];
			return a && (i[n] = Sp(a, {
				isFailed: r.isFailed,
				isCompleted: !r.isFailed && a.isCompleted,
				isActive: r.activateStep,
				isSelectable: r.isSelectable,
				url: r.activateStep ? void 0 : a.url
			})), i;
		}
		case "disable-step": {
			let { stepIndex: n, isDisabled: r } = t, i = [...e], a = i[n];
			return a && (i[n] = Sp(a, { isDisabled: r })), i;
		}
		case "activate-step": {
			let { stepIndex: n, isActive: r } = t, i = e.map((e) => ({
				...e,
				isActive: !1
			})), a = i[n];
			return a && (i[n] = Sp(a, { isActive: r })), i;
		}
		case "leave-step": {
			let { stepIndex: n, options: r } = t, i = [...e], a = i[n];
			return a && (i[n] = Sp(a, {
				isActive: r.activateStep,
				isSelectable: r.isSelectable,
				isCompleted: r.isCompleted ?? a?.isCompleted,
				isFailed: r.isFailed ?? a?.isFailed
			})), i;
		}
		case "refresh-step-names": return e.map((e, n) => ({
			...e,
			label: t.steps[n]?.label ?? e.label
		}));
	}
}, wp = (e) => e.map((e) => e.isDisabled ? !0 : !!e.isCompleted), Tp = (e, t) => wp([...e].splice(0, t)), Ep = (e) => e.every((e) => e), Dp = ({ initialSteps: e = [], currentStepIndex: t = 0 }) => {
	let n = m(() => e, [e]), [r, i] = h(Cp, n), [a, o] = _(!1), [s, l] = _(!1), [d, f] = _(t);
	u(() => {
		let e = wp(r);
		l(Ep(e));
	}, [r]), u(() => {
		let e = Tp(r, d);
		o(Ep(e));
	}, [d, r]);
	let p = c(() => {
		i({
			type: "refresh-step-names",
			steps: e
		});
	}, [e]);
	u(() => {
		p();
	}, [p]);
	let g = c((e, { forceStep: t } = { forceStep: !1 }) => {
		let n = t ? e : Xu({
			steps: r,
			stepIndex: e
		});
		f(n);
	}, [r]), v = (t) => {
		let n = e[t];
		n && i({
			type: "set-step",
			stepIndex: t,
			step: n
		});
	}, y = () => i({
		type: "set-all-steps",
		steps: e
	}), b = (e, t = !0) => i({
		type: "disable-step",
		stepIndex: e,
		isDisabled: t
	}), x = c((e, t = !0) => i({
		type: "activate-step",
		stepIndex: e,
		isActive: t
	}), []);
	return [{
		allStepsCompleted: s,
		currentStepIndex: d,
		prevStepsCompleted: a,
		steps: r
	}, {
		moveToStep: g,
		resetAllSteps: y,
		resetStep: v,
		updateStepActive: x,
		updateStepCompleted: (e, { activateStep: t = !1, isCompleted: n = !0, isSelectable: r = !1 } = {}) => i({
			type: "complete-step",
			stepIndex: e,
			options: {
				isCompleted: n,
				activateStep: t,
				isSelectable: r
			}
		}),
		updateStepFailed: (e, { activateStep: t = !1, isSelectable: n = !1, isFailed: r = !0 } = {}) => i({
			type: "fail-step",
			stepIndex: e,
			options: {
				activateStep: t,
				isSelectable: n,
				isFailed: r
			}
		}),
		updateStepDisabled: b,
		updateStepLeave: (e, { activateStep: t = !1, isSelectable: n = !0 } = {}) => i({
			type: "leave-step",
			stepIndex: e,
			options: {
				activateStep: t,
				isSelectable: n
			}
		})
	}];
}, Op = (e) => {
	let t = Ke.indexOf(e);
	if (t === -1) throw Error(`breakpoint ${e} not found in ${Ke}`);
	return Ke[t + 1] ?? null;
}, kp = (e) => {
	let t = Ge[e];
	return t > 0 ? t : null;
}, Ap = (e) => {
	if (e === null) return null;
	let t = Ge[e];
	return t > 0 ? t - .02 : null;
}, jp = (e) => {
	let t = kp(e);
	return t ? `(min-width: ${t}px)` : "";
}, Mp = (e) => {
	let t = Ap(e);
	return t ? `(max-width: ${t}px)` : "";
}, Np = (e, t) => {
	let n = kp(e), r = Ap(t);
	return n !== null && r !== null ? `(min-width: ${n}px) and (max-width: ${r}px)` : r === null ? jp(e) : Mp(t);
}, Pp = (e) => {
	let t = kp(e), n = Op(e), r = Ap(n);
	return t !== null && r !== null ? `(min-width: ${t}px) and (max-width: ${r}px)` : r === null ? jp(e) : Mp(n);
}, Fp = "(pointer: coarse)", Ip = "(orientation: portrait)", Lp = "(orientation: landscape)", Rp = `${Fp} and ${Ip} and ${Mp("md")}`, zp = `${Fp} and ${Lp} and ${Mp("lg")}`, Bp = `${Fp} and ${jp("md")}`, Vp = Pp("xs"), Hp = Pp("sm"), Up = Pp("md"), Wp = Pp("lg"), Gp = Pp("xl"), Kp = jp("sm"), qp = jp("md"), Jp = jp("lg"), Yp = jp("xl"), Xp = Mp("sm"), Zp = Mp("md"), Qp = Mp("lg"), $p = Mp("xl"), em = Np("sm", "lg"), tm = Np("sm", "xl"), nm = Np("md", "xl"), rm = "(max-width: 359px)", im = () => P(Fp), am = () => P(Bp), om = () => P(Rp), sm = () => P(zp), cm = () => {
	let e = om(), t = sm();
	return e || t;
}, lm = () => P(Ip), um = () => P(Lp), dm = () => P(Vp), fm = () => P(Hp), pm = () => P(Up), mm = () => P(Wp), hm = () => P(Gp), gm = () => P(Kp), _m = () => P(qp), vm = () => P(Jp), ym = () => P(Yp), bm = () => P(Xp), xm = () => P(Zp), Sm = () => P(Qp), Cm = () => P($p), wm = () => P(em), Tm = () => P(tm), Em = () => P(nm), Dm = () => P(rm), Om = () => {
	let e = g(!0), t = dm(), n = fm(), r = pm(), i = mm(), a = hm(), o = m(() => b({ name: "breakpoint:change" }), []);
	return u(() => {
		let s = [
			t,
			n,
			r,
			i,
			a
		].filter((e) => e).length === 1;
		!e.current && s ? o.emit() : e.current = !1;
	}, [
		o,
		t,
		n,
		r,
		i,
		a
	]), o;
}, km = (e, t = {}) => {
	let { delay: n = 0 } = t;
	return c(() => {
		if (e.current) {
			let t = () => e.current?.scrollIntoView({
				behavior: "smooth",
				block: "nearest",
				inline: "start"
			});
			n ? setTimeout(t, n) : t();
		}
	}, [e, n]);
}, Am = () => {
	let e = g(null);
	return {
		modalHandleRef: e,
		focusModal: c(() => {
			window.setTimeout(() => {
				e.current?.focus();
			}, 0);
		}, [])
	};
}, jm = (e) => {
	let t = g(null), n = _e({ isOpen: e }), { modalProps: r } = E({}, n, t);
	return {
		ref: t,
		modalProps: r
	};
}, Mm = (e) => {
	let t = g(null), n = _e({ isOpen: e }), { overlayProps: r } = D({
		isOpen: n.isOpen,
		onClose: n.close
	}, t);
	return O(), u(() => {
		if (n.isOpen && t.current) return T([t.current], { shouldUseInert: !0 });
	}, [n.isOpen]), {
		ref: t,
		modalProps: r
	};
}, Nm = ({ content: e, root: n, containerClassName: r, isDisabled: i = !1, moveBy: a = 60 }) => {
	let [o, s] = _(0), [l, d] = _(void 0), [f, p] = _(void 0), [m, h] = _(null), [g, y] = _(null), [b, x] = _(null), S = c((e) => {
		h(e);
	}, []), C = c(() => {
		s((e) => e + a);
	}, [a]), w = c(() => {
		s((e) => e - a);
	}, [a]), T = c((e) => {
		y(e);
	}, []), E = c((e) => {
		x(e);
	}, []), D = /*#__PURE__*/ t.createElement("div", {
		style: {
			transform: `translateX(${o}px)`,
			transition: "transform 300ms ease"
		},
		ref: S,
		className: v(r)
	}, /*#__PURE__*/ t.createElement("div", {
		ref: T,
		style: {
			width: "1px",
			flexShrink: 0
		}
	}), e, /*#__PURE__*/ t.createElement("div", {
		ref: E,
		style: {
			width: "1px",
			flexShrink: 0
		}
	}));
	u(() => {
		if (i || !n || !m || !g || !b) return;
		let e = new IntersectionObserver((e) => {
			for (let t of e) t.target === g && d(() => t.isIntersecting ? void 0 : C), t.target === b && p(() => t.isIntersecting ? void 0 : w);
		}, {
			root: n,
			threshold: .99
		});
		return e.observe(g), e.observe(b), () => e.disconnect();
	}, [
		n,
		m,
		g,
		b,
		i,
		C,
		w
	]), u(() => {
		let e = m?.parentElement;
		if (!e) return;
		let t = new ResizeObserver((e) => {
			for (let t of e) {
				let e = t.contentRect.width;
				m.getBoundingClientRect().width < e && o !== 0 && s(0);
			}
		});
		return t.observe(e), () => t.disconnect();
	}, [m, o]);
	let O = !!l || !!f;
	return u(() => {
		!O && o !== 0 && s(0);
	}, [O, o]), {
		navigationView: D,
		moveLeft: l,
		moveRight: f,
		hasOverflowingContent: O
	};
};
// src/components/modules/Tabs/withTabName.tsx
function Pm(e, n) {
	return function(r) {
		return /*#__PURE__*/ t.createElement(e, {
			...r,
			...n
		});
	};
}
// src/utils/typeGuards.ts
function Fm(e) {
	return Object.hasOwn(U, e);
}
export { Bl as AboutModal, Rl as AboutText, Jl as Accordion, bc as ActionsRow, Xl as ActivityCard, js as Announcer, up as AriaMenu, $l as AspectRatio, Xc as Audio, rf as Avatar, Jd as AvatarType, el as BadgeCounter, tu as Bar, Ae as Box, Ee as BoxHeader, iu as Breadcrumbs, H as Button, Bt as ButtonText, su as CakeTimer, Ps as CallToAction, Df as Captions, Fe as CardLayout, He as Cell, We as CenterLayout, Is as Checkbox, du as CircleCountDown, pp as CollapsableContainer, rt as Color, Ff as ColorPickerPreviewButton, Mf as ColorPreviewButton, pu as CondensedTabs, wu as ConfirmableMultiselect, Du as ConfirmationModal, ku as ContextMenu, Rs as CoreHeader, gc as CustomTooltip, Mu as Details, Me as Divider, Bs as DragAndDrop, Fu as DragAndUploadFiles, gl as Draggable, hu as DropContent, zt as Enhancers, Gf as ExpanderCell, Hs as FileUpload, R as FontVariant, Iu as Form, st as FullSizeWindow, ut as FullscreenLayout, ft as FullscreenOverlay, Et as FullscreenSpinner, Ot as Grid, Ru as Group, Ws as Heading, Fl as HotKey, Pl as HotkeysTooltip, W as Icon, U as IconTypes, jf as ImagePreviewButton, Kf as InfoHeadCell, Bu as InfoMessage, Ys as Input, Js as InputLabel, z as InteractiveElement, ul as KEYBOARD_EVENT_KEY, Cf as KebabMenuButton, Ks as LineHeading, Ll as List, Lc as ListBoxLink, zc as ListLink, Rt as LoadingBox, pl as LockStyle, $s as Logo, Ku as Menu, Uu as MenuEntry, Ml as Modal, ic as ModalCloseButton, Nl as ModalCloseButtonWithTooltip, Al as ModalType, yu as Multiselect, gu as MultiselectCore, nd as MultistepIndicator, bl as Notification, xf as NotificationToast, hc as NotificationTooltip, hp as NotificationsList, id as NumberStepInput, vl as Panel, od as PasswordInput, nc as PexipLogo, vc as Pill, Hu as PlainMenuEntry, hd as PopOutWindow, vd as PreferenceInput, yd as PreferenceMultiselect, xd as PreferenceRow, _d as PreferenceWrapper, Hc as ProgressBar, Vc as ProgressBarColor, Sc as RadioButton, Tf as RangeSlider, Ht as RefButton, Pt as RefInteractiveElement, Lt as RefSimpleButton, it as RgbColor, Fc as Row, At as Scrim, wc as Scrollbars, Sd as SearchInput, Td as Section, wd as SectionAccordion, Ed as Select, Ad as Sheet, It as SimpleButton, Wf as SortingIndicator, Tt as Spinner, Pd as StatCard, Md as StatCardBox, Nd as StatCardRow, jd as StatCardVariant, Ec as StatIndicator, Oc as StepNumber, xt as SvgImage, Ld as Tab, If as Table, zf as TableBody, Bf as TableCell, Vf as TableContent, Hf as TableHead, Uf as TableHeadCell, $f as TablePagination, Rf as TableRow, Lf as TableRowWrapper, ep as TableSection, Id as Tabs, Hd as Tag, Ud as TagList, G as TestId, V as Text, jc as TextArea, Ne as TextHeading, Nc as TextLink, F as ThemeConsumer, Ce as ThemeContext, I as ThemeProvider, dp as ThreeColumnSelector, qd as Toast, Gc as ToggleSwitch, Wc as ToggleSwitchDisplay, Kc as Tooltip, _p as TooltipPositionValue, ll as URLToLink, uf as User, sf as UserMenuButton, cf as UserMenuDropContent, Yc as Video, df as VideoWrapper, lt as Wrapper, Ms as announce, tp as ariaMenuOpenStateSignal, Ge as breakpoints, bp as buttonVariantsValues, $e as isBackgroundImageSrcEmpty, Ye as isImageSrcEmpty, qe as isImageSrcString, Fm as isValidIconName, hf as notificationToastSignal, Vl as onEnter, ld as openPopOutWindow, fd as setPopOutWindowCloser, ve as sizeToPadding, Se as themeValues, Dm as useBelow360, sp as useBoundingRect, Om as useBreakpointChange, xl as useFocusFrom, Dd as useFocusFromOpened, qf as useGroupedPagesNav, Xs as useInput, um as useLandscape, mm as useLg, Sm as useLgDown, vm as useLgUp, pm as useMd, xm as useMdDown, Em as useMdToXl, _m as useMdUp, cm as useMobileDevice, sm as useMobileDeviceLandscape, om as useMobileDevicePortrait, jm as useModal, Am as useModalHandle, Mm as useModalWithoutPreventScroll, Dp as useMultistepIndicator, Nm as useOutOfViewNavigation, lm as usePortrait, km as useScrollIntoView, fm as useSm, bm as useSmDown, wm as useSmToLg, Tm as useSmToXl, gm as useSmUp, am as useTabletDevice, xp as useTabs, im as useTouchDevice, hm as useXl, Cm as useXlDown, ym as useXlUp, dm as useXs, gp as variables, we as withColorScheme, Pm as withTabName, Gd as withTransition };

//# sourceMappingURL=components.js.map